//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), s = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, c = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, l = (n, r, a) => (a = n == null ? {} : e(i(n)), c(r || !n || !n.__esModule ? t(a, "default", {
	value: n,
	enumerable: !0
}) : a, n)), u = class {
	context;
	ext = null;
	activeQuery = null;
	isRunning = !1;
	eventsPendingTimestamps = [];
	resolvedEvents = [];
	namedContextStack = [];
	constructor(e) {
		this.context = e, this.ext = e.getExtension("EXT_disjoint_timer_query");
	}
	isProfilerRunning() {
		return this.isRunning;
	}
	start() {
		if (this.ext == null) throw Error("EXT_disjoint_timer_query WebGL extension is not available. Cannot start profiler.");
		if (this.isRunning) throw Error("Profiler is already running");
		let e = this.context.getExtension("WEBGL_debug_renderer_info");
		if (e != null) {
			let t = this.context.getParameter(e.UNMASKED_RENDERER_WEBGL);
			if (t.indexOf("NVIDIA GeForce GT 750M") !== -1) throw Error(`${t} cards seem to have a buggy implementation of EXT_disjoint_timer_query. Refusing to record to avoid misleading results.`);
		}
		this.isRunning = !0, this.eventsPendingTimestamps = [], this.resolvedEvents = [], this.activeQuery = this.ext.createQueryEXT(), this.ext.beginQueryEXT(this.ext.TIME_ELAPSED_EXT, this.activeQuery), this.pushContext("profile");
	}
	stop() {
		if (this.ext != null) {
			if (!this.isRunning) throw Error("Profiler is already stopped");
			this.isRunning = !1, this.popContext("profile"), this.activeQuery = null, this.ext.endQueryEXT(this.ext.TIME_ELAPSED_EXT);
		}
	}
	pushContext(e) {
		this.markAction({
			type: 0,
			name: e
		}), this.namedContextStack.push(e);
	}
	popContext(e) {
		if (this.namedContextStack.length === 0) throw Error("Tried to pop a context when the context stack is empty!");
		let t = this.namedContextStack.pop();
		if (t !== e) throw Error(`Expected popContext to be called with ${t}, but it was called with ${e}`);
		this.markAction({
			type: 1,
			name: e
		});
	}
	withContext(e, t) {
		this.pushContext(e), t(), this.popContext(e);
	}
	async exportSpeedscopeProfile() {
		for (; this.eventsPendingTimestamps.length > 0;) this.resolveEventsIfPossible(), await new Promise((e) => requestAnimationFrame(e));
		return this.toSpeedscopeProfile();
	}
	async downloadWhenReady() {
		let e = await this.exportSpeedscopeProfile(), t = document.createElement("a");
		t.href = URL.createObjectURL(new Blob([e], { type: "application/json" })), t.download = `gpuprofile-${+/* @__PURE__ */ new Date()}.speedscope.json`, document.body.appendChild(t), t.click(), document.body.removeChild(t);
	}
	async stopAndDownload() {
		this.stop(), await this.downloadWhenReady();
	}
	markAction(e) {
		if (this.ext == null) return;
		if (this.activeQuery == null) throw Error("Cannot mark actions while no profile is active");
		let t = this.activeQuery;
		this.activeQuery = this.ext.createQueryEXT(), this.ext.endQueryEXT(this.ext.TIME_ELAPSED_EXT), this.ext.beginQueryEXT(this.ext.TIME_ELAPSED_EXT, this.activeQuery), this.eventsPendingTimestamps.push({
			action: e,
			query: t
		});
	}
	resolveEventsIfPossible() {
		if (this.ext == null) return;
		let e = 0;
		for (; e < this.eventsPendingTimestamps.length;) {
			let n = this.eventsPendingTimestamps[e], r = n.query;
			if (!this.ext.getQueryObjectEXT(r, this.ext.QUERY_RESULT_AVAILABLE_EXT)) break;
			if (this.context.getParameter(this.ext.GPU_DISJOINT_EXT)) throw Error("GPU_DISJOINT_EXT");
			let i = this.ext.getQueryObjectEXT(r, this.ext.QUERY_RESULT_EXT);
			this.ext.deleteQueryEXT(r);
			var t = (this.resolvedEvents.length === 0 ? 0 : this.resolvedEvents[this.resolvedEvents.length - 1].timestamp) + i;
			this.resolvedEvents.push({
				action: n.action,
				timestamp: t
			}), e++;
		}
		e > 0 && (this.eventsPendingTimestamps = this.eventsPendingTimestamps.slice(e));
	}
	toSpeedscopeProfile() {
		let e = [], t = [];
		if (this.resolvedEvents.length === 0) throw Error("Profile is empty");
		let n = {
			type: "evented",
			name: "GPU Profile",
			unit: "nanoseconds",
			startValue: 0,
			endValue: this.resolvedEvents[this.resolvedEvents.length - 1].timestamp,
			events: t
		}, r = {
			$schema: "https://www.Speedscopeapp/file-format-schema.json",
			shared: { frames: e },
			profiles: [n]
		}, i = {};
		function a(t) {
			return t in i || (i[t] = e.length, e.push({ name: t })), i[t];
		}
		for (let e of this.resolvedEvents) t.push({
			type: e.action.type == 0 ? "O" : "C",
			frame: a(e.action.name),
			at: e.timestamp
		});
		return JSON.stringify(r);
	}
}, d = /* @__PURE__ */ new WeakMap();
function f(e) {
	if (!m()) throw Error("WebGL Profiling is not supported.");
	let t = (d.has(e) || d.set(e, new u(e)), d.get(e));
	return {
		start: () => {
			t.start();
		},
		stop: async () => {
			await t.stopAndDownload();
		},
		disable: () => {
			d.delete(e);
		}
	};
}
function p(e, t, n) {
	let r = d.get(e);
	if (r && r.isProfilerRunning()) {
		r.pushContext(t);
		try {
			n();
		} finally {
			r.popContext(t);
		}
	} else n();
}
function m() {
	return !1;
}
//#endregion
//#region src/utils/dummy_class.ts
var h = class {
	constructor() {
		return new Proxy(this, { get: (e, t, n) => e[t] === void 0 ? (...e) => n : Reflect.get(e, t, n) });
	}
};
//#endregion
//#region src/utils/sprintf.ts
function g(e, ...t) {
	let n = 0;
	return e.replace(/%(-)?(0)?(\d+)?(\.\d+)?([dfs])/g, (e, r, i, a, o, s) => {
		if (n >= t.length) return e;
		let c = t[n++], l = "", u = 0;
		switch (s) {
			case "d":
				c = parseInt(c).toString();
				break;
			case "f":
				c = parseFloat(c).toFixed(o ? parseInt(o.substring(1)) : 6);
				break;
			case "s":
				c = c.toString();
				break;
		}
		return a && (u = parseInt(a) - c.length, l = Array(u + 1).join(i ? "0" : " ")), r ? c + l : l + c;
	});
}
//#endregion
//#region src/lib/gl-wrapper/utils.ts
function _(e, t, n) {
	for (let n of t) e.enable(n);
	n();
	for (let n of t) e.disable(n);
}
function v(e) {
	return e.split("\n").map((e, t) => g("%4d | %s", t + 1, e)).join("\n");
}
function y(e) {
	if (!e) throw Error(`non-null check error: ${e}`);
	return e;
}
//#endregion
//#region src/lib/gl-wrapper/context_pool.ts
function b(e, { jsdomTest: t, webgl: n }) {
	let r = x(), i = t ? new h() : y(r.getContext(n, e));
	return {
		canvas: r,
		gl: i,
		release: () => {
			i.getExtension("WEBGL_lose_context")?.loseContext();
		}
	};
}
function x() {
	return document.createElement("canvas");
}
//#endregion
//#region src/lib/gl-wrapper/program.ts
var S = class e {
	gl;
	vertShader;
	fragShader;
	name;
	attribLocationMemo = /* @__PURE__ */ new Map();
	uniformLocationMemo = /* @__PURE__ */ new Map();
	refCount = 1;
	constructor(e, t, n) {
		if (this.gl = e, this.vertShader = this.createShader(t, this.gl.VERTEX_SHADER), this.fragShader = this.createShader(n, this.gl.FRAGMENT_SHADER), this.name = y(this.gl.createProgram()), this.gl.attachShader(this.name, this.vertShader), this.gl.attachShader(this.name, this.fragShader), this.gl.linkProgram(this.name), !this.gl.getProgramParameter(this.name, this.gl.LINK_STATUS)) throw `WebGL link error: ${this.gl.getProgramInfoLog(this.name)}`;
	}
	static new(t, n, r) {
		let i = w(t, {
			vertSource: n,
			fragSource: r
		});
		if (i) return ++i.refCount, i;
		{
			let i = new e(t, n, r);
			return i.forget = T(t, {
				vertSource: n,
				fragSource: r
			}, i), i;
		}
	}
	forget;
	release() {
		--this.refCount, this.refCount == 0 && (this.gl.deleteShader(this.fragShader), this.gl.deleteShader(this.vertShader), this.gl.deleteProgram(this.name), this.forget());
	}
	use() {
		C.get(this.gl) !== this && (C.set(this.gl, this), this.gl.useProgram(this.name));
	}
	attribLocation(e) {
		let t = this.attribLocationMemo.get(e);
		if (t ??= this.gl.getAttribLocation(this.name, e), t == -1) throw `unknown attribute: ${e}`;
		return this.attribLocationMemo.set(e, t), t;
	}
	uniformLocation(e) {
		let t = this.uniformLocationMemo.get(e);
		if (t ??= this.gl.getUniformLocation(this.name, e), t == null) throw `unknown uniform: ${e}`;
		return this.uniformLocationMemo.set(e, t), t;
	}
	enableAttribList(e, t) {
		this.use(), e.enable(this, t);
	}
	uniformMatrix4fv(e, t = !1) {
		for (let n in e) {
			let r = e[n];
			this.gl.uniformMatrix4fv(this.uniformLocation(n), t, r);
		}
	}
	uniformMatrix3fv(e, t = !1) {
		for (let n in e) {
			let r = e[n];
			this.gl.uniformMatrix3fv(this.uniformLocation(n), t, r);
		}
	}
	uniformMatrix2fv(e, t = !1) {
		for (let n in e) {
			let r = e[n];
			this.gl.uniformMatrix2fv(this.uniformLocation(n), t, r);
		}
	}
	uniform1f(e) {
		for (let t in e) this.gl.uniform1f(this.uniformLocation(t), e[t]);
	}
	uniform1i(e) {
		for (let t in e) this.gl.uniform1i(this.uniformLocation(t), e[t]);
	}
	uniform2fv(e) {
		for (let t in e) this.gl.uniform2fv(this.uniformLocation(t), e[t]);
	}
	uniform3fv(e) {
		for (let t in e) this.gl.uniform3fv(this.uniformLocation(t), e[t]);
	}
	uniform4fv(e) {
		for (let t in e) this.gl.uniform4fv(this.uniformLocation(t), e[t]);
	}
	createShader(e, t) {
		let n = this.gl.createShader(t);
		if (!n) throw `WebGL createShader error: ${this.gl.getError()}`;
		if (this.gl.shaderSource(n, e), this.gl.compileShader(n), !this.gl.getShaderParameter(n, this.gl.COMPILE_STATUS)) throw `WebGL shader compile error: ${this.gl.getShaderInfoLog(n)}\nsource:\n${v(e)}`;
		return y(n);
	}
}, C = /* @__PURE__ */ new WeakMap(), { recallProgram: w, memoProgram: T } = (() => {
	let e = /* @__PURE__ */ new WeakMap();
	function t(t) {
		return e.has(t) || e.set(t, /* @__PURE__ */ new Map()), e.get(t);
	}
	let n = (e) => JSON.stringify([e.vertSource, e.fragSource]);
	return {
		recallProgram: (e, r) => {
			let i = t(e), a = n(r);
			return i.get(a);
		},
		memoProgram: (e, r, i) => {
			let a = t(e), o = n(r);
			return a.set(o, i), () => {
				a.delete(o);
			};
		}
	};
})(), E = class {
	gl;
	bufferName;
	stride;
	offset;
	members;
	usage = -1;
	bufferSize = -1;
	vertexCount = 0;
	constructor(e, t) {
		this.gl = e, this.bufferName = y(e.createBuffer()), t && this.setData(t);
	}
	release() {
		this.gl.deleteBuffer(this.bufferName);
	}
	setData({ members: e, array: t, usage: n = this.gl.STATIC_DRAW }) {
		if (e) {
			this.members = e, this.stride = 0, this.offset = [];
			for (let t of e) t.dataType ??= this.gl.FLOAT, t.normalize ??= !1, this.offset.push(this.stride), this.stride += t.nComponents * D(this.gl, t.dataType);
		}
		if (t && (this.vertexCount = O(t) / this.stride, this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.bufferName), n != this.usage || this.bufferSize < this.vertexCount ? (this.usage = n, this.bufferSize = this.vertexCount, this.gl.bufferData(this.gl.ARRAY_BUFFER, t, n)) : this.gl.bufferSubData(this.gl.ARRAY_BUFFER, 0, t), this.gl.bindBuffer(this.gl.ARRAY_BUFFER, null), this.vertexCount % 1 != 0)) throw "nComponents may be invalid";
	}
	enable(e, t) {
		let n = this.gl;
		n.bindBuffer(n.ARRAY_BUFFER, this.bufferName);
		for (let t in this.members) {
			let r = this.members[t];
			n.enableVertexAttribArray(e.attribLocation(r.name)), n.vertexAttribPointer(e.attribLocation(r.name), r.nComponents, r.dataType, r.normalize, this.stride, this.offset[t]);
		}
		t();
		for (let t of this.members) n.disableVertexAttribArray(e.attribLocation(t.name));
		n.bindBuffer(n.ARRAY_BUFFER, null);
	}
};
function D(e, t) {
	switch (t) {
		case e.FLOAT: return 4;
		default: throw `unknown type: ${t}`;
	}
}
function O(e) {
	return e.length * e.BYTES_PER_ELEMENT;
}
//#endregion
//#region src/lib/gl-wrapper/index_buffer.ts
var k = class {
	gl;
	name;
	usage;
	_length;
	constructor(e, t) {
		this.gl = e, this.name = y(this.gl.createBuffer()), t && this.setData(t);
	}
	release() {
		this.gl.deleteBuffer(this.name);
	}
	bind(e) {
		this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, this.name), e(), this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, null);
	}
	setData({ usage: e, array: t }) {
		this.usage = e || this.gl.STATIC_DRAW, this._length = t.length, this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, this.name), this.gl.bufferData(this.gl.ELEMENT_ARRAY_BUFFER, t, this.usage), this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, null);
	}
	get length() {
		return this._length;
	}
}, A = class {
	gl;
	name;
	constructor(e, t) {
		this.gl = e, this.name = y(e.createTexture()), this.bind(() => (t || j)(this.gl));
	}
	release() {
		this.gl.deleteTexture(this.name);
	}
	bind(e) {
		this.gl.bindTexture(this.gl.TEXTURE_2D, this.name), e(), this.gl.bindTexture(this.gl.TEXTURE_2D, null);
	}
	setImage(e) {
		let t = this.gl;
		this.bind(() => {
			this.gl.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, e);
		});
	}
	setImageArrayBuffer(e, t, n) {
		let r = this.gl;
		this.bind(() => {
			this.gl.texImage2D(r.TEXTURE_2D, 0, r.RGBA, t, n, 0, r.RGBA, r.UNSIGNED_BYTE, e);
		});
	}
};
function j(e) {
	e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
}
//#endregion
//#region node_modules/gl-matrix/esm/common.js
var M = /* @__PURE__ */ s({
	ANGLE_ORDER: () => "zyx",
	ARRAY_TYPE: () => P,
	EPSILON: () => N,
	RANDOM: () => F,
	equals: () => te,
	round: () => I,
	setMatrixArrayType: () => L,
	toDegree: () => B,
	toRadian: () => ee
}), N = 1e-6, P = typeof Float32Array < "u" ? Float32Array : Array, F = Math.random;
function I(e) {
	return e >= 0 ? Math.round(e) : e % .5 == 0 ? Math.floor(e) : Math.round(e);
}
function L(e) {
	P = e;
}
var R = Math.PI / 180, z = 180 / Math.PI;
function ee(e) {
	return e * R;
}
function B(e) {
	return e * z;
}
function te(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : N;
	return Math.abs(e - t) <= n * Math.max(1, Math.abs(e), Math.abs(t));
}
//#endregion
//#region node_modules/gl-matrix/esm/mat2.js
var ne = /* @__PURE__ */ s({
	LDU: () => pe,
	add: () => me,
	adjoint: () => U,
	clone: () => re,
	copy: () => ie,
	create: () => V,
	determinant: () => W,
	equals: () => _e,
	exactEquals: () => ge,
	frob: () => q,
	fromRotation: () => K,
	fromScaling: () => de,
	fromValues: () => H,
	identity: () => ae,
	invert: () => ce,
	mul: () => ye,
	multiply: () => G,
	multiplyScalar: () => ve,
	multiplyScalarAndAdd: () => J,
	rotate: () => le,
	scale: () => ue,
	set: () => oe,
	str: () => fe,
	sub: () => be,
	subtract: () => he,
	transpose: () => se
});
function V() {
	var e = new P(4);
	return P != Float32Array && (e[1] = 0, e[2] = 0), e[0] = 1, e[3] = 1, e;
}
function re(e) {
	var t = new P(4);
	return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t;
}
function ie(e, t) {
	return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e;
}
function ae(e) {
	return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 1, e;
}
function H(e, t, n, r) {
	var i = new P(4);
	return i[0] = e, i[1] = t, i[2] = n, i[3] = r, i;
}
function oe(e, t, n, r, i) {
	return e[0] = t, e[1] = n, e[2] = r, e[3] = i, e;
}
function se(e, t) {
	if (e === t) {
		var n = t[1];
		e[1] = t[2], e[2] = n;
	} else e[0] = t[0], e[1] = t[2], e[2] = t[1], e[3] = t[3];
	return e;
}
function ce(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = n * a - i * r;
	return o ? (o = 1 / o, e[0] = a * o, e[1] = -r * o, e[2] = -i * o, e[3] = n * o, e) : null;
}
function U(e, t) {
	var n = t[0];
	return e[0] = t[3], e[1] = -t[1], e[2] = -t[2], e[3] = n, e;
}
function W(e) {
	return e[0] * e[3] - e[2] * e[1];
}
function G(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = n[0], c = n[1], l = n[2], u = n[3];
	return e[0] = r * s + a * c, e[1] = i * s + o * c, e[2] = r * l + a * u, e[3] = i * l + o * u, e;
}
function le(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = Math.sin(n), c = Math.cos(n);
	return e[0] = r * c + a * s, e[1] = i * c + o * s, e[2] = r * -s + a * c, e[3] = i * -s + o * c, e;
}
function ue(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = n[0], c = n[1];
	return e[0] = r * s, e[1] = i * s, e[2] = a * c, e[3] = o * c, e;
}
function K(e, t) {
	var n = Math.sin(t), r = Math.cos(t);
	return e[0] = r, e[1] = n, e[2] = -n, e[3] = r, e;
}
function de(e, t) {
	return e[0] = t[0], e[1] = 0, e[2] = 0, e[3] = t[1], e;
}
function fe(e) {
	return "mat2(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ")";
}
function q(e) {
	return Math.sqrt(e[0] * e[0] + e[1] * e[1] + e[2] * e[2] + e[3] * e[3]);
}
function pe(e, t, n, r) {
	return e[2] = r[2] / r[0], n[0] = r[0], n[1] = r[1], n[3] = r[3] - e[2] * n[1], [
		e,
		t,
		n
	];
}
function me(e, t, n) {
	return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2], e[3] = t[3] + n[3], e;
}
function he(e, t, n) {
	return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2], e[3] = t[3] - n[3], e;
}
function ge(e, t) {
	return e[0] === t[0] && e[1] === t[1] && e[2] === t[2] && e[3] === t[3];
}
function _e(e, t) {
	var n = e[0], r = e[1], i = e[2], a = e[3], o = t[0], s = t[1], c = t[2], l = t[3];
	return Math.abs(n - o) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(r - s) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(s)) && Math.abs(i - c) <= 1e-6 * Math.max(1, Math.abs(i), Math.abs(c)) && Math.abs(a - l) <= 1e-6 * Math.max(1, Math.abs(a), Math.abs(l));
}
function ve(e, t, n) {
	return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e;
}
function J(e, t, n, r) {
	return e[0] = t[0] + n[0] * r, e[1] = t[1] + n[1] * r, e[2] = t[2] + n[2] * r, e[3] = t[3] + n[3] * r, e;
}
var ye = G, be = he, xe = /* @__PURE__ */ s({
	add: () => Le,
	clone: () => X,
	copy: () => Se,
	create: () => Y,
	determinant: () => De,
	equals: () => He,
	exactEquals: () => Ve,
	frob: () => Ie,
	fromRotation: () => Me,
	fromScaling: () => Ne,
	fromTranslation: () => Pe,
	fromValues: () => we,
	identity: () => Ce,
	invert: () => Ee,
	mul: () => Ue,
	multiply: () => Oe,
	multiplyScalar: () => ze,
	multiplyScalarAndAdd: () => Be,
	rotate: () => ke,
	scale: () => Ae,
	set: () => Te,
	str: () => Fe,
	sub: () => We,
	subtract: () => Re,
	translate: () => je
});
function Y() {
	var e = new P(6);
	return P != Float32Array && (e[1] = 0, e[2] = 0, e[4] = 0, e[5] = 0), e[0] = 1, e[3] = 1, e;
}
function X(e) {
	var t = new P(6);
	return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t;
}
function Se(e, t) {
	return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e;
}
function Ce(e) {
	return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 1, e[4] = 0, e[5] = 0, e;
}
function we(e, t, n, r, i, a) {
	var o = new P(6);
	return o[0] = e, o[1] = t, o[2] = n, o[3] = r, o[4] = i, o[5] = a, o;
}
function Te(e, t, n, r, i, a, o) {
	return e[0] = t, e[1] = n, e[2] = r, e[3] = i, e[4] = a, e[5] = o, e;
}
function Ee(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = t[4], s = t[5], c = n * a - r * i;
	return c ? (c = 1 / c, e[0] = a * c, e[1] = -r * c, e[2] = -i * c, e[3] = n * c, e[4] = (i * s - a * o) * c, e[5] = (r * o - n * s) * c, e) : null;
}
function De(e) {
	return e[0] * e[3] - e[1] * e[2];
}
function Oe(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = n[0], u = n[1], d = n[2], f = n[3], p = n[4], m = n[5];
	return e[0] = r * l + a * u, e[1] = i * l + o * u, e[2] = r * d + a * f, e[3] = i * d + o * f, e[4] = r * p + a * m + s, e[5] = i * p + o * m + c, e;
}
function ke(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = Math.sin(n), u = Math.cos(n);
	return e[0] = r * u + a * l, e[1] = i * u + o * l, e[2] = r * -l + a * u, e[3] = i * -l + o * u, e[4] = s, e[5] = c, e;
}
function Ae(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = n[0], u = n[1];
	return e[0] = r * l, e[1] = i * l, e[2] = a * u, e[3] = o * u, e[4] = s, e[5] = c, e;
}
function je(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = n[0], u = n[1];
	return e[0] = r, e[1] = i, e[2] = a, e[3] = o, e[4] = r * l + a * u + s, e[5] = i * l + o * u + c, e;
}
function Me(e, t) {
	var n = Math.sin(t), r = Math.cos(t);
	return e[0] = r, e[1] = n, e[2] = -n, e[3] = r, e[4] = 0, e[5] = 0, e;
}
function Ne(e, t) {
	return e[0] = t[0], e[1] = 0, e[2] = 0, e[3] = t[1], e[4] = 0, e[5] = 0, e;
}
function Pe(e, t) {
	return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 1, e[4] = t[0], e[5] = t[1], e;
}
function Fe(e) {
	return "mat2d(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ")";
}
function Ie(e) {
	return Math.sqrt(e[0] * e[0] + e[1] * e[1] + e[2] * e[2] + e[3] * e[3] + e[4] * e[4] + e[5] * e[5] + 1);
}
function Le(e, t, n) {
	return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2], e[3] = t[3] + n[3], e[4] = t[4] + n[4], e[5] = t[5] + n[5], e;
}
function Re(e, t, n) {
	return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2], e[3] = t[3] - n[3], e[4] = t[4] - n[4], e[5] = t[5] - n[5], e;
}
function ze(e, t, n) {
	return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e[4] = t[4] * n, e[5] = t[5] * n, e;
}
function Be(e, t, n, r) {
	return e[0] = t[0] + n[0] * r, e[1] = t[1] + n[1] * r, e[2] = t[2] + n[2] * r, e[3] = t[3] + n[3] * r, e[4] = t[4] + n[4] * r, e[5] = t[5] + n[5] * r, e;
}
function Ve(e, t) {
	return e[0] === t[0] && e[1] === t[1] && e[2] === t[2] && e[3] === t[3] && e[4] === t[4] && e[5] === t[5];
}
function He(e, t) {
	var n = e[0], r = e[1], i = e[2], a = e[3], o = e[4], s = e[5], c = t[0], l = t[1], u = t[2], d = t[3], f = t[4], p = t[5];
	return Math.abs(n - c) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(c)) && Math.abs(r - l) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(l)) && Math.abs(i - u) <= 1e-6 * Math.max(1, Math.abs(i), Math.abs(u)) && Math.abs(a - d) <= 1e-6 * Math.max(1, Math.abs(a), Math.abs(d)) && Math.abs(o - f) <= 1e-6 * Math.max(1, Math.abs(o), Math.abs(f)) && Math.abs(s - p) <= 1e-6 * Math.max(1, Math.abs(s), Math.abs(p));
}
var Ue = Oe, We = Re, Ge = /* @__PURE__ */ s({
	add: () => gt,
	adjoint: () => tt,
	clone: () => Je,
	copy: () => Ye,
	create: () => Ke,
	determinant: () => nt,
	equals: () => xt,
	exactEquals: () => bt,
	frob: () => ht,
	fromMat2d: () => ut,
	fromMat4: () => qe,
	fromQuat: () => dt,
	fromRotation: () => ct,
	fromScaling: () => lt,
	fromTranslation: () => st,
	fromValues: () => Xe,
	identity: () => Qe,
	invert: () => et,
	mul: () => St,
	multiply: () => rt,
	multiplyScalar: () => vt,
	multiplyScalarAndAdd: () => yt,
	normalFromMat4: () => ft,
	projection: () => pt,
	rotate: () => at,
	scale: () => ot,
	set: () => Ze,
	str: () => mt,
	sub: () => Ct,
	subtract: () => _t,
	translate: () => it,
	transpose: () => $e
});
function Ke() {
	var e = new P(9);
	return P != Float32Array && (e[1] = 0, e[2] = 0, e[3] = 0, e[5] = 0, e[6] = 0, e[7] = 0), e[0] = 1, e[4] = 1, e[8] = 1, e;
}
function qe(e, t) {
	return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[4], e[4] = t[5], e[5] = t[6], e[6] = t[8], e[7] = t[9], e[8] = t[10], e;
}
function Je(e) {
	var t = new P(9);
	return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t;
}
function Ye(e, t) {
	return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e;
}
function Xe(e, t, n, r, i, a, o, s, c) {
	var l = new P(9);
	return l[0] = e, l[1] = t, l[2] = n, l[3] = r, l[4] = i, l[5] = a, l[6] = o, l[7] = s, l[8] = c, l;
}
function Ze(e, t, n, r, i, a, o, s, c, l) {
	return e[0] = t, e[1] = n, e[2] = r, e[3] = i, e[4] = a, e[5] = o, e[6] = s, e[7] = c, e[8] = l, e;
}
function Qe(e) {
	return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 1, e[5] = 0, e[6] = 0, e[7] = 0, e[8] = 1, e;
}
function $e(e, t) {
	if (e === t) {
		var n = t[1], r = t[2], i = t[5];
		e[1] = t[3], e[2] = t[6], e[3] = n, e[5] = t[7], e[6] = r, e[7] = i;
	} else e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8];
	return e;
}
function et(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = t[4], s = t[5], c = t[6], l = t[7], u = t[8], d = u * o - s * l, f = -u * a + s * c, p = l * a - o * c, m = n * d + r * f + i * p;
	return m ? (m = 1 / m, e[0] = d * m, e[1] = (-u * r + i * l) * m, e[2] = (s * r - i * o) * m, e[3] = f * m, e[4] = (u * n - i * c) * m, e[5] = (-s * n + i * a) * m, e[6] = p * m, e[7] = (-l * n + r * c) * m, e[8] = (o * n - r * a) * m, e) : null;
}
function tt(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = t[4], s = t[5], c = t[6], l = t[7], u = t[8];
	return e[0] = o * u - s * l, e[1] = i * l - r * u, e[2] = r * s - i * o, e[3] = s * c - a * u, e[4] = n * u - i * c, e[5] = i * a - n * s, e[6] = a * l - o * c, e[7] = r * c - n * l, e[8] = n * o - r * a, e;
}
function nt(e) {
	var t = e[0], n = e[1], r = e[2], i = e[3], a = e[4], o = e[5], s = e[6], c = e[7], l = e[8];
	return t * (l * a - o * c) + n * (-l * i + o * s) + r * (c * i - a * s);
}
function rt(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = t[8], f = n[0], p = n[1], m = n[2], h = n[3], g = n[4], _ = n[5], v = n[6], y = n[7], b = n[8];
	return e[0] = f * r + p * o + m * l, e[1] = f * i + p * s + m * u, e[2] = f * a + p * c + m * d, e[3] = h * r + g * o + _ * l, e[4] = h * i + g * s + _ * u, e[5] = h * a + g * c + _ * d, e[6] = v * r + y * o + b * l, e[7] = v * i + y * s + b * u, e[8] = v * a + y * c + b * d, e;
}
function it(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = t[8], f = n[0], p = n[1];
	return e[0] = r, e[1] = i, e[2] = a, e[3] = o, e[4] = s, e[5] = c, e[6] = f * r + p * o + l, e[7] = f * i + p * s + u, e[8] = f * a + p * c + d, e;
}
function at(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = t[8], f = Math.sin(n), p = Math.cos(n);
	return e[0] = p * r + f * o, e[1] = p * i + f * s, e[2] = p * a + f * c, e[3] = p * o - f * r, e[4] = p * s - f * i, e[5] = p * c - f * a, e[6] = l, e[7] = u, e[8] = d, e;
}
function ot(e, t, n) {
	var r = n[0], i = n[1];
	return e[0] = r * t[0], e[1] = r * t[1], e[2] = r * t[2], e[3] = i * t[3], e[4] = i * t[4], e[5] = i * t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e;
}
function st(e, t) {
	return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 1, e[5] = 0, e[6] = t[0], e[7] = t[1], e[8] = 1, e;
}
function ct(e, t) {
	var n = Math.sin(t), r = Math.cos(t);
	return e[0] = r, e[1] = n, e[2] = 0, e[3] = -n, e[4] = r, e[5] = 0, e[6] = 0, e[7] = 0, e[8] = 1, e;
}
function lt(e, t) {
	return e[0] = t[0], e[1] = 0, e[2] = 0, e[3] = 0, e[4] = t[1], e[5] = 0, e[6] = 0, e[7] = 0, e[8] = 1, e;
}
function ut(e, t) {
	return e[0] = t[0], e[1] = t[1], e[2] = 0, e[3] = t[2], e[4] = t[3], e[5] = 0, e[6] = t[4], e[7] = t[5], e[8] = 1, e;
}
function dt(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = n + n, s = r + r, c = i + i, l = n * o, u = r * o, d = r * s, f = i * o, p = i * s, m = i * c, h = a * o, g = a * s, _ = a * c;
	return e[0] = 1 - d - m, e[3] = u - _, e[6] = f + g, e[1] = u + _, e[4] = 1 - l - m, e[7] = p - h, e[2] = f - g, e[5] = p + h, e[8] = 1 - l - d, e;
}
function ft(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = t[4], s = t[5], c = t[6], l = t[7], u = t[8], d = t[9], f = t[10], p = t[11], m = t[12], h = t[13], g = t[14], _ = t[15], v = n * s - r * o, y = n * c - i * o, b = n * l - a * o, x = r * c - i * s, S = r * l - a * s, C = i * l - a * c, w = u * h - d * m, T = u * g - f * m, E = u * _ - p * m, D = d * g - f * h, O = d * _ - p * h, k = f * _ - p * g, A = v * k - y * O + b * D + x * E - S * T + C * w;
	return A ? (A = 1 / A, e[0] = (s * k - c * O + l * D) * A, e[1] = (c * E - o * k - l * T) * A, e[2] = (o * O - s * E + l * w) * A, e[3] = (i * O - r * k - a * D) * A, e[4] = (n * k - i * E + a * T) * A, e[5] = (r * E - n * O - a * w) * A, e[6] = (h * C - g * S + _ * x) * A, e[7] = (g * b - m * C - _ * y) * A, e[8] = (m * S - h * b + _ * v) * A, e) : null;
}
function pt(e, t, n) {
	return e[0] = 2 / t, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = -2 / n, e[5] = 0, e[6] = -1, e[7] = 1, e[8] = 1, e;
}
function mt(e) {
	return "mat3(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ", " + e[6] + ", " + e[7] + ", " + e[8] + ")";
}
function ht(e) {
	return Math.sqrt(e[0] * e[0] + e[1] * e[1] + e[2] * e[2] + e[3] * e[3] + e[4] * e[4] + e[5] * e[5] + e[6] * e[6] + e[7] * e[7] + e[8] * e[8]);
}
function gt(e, t, n) {
	return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2], e[3] = t[3] + n[3], e[4] = t[4] + n[4], e[5] = t[5] + n[5], e[6] = t[6] + n[6], e[7] = t[7] + n[7], e[8] = t[8] + n[8], e;
}
function _t(e, t, n) {
	return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2], e[3] = t[3] - n[3], e[4] = t[4] - n[4], e[5] = t[5] - n[5], e[6] = t[6] - n[6], e[7] = t[7] - n[7], e[8] = t[8] - n[8], e;
}
function vt(e, t, n) {
	return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e[4] = t[4] * n, e[5] = t[5] * n, e[6] = t[6] * n, e[7] = t[7] * n, e[8] = t[8] * n, e;
}
function yt(e, t, n, r) {
	return e[0] = t[0] + n[0] * r, e[1] = t[1] + n[1] * r, e[2] = t[2] + n[2] * r, e[3] = t[3] + n[3] * r, e[4] = t[4] + n[4] * r, e[5] = t[5] + n[5] * r, e[6] = t[6] + n[6] * r, e[7] = t[7] + n[7] * r, e[8] = t[8] + n[8] * r, e;
}
function bt(e, t) {
	return e[0] === t[0] && e[1] === t[1] && e[2] === t[2] && e[3] === t[3] && e[4] === t[4] && e[5] === t[5] && e[6] === t[6] && e[7] === t[7] && e[8] === t[8];
}
function xt(e, t) {
	var n = e[0], r = e[1], i = e[2], a = e[3], o = e[4], s = e[5], c = e[6], l = e[7], u = e[8], d = t[0], f = t[1], p = t[2], m = t[3], h = t[4], g = t[5], _ = t[6], v = t[7], y = t[8];
	return Math.abs(n - d) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(d)) && Math.abs(r - f) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(f)) && Math.abs(i - p) <= 1e-6 * Math.max(1, Math.abs(i), Math.abs(p)) && Math.abs(a - m) <= 1e-6 * Math.max(1, Math.abs(a), Math.abs(m)) && Math.abs(o - h) <= 1e-6 * Math.max(1, Math.abs(o), Math.abs(h)) && Math.abs(s - g) <= 1e-6 * Math.max(1, Math.abs(s), Math.abs(g)) && Math.abs(c - _) <= 1e-6 * Math.max(1, Math.abs(c), Math.abs(_)) && Math.abs(l - v) <= 1e-6 * Math.max(1, Math.abs(l), Math.abs(v)) && Math.abs(u - y) <= 1e-6 * Math.max(1, Math.abs(u), Math.abs(y));
}
var St = rt, Ct = _t, wt = /* @__PURE__ */ s({
	add: () => mn,
	adjoint: () => jt,
	clone: () => Tt,
	copy: () => Et,
	create: () => Z,
	decompose: () => Zt,
	determinant: () => Mt,
	equals: () => yn,
	exactEquals: () => vn,
	frob: () => pn,
	fromQuat: () => en,
	fromQuat2: () => qt,
	fromRotation: () => Ht,
	fromRotationTranslation: () => Kt,
	fromRotationTranslationScale: () => Qt,
	fromRotationTranslationScaleOrigin: () => $t,
	fromScaling: () => Vt,
	fromTranslation: () => Bt,
	fromValues: () => Q,
	fromXRotation: () => Ut,
	fromYRotation: () => Wt,
	fromZRotation: () => Gt,
	frustum: () => tn,
	getRotation: () => Xt,
	getScaling: () => Yt,
	getTranslation: () => Jt,
	identity: () => Ot,
	invert: () => At,
	lookAt: () => un,
	mul: () => bn,
	multiply: () => Nt,
	multiplyScalar: () => gn,
	multiplyScalarAndAdd: () => _n,
	ortho: () => cn,
	orthoNO: () => sn,
	orthoZO: () => ln,
	perspective: () => rn,
	perspectiveFromFieldOfView: () => on,
	perspectiveNO: () => nn,
	perspectiveZO: () => an,
	rotate: () => It,
	rotateX: () => Lt,
	rotateY: () => Rt,
	rotateZ: () => zt,
	scale: () => Ft,
	set: () => Dt,
	str: () => fn,
	sub: () => xn,
	subtract: () => hn,
	targetTo: () => dn,
	translate: () => Pt,
	transpose: () => kt
});
function Z() {
	var e = new P(16);
	return P != Float32Array && (e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0), e[0] = 1, e[5] = 1, e[10] = 1, e[15] = 1, e;
}
function Tt(e) {
	var t = new P(16);
	return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
}
function Et(e, t) {
	return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
}
function Q(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h) {
	var g = new P(16);
	return g[0] = e, g[1] = t, g[2] = n, g[3] = r, g[4] = i, g[5] = a, g[6] = o, g[7] = s, g[8] = c, g[9] = l, g[10] = u, g[11] = d, g[12] = f, g[13] = p, g[14] = m, g[15] = h, g;
}
function Dt(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g) {
	return e[0] = t, e[1] = n, e[2] = r, e[3] = i, e[4] = a, e[5] = o, e[6] = s, e[7] = c, e[8] = l, e[9] = u, e[10] = d, e[11] = f, e[12] = p, e[13] = m, e[14] = h, e[15] = g, e;
}
function Ot(e) {
	return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
}
function kt(e, t) {
	if (e === t) {
		var n = t[1], r = t[2], i = t[3], a = t[6], o = t[7], s = t[11];
		e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = n, e[6] = t[9], e[7] = t[13], e[8] = r, e[9] = a, e[11] = t[14], e[12] = i, e[13] = o, e[14] = s;
	} else e[0] = t[0], e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = t[1], e[5] = t[5], e[6] = t[9], e[7] = t[13], e[8] = t[2], e[9] = t[6], e[10] = t[10], e[11] = t[14], e[12] = t[3], e[13] = t[7], e[14] = t[11], e[15] = t[15];
	return e;
}
function At(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = t[4], s = t[5], c = t[6], l = t[7], u = t[8], d = t[9], f = t[10], p = t[11], m = t[12], h = t[13], g = t[14], _ = t[15], v = n * s - r * o, y = n * c - i * o, b = n * l - a * o, x = r * c - i * s, S = r * l - a * s, C = i * l - a * c, w = u * h - d * m, T = u * g - f * m, E = u * _ - p * m, D = d * g - f * h, O = d * _ - p * h, k = f * _ - p * g, A = v * k - y * O + b * D + x * E - S * T + C * w;
	return A ? (A = 1 / A, e[0] = (s * k - c * O + l * D) * A, e[1] = (i * O - r * k - a * D) * A, e[2] = (h * C - g * S + _ * x) * A, e[3] = (f * S - d * C - p * x) * A, e[4] = (c * E - o * k - l * T) * A, e[5] = (n * k - i * E + a * T) * A, e[6] = (g * b - m * C - _ * y) * A, e[7] = (u * C - f * b + p * y) * A, e[8] = (o * O - s * E + l * w) * A, e[9] = (r * E - n * O - a * w) * A, e[10] = (m * S - h * b + _ * v) * A, e[11] = (d * b - u * S - p * v) * A, e[12] = (s * T - o * D - c * w) * A, e[13] = (n * D - r * T + i * w) * A, e[14] = (h * y - m * x - g * v) * A, e[15] = (u * x - d * y + f * v) * A, e) : null;
}
function jt(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = t[4], s = t[5], c = t[6], l = t[7], u = t[8], d = t[9], f = t[10], p = t[11], m = t[12], h = t[13], g = t[14], _ = t[15], v = n * s - r * o, y = n * c - i * o, b = n * l - a * o, x = r * c - i * s, S = r * l - a * s, C = i * l - a * c, w = u * h - d * m, T = u * g - f * m, E = u * _ - p * m, D = d * g - f * h, O = d * _ - p * h, k = f * _ - p * g;
	return e[0] = s * k - c * O + l * D, e[1] = i * O - r * k - a * D, e[2] = h * C - g * S + _ * x, e[3] = f * S - d * C - p * x, e[4] = c * E - o * k - l * T, e[5] = n * k - i * E + a * T, e[6] = g * b - m * C - _ * y, e[7] = u * C - f * b + p * y, e[8] = o * O - s * E + l * w, e[9] = r * E - n * O - a * w, e[10] = m * S - h * b + _ * v, e[11] = d * b - u * S - p * v, e[12] = s * T - o * D - c * w, e[13] = n * D - r * T + i * w, e[14] = h * y - m * x - g * v, e[15] = u * x - d * y + f * v, e;
}
function Mt(e) {
	var t = e[0], n = e[1], r = e[2], i = e[3], a = e[4], o = e[5], s = e[6], c = e[7], l = e[8], u = e[9], d = e[10], f = e[11], p = e[12], m = e[13], h = e[14], g = e[15], _ = t * o - n * a, v = t * s - r * a, y = n * s - r * o, b = l * m - u * p, x = l * h - d * p, S = u * h - d * m, C = t * S - n * x + r * b, w = a * S - o * x + s * b, T = l * y - u * v + d * _, E = p * y - m * v + h * _;
	return c * C - i * w + g * T - f * E;
}
function Nt(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = t[8], f = t[9], p = t[10], m = t[11], h = t[12], g = t[13], _ = t[14], v = t[15], y = n[0], b = n[1], x = n[2], S = n[3];
	return e[0] = y * r + b * s + x * d + S * h, e[1] = y * i + b * c + x * f + S * g, e[2] = y * a + b * l + x * p + S * _, e[3] = y * o + b * u + x * m + S * v, y = n[4], b = n[5], x = n[6], S = n[7], e[4] = y * r + b * s + x * d + S * h, e[5] = y * i + b * c + x * f + S * g, e[6] = y * a + b * l + x * p + S * _, e[7] = y * o + b * u + x * m + S * v, y = n[8], b = n[9], x = n[10], S = n[11], e[8] = y * r + b * s + x * d + S * h, e[9] = y * i + b * c + x * f + S * g, e[10] = y * a + b * l + x * p + S * _, e[11] = y * o + b * u + x * m + S * v, y = n[12], b = n[13], x = n[14], S = n[15], e[12] = y * r + b * s + x * d + S * h, e[13] = y * i + b * c + x * f + S * g, e[14] = y * a + b * l + x * p + S * _, e[15] = y * o + b * u + x * m + S * v, e;
}
function Pt(e, t, n) {
	var r = n[0], i = n[1], a = n[2], o, s, c, l, u, d, f, p, m, h, g, _;
	return t === e ? (e[12] = t[0] * r + t[4] * i + t[8] * a + t[12], e[13] = t[1] * r + t[5] * i + t[9] * a + t[13], e[14] = t[2] * r + t[6] * i + t[10] * a + t[14], e[15] = t[3] * r + t[7] * i + t[11] * a + t[15]) : (o = t[0], s = t[1], c = t[2], l = t[3], u = t[4], d = t[5], f = t[6], p = t[7], m = t[8], h = t[9], g = t[10], _ = t[11], e[0] = o, e[1] = s, e[2] = c, e[3] = l, e[4] = u, e[5] = d, e[6] = f, e[7] = p, e[8] = m, e[9] = h, e[10] = g, e[11] = _, e[12] = o * r + u * i + m * a + t[12], e[13] = s * r + d * i + h * a + t[13], e[14] = c * r + f * i + g * a + t[14], e[15] = l * r + p * i + _ * a + t[15]), e;
}
function Ft(e, t, n) {
	var r = n[0], i = n[1], a = n[2];
	return e[0] = t[0] * r, e[1] = t[1] * r, e[2] = t[2] * r, e[3] = t[3] * r, e[4] = t[4] * i, e[5] = t[5] * i, e[6] = t[6] * i, e[7] = t[7] * i, e[8] = t[8] * a, e[9] = t[9] * a, e[10] = t[10] * a, e[11] = t[11] * a, e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
}
function It(e, t, n, r) {
	var i = r[0], a = r[1], o = r[2], s = Math.sqrt(i * i + a * a + o * o), c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E, D, O, k, A, j;
	return s < 1e-6 ? null : (s = 1 / s, i *= s, a *= s, o *= s, c = Math.sin(n), l = Math.cos(n), u = 1 - l, d = t[0], f = t[1], p = t[2], m = t[3], h = t[4], g = t[5], _ = t[6], v = t[7], y = t[8], b = t[9], x = t[10], S = t[11], C = i * i * u + l, w = a * i * u + o * c, T = o * i * u - a * c, E = i * a * u - o * c, D = a * a * u + l, O = o * a * u + i * c, k = i * o * u + a * c, A = a * o * u - i * c, j = o * o * u + l, e[0] = d * C + h * w + y * T, e[1] = f * C + g * w + b * T, e[2] = p * C + _ * w + x * T, e[3] = m * C + v * w + S * T, e[4] = d * E + h * D + y * O, e[5] = f * E + g * D + b * O, e[6] = p * E + _ * D + x * O, e[7] = m * E + v * D + S * O, e[8] = d * k + h * A + y * j, e[9] = f * k + g * A + b * j, e[10] = p * k + _ * A + x * j, e[11] = m * k + v * A + S * j, t !== e && (e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e);
}
function Lt(e, t, n) {
	var r = Math.sin(n), i = Math.cos(n), a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11];
	return t !== e && (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[4] = a * i + l * r, e[5] = o * i + u * r, e[6] = s * i + d * r, e[7] = c * i + f * r, e[8] = l * i - a * r, e[9] = u * i - o * r, e[10] = d * i - s * r, e[11] = f * i - c * r, e;
}
function Rt(e, t, n) {
	var r = Math.sin(n), i = Math.cos(n), a = t[0], o = t[1], s = t[2], c = t[3], l = t[8], u = t[9], d = t[10], f = t[11];
	return t !== e && (e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = a * i - l * r, e[1] = o * i - u * r, e[2] = s * i - d * r, e[3] = c * i - f * r, e[8] = a * r + l * i, e[9] = o * r + u * i, e[10] = s * r + d * i, e[11] = c * r + f * i, e;
}
function zt(e, t, n) {
	var r = Math.sin(n), i = Math.cos(n), a = t[0], o = t[1], s = t[2], c = t[3], l = t[4], u = t[5], d = t[6], f = t[7];
	return t !== e && (e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = a * i + l * r, e[1] = o * i + u * r, e[2] = s * i + d * r, e[3] = c * i + f * r, e[4] = l * i - a * r, e[5] = u * i - o * r, e[6] = d * i - s * r, e[7] = f * i - c * r, e;
}
function Bt(e, t) {
	return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = t[0], e[13] = t[1], e[14] = t[2], e[15] = 1, e;
}
function Vt(e, t) {
	return e[0] = t[0], e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = t[1], e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = t[2], e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
}
function Ht(e, t, n) {
	var r = n[0], i = n[1], a = n[2], o = Math.sqrt(r * r + i * i + a * a), s, c, l;
	return o < 1e-6 ? null : (o = 1 / o, r *= o, i *= o, a *= o, s = Math.sin(t), c = Math.cos(t), l = 1 - c, e[0] = r * r * l + c, e[1] = i * r * l + a * s, e[2] = a * r * l - i * s, e[3] = 0, e[4] = r * i * l - a * s, e[5] = i * i * l + c, e[6] = a * i * l + r * s, e[7] = 0, e[8] = r * a * l + i * s, e[9] = i * a * l - r * s, e[10] = a * a * l + c, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e);
}
function Ut(e, t) {
	var n = Math.sin(t), r = Math.cos(t);
	return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = r, e[6] = n, e[7] = 0, e[8] = 0, e[9] = -n, e[10] = r, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
}
function Wt(e, t) {
	var n = Math.sin(t), r = Math.cos(t);
	return e[0] = r, e[1] = 0, e[2] = -n, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = n, e[9] = 0, e[10] = r, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
}
function Gt(e, t) {
	var n = Math.sin(t), r = Math.cos(t);
	return e[0] = r, e[1] = n, e[2] = 0, e[3] = 0, e[4] = -n, e[5] = r, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
}
function Kt(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = r + r, c = i + i, l = a + a, u = r * s, d = r * c, f = r * l, p = i * c, m = i * l, h = a * l, g = o * s, _ = o * c, v = o * l;
	return e[0] = 1 - (p + h), e[1] = d + v, e[2] = f - _, e[3] = 0, e[4] = d - v, e[5] = 1 - (u + h), e[6] = m + g, e[7] = 0, e[8] = f + _, e[9] = m - g, e[10] = 1 - (u + p), e[11] = 0, e[12] = n[0], e[13] = n[1], e[14] = n[2], e[15] = 1, e;
}
function qt(e, t) {
	var n = new P(3), r = -t[0], i = -t[1], a = -t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = r * r + i * i + a * a + o * o;
	return d > 0 ? (n[0] = (s * o + u * r + c * a - l * i) * 2 / d, n[1] = (c * o + u * i + l * r - s * a) * 2 / d, n[2] = (l * o + u * a + s * i - c * r) * 2 / d) : (n[0] = (s * o + u * r + c * a - l * i) * 2, n[1] = (c * o + u * i + l * r - s * a) * 2, n[2] = (l * o + u * a + s * i - c * r) * 2), Kt(e, t, n), e;
}
function Jt(e, t) {
	return e[0] = t[12], e[1] = t[13], e[2] = t[14], e;
}
function Yt(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[4], o = t[5], s = t[6], c = t[8], l = t[9], u = t[10];
	return e[0] = Math.sqrt(n * n + r * r + i * i), e[1] = Math.sqrt(a * a + o * o + s * s), e[2] = Math.sqrt(c * c + l * l + u * u), e;
}
function Xt(e, t) {
	var n = new P(3);
	Yt(n, t);
	var r = 1 / n[0], i = 1 / n[1], a = 1 / n[2], o = t[0] * r, s = t[1] * i, c = t[2] * a, l = t[4] * r, u = t[5] * i, d = t[6] * a, f = t[8] * r, p = t[9] * i, m = t[10] * a, h = o + u + m, g = 0;
	return h > 0 ? (g = Math.sqrt(h + 1) * 2, e[3] = .25 * g, e[0] = (d - p) / g, e[1] = (f - c) / g, e[2] = (s - l) / g) : o > u && o > m ? (g = Math.sqrt(1 + o - u - m) * 2, e[3] = (d - p) / g, e[0] = .25 * g, e[1] = (s + l) / g, e[2] = (f + c) / g) : u > m ? (g = Math.sqrt(1 + u - o - m) * 2, e[3] = (f - c) / g, e[0] = (s + l) / g, e[1] = .25 * g, e[2] = (d + p) / g) : (g = Math.sqrt(1 + m - o - u) * 2, e[3] = (s - l) / g, e[0] = (f + c) / g, e[1] = (d + p) / g, e[2] = .25 * g), e;
}
function Zt(e, t, n, r) {
	t[0] = r[12], t[1] = r[13], t[2] = r[14];
	var i = r[0], a = r[1], o = r[2], s = r[4], c = r[5], l = r[6], u = r[8], d = r[9], f = r[10];
	n[0] = Math.sqrt(i * i + a * a + o * o), n[1] = Math.sqrt(s * s + c * c + l * l), n[2] = Math.sqrt(u * u + d * d + f * f);
	var p = 1 / n[0], m = 1 / n[1], h = 1 / n[2], g = i * p, _ = a * m, v = o * h, y = s * p, b = c * m, x = l * h, S = u * p, C = d * m, w = f * h, T = g + b + w, E = 0;
	return T > 0 ? (E = Math.sqrt(T + 1) * 2, e[3] = .25 * E, e[0] = (x - C) / E, e[1] = (S - v) / E, e[2] = (_ - y) / E) : g > b && g > w ? (E = Math.sqrt(1 + g - b - w) * 2, e[3] = (x - C) / E, e[0] = .25 * E, e[1] = (_ + y) / E, e[2] = (S + v) / E) : b > w ? (E = Math.sqrt(1 + b - g - w) * 2, e[3] = (S - v) / E, e[0] = (_ + y) / E, e[1] = .25 * E, e[2] = (x + C) / E) : (E = Math.sqrt(1 + w - g - b) * 2, e[3] = (_ - y) / E, e[0] = (S + v) / E, e[1] = (x + C) / E, e[2] = .25 * E), e;
}
function Qt(e, t, n, r) {
	var i = t[0], a = t[1], o = t[2], s = t[3], c = i + i, l = a + a, u = o + o, d = i * c, f = i * l, p = i * u, m = a * l, h = a * u, g = o * u, _ = s * c, v = s * l, y = s * u, b = r[0], x = r[1], S = r[2];
	return e[0] = (1 - (m + g)) * b, e[1] = (f + y) * b, e[2] = (p - v) * b, e[3] = 0, e[4] = (f - y) * x, e[5] = (1 - (d + g)) * x, e[6] = (h + _) * x, e[7] = 0, e[8] = (p + v) * S, e[9] = (h - _) * S, e[10] = (1 - (d + m)) * S, e[11] = 0, e[12] = n[0], e[13] = n[1], e[14] = n[2], e[15] = 1, e;
}
function $t(e, t, n, r, i) {
	var a = t[0], o = t[1], s = t[2], c = t[3], l = a + a, u = o + o, d = s + s, f = a * l, p = a * u, m = a * d, h = o * u, g = o * d, _ = s * d, v = c * l, y = c * u, b = c * d, x = r[0], S = r[1], C = r[2], w = i[0], T = i[1], E = i[2], D = (1 - (h + _)) * x, O = (p + b) * x, k = (m - y) * x, A = (p - b) * S, j = (1 - (f + _)) * S, M = (g + v) * S, N = (m + y) * C, P = (g - v) * C, F = (1 - (f + h)) * C;
	return e[0] = D, e[1] = O, e[2] = k, e[3] = 0, e[4] = A, e[5] = j, e[6] = M, e[7] = 0, e[8] = N, e[9] = P, e[10] = F, e[11] = 0, e[12] = n[0] + w - (D * w + A * T + N * E), e[13] = n[1] + T - (O * w + j * T + P * E), e[14] = n[2] + E - (k * w + M * T + F * E), e[15] = 1, e;
}
function en(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = n + n, s = r + r, c = i + i, l = n * o, u = r * o, d = r * s, f = i * o, p = i * s, m = i * c, h = a * o, g = a * s, _ = a * c;
	return e[0] = 1 - d - m, e[1] = u + _, e[2] = f - g, e[3] = 0, e[4] = u - _, e[5] = 1 - l - m, e[6] = p + h, e[7] = 0, e[8] = f + g, e[9] = p - h, e[10] = 1 - l - d, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
}
function tn(e, t, n, r, i, a, o) {
	var s = 1 / (n - t), c = 1 / (i - r), l = 1 / (a - o);
	return e[0] = a * 2 * s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = a * 2 * c, e[6] = 0, e[7] = 0, e[8] = (n + t) * s, e[9] = (i + r) * c, e[10] = (o + a) * l, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = o * a * 2 * l, e[15] = 0, e;
}
function nn(e, t, n, r, i) {
	var a = 1 / Math.tan(t / 2);
	if (e[0] = a / n, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = a, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[11] = -1, e[12] = 0, e[13] = 0, e[15] = 0, i != null && i !== Infinity) {
		var o = 1 / (r - i);
		e[10] = (i + r) * o, e[14] = 2 * i * r * o;
	} else e[10] = -1, e[14] = -2 * r;
	return e;
}
var rn = nn;
function an(e, t, n, r, i) {
	var a = 1 / Math.tan(t / 2);
	if (e[0] = a / n, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = a, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[11] = -1, e[12] = 0, e[13] = 0, e[15] = 0, i != null && i !== Infinity) {
		var o = 1 / (r - i);
		e[10] = i * o, e[14] = i * r * o;
	} else e[10] = -1, e[14] = -r;
	return e;
}
function on(e, t, n, r) {
	var i = Math.tan(t.upDegrees * Math.PI / 180), a = Math.tan(t.downDegrees * Math.PI / 180), o = Math.tan(t.leftDegrees * Math.PI / 180), s = Math.tan(t.rightDegrees * Math.PI / 180), c = 2 / (o + s), l = 2 / (i + a);
	return e[0] = c, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = l, e[6] = 0, e[7] = 0, e[8] = -((o - s) * c * .5), e[9] = (i - a) * l * .5, e[10] = r / (n - r), e[11] = -1, e[12] = 0, e[13] = 0, e[14] = r * n / (n - r), e[15] = 0, e;
}
function sn(e, t, n, r, i, a, o) {
	var s = 1 / (t - n), c = 1 / (r - i), l = 1 / (a - o);
	return e[0] = -2 * s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * c, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * l, e[11] = 0, e[12] = (t + n) * s, e[13] = (i + r) * c, e[14] = (o + a) * l, e[15] = 1, e;
}
var cn = sn;
function ln(e, t, n, r, i, a, o) {
	var s = 1 / (t - n), c = 1 / (r - i), l = 1 / (a - o);
	return e[0] = -2 * s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * c, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = l, e[11] = 0, e[12] = (t + n) * s, e[13] = (i + r) * c, e[14] = a * l, e[15] = 1, e;
}
function un(e, t, n, r) {
	var i, a, o, s, c, l, u, d, f, p, m = t[0], h = t[1], g = t[2], _ = r[0], v = r[1], y = r[2], b = n[0], x = n[1], S = n[2];
	return Math.abs(m - b) < 1e-6 && Math.abs(h - x) < 1e-6 && Math.abs(g - S) < 1e-6 ? Ot(e) : (u = m - b, d = h - x, f = g - S, p = 1 / Math.sqrt(u * u + d * d + f * f), u *= p, d *= p, f *= p, i = v * f - y * d, a = y * u - _ * f, o = _ * d - v * u, p = Math.sqrt(i * i + a * a + o * o), p ? (p = 1 / p, i *= p, a *= p, o *= p) : (i = 0, a = 0, o = 0), s = d * o - f * a, c = f * i - u * o, l = u * a - d * i, p = Math.sqrt(s * s + c * c + l * l), p ? (p = 1 / p, s *= p, c *= p, l *= p) : (s = 0, c = 0, l = 0), e[0] = i, e[1] = s, e[2] = u, e[3] = 0, e[4] = a, e[5] = c, e[6] = d, e[7] = 0, e[8] = o, e[9] = l, e[10] = f, e[11] = 0, e[12] = -(i * m + a * h + o * g), e[13] = -(s * m + c * h + l * g), e[14] = -(u * m + d * h + f * g), e[15] = 1, e);
}
function dn(e, t, n, r) {
	var i = t[0], a = t[1], o = t[2], s = r[0], c = r[1], l = r[2], u = i - n[0], d = a - n[1], f = o - n[2], p = u * u + d * d + f * f;
	p > 0 && (p = 1 / Math.sqrt(p), u *= p, d *= p, f *= p);
	var m = c * f - l * d, h = l * u - s * f, g = s * d - c * u;
	return p = m * m + h * h + g * g, p > 0 && (p = 1 / Math.sqrt(p), m *= p, h *= p, g *= p), e[0] = m, e[1] = h, e[2] = g, e[3] = 0, e[4] = d * g - f * h, e[5] = f * m - u * g, e[6] = u * h - d * m, e[7] = 0, e[8] = u, e[9] = d, e[10] = f, e[11] = 0, e[12] = i, e[13] = a, e[14] = o, e[15] = 1, e;
}
function fn(e) {
	return "mat4(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ", " + e[6] + ", " + e[7] + ", " + e[8] + ", " + e[9] + ", " + e[10] + ", " + e[11] + ", " + e[12] + ", " + e[13] + ", " + e[14] + ", " + e[15] + ")";
}
function pn(e) {
	return Math.sqrt(e[0] * e[0] + e[1] * e[1] + e[2] * e[2] + e[3] * e[3] + e[4] * e[4] + e[5] * e[5] + e[6] * e[6] + e[7] * e[7] + e[8] * e[8] + e[9] * e[9] + e[10] * e[10] + e[11] * e[11] + e[12] * e[12] + e[13] * e[13] + e[14] * e[14] + e[15] * e[15]);
}
function mn(e, t, n) {
	return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2], e[3] = t[3] + n[3], e[4] = t[4] + n[4], e[5] = t[5] + n[5], e[6] = t[6] + n[6], e[7] = t[7] + n[7], e[8] = t[8] + n[8], e[9] = t[9] + n[9], e[10] = t[10] + n[10], e[11] = t[11] + n[11], e[12] = t[12] + n[12], e[13] = t[13] + n[13], e[14] = t[14] + n[14], e[15] = t[15] + n[15], e;
}
function hn(e, t, n) {
	return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2], e[3] = t[3] - n[3], e[4] = t[4] - n[4], e[5] = t[5] - n[5], e[6] = t[6] - n[6], e[7] = t[7] - n[7], e[8] = t[8] - n[8], e[9] = t[9] - n[9], e[10] = t[10] - n[10], e[11] = t[11] - n[11], e[12] = t[12] - n[12], e[13] = t[13] - n[13], e[14] = t[14] - n[14], e[15] = t[15] - n[15], e;
}
function gn(e, t, n) {
	return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e[4] = t[4] * n, e[5] = t[5] * n, e[6] = t[6] * n, e[7] = t[7] * n, e[8] = t[8] * n, e[9] = t[9] * n, e[10] = t[10] * n, e[11] = t[11] * n, e[12] = t[12] * n, e[13] = t[13] * n, e[14] = t[14] * n, e[15] = t[15] * n, e;
}
function _n(e, t, n, r) {
	return e[0] = t[0] + n[0] * r, e[1] = t[1] + n[1] * r, e[2] = t[2] + n[2] * r, e[3] = t[3] + n[3] * r, e[4] = t[4] + n[4] * r, e[5] = t[5] + n[5] * r, e[6] = t[6] + n[6] * r, e[7] = t[7] + n[7] * r, e[8] = t[8] + n[8] * r, e[9] = t[9] + n[9] * r, e[10] = t[10] + n[10] * r, e[11] = t[11] + n[11] * r, e[12] = t[12] + n[12] * r, e[13] = t[13] + n[13] * r, e[14] = t[14] + n[14] * r, e[15] = t[15] + n[15] * r, e;
}
function vn(e, t) {
	return e[0] === t[0] && e[1] === t[1] && e[2] === t[2] && e[3] === t[3] && e[4] === t[4] && e[5] === t[5] && e[6] === t[6] && e[7] === t[7] && e[8] === t[8] && e[9] === t[9] && e[10] === t[10] && e[11] === t[11] && e[12] === t[12] && e[13] === t[13] && e[14] === t[14] && e[15] === t[15];
}
function yn(e, t) {
	var n = e[0], r = e[1], i = e[2], a = e[3], o = e[4], s = e[5], c = e[6], l = e[7], u = e[8], d = e[9], f = e[10], p = e[11], m = e[12], h = e[13], g = e[14], _ = e[15], v = t[0], y = t[1], b = t[2], x = t[3], S = t[4], C = t[5], w = t[6], T = t[7], E = t[8], D = t[9], O = t[10], k = t[11], A = t[12], j = t[13], M = t[14], N = t[15];
	return Math.abs(n - v) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(r - y) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(y)) && Math.abs(i - b) <= 1e-6 * Math.max(1, Math.abs(i), Math.abs(b)) && Math.abs(a - x) <= 1e-6 * Math.max(1, Math.abs(a), Math.abs(x)) && Math.abs(o - S) <= 1e-6 * Math.max(1, Math.abs(o), Math.abs(S)) && Math.abs(s - C) <= 1e-6 * Math.max(1, Math.abs(s), Math.abs(C)) && Math.abs(c - w) <= 1e-6 * Math.max(1, Math.abs(c), Math.abs(w)) && Math.abs(l - T) <= 1e-6 * Math.max(1, Math.abs(l), Math.abs(T)) && Math.abs(u - E) <= 1e-6 * Math.max(1, Math.abs(u), Math.abs(E)) && Math.abs(d - D) <= 1e-6 * Math.max(1, Math.abs(d), Math.abs(D)) && Math.abs(f - O) <= 1e-6 * Math.max(1, Math.abs(f), Math.abs(O)) && Math.abs(p - k) <= 1e-6 * Math.max(1, Math.abs(p), Math.abs(k)) && Math.abs(m - A) <= 1e-6 * Math.max(1, Math.abs(m), Math.abs(A)) && Math.abs(h - j) <= 1e-6 * Math.max(1, Math.abs(h), Math.abs(j)) && Math.abs(g - M) <= 1e-6 * Math.max(1, Math.abs(g), Math.abs(M)) && Math.abs(_ - N) <= 1e-6 * Math.max(1, Math.abs(_), Math.abs(N));
}
var bn = Nt, xn = hn, Sn = /* @__PURE__ */ s({
	add: () => kn,
	angle: () => ar,
	bezier: () => Zn,
	ceil: () => Nn,
	clone: () => wn,
	copy: () => Dn,
	create: () => Cn,
	cross: () => qn,
	dist: () => pr,
	distance: () => Bn,
	div: () => fr,
	divide: () => Mn,
	dot: () => Kn,
	equals: () => lr,
	exactEquals: () => cr,
	floor: () => Pn,
	forEach: () => _r,
	fromValues: () => En,
	hermite: () => Xn,
	inverse: () => Wn,
	len: () => hr,
	length: () => Tn,
	lerp: () => Jn,
	max: () => In,
	min: () => Fn,
	mul: () => dr,
	multiply: () => jn,
	negate: () => Un,
	normalize: () => Gn,
	random: () => Qn,
	rotateX: () => nr,
	rotateY: () => rr,
	rotateZ: () => ir,
	round: () => Ln,
	scale: () => Rn,
	scaleAndAdd: () => zn,
	set: () => On,
	slerp: () => Yn,
	sqrDist: () => mr,
	sqrLen: () => gr,
	squaredDistance: () => Vn,
	squaredLength: () => Hn,
	str: () => sr,
	sub: () => ur,
	subtract: () => An,
	transformMat3: () => er,
	transformMat4: () => $n,
	transformQuat: () => tr,
	zero: () => or
});
function Cn() {
	var e = new P(3);
	return P != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0), e;
}
function wn(e) {
	var t = new P(3);
	return t[0] = e[0], t[1] = e[1], t[2] = e[2], t;
}
function Tn(e) {
	var t = e[0], n = e[1], r = e[2];
	return Math.sqrt(t * t + n * n + r * r);
}
function En(e, t, n) {
	var r = new P(3);
	return r[0] = e, r[1] = t, r[2] = n, r;
}
function Dn(e, t) {
	return e[0] = t[0], e[1] = t[1], e[2] = t[2], e;
}
function On(e, t, n, r) {
	return e[0] = t, e[1] = n, e[2] = r, e;
}
function kn(e, t, n) {
	return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2], e;
}
function An(e, t, n) {
	return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2], e;
}
function jn(e, t, n) {
	return e[0] = t[0] * n[0], e[1] = t[1] * n[1], e[2] = t[2] * n[2], e;
}
function Mn(e, t, n) {
	return e[0] = t[0] / n[0], e[1] = t[1] / n[1], e[2] = t[2] / n[2], e;
}
function Nn(e, t) {
	return e[0] = Math.ceil(t[0]), e[1] = Math.ceil(t[1]), e[2] = Math.ceil(t[2]), e;
}
function Pn(e, t) {
	return e[0] = Math.floor(t[0]), e[1] = Math.floor(t[1]), e[2] = Math.floor(t[2]), e;
}
function Fn(e, t, n) {
	return e[0] = Math.min(t[0], n[0]), e[1] = Math.min(t[1], n[1]), e[2] = Math.min(t[2], n[2]), e;
}
function In(e, t, n) {
	return e[0] = Math.max(t[0], n[0]), e[1] = Math.max(t[1], n[1]), e[2] = Math.max(t[2], n[2]), e;
}
function Ln(e, t) {
	return e[0] = I(t[0]), e[1] = I(t[1]), e[2] = I(t[2]), e;
}
function Rn(e, t, n) {
	return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e;
}
function zn(e, t, n, r) {
	return e[0] = t[0] + n[0] * r, e[1] = t[1] + n[1] * r, e[2] = t[2] + n[2] * r, e;
}
function Bn(e, t) {
	var n = t[0] - e[0], r = t[1] - e[1], i = t[2] - e[2];
	return Math.sqrt(n * n + r * r + i * i);
}
function Vn(e, t) {
	var n = t[0] - e[0], r = t[1] - e[1], i = t[2] - e[2];
	return n * n + r * r + i * i;
}
function Hn(e) {
	var t = e[0], n = e[1], r = e[2];
	return t * t + n * n + r * r;
}
function Un(e, t) {
	return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e;
}
function Wn(e, t) {
	return e[0] = 1 / t[0], e[1] = 1 / t[1], e[2] = 1 / t[2], e;
}
function Gn(e, t) {
	var n = t[0], r = t[1], i = t[2], a = n * n + r * r + i * i;
	return a > 0 && (a = 1 / Math.sqrt(a)), e[0] = t[0] * a, e[1] = t[1] * a, e[2] = t[2] * a, e;
}
function Kn(e, t) {
	return e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
}
function qn(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = n[0], s = n[1], c = n[2];
	return e[0] = i * c - a * s, e[1] = a * o - r * c, e[2] = r * s - i * o, e;
}
function Jn(e, t, n, r) {
	var i = t[0], a = t[1], o = t[2];
	return e[0] = i + r * (n[0] - i), e[1] = a + r * (n[1] - a), e[2] = o + r * (n[2] - o), e;
}
function Yn(e, t, n, r) {
	var i = Math.acos(Math.min(Math.max(Kn(t, n), -1), 1)), a = Math.sin(i), o = Math.sin((1 - r) * i) / a, s = Math.sin(r * i) / a;
	return e[0] = o * t[0] + s * n[0], e[1] = o * t[1] + s * n[1], e[2] = o * t[2] + s * n[2], e;
}
function Xn(e, t, n, r, i, a) {
	var o = a * a, s = o * (2 * a - 3) + 1, c = o * (a - 2) + a, l = o * (a - 1), u = o * (3 - 2 * a);
	return e[0] = t[0] * s + n[0] * c + r[0] * l + i[0] * u, e[1] = t[1] * s + n[1] * c + r[1] * l + i[1] * u, e[2] = t[2] * s + n[2] * c + r[2] * l + i[2] * u, e;
}
function Zn(e, t, n, r, i, a) {
	var o = 1 - a, s = o * o, c = a * a, l = s * o, u = 3 * a * s, d = 3 * c * o, f = c * a;
	return e[0] = t[0] * l + n[0] * u + r[0] * d + i[0] * f, e[1] = t[1] * l + n[1] * u + r[1] * d + i[1] * f, e[2] = t[2] * l + n[2] * u + r[2] * d + i[2] * f, e;
}
function Qn(e, t) {
	t = t === void 0 ? 1 : t;
	var n = F() * 2 * Math.PI, r = F() * 2 - 1, i = Math.sqrt(1 - r * r) * t;
	return e[0] = Math.cos(n) * i, e[1] = Math.sin(n) * i, e[2] = r * t, e;
}
function $n(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = n[3] * r + n[7] * i + n[11] * a + n[15];
	return o ||= 1, e[0] = (n[0] * r + n[4] * i + n[8] * a + n[12]) / o, e[1] = (n[1] * r + n[5] * i + n[9] * a + n[13]) / o, e[2] = (n[2] * r + n[6] * i + n[10] * a + n[14]) / o, e;
}
function er(e, t, n) {
	var r = t[0], i = t[1], a = t[2];
	return e[0] = r * n[0] + i * n[3] + a * n[6], e[1] = r * n[1] + i * n[4] + a * n[7], e[2] = r * n[2] + i * n[5] + a * n[8], e;
}
function tr(e, t, n) {
	var r = n[0], i = n[1], a = n[2], o = n[3], s = t[0], c = t[1], l = t[2], u = i * l - a * c, d = a * s - r * l, f = r * c - i * s;
	return u += u, d += d, f += f, e[0] = s + o * u + i * f - a * d, e[1] = c + o * d + a * u - r * f, e[2] = l + o * f + r * d - i * u, e;
}
function nr(e, t, n, r) {
	var i = [], a = [];
	return i[0] = t[0] - n[0], i[1] = t[1] - n[1], i[2] = t[2] - n[2], a[0] = i[0], a[1] = i[1] * Math.cos(r) - i[2] * Math.sin(r), a[2] = i[1] * Math.sin(r) + i[2] * Math.cos(r), e[0] = a[0] + n[0], e[1] = a[1] + n[1], e[2] = a[2] + n[2], e;
}
function rr(e, t, n, r) {
	var i = [], a = [];
	return i[0] = t[0] - n[0], i[1] = t[1] - n[1], i[2] = t[2] - n[2], a[0] = i[2] * Math.sin(r) + i[0] * Math.cos(r), a[1] = i[1], a[2] = i[2] * Math.cos(r) - i[0] * Math.sin(r), e[0] = a[0] + n[0], e[1] = a[1] + n[1], e[2] = a[2] + n[2], e;
}
function ir(e, t, n, r) {
	var i = [], a = [];
	return i[0] = t[0] - n[0], i[1] = t[1] - n[1], i[2] = t[2] - n[2], a[0] = i[0] * Math.cos(r) - i[1] * Math.sin(r), a[1] = i[0] * Math.sin(r) + i[1] * Math.cos(r), a[2] = i[2], e[0] = a[0] + n[0], e[1] = a[1] + n[1], e[2] = a[2] + n[2], e;
}
function ar(e, t) {
	var n = e[0], r = e[1], i = e[2], a = t[0], o = t[1], s = t[2], c = Math.sqrt((n * n + r * r + i * i) * (a * a + o * o + s * s)), l = c && Kn(e, t) / c;
	return Math.acos(Math.min(Math.max(l, -1), 1));
}
function or(e) {
	return e[0] = 0, e[1] = 0, e[2] = 0, e;
}
function sr(e) {
	return "vec3(" + e[0] + ", " + e[1] + ", " + e[2] + ")";
}
function cr(e, t) {
	return e[0] === t[0] && e[1] === t[1] && e[2] === t[2];
}
function lr(e, t) {
	var n = e[0], r = e[1], i = e[2], a = t[0], o = t[1], s = t[2];
	return Math.abs(n - a) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(a)) && Math.abs(r - o) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(o)) && Math.abs(i - s) <= 1e-6 * Math.max(1, Math.abs(i), Math.abs(s));
}
var ur = An, dr = jn, fr = Mn, pr = Bn, mr = Vn, hr = Tn, gr = Hn, _r = function() {
	var e = Cn();
	return function(t, n, r, i, a, o) {
		var s, c;
		for (n ||= 3, r ||= 0, c = i ? Math.min(i * n + r, t.length) : t.length, s = r; s < c; s += n) e[0] = t[s], e[1] = t[s + 1], e[2] = t[s + 2], a(e, e, o), t[s] = e[0], t[s + 1] = e[1], t[s + 2] = e[2];
		return t;
	};
}(), vr = /* @__PURE__ */ s({
	add: () => wr,
	ceil: () => Or,
	clone: () => br,
	copy: () => Sr,
	create: () => yr,
	cross: () => Ur,
	dist: () => ti,
	distance: () => Fr,
	div: () => ei,
	divide: () => Dr,
	dot: () => Hr,
	equals: () => Zr,
	exactEquals: () => Xr,
	floor: () => kr,
	forEach: () => ai,
	fromValues: () => xr,
	inverse: () => Br,
	len: () => ri,
	length: () => Lr,
	lerp: () => Wr,
	max: () => jr,
	min: () => Ar,
	mul: () => $r,
	multiply: () => Er,
	negate: () => zr,
	normalize: () => Vr,
	random: () => Gr,
	round: () => Mr,
	scale: () => Nr,
	scaleAndAdd: () => Pr,
	set: () => Cr,
	sqrDist: () => ni,
	sqrLen: () => ii,
	squaredDistance: () => Ir,
	squaredLength: () => Rr,
	str: () => Yr,
	sub: () => Qr,
	subtract: () => Tr,
	transformMat4: () => Kr,
	transformQuat: () => qr,
	zero: () => Jr
});
function yr() {
	var e = new P(4);
	return P != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0), e;
}
function br(e) {
	var t = new P(4);
	return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t;
}
function xr(e, t, n, r) {
	var i = new P(4);
	return i[0] = e, i[1] = t, i[2] = n, i[3] = r, i;
}
function Sr(e, t) {
	return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e;
}
function Cr(e, t, n, r, i) {
	return e[0] = t, e[1] = n, e[2] = r, e[3] = i, e;
}
function wr(e, t, n) {
	return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2], e[3] = t[3] + n[3], e;
}
function Tr(e, t, n) {
	return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2], e[3] = t[3] - n[3], e;
}
function Er(e, t, n) {
	return e[0] = t[0] * n[0], e[1] = t[1] * n[1], e[2] = t[2] * n[2], e[3] = t[3] * n[3], e;
}
function Dr(e, t, n) {
	return e[0] = t[0] / n[0], e[1] = t[1] / n[1], e[2] = t[2] / n[2], e[3] = t[3] / n[3], e;
}
function Or(e, t) {
	return e[0] = Math.ceil(t[0]), e[1] = Math.ceil(t[1]), e[2] = Math.ceil(t[2]), e[3] = Math.ceil(t[3]), e;
}
function kr(e, t) {
	return e[0] = Math.floor(t[0]), e[1] = Math.floor(t[1]), e[2] = Math.floor(t[2]), e[3] = Math.floor(t[3]), e;
}
function Ar(e, t, n) {
	return e[0] = Math.min(t[0], n[0]), e[1] = Math.min(t[1], n[1]), e[2] = Math.min(t[2], n[2]), e[3] = Math.min(t[3], n[3]), e;
}
function jr(e, t, n) {
	return e[0] = Math.max(t[0], n[0]), e[1] = Math.max(t[1], n[1]), e[2] = Math.max(t[2], n[2]), e[3] = Math.max(t[3], n[3]), e;
}
function Mr(e, t) {
	return e[0] = I(t[0]), e[1] = I(t[1]), e[2] = I(t[2]), e[3] = I(t[3]), e;
}
function Nr(e, t, n) {
	return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e;
}
function Pr(e, t, n, r) {
	return e[0] = t[0] + n[0] * r, e[1] = t[1] + n[1] * r, e[2] = t[2] + n[2] * r, e[3] = t[3] + n[3] * r, e;
}
function Fr(e, t) {
	var n = t[0] - e[0], r = t[1] - e[1], i = t[2] - e[2], a = t[3] - e[3];
	return Math.sqrt(n * n + r * r + i * i + a * a);
}
function Ir(e, t) {
	var n = t[0] - e[0], r = t[1] - e[1], i = t[2] - e[2], a = t[3] - e[3];
	return n * n + r * r + i * i + a * a;
}
function Lr(e) {
	var t = e[0], n = e[1], r = e[2], i = e[3];
	return Math.sqrt(t * t + n * n + r * r + i * i);
}
function Rr(e) {
	var t = e[0], n = e[1], r = e[2], i = e[3];
	return t * t + n * n + r * r + i * i;
}
function zr(e, t) {
	return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e[3] = -t[3], e;
}
function Br(e, t) {
	return e[0] = 1 / t[0], e[1] = 1 / t[1], e[2] = 1 / t[2], e[3] = 1 / t[3], e;
}
function Vr(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = n * n + r * r + i * i + a * a;
	return o > 0 && (o = 1 / Math.sqrt(o)), e[0] = n * o, e[1] = r * o, e[2] = i * o, e[3] = a * o, e;
}
function Hr(e, t) {
	return e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3] * t[3];
}
function Ur(e, t, n, r) {
	var i = n[0] * r[1] - n[1] * r[0], a = n[0] * r[2] - n[2] * r[0], o = n[0] * r[3] - n[3] * r[0], s = n[1] * r[2] - n[2] * r[1], c = n[1] * r[3] - n[3] * r[1], l = n[2] * r[3] - n[3] * r[2], u = t[0], d = t[1], f = t[2], p = t[3];
	return e[0] = d * l - f * c + p * s, e[1] = -(u * l) + f * o - p * a, e[2] = u * c - d * o + p * i, e[3] = -(u * s) + d * a - f * i, e;
}
function Wr(e, t, n, r) {
	var i = t[0], a = t[1], o = t[2], s = t[3];
	return e[0] = i + r * (n[0] - i), e[1] = a + r * (n[1] - a), e[2] = o + r * (n[2] - o), e[3] = s + r * (n[3] - s), e;
}
function Gr(e, t) {
	t = t === void 0 ? 1 : t;
	var n, r, i, a, o, s, c = F();
	n = c * 2 - 1, r = (4 * F() - 2) * Math.sqrt(c * -c + c), o = n * n + r * r, c = F(), i = c * 2 - 1, a = (4 * F() - 2) * Math.sqrt(c * -c + c), s = i * i + a * a;
	var l = Math.sqrt((1 - o) / s);
	return e[0] = t * n, e[1] = t * r, e[2] = t * i * l, e[3] = t * a * l, e;
}
function Kr(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3];
	return e[0] = n[0] * r + n[4] * i + n[8] * a + n[12] * o, e[1] = n[1] * r + n[5] * i + n[9] * a + n[13] * o, e[2] = n[2] * r + n[6] * i + n[10] * a + n[14] * o, e[3] = n[3] * r + n[7] * i + n[11] * a + n[15] * o, e;
}
function qr(e, t, n) {
	var r = n[0], i = n[1], a = n[2], o = n[3], s = t[0], c = t[1], l = t[2], u = i * l - a * c, d = a * s - r * l, f = r * c - i * s;
	return u += u, d += d, f += f, e[0] = s + o * u + i * f - a * d, e[1] = c + o * d + a * u - r * f, e[2] = l + o * f + r * d - i * u, e[3] = t[3], e;
}
function Jr(e) {
	return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0, e;
}
function Yr(e) {
	return "vec4(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ")";
}
function Xr(e, t) {
	return e[0] === t[0] && e[1] === t[1] && e[2] === t[2] && e[3] === t[3];
}
function Zr(e, t) {
	var n = e[0], r = e[1], i = e[2], a = e[3], o = t[0], s = t[1], c = t[2], l = t[3];
	return Math.abs(n - o) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(r - s) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(s)) && Math.abs(i - c) <= 1e-6 * Math.max(1, Math.abs(i), Math.abs(c)) && Math.abs(a - l) <= 1e-6 * Math.max(1, Math.abs(a), Math.abs(l));
}
var Qr = Tr, $r = Er, ei = Dr, ti = Fr, ni = Ir, ri = Lr, ii = Rr, ai = function() {
	var e = yr();
	return function(t, n, r, i, a, o) {
		var s, c;
		for (n ||= 4, r ||= 0, c = i ? Math.min(i * n + r, t.length) : t.length, s = r; s < c; s += n) e[0] = t[s], e[1] = t[s + 1], e[2] = t[s + 2], e[3] = t[s + 3], a(e, e, o), t[s] = e[0], t[s + 1] = e[1], t[s + 2] = e[2], t[s + 3] = e[3];
		return t;
	};
}(), oi = /* @__PURE__ */ s({
	add: () => ji,
	calculateW: () => gi,
	clone: () => Di,
	conjugate: () => Ci,
	copy: () => ki,
	create: () => si,
	dot: () => Pi,
	equals: () => Hi,
	exactEquals: () => Vi,
	exp: () => _i,
	fromEuler: () => Ti,
	fromMat3: () => wi,
	fromValues: () => Oi,
	getAngle: () => di,
	getAxisAngle: () => ui,
	identity: () => ci,
	invert: () => Si,
	len: () => Li,
	length: () => Ii,
	lerp: () => Fi,
	ln: () => vi,
	mul: () => Mi,
	multiply: () => fi,
	normalize: () => Bi,
	pow: () => yi,
	random: () => xi,
	rotateX: () => pi,
	rotateY: () => mi,
	rotateZ: () => hi,
	rotationTo: () => Ui,
	scale: () => Ni,
	set: () => Ai,
	setAxes: () => Gi,
	setAxisAngle: () => li,
	slerp: () => bi,
	sqlerp: () => Wi,
	sqrLen: () => zi,
	squaredLength: () => Ri,
	str: () => Ei
});
function si() {
	var e = new P(4);
	return P != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0), e[3] = 1, e;
}
function ci(e) {
	return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 1, e;
}
function li(e, t, n) {
	n *= .5;
	var r = Math.sin(n);
	return e[0] = r * t[0], e[1] = r * t[1], e[2] = r * t[2], e[3] = Math.cos(n), e;
}
function ui(e, t) {
	var n = Math.acos(t[3]) * 2, r = Math.sin(n / 2);
	return r > 1e-6 ? (e[0] = t[0] / r, e[1] = t[1] / r, e[2] = t[2] / r) : (e[0] = 1, e[1] = 0, e[2] = 0), n;
}
function di(e, t) {
	var n = Pi(e, t);
	return Math.acos(2 * n * n - 1);
}
function fi(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = n[0], c = n[1], l = n[2], u = n[3];
	return e[0] = r * u + o * s + i * l - a * c, e[1] = i * u + o * c + a * s - r * l, e[2] = a * u + o * l + r * c - i * s, e[3] = o * u - r * s - i * c - a * l, e;
}
function pi(e, t, n) {
	n *= .5;
	var r = t[0], i = t[1], a = t[2], o = t[3], s = Math.sin(n), c = Math.cos(n);
	return e[0] = r * c + o * s, e[1] = i * c + a * s, e[2] = a * c - i * s, e[3] = o * c - r * s, e;
}
function mi(e, t, n) {
	n *= .5;
	var r = t[0], i = t[1], a = t[2], o = t[3], s = Math.sin(n), c = Math.cos(n);
	return e[0] = r * c - a * s, e[1] = i * c + o * s, e[2] = a * c + r * s, e[3] = o * c - i * s, e;
}
function hi(e, t, n) {
	n *= .5;
	var r = t[0], i = t[1], a = t[2], o = t[3], s = Math.sin(n), c = Math.cos(n);
	return e[0] = r * c + i * s, e[1] = i * c - r * s, e[2] = a * c + o * s, e[3] = o * c - a * s, e;
}
function gi(e, t) {
	var n = t[0], r = t[1], i = t[2];
	return e[0] = n, e[1] = r, e[2] = i, e[3] = Math.sqrt(Math.abs(1 - n * n - r * r - i * i)), e;
}
function _i(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = Math.sqrt(n * n + r * r + i * i), s = Math.exp(a), c = o > 0 ? s * Math.sin(o) / o : 0;
	return e[0] = n * c, e[1] = r * c, e[2] = i * c, e[3] = s * Math.cos(o), e;
}
function vi(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = Math.sqrt(n * n + r * r + i * i), s = o > 0 ? Math.atan2(o, a) / o : 0;
	return e[0] = n * s, e[1] = r * s, e[2] = i * s, e[3] = .5 * Math.log(n * n + r * r + i * i + a * a), e;
}
function yi(e, t, n) {
	return vi(e, t), Ni(e, e, n), _i(e, e), e;
}
function bi(e, t, n, r) {
	var i = t[0], a = t[1], o = t[2], s = t[3], c = n[0], l = n[1], u = n[2], d = n[3], f, p = i * c + a * l + o * u + s * d, m, h, g;
	return p < 0 && (p = -p, c = -c, l = -l, u = -u, d = -d), 1 - p > 1e-6 ? (f = Math.acos(p), m = Math.sin(f), h = Math.sin((1 - r) * f) / m, g = Math.sin(r * f) / m) : (h = 1 - r, g = r), e[0] = h * i + g * c, e[1] = h * a + g * l, e[2] = h * o + g * u, e[3] = h * s + g * d, e;
}
function xi(e) {
	var t = F(), n = F(), r = F(), i = Math.sqrt(1 - t), a = Math.sqrt(t);
	return e[0] = i * Math.sin(2 * Math.PI * n), e[1] = i * Math.cos(2 * Math.PI * n), e[2] = a * Math.sin(2 * Math.PI * r), e[3] = a * Math.cos(2 * Math.PI * r), e;
}
function Si(e, t) {
	var n = t[0], r = t[1], i = t[2], a = t[3], o = n * n + r * r + i * i + a * a, s = o ? 1 / o : 0;
	return e[0] = -n * s, e[1] = -r * s, e[2] = -i * s, e[3] = a * s, e;
}
function Ci(e, t) {
	return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e[3] = t[3], e;
}
function wi(e, t) {
	var n = t[0] + t[4] + t[8], r;
	if (n > 0) r = Math.sqrt(n + 1), e[3] = .5 * r, r = .5 / r, e[0] = (t[5] - t[7]) * r, e[1] = (t[6] - t[2]) * r, e[2] = (t[1] - t[3]) * r;
	else {
		var i = 0;
		t[4] > t[0] && (i = 1), t[8] > t[i * 3 + i] && (i = 2);
		var a = (i + 1) % 3, o = (i + 2) % 3;
		r = Math.sqrt(t[i * 3 + i] - t[a * 3 + a] - t[o * 3 + o] + 1), e[i] = .5 * r, r = .5 / r, e[3] = (t[a * 3 + o] - t[o * 3 + a]) * r, e[a] = (t[a * 3 + i] + t[i * 3 + a]) * r, e[o] = (t[o * 3 + i] + t[i * 3 + o]) * r;
	}
	return e;
}
function Ti(e, t, n, r) {
	var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "zyx", a = Math.PI / 360;
	t *= a, r *= a, n *= a;
	var o = Math.sin(t), s = Math.cos(t), c = Math.sin(n), l = Math.cos(n), u = Math.sin(r), d = Math.cos(r);
	switch (i) {
		case "xyz":
			e[0] = o * l * d + s * c * u, e[1] = s * c * d - o * l * u, e[2] = s * l * u + o * c * d, e[3] = s * l * d - o * c * u;
			break;
		case "xzy":
			e[0] = o * l * d - s * c * u, e[1] = s * c * d - o * l * u, e[2] = s * l * u + o * c * d, e[3] = s * l * d + o * c * u;
			break;
		case "yxz":
			e[0] = o * l * d + s * c * u, e[1] = s * c * d - o * l * u, e[2] = s * l * u - o * c * d, e[3] = s * l * d + o * c * u;
			break;
		case "yzx":
			e[0] = o * l * d + s * c * u, e[1] = s * c * d + o * l * u, e[2] = s * l * u - o * c * d, e[3] = s * l * d - o * c * u;
			break;
		case "zxy":
			e[0] = o * l * d - s * c * u, e[1] = s * c * d + o * l * u, e[2] = s * l * u + o * c * d, e[3] = s * l * d - o * c * u;
			break;
		case "zyx":
			e[0] = o * l * d - s * c * u, e[1] = s * c * d + o * l * u, e[2] = s * l * u - o * c * d, e[3] = s * l * d + o * c * u;
			break;
		default: throw Error("Unknown angle order " + i);
	}
	return e;
}
function Ei(e) {
	return "quat(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ")";
}
var Di = br, Oi = xr, ki = Sr, Ai = Cr, ji = wr, Mi = fi, Ni = Nr, Pi = Hr, Fi = Wr, Ii = Lr, Li = Ii, Ri = Rr, zi = Ri, Bi = Vr, Vi = Xr;
function Hi(e, t) {
	return Math.abs(Hr(e, t)) >= 1 - N;
}
var Ui = function() {
	var e = Cn(), t = En(1, 0, 0), n = En(0, 1, 0);
	return function(r, i, a) {
		var o = Kn(i, a);
		return o < -.999999 ? (qn(e, t, i), hr(e) < 1e-6 && qn(e, n, i), Gn(e, e), li(r, e, Math.PI), r) : o > .999999 ? (r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 1, r) : (qn(e, i, a), r[0] = e[0], r[1] = e[1], r[2] = e[2], r[3] = 1 + o, Bi(r, r));
	};
}(), Wi = function() {
	var e = si(), t = si();
	return function(n, r, i, a, o, s) {
		return bi(e, r, o, s), bi(t, i, a, s), bi(n, e, t, 2 * s * (1 - s)), n;
	};
}(), Gi = function() {
	var e = Ke();
	return function(t, n, r, i) {
		return e[0] = r[0], e[3] = r[1], e[6] = r[2], e[1] = i[0], e[4] = i[1], e[7] = i[2], e[2] = -n[0], e[5] = -n[1], e[8] = -n[2], Bi(t, wi(t, e));
	};
}(), Ki = /* @__PURE__ */ s({
	add: () => ga,
	clone: () => Ji,
	conjugate: () => Ca,
	copy: () => ta,
	create: () => qi,
	dot: () => ba,
	equals: () => ja,
	exactEquals: () => Aa,
	fromMat4: () => ea,
	fromRotation: () => $i,
	fromRotationTranslation: () => Zi,
	fromRotationTranslationValues: () => Xi,
	fromTranslation: () => Qi,
	fromValues: () => Yi,
	getDual: () => aa,
	getReal: () => ia,
	getTranslation: () => ca,
	identity: () => na,
	invert: () => Sa,
	len: () => Ta,
	length: () => wa,
	lerp: () => xa,
	mul: () => va,
	multiply: () => _a,
	normalize: () => Oa,
	rotateAroundAxis: () => ha,
	rotateByQuatAppend: () => pa,
	rotateByQuatPrepend: () => ma,
	rotateX: () => ua,
	rotateY: () => da,
	rotateZ: () => fa,
	scale: () => ya,
	set: () => ra,
	setDual: () => sa,
	setReal: () => oa,
	sqrLen: () => Da,
	squaredLength: () => Ea,
	str: () => ka,
	translate: () => la
});
function qi() {
	var e = new P(8);
	return P != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0, e[4] = 0, e[5] = 0, e[6] = 0, e[7] = 0), e[3] = 1, e;
}
function Ji(e) {
	var t = new P(8);
	return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t;
}
function Yi(e, t, n, r, i, a, o, s) {
	var c = new P(8);
	return c[0] = e, c[1] = t, c[2] = n, c[3] = r, c[4] = i, c[5] = a, c[6] = o, c[7] = s, c;
}
function Xi(e, t, n, r, i, a, o) {
	var s = new P(8);
	s[0] = e, s[1] = t, s[2] = n, s[3] = r;
	var c = i * .5, l = a * .5, u = o * .5;
	return s[4] = c * r + l * n - u * t, s[5] = l * r + u * e - c * n, s[6] = u * r + c * t - l * e, s[7] = -c * e - l * t - u * n, s;
}
function Zi(e, t, n) {
	var r = n[0] * .5, i = n[1] * .5, a = n[2] * .5, o = t[0], s = t[1], c = t[2], l = t[3];
	return e[0] = o, e[1] = s, e[2] = c, e[3] = l, e[4] = r * l + i * c - a * s, e[5] = i * l + a * o - r * c, e[6] = a * l + r * s - i * o, e[7] = -r * o - i * s - a * c, e;
}
function Qi(e, t) {
	return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 1, e[4] = t[0] * .5, e[5] = t[1] * .5, e[6] = t[2] * .5, e[7] = 0, e;
}
function $i(e, t) {
	return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = 0, e[5] = 0, e[6] = 0, e[7] = 0, e;
}
function ea(e, t) {
	var n = si();
	Xt(n, t);
	var r = new P(3);
	return Jt(r, t), Zi(e, n, r), e;
}
function ta(e, t) {
	return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e;
}
function na(e) {
	return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 1, e[4] = 0, e[5] = 0, e[6] = 0, e[7] = 0, e;
}
function ra(e, t, n, r, i, a, o, s, c) {
	return e[0] = t, e[1] = n, e[2] = r, e[3] = i, e[4] = a, e[5] = o, e[6] = s, e[7] = c, e;
}
var ia = ki;
function aa(e, t) {
	return e[0] = t[4], e[1] = t[5], e[2] = t[6], e[3] = t[7], e;
}
var oa = ki;
function sa(e, t) {
	return e[4] = t[0], e[5] = t[1], e[6] = t[2], e[7] = t[3], e;
}
function ca(e, t) {
	var n = t[4], r = t[5], i = t[6], a = t[7], o = -t[0], s = -t[1], c = -t[2], l = t[3];
	return e[0] = (n * l + a * o + r * c - i * s) * 2, e[1] = (r * l + a * s + i * o - n * c) * 2, e[2] = (i * l + a * c + n * s - r * o) * 2, e;
}
function la(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = n[0] * .5, c = n[1] * .5, l = n[2] * .5, u = t[4], d = t[5], f = t[6], p = t[7];
	return e[0] = r, e[1] = i, e[2] = a, e[3] = o, e[4] = o * s + i * l - a * c + u, e[5] = o * c + a * s - r * l + d, e[6] = o * l + r * c - i * s + f, e[7] = -r * s - i * c - a * l + p, e;
}
function ua(e, t, n) {
	var r = -t[0], i = -t[1], a = -t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = s * o + u * r + c * a - l * i, f = c * o + u * i + l * r - s * a, p = l * o + u * a + s * i - c * r, m = u * o - s * r - c * i - l * a;
	return pi(e, t, n), r = e[0], i = e[1], a = e[2], o = e[3], e[4] = d * o + m * r + f * a - p * i, e[5] = f * o + m * i + p * r - d * a, e[6] = p * o + m * a + d * i - f * r, e[7] = m * o - d * r - f * i - p * a, e;
}
function da(e, t, n) {
	var r = -t[0], i = -t[1], a = -t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = s * o + u * r + c * a - l * i, f = c * o + u * i + l * r - s * a, p = l * o + u * a + s * i - c * r, m = u * o - s * r - c * i - l * a;
	return mi(e, t, n), r = e[0], i = e[1], a = e[2], o = e[3], e[4] = d * o + m * r + f * a - p * i, e[5] = f * o + m * i + p * r - d * a, e[6] = p * o + m * a + d * i - f * r, e[7] = m * o - d * r - f * i - p * a, e;
}
function fa(e, t, n) {
	var r = -t[0], i = -t[1], a = -t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = s * o + u * r + c * a - l * i, f = c * o + u * i + l * r - s * a, p = l * o + u * a + s * i - c * r, m = u * o - s * r - c * i - l * a;
	return hi(e, t, n), r = e[0], i = e[1], a = e[2], o = e[3], e[4] = d * o + m * r + f * a - p * i, e[5] = f * o + m * i + p * r - d * a, e[6] = p * o + m * a + d * i - f * r, e[7] = m * o - d * r - f * i - p * a, e;
}
function pa(e, t, n) {
	var r = n[0], i = n[1], a = n[2], o = n[3], s = t[0], c = t[1], l = t[2], u = t[3];
	return e[0] = s * o + u * r + c * a - l * i, e[1] = c * o + u * i + l * r - s * a, e[2] = l * o + u * a + s * i - c * r, e[3] = u * o - s * r - c * i - l * a, s = t[4], c = t[5], l = t[6], u = t[7], e[4] = s * o + u * r + c * a - l * i, e[5] = c * o + u * i + l * r - s * a, e[6] = l * o + u * a + s * i - c * r, e[7] = u * o - s * r - c * i - l * a, e;
}
function ma(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = n[0], c = n[1], l = n[2], u = n[3];
	return e[0] = r * u + o * s + i * l - a * c, e[1] = i * u + o * c + a * s - r * l, e[2] = a * u + o * l + r * c - i * s, e[3] = o * u - r * s - i * c - a * l, s = n[4], c = n[5], l = n[6], u = n[7], e[4] = r * u + o * s + i * l - a * c, e[5] = i * u + o * c + a * s - r * l, e[6] = a * u + o * l + r * c - i * s, e[7] = o * u - r * s - i * c - a * l, e;
}
function ha(e, t, n, r) {
	if (Math.abs(r) < 1e-6) return ta(e, t);
	var i = Math.sqrt(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);
	r *= .5;
	var a = Math.sin(r), o = a * n[0] / i, s = a * n[1] / i, c = a * n[2] / i, l = Math.cos(r), u = t[0], d = t[1], f = t[2], p = t[3];
	e[0] = u * l + p * o + d * c - f * s, e[1] = d * l + p * s + f * o - u * c, e[2] = f * l + p * c + u * s - d * o, e[3] = p * l - u * o - d * s - f * c;
	var m = t[4], h = t[5], g = t[6], _ = t[7];
	return e[4] = m * l + _ * o + h * c - g * s, e[5] = h * l + _ * s + g * o - m * c, e[6] = g * l + _ * c + m * s - h * o, e[7] = _ * l - m * o - h * s - g * c, e;
}
function ga(e, t, n) {
	return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2], e[3] = t[3] + n[3], e[4] = t[4] + n[4], e[5] = t[5] + n[5], e[6] = t[6] + n[6], e[7] = t[7] + n[7], e;
}
function _a(e, t, n) {
	var r = t[0], i = t[1], a = t[2], o = t[3], s = n[4], c = n[5], l = n[6], u = n[7], d = t[4], f = t[5], p = t[6], m = t[7], h = n[0], g = n[1], _ = n[2], v = n[3];
	return e[0] = r * v + o * h + i * _ - a * g, e[1] = i * v + o * g + a * h - r * _, e[2] = a * v + o * _ + r * g - i * h, e[3] = o * v - r * h - i * g - a * _, e[4] = r * u + o * s + i * l - a * c + d * v + m * h + f * _ - p * g, e[5] = i * u + o * c + a * s - r * l + f * v + m * g + p * h - d * _, e[6] = a * u + o * l + r * c - i * s + p * v + m * _ + d * g - f * h, e[7] = o * u - r * s - i * c - a * l + m * v - d * h - f * g - p * _, e;
}
var va = _a;
function ya(e, t, n) {
	return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e[4] = t[4] * n, e[5] = t[5] * n, e[6] = t[6] * n, e[7] = t[7] * n, e;
}
var ba = Pi;
function xa(e, t, n, r) {
	var i = 1 - r;
	return ba(t, n) < 0 && (r = -r), e[0] = t[0] * i + n[0] * r, e[1] = t[1] * i + n[1] * r, e[2] = t[2] * i + n[2] * r, e[3] = t[3] * i + n[3] * r, e[4] = t[4] * i + n[4] * r, e[5] = t[5] * i + n[5] * r, e[6] = t[6] * i + n[6] * r, e[7] = t[7] * i + n[7] * r, e;
}
function Sa(e, t) {
	var n = Ea(t);
	return e[0] = -t[0] / n, e[1] = -t[1] / n, e[2] = -t[2] / n, e[3] = t[3] / n, e[4] = -t[4] / n, e[5] = -t[5] / n, e[6] = -t[6] / n, e[7] = t[7] / n, e;
}
function Ca(e, t) {
	return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e[3] = t[3], e[4] = -t[4], e[5] = -t[5], e[6] = -t[6], e[7] = t[7], e;
}
var wa = Ii, Ta = wa, Ea = Ri, Da = Ea;
function Oa(e, t) {
	var n = Ea(t);
	if (n > 0) {
		n = Math.sqrt(n);
		var r = t[0] / n, i = t[1] / n, a = t[2] / n, o = t[3] / n, s = t[4], c = t[5], l = t[6], u = t[7], d = r * s + i * c + a * l + o * u;
		e[0] = r, e[1] = i, e[2] = a, e[3] = o, e[4] = (s - r * d) / n, e[5] = (c - i * d) / n, e[6] = (l - a * d) / n, e[7] = (u - o * d) / n;
	}
	return e;
}
function ka(e) {
	return "quat2(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ", " + e[6] + ", " + e[7] + ")";
}
function Aa(e, t) {
	return e[0] === t[0] && e[1] === t[1] && e[2] === t[2] && e[3] === t[3] && e[4] === t[4] && e[5] === t[5] && e[6] === t[6] && e[7] === t[7];
}
function ja(e, t) {
	var n = e[0], r = e[1], i = e[2], a = e[3], o = e[4], s = e[5], c = e[6], l = e[7], u = t[0], d = t[1], f = t[2], p = t[3], m = t[4], h = t[5], g = t[6], _ = t[7];
	return Math.abs(n - u) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(u)) && Math.abs(r - d) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(d)) && Math.abs(i - f) <= 1e-6 * Math.max(1, Math.abs(i), Math.abs(f)) && Math.abs(a - p) <= 1e-6 * Math.max(1, Math.abs(a), Math.abs(p)) && Math.abs(o - m) <= 1e-6 * Math.max(1, Math.abs(o), Math.abs(m)) && Math.abs(s - h) <= 1e-6 * Math.max(1, Math.abs(s), Math.abs(h)) && Math.abs(c - g) <= 1e-6 * Math.max(1, Math.abs(c), Math.abs(g)) && Math.abs(l - _) <= 1e-6 * Math.max(1, Math.abs(l), Math.abs(_));
}
//#endregion
//#region node_modules/gl-matrix/esm/vec2.js
var Ma = /* @__PURE__ */ s({
	add: () => Ra,
	angle: () => fo,
	ceil: () => Ha,
	clone: () => Pa,
	copy: () => Ia,
	create: () => Na,
	cross: () => ro,
	dist: () => So,
	distance: () => Ya,
	div: () => xo,
	divide: () => Va,
	dot: () => no,
	equals: () => _o,
	exactEquals: () => go,
	floor: () => Ua,
	forEach: () => To,
	fromValues: () => Fa,
	inverse: () => eo,
	len: () => vo,
	length: () => Za,
	lerp: () => io,
	max: () => Ga,
	min: () => Wa,
	mul: () => bo,
	multiply: () => Ba,
	negate: () => $a,
	normalize: () => to,
	random: () => ao,
	rotate: () => uo,
	round: () => Ka,
	scale: () => qa,
	scaleAndAdd: () => Ja,
	set: () => La,
	signedAngle: () => po,
	sqrDist: () => Co,
	sqrLen: () => wo,
	squaredDistance: () => Xa,
	squaredLength: () => Qa,
	str: () => ho,
	sub: () => yo,
	subtract: () => za,
	transformMat2: () => oo,
	transformMat2d: () => so,
	transformMat3: () => co,
	transformMat4: () => lo,
	zero: () => mo
});
function Na() {
	var e = new P(2);
	return P != Float32Array && (e[0] = 0, e[1] = 0), e;
}
function Pa(e) {
	var t = new P(2);
	return t[0] = e[0], t[1] = e[1], t;
}
function Fa(e, t) {
	var n = new P(2);
	return n[0] = e, n[1] = t, n;
}
function Ia(e, t) {
	return e[0] = t[0], e[1] = t[1], e;
}
function La(e, t, n) {
	return e[0] = t, e[1] = n, e;
}
function Ra(e, t, n) {
	return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e;
}
function za(e, t, n) {
	return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e;
}
function Ba(e, t, n) {
	return e[0] = t[0] * n[0], e[1] = t[1] * n[1], e;
}
function Va(e, t, n) {
	return e[0] = t[0] / n[0], e[1] = t[1] / n[1], e;
}
function Ha(e, t) {
	return e[0] = Math.ceil(t[0]), e[1] = Math.ceil(t[1]), e;
}
function Ua(e, t) {
	return e[0] = Math.floor(t[0]), e[1] = Math.floor(t[1]), e;
}
function Wa(e, t, n) {
	return e[0] = Math.min(t[0], n[0]), e[1] = Math.min(t[1], n[1]), e;
}
function Ga(e, t, n) {
	return e[0] = Math.max(t[0], n[0]), e[1] = Math.max(t[1], n[1]), e;
}
function Ka(e, t) {
	return e[0] = I(t[0]), e[1] = I(t[1]), e;
}
function qa(e, t, n) {
	return e[0] = t[0] * n, e[1] = t[1] * n, e;
}
function Ja(e, t, n, r) {
	return e[0] = t[0] + n[0] * r, e[1] = t[1] + n[1] * r, e;
}
function Ya(e, t) {
	var n = t[0] - e[0], r = t[1] - e[1];
	return Math.sqrt(n * n + r * r);
}
function Xa(e, t) {
	var n = t[0] - e[0], r = t[1] - e[1];
	return n * n + r * r;
}
function Za(e) {
	var t = e[0], n = e[1];
	return Math.sqrt(t * t + n * n);
}
function Qa(e) {
	var t = e[0], n = e[1];
	return t * t + n * n;
}
function $a(e, t) {
	return e[0] = -t[0], e[1] = -t[1], e;
}
function eo(e, t) {
	return e[0] = 1 / t[0], e[1] = 1 / t[1], e;
}
function to(e, t) {
	var n = t[0], r = t[1], i = n * n + r * r;
	return i > 0 && (i = 1 / Math.sqrt(i)), e[0] = t[0] * i, e[1] = t[1] * i, e;
}
function no(e, t) {
	return e[0] * t[0] + e[1] * t[1];
}
function ro(e, t, n) {
	var r = t[0] * n[1] - t[1] * n[0];
	return e[0] = e[1] = 0, e[2] = r, e;
}
function io(e, t, n, r) {
	var i = t[0], a = t[1];
	return e[0] = i + r * (n[0] - i), e[1] = a + r * (n[1] - a), e;
}
function ao(e, t) {
	t = t === void 0 ? 1 : t;
	var n = F() * 2 * Math.PI;
	return e[0] = Math.cos(n) * t, e[1] = Math.sin(n) * t, e;
}
function oo(e, t, n) {
	var r = t[0], i = t[1];
	return e[0] = n[0] * r + n[2] * i, e[1] = n[1] * r + n[3] * i, e;
}
function so(e, t, n) {
	var r = t[0], i = t[1];
	return e[0] = n[0] * r + n[2] * i + n[4], e[1] = n[1] * r + n[3] * i + n[5], e;
}
function co(e, t, n) {
	var r = t[0], i = t[1];
	return e[0] = n[0] * r + n[3] * i + n[6], e[1] = n[1] * r + n[4] * i + n[7], e;
}
function lo(e, t, n) {
	var r = t[0], i = t[1];
	return e[0] = n[0] * r + n[4] * i + n[12], e[1] = n[1] * r + n[5] * i + n[13], e;
}
function uo(e, t, n, r) {
	var i = t[0] - n[0], a = t[1] - n[1], o = Math.sin(r), s = Math.cos(r);
	return e[0] = i * s - a * o + n[0], e[1] = i * o + a * s + n[1], e;
}
function fo(e, t) {
	var n = e[0], r = e[1], i = t[0], a = t[1];
	return Math.abs(Math.atan2(r * i - n * a, n * i + r * a));
}
function po(e, t) {
	var n = e[0], r = e[1], i = t[0], a = t[1];
	return Math.atan2(n * a - r * i, n * i + r * a);
}
function mo(e) {
	return e[0] = 0, e[1] = 0, e;
}
function ho(e) {
	return "vec2(" + e[0] + ", " + e[1] + ")";
}
function go(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}
function _o(e, t) {
	var n = e[0], r = e[1], i = t[0], a = t[1];
	return Math.abs(n - i) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(i)) && Math.abs(r - a) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(a));
}
var vo = Za, yo = za, bo = Ba, xo = Va, So = Ya, Co = Xa, wo = Qa, To = function() {
	var e = Na();
	return function(t, n, r, i, a, o) {
		var s, c;
		for (n ||= 2, r ||= 0, c = i ? Math.min(i * n + r, t.length) : t.length, s = r; s < c; s += n) e[0] = t[s], e[1] = t[s + 1], a(e, e, o), t[s] = e[0], t[s + 1] = e[1];
		return t;
	};
}(), Eo = /* @__PURE__ */ s({
	glMatrix: () => M,
	mat2: () => ne,
	mat2d: () => xe,
	mat3: () => Ge,
	mat4: () => wt,
	quat: () => oi,
	quat2: () => Ki,
	vec2: () => Ma,
	vec3: () => Sn,
	vec4: () => vr
}), Do = class {
	gl;
	frameBuffer;
	rawOutput;
	canvasWidth;
	targetWidth;
	canvasHeight;
	targetHeight;
	constructor(e) {
		this.gl = e, this.frameBuffer = y(e.createFramebuffer()), this.rawOutput = new A(e), this.refreshDimensions();
	}
	release() {
		this.rawOutput.release(), this.gl.deleteFramebuffer(this.frameBuffer);
	}
	refreshDimensions() {
		let e = this.gl, t = e.drawingBufferWidth, n = e.drawingBufferHeight, r = Oo(t), i = Oo(n);
		this.canvasWidth = t, this.targetWidth = r, this.canvasHeight = n, this.targetHeight = i;
	}
	capture(e) {
		let t = this.gl, n = this.rawOutput;
		this.refreshDimensions();
		let { canvasWidth: r, targetWidth: i, canvasHeight: a, targetHeight: o } = this;
		t.bindTexture(t.TEXTURE_2D, n.name), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, i, o, 0, t.RGBA, t.UNSIGNED_BYTE, null), t.bindTexture(t.TEXTURE_2D, null), t.bindFramebuffer(t.FRAMEBUFFER, this.frameBuffer), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, n.name, 0), t.viewport(0, 0, t.canvas.width, t.canvas.height);
		try {
			e();
		} finally {
			t.bindFramebuffer(t.FRAMEBUFFER, null), t.activeTexture(t.TEXTURE0), t.viewport(0, 0, r, a);
		}
	}
	texMatrix() {
		let { canvasWidth: e, targetWidth: t, canvasHeight: n, targetHeight: r } = this, i = V();
		return ue(i, i, [e / t, n / r]);
	}
	texelSize() {
		return [1 / this.targetWidth, 1 / this.targetHeight];
	}
};
function Oo(e) {
	let t = 1;
	for (; t < e;) t <<= 1;
	return t;
}
//#endregion
//#region src/visualEffects/VisualEffectParams.ts
var ko = class {
	scale = 1;
}, Ao = ko, jo = class extends ko {
	gamma = 1;
	alpha = 1;
	scale = 1.5;
	fragShader() {
		return "\n      precision mediump float;\n      uniform sampler2D     u_raw;\n      uniform mat2          u_tex_matrix;\n      uniform float         u_gamma;\n      uniform float         u_alpha;\n      varying vec2          v_coord;\n      \n      #define M_PI 3.14159265359\n      \n      void main(void){\n          vec2 xy = 2. * v_coord - vec2(1.);\n          float r = length(xy);\n          float r0 = tan(0.25 * M_PI * r);\n          vec2 xy0 = (r == 0. ? 0. : (r0 / r)) * xy;\n          xy0 = 0.5 * (xy0 + vec2(1.));\n          vec4 rgba = texture2D(u_raw, u_tex_matrix * xy0);\n          rgba = pow(rgba, vec4(u_gamma));\n          rgba.rgb *= vec3(u_alpha);\n          if (r > 1.) {\n            discard;\n          }\n          else {\n            gl_FragColor = rgba;\n          }\n      }\n    ";
	}
	setUniforms(e) {
		e.uniform1f({
			u_gamma: this.gamma,
			u_alpha: this.alpha
		});
	}
}, Mo = class extends ko {
	decay = .85;
	intensity = .5;
	fragShader() {
		return "\n      precision mediump float;\n      uniform sampler2D     u_raw;\n      uniform mat2          u_tex_matrix;\n      uniform float         u_decay;\n      uniform float         u_intensity;\n      varying vec2          v_coord;\n\n      void main(void) {\n          vec2 texCoord = u_tex_matrix * v_coord;\n          vec4 color = texture2D(u_raw, texCoord);\n          \n          // 中心からの距離に基づいて残像効果を調整\n          vec2 center = vec2(0.5);\n          float dist = length(v_coord - center);\n          \n          // 残像効果を追加（現在のフレームに軽いトレイルを追加）\n          float blur = u_intensity * (1.0 - dist);\n          color.rgb = mix(color.rgb, color.rgb * 1.1, blur * 0.2);\n          \n          gl_FragColor = color;\n      }\n    ";
	}
	setUniforms(e) {
		e.uniform1f({
			u_decay: this.decay,
			u_intensity: this.intensity
		});
	}
}, No = class extends ko {
	intensity = 1;
	threshold = .5;
	radius = 3;
	aspectRatio = 1;
	texelSize = [1 / 1024, 1 / 1024];
	fragShader() {
		return "\n      precision mediump float;\n      uniform sampler2D     u_raw;\n      uniform mat2          u_tex_matrix;\n      uniform vec2          u_texel_size;\n      uniform float         u_intensity;\n      uniform float         u_threshold;\n      uniform float         u_radius;\n      varying vec2          v_coord;\n\n      float gaussian(float x, float sigma) {\n          return exp(-(x * x) / (2.0 * sigma * sigma));\n      }\n\n      float luminance(vec3 color) {\n          return dot(color, vec3(0.299, 0.587, 0.114));\n      }\n\n      vec3 extractBright(vec3 color) {\n          float brightness = luminance(color);\n          float knee = max(0.03, (1.0 - u_threshold) * 0.2);\n          float strength = smoothstep(max(u_threshold - knee, 0.0), min(u_threshold + knee, 1.0), brightness);\n          return color * strength;\n      }\n\n      void main(void) {\n          vec2 texCoord = u_tex_matrix * v_coord;\n          vec4 color = texture2D(u_raw, texCoord);\n\n          vec2 texMax = u_tex_matrix * vec2(1.0, 1.0);\n          vec2 pixelSize = u_texel_size;\n\n          // 明るい部分を抽出した画像をガウシアンブラーして加算する\n          vec3 glow = vec3(0.0);\n          float totalWeight = 0.0;\n\n          for (float x = -4.0; x <= 4.0; x += 1.0) {\n              for (float y = -4.0; y <= 4.0; y += 1.0) {\n                  vec2 offset = vec2(x, y) * pixelSize * max(u_radius, 0.001);\n                  vec2 sampleTexCoord = clamp(texCoord + offset, vec2(0.0), texMax);\n                  vec3 sampleColor = texture2D(u_raw, sampleTexCoord).rgb;\n                  float weight = gaussian(length(vec2(x, y)), 2.0);\n\n                  glow += extractBright(sampleColor) * weight;\n                  totalWeight += weight;\n              }\n          }\n\n          if (totalWeight > 0.0) {\n              glow /= totalWeight;\n          }\n\n          gl_FragColor = vec4(color.rgb + glow * u_intensity, color.a);\n      }\n    ";
	}
	setUniforms(e) {
		e.uniform1f({
			u_intensity: this.intensity,
			u_threshold: this.threshold,
			u_radius: this.radius
		}), e.uniform2fv({ u_texel_size: this.texelSize });
	}
	setRenderTargetInfo(e) {
		this.texelSize = e.texelSize;
	}
}, Po = class extends ko {
	blurAmount = 2;
	noiseAmount = .02;
	time = 0;
	fragShader() {
		return "\n      precision mediump float;\n      uniform sampler2D     u_raw;\n      uniform mat2          u_tex_matrix;\n      uniform float         u_blur_amount;\n      uniform float         u_noise_amount;\n      uniform float         u_time;\n      varying vec2          v_coord;\n      \n      // シンプルなノイズ関数\n      float rand(vec2 co) {\n          return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n      }\n\n      void main(void) {\n          vec2 texCoord = u_tex_matrix * v_coord;\n          vec2 pixelSize = vec2(1.0 / 1024.0);\n          \n          // ランダムなオフセットを追加（すりガラスの粒感）\n          float noise = rand(v_coord + u_time);\n          vec2 noiseOffset = vec2(\n              rand(v_coord + vec2(u_time, 0.0)) - 0.5,\n              rand(v_coord + vec2(0.0, u_time)) - 0.5\n          ) * u_noise_amount;\n          \n          // ガウシアンブラー\n          vec4 color = vec4(0.0);\n          float totalWeight = 0.0;\n          \n          for (float x = -3.0; x <= 3.0; x += 1.0) {\n              for (float y = -3.0; y <= 3.0; y += 1.0) {\n                  vec2 offset = vec2(x, y) * pixelSize * u_blur_amount + noiseOffset;\n                  float weight = exp(-(x*x + y*y) / 8.0);\n                  color += texture2D(u_raw, u_tex_matrix * (v_coord + offset)) * weight;\n                  totalWeight += weight;\n              }\n          }\n          \n          color /= totalWeight;\n          gl_FragColor = color;\n      }\n    ";
	}
	setUniforms(e) {
		e.uniform1f({
			u_blur_amount: this.blurAmount,
			u_noise_amount: this.noiseAmount,
			u_time: this.time
		});
	}
	update(e) {
		this.time += e * .001;
	}
}, Fo = class extends ko {
	centerX = .5;
	centerY = .5;
	amplitude = .02;
	frequency = 20;
	speed = 2;
	time = 0;
	fragShader() {
		return "\n      precision mediump float;\n      uniform sampler2D     u_raw;\n      uniform mat2          u_tex_matrix;\n      uniform vec2          u_center;\n      uniform float         u_amplitude;\n      uniform float         u_frequency;\n      uniform float         u_time;\n      varying vec2          v_coord;\n\n      void main(void) {\n          vec2 center = u_center;\n          vec2 uv = v_coord - center;\n          float dist = length(uv);\n          \n          // 波紋の計算\n          float wave = sin(dist * u_frequency - u_time) * u_amplitude;\n          wave *= exp(-dist * 2.0); // 中心から離れるほど減衰\n          \n          // 変位を適用\n          vec2 displacement = normalize(uv) * wave;\n          if (dist < 0.001) displacement = vec2(0.0);\n          \n          vec2 texCoord = u_tex_matrix * (v_coord + displacement);\n          vec4 color = texture2D(u_raw, texCoord);\n          \n          gl_FragColor = color;\n      }\n    ";
	}
	setUniforms(e) {
		e.uniform2fv({ u_center: [this.centerX, this.centerY] }), e.uniform1f({
			u_amplitude: this.amplitude,
			u_frequency: this.frequency,
			u_time: this.time
		});
	}
	update(e) {
		this.time += e * .001 * this.speed;
	}
}, Io = class extends ko {
	warpStrength = 0;
	streakLength = .3;
	centerX = .5;
	centerY = .5;
	saturationBoost = 1.2;
	fragShader() {
		return "\n      precision mediump float;\n      uniform sampler2D     u_raw;\n      uniform mat2          u_tex_matrix;\n      uniform float         u_warp_strength;\n      uniform float         u_streak_length;\n      uniform vec2          u_center;\n      uniform float         u_saturation_boost;\n      varying vec2          v_coord;\n\n      void main(void) {\n          vec2 center = u_center;\n          vec2 uv = v_coord - center;\n          float dist = length(uv);\n          vec2 dir = normalize(uv);\n          \n          if (dist < 0.001) {\n              gl_FragColor = texture2D(u_raw, u_tex_matrix * v_coord);\n              return;\n          }\n          \n          // ワープ効果：中心から外側に向かって光の筋\n          vec4 color = vec4(0.0);\n          float totalWeight = 0.0;\n          \n          // 放射状ブラー\n          int samples = 16;\n          for (int i = 0; i < 16; i++) {\n              float t = float(i) / 15.0;\n              float offset = t * u_streak_length * u_warp_strength * dist;\n              vec2 samplePos = v_coord - dir * offset;\n              \n              float weight = 1.0 - t * 0.8;\n              color += texture2D(u_raw, u_tex_matrix * samplePos) * weight;\n              totalWeight += weight;\n          }\n          \n          color /= totalWeight;\n          \n          // ワープ時の彩度・明るさブースト\n          float boost = 1.0 + u_warp_strength * 0.5;\n          color.rgb *= boost;\n          \n          // 彩度ブースト\n          float gray = dot(color.rgb, vec3(0.299, 0.587, 0.114));\n          color.rgb = mix(vec3(gray), color.rgb, u_saturation_boost);\n          \n          // 中心から外側に向かって青みを追加（ワープ感）\n          color.rgb += vec3(0.0, 0.05, 0.15) * u_warp_strength * dist;\n          \n          gl_FragColor = color;\n      }\n    ";
	}
	setUniforms(e) {
		e.uniform1f({
			u_warp_strength: this.warpStrength,
			u_streak_length: this.streakLength,
			u_saturation_boost: this.saturationBoost
		}), e.uniform2fv({ u_center: [this.centerX, this.centerY] });
	}
	startWarp(e = 1e3) {
		return new Promise((t) => {
			let n = performance.now(), r = () => {
				let i = performance.now() - n, a = Math.min(i / e, 1);
				this.warpStrength = this.easeInQuad(a), a < 1 ? requestAnimationFrame(r) : t();
			};
			r();
		});
	}
	endWarp(e = 500) {
		return new Promise((t) => {
			let n = this.warpStrength, r = performance.now(), i = () => {
				let a = performance.now() - r, o = Math.min(a / e, 1);
				this.warpStrength = n * (1 - this.easeOutQuad(o)), o < 1 ? requestAnimationFrame(i) : t();
			};
			i();
		});
	}
	easeInQuad(e) {
		return e * e;
	}
	easeOutQuad(e) {
		return 1 - (1 - e) * (1 - e);
	}
}, Lo = class extends ko {
	fragShader() {
		return "\n      precision mediump float;\n      uniform sampler2D     u_raw;\n      uniform mat2          u_tex_matrix;\n      varying vec2          v_coord;\n\n      void main(void) {\n          vec2 texCoord = u_tex_matrix * v_coord;\n          gl_FragColor = texture2D(u_raw, texCoord);\n      }\n    ";
	}
	setUniforms(e) {}
}, Ro = class {
	gl;
	params;
	globe;
	attribList;
	program;
	captureTarget;
	previousFrameTexture = null;
	previousFrameBuffer = null;
	previousFrameWidth = 0;
	previousFrameHeight = 0;
	hasPreviousFrame = !1;
	snapshotTexture = null;
	snapshotWidth = 0;
	snapshotHeight = 0;
	hasSnapshot = !1;
	constructor(e, t, n) {
		this.gl = e, this.params = t, this.globe = n, this.captureTarget = new Do(e), this.attribList = new E(e, {
			members: [{
				name: "a_coord",
				nComponents: 2
			}],
			array: new Float32Array([
				0,
				0,
				1,
				0,
				1,
				1,
				0,
				0,
				1,
				1,
				0,
				1
			])
		}), this.program = S.new(e, "\n      attribute  vec2   a_coord;\n      varying    vec2   v_coord;\n      \n      void main(void) {\n          gl_Position = vec4(2. * a_coord - vec2(1.), 0., 1.);\n          v_coord = a_coord;\n      }\n    ", t.fragShader()), this.usesPreviousFrame() && this.initPreviousFrameResources(), this.usesSnapshot() && this.initSnapshotResources();
	}
	usesPreviousFrame() {
		return "usesPreviousFrame" in this.params && this.params.usesPreviousFrame === !0;
	}
	usesSnapshot() {
		return "usesSnapshot" in this.params && this.params.usesSnapshot === !0;
	}
	initPreviousFrameResources() {
		let e = this.gl;
		this.previousFrameTexture = new A(e), this.previousFrameBuffer = y(e.createFramebuffer());
	}
	initSnapshotResources() {
		let e = this.gl;
		this.snapshotTexture = new A(e);
	}
	releasePreviousFrameResources() {
		this.previousFrameTexture &&= (this.previousFrameTexture.release(), null), this.previousFrameBuffer &&= (this.gl.deleteFramebuffer(this.previousFrameBuffer), null);
	}
	releaseSnapshotResources() {
		this.snapshotTexture &&= (this.snapshotTexture.release(), null), this.hasSnapshot = !1;
	}
	get aspectRatio() {
		return this.gl.drawingBufferWidth / this.gl.drawingBufferHeight;
	}
	get width() {
		return this.gl.drawingBufferWidth;
	}
	get height() {
		return this.gl.drawingBufferHeight;
	}
	release() {
		this.attribList.release(), this.program.release(), this.captureTarget.release(), this.releasePreviousFrameResources(), this.releaseSnapshotResources();
	}
	captureSnapshot() {
		this.snapshotTexture || this.initSnapshotResources();
		let e = this.gl, t = e.drawingBufferWidth, n = e.drawingBufferHeight;
		(t !== this.snapshotWidth || n !== this.snapshotHeight) && (e.bindTexture(e.TEXTURE_2D, this.snapshotTexture.name), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, t, n, 0, e.RGBA, e.UNSIGNED_BYTE, null), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.bindTexture(e.TEXTURE_2D, null), this.snapshotWidth = t, this.snapshotHeight = n), e.bindTexture(e.TEXTURE_2D, this.snapshotTexture.name), e.copyTexSubImage2D(e.TEXTURE_2D, 0, 0, 0, 0, 0, t, n), e.bindTexture(e.TEXTURE_2D, null), this.hasSnapshot = !0;
	}
	clearSnapshot() {
		this.hasSnapshot = !1;
	}
	pipeAndDraw(e) {
		this.captureTarget.capture(e), this.draw(), this.usesPreviousFrame() && this.savePreviousFrame();
	}
	savePreviousFrame() {
		let e = this.gl;
		if (!this.previousFrameTexture || !this.previousFrameBuffer) return;
		let t = e.drawingBufferWidth, n = e.drawingBufferHeight;
		(t !== this.previousFrameWidth || n !== this.previousFrameHeight) && (e.bindTexture(e.TEXTURE_2D, this.previousFrameTexture.name), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, t, n, 0, e.RGBA, e.UNSIGNED_BYTE, null), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.bindTexture(e.TEXTURE_2D, null), this.previousFrameWidth = t, this.previousFrameHeight = n), e.bindTexture(e.TEXTURE_2D, this.previousFrameTexture.name), e.copyTexSubImage2D(e.TEXTURE_2D, 0, 0, 0, 0, 0, t, n), e.bindTexture(e.TEXTURE_2D, null), this.hasPreviousFrame = !0;
	}
	draw() {
		let { gl: e, program: t, captureTarget: n } = this;
		t.use(), this.params.setRenderTargetInfo?.({ texelSize: n.texelSize() }), t.uniformMatrix2fv({ u_tex_matrix: n.texMatrix() }), this.attribList.enable(t, () => {
			t.uniform1i({ u_raw: 0 }), this.usesPreviousFrame() && this.previousFrameTexture && (t.uniform1i({ u_previous_frame: 1 }), t.uniform1f({ u_has_previous: +!!this.hasPreviousFrame }), e.activeTexture(e.TEXTURE1), e.bindTexture(e.TEXTURE_2D, this.previousFrameTexture.name)), this.usesSnapshot() && this.snapshotTexture && (t.uniform1i({ u_snapshot: 2 }), t.uniform1f({ u_has_snapshot: +!!this.hasSnapshot }), e.activeTexture(e.TEXTURE2), e.bindTexture(e.TEXTURE_2D, this.snapshotTexture.name)), this.params.setUniforms(t), e.activeTexture(e.TEXTURE0), e.bindTexture(e.TEXTURE_2D, n.rawOutput.name), e.drawArrays(e.TRIANGLES, 0, 6), e.activeTexture(e.TEXTURE2), e.bindTexture(e.TEXTURE_2D, null), e.activeTexture(e.TEXTURE1), e.bindTexture(e.TEXTURE_2D, null), e.activeTexture(e.TEXTURE0), e.bindTexture(e.TEXTURE_2D, null);
		});
	}
}, zo = {
	omega0: .05,
	gamma: .05,
	gamma0: .002,
	minSpeed: 1 / 1e3
}, Bo = class {
	h = 0;
	x = 0;
	v = 0;
	hold = !1;
	options;
	t0;
	constructor(e = {}) {
		this.options = {
			...zo,
			...e
		};
	}
	setOptions(e) {
		return this.options = {
			...this.options,
			...e
		}, this;
	}
	release() {
		return this.hold = !1, this;
	}
	drag(e) {
		return this.hold = !0, this.h += e, this;
	}
	dragTo(e) {
		return this.hold = !0, this.h = e, this;
	}
	addImpulse(e) {
		this.v += e;
	}
	stop() {
		return this.v = 0, this.h = this.x, this;
	}
	reset() {
		return this.h = 0, this.x = 0, this.v = 0, this;
	}
	evolve(e) {
		this.t0 === void 0 && (this.t0 = e);
		let t = e - this.t0;
		this.t0 = e;
		let n = this.options.omega0, r = this.options.gamma;
		if (this.hold) {
			let e = this.x - this.h, i = this.v;
			if (Math.abs(n / r - 1) <= .001) {
				let n = r * e + i, a = e, o = Math.exp(-r * t);
				this.x = o * (n * t + a) + this.h, this.v = -r * o * (n * t + a) + n * o;
			} else if (n > r) {
				let a = Math.sqrt(n * n - r * r), o = e, s = -(e * r + i) / a, c = Math.sqrt(o * o + s * s), l = Math.exp(-r * t), u = Math.atan2(o, -s);
				this.x = c * l * Math.sin(a * t + u) + this.h, this.v = c * l * (-r * Math.sin(a * t + u) + a * Math.cos(a * t + u));
			} else {
				let a = Math.sqrt(r * r - n * n), o = -r + a, s = -r - a, c = (-s * e + i) / (2 * a), l = (o * e - i) / (2 * a);
				this.x = c * Math.exp(o * t) + l * Math.exp(s * t) + this.h, this.v = c * o * Math.exp(o * t) + l * s * Math.exp(s * t);
			}
		} else {
			let e = this.options.gamma0, n = this.v, r = Math.exp(-2 * e * t);
			this.v = n * r, this.x += n / (2 * e) * (1 - r);
		}
		return this;
	}
	get state() {
		let { x: e, v: t } = this;
		return {
			x: e,
			v: t,
			moving: Math.abs(t) >= this.options.minSpeed
		};
	}
}, Vo = class {
	dim;
	constructor(e, t = {}) {
		t = {
			...zo,
			...t
		}, this.dim = Uo(e).map((e) => new Bo(t));
	}
	setOptions(e) {
		return this.dim.forEach((t) => t.setOptions(e)), this;
	}
	evolve(e) {
		return this.dim.forEach((t) => t.evolve(e)), this;
	}
	release() {
		return this.dim.forEach((e) => e.release()), this;
	}
	_drag(e) {
		return this.dim.forEach((t, n) => t.drag(e[n])), this;
	}
	_dragTo(e) {
		return this.dim.forEach((t, n) => t.dragTo(e[n])), this;
	}
	stop() {
		return this.dim.forEach((e) => e.stop()), this;
	}
	reset() {
		return this.dim.forEach((e) => e.reset()), this;
	}
	get _state() {
		let e = this.dim.map((e) => e.state);
		return {
			x: e.map((e) => e.x),
			v: e.map((e) => e.v),
			moving: e.some((e) => e.moving)
		};
	}
}, Ho = class extends Vo {
	constructor(e = {}) {
		super(2, e);
	}
	drag(e, t) {
		return this._drag([e, t]);
	}
	dragTo(e, t) {
		return this._dragTo([e, t]);
	}
	get state() {
		let e = this._state;
		return {
			position: {
				x: e.x[0],
				y: e.x[1]
			},
			velocity: {
				x: e.v[0],
				y: e.v[1]
			},
			moving: e.moving
		};
	}
};
function Uo(e) {
	let t = [];
	for (let n = 0; n < e; ++n) t.push(n);
	return t;
}
//#endregion
//#region src/utils/event.ts
var Wo = {
	maxMove: 4,
	maxDuration: 200
};
function Go(e, t, n = {}) {
	let { maxDuration: r, maxMove: i } = {
		...n,
		...Wo
	};
	return Math.abs(e.clientX - t.clientX) < i && Math.abs(e.clientY - t.clientY) < i && t.timeStamp - e.timeStamp < r;
}
function Ko(e, t, n, r) {
	return e.addEventListener(t, n, r), () => {
		e.removeEventListener(t, n);
	};
}
//#endregion
//#region src/utils/math.ts
var qo = /* @__PURE__ */ s({
	clip: () => Jo,
	diff: () => es,
	dot: () => $o,
	range: () => Yo,
	square: () => Xo,
	thetaphi2xyz: () => Zo,
	xyz2thetaphi: () => Qo
});
function Jo(e, t, n) {
	return e < t ? t : e > n ? n : e;
}
function Yo(e, t) {
	t === void 0 && (t = e, e = 0);
	let n = [];
	for (let r = e; r < t; ++r) n.push(r);
	return n;
}
function Xo(e) {
	return e * e;
}
function Zo(e, t) {
	let n = Math.cos(e);
	return [
		n * Math.cos(t),
		n * Math.sin(t),
		Math.sin(e)
	];
}
function Qo(e, t, n) {
	let r = e * e + t * t;
	if (r === 0) return [n > 0 ? Math.PI / 2 : -Math.PI / 2, 0];
	{
		let i = 2 * Math.PI, a = (Math.atan2(t, e) + i) % i;
		return [Math.atan2(n, Math.sqrt(r)), a];
	}
}
function $o(e, t) {
	return e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
}
function es(e, t) {
	return [
		e[0] - t[0],
		e[1] - t[1],
		e[2] - t[2]
	];
}
//#endregion
//#region src/utils/mouse.ts
var ts = /* @__PURE__ */ function(e) {
	return e[e.LEFT = 0] = "LEFT", e[e.MIDDLE = 1] = "MIDDLE", e[e.RIGHT = 2] = "RIGHT", e;
}({});
function ns(e) {
	switch (e.button) {
		case 2: return 2;
		case 1: return 1;
		default:
			if (!e.altKey && e.ctrlKey && !e.shiftKey) return 2;
			if (e.altKey && !e.ctrlKey && !e.shiftKey) return 1;
	}
	return 0;
}
var rs = {
	button: ns,
	Button: ts
};
//#endregion
//#region src/layer/camera_motion.ts
function is(e, t, n, r = V()) {
	let i = e.camera, a = i.coord2thetaphi(e.canvas.coordFromOffset(t, n)), o = i.coord2thetaphi(e.canvas.coordFromOffset(t + 1, n)), s = i.coord2thetaphi(e.canvas.coordFromOffset(t, n + 1));
	as(o, a[1]), as(s, a[1]);
	let c = o[0] - a[0], l = s[0] - a[0];
	return oe(r, o[1] - a[1], c, s[1] - a[1], l);
}
function as(e, t) {
	Math.abs(t - e[1]) > Math.PI && (e[1] += (e[1] > t ? -1 : 1) * 2 * Math.PI);
}
//#endregion
//#region src/utils/EventManager.ts
function os() {
	let e = /* @__PURE__ */ new Map();
	return {
		on: (t, n) => (e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n), () => {
			e.get(t)?.delete(n);
		}),
		emit: (t, n) => {
			for (let r of e.get(t) ?? []) r(n);
		}
	};
}
function ss({ runReversedOrder: e = !1 } = {}) {
	let t = [];
	return {
		add: (e) => (t.push(e), () => {
			let n = t.indexOf(e);
			n >= 0 && t.splice(n, 1);
		}),
		flush: () => {
			let n = e ? (() => t.pop()) : (() => t.shift());
			for (; t.length > 0;) n()();
		}
	};
}
function cs() {
	return ss({ runReversedOrder: !0 });
}
//#endregion
//#region src/layer/layer/index.ts
var $ = class {
	globe;
	constructor(e) {
		this.globe = e;
	}
	render(e) {}
	release() {
		this.globe.removeLayer(this), this.releaseCallbacks.flush();
	}
	addAnimation(...e) {
		let t = this.globe.animations.add(...e);
		return t.finally(this.onRelease(t.stop)), t;
	}
	releaseCallbacks = cs();
	onRelease = this.releaseCallbacks.add;
	onAddToGlobe() {}
	runOnAddToGlobeCallbacks() {
		this.onAddToGlobe();
	}
	onRemoveFromGlobeCallbacks = cs();
	onRemoveFromGlobe = this.onRemoveFromGlobeCallbacks.add;
	runRemoveFromGlobeCallbacks() {
		this.onRemoveFromGlobeCallbacks.flush();
	}
	pointingObjects = [];
}, ls = class {
	onPointerDown(e) {}
	onDrag(e) {}
	onPointerUp(e) {}
	onClick(e) {}
	onContextMenu(e) {}
	onMove(e) {}
	onHover(e) {}
	onEnter(e) {}
	onLeave(e) {}
	hovering = !1;
	runHover(e) {
		let t = this.hit(e), { hit: n } = t;
		return this.onHover(e), this.hovering !== n && (this.hovering = n, n ? this.onEnter(e) : this.onLeave(e)), t;
	}
	runOnClick(...e) {
		return this.onClick(...e);
	}
	runOnContextMenu(...e) {
		return this.onContextMenu(...e);
	}
	runOnPointerUp(...e) {
		return this.onPointerUp(...e);
	}
	runOnPointerDown(...e) {
		return this.onPointerDown(...e);
	}
	runOnDrag(...e) {
		return this.onDrag(...e);
	}
	hoverIcon(e) {
		return "default";
	}
	dragIcon(e) {
		return "default";
	}
	get dragDetectionDelay() {
		return 100;
	}
}, us = class extends ls {
	globe;
	inertia;
	cameraMotion;
	animation;
	constructor(e, t, n = !1) {
		super(), this.globe = e, this.inertia = t, this.cameraMotion = n;
	}
	onPointerDown(e) {
		this.inertia.reset(), this.onInertialPointerDown(e);
	}
	onPointerUp() {
		this.inertia.release();
	}
	onDrag(e) {
		this.animation === void 0 && (this.animation = this.globe.animations.add((e) => {
			this.onInertiaMove(e), this.inertia.evolve(e.T);
			let { moving: t } = this.inertia.state;
			t || this.animation?.stop();
		}, { cameraMotion: this.cameraMotion }), this.animation.then(() => {
			this.animation = void 0;
		}));
		let t = e.delta();
		this.inertia.dragTo(t.x, t.y);
	}
	onInertiaMove(e) {}
	onInertialPointerDown(e) {}
	onInertiaMoveEnd() {}
};
function ds(e) {
	return new class extends ls {
		hoverIcon(t) {
			return typeof e.hoverIcon == "function" ? e.hoverIcon(t) : e.hoverIcon ?? "default";
		}
		dragIcon(t) {
			return typeof e.dragIcon == "function" ? e.dragIcon(t) : e.dragIcon ?? "default";
		}
		hit(t) {
			let { hit: n, passThrough: r } = e.hit(t);
			return {
				hit: n,
				passThrough: r ?? !1
			};
		}
		_onDrag;
		_onPointerUp;
		onPointerDown(t) {
			let { onDrag: n, onPointerUp: r } = e.onPointerDown?.(t) ?? {};
			this._onDrag = n, this._onPointerUp = r;
		}
		onDrag(e) {
			this._onDrag?.(e);
		}
		onPointerUp(e) {
			this._onPointerUp?.(e);
		}
		onContextMenu(t) {
			e.onContextMenu?.(t);
		}
		onClick(t) {
			e.onClick?.(t);
		}
	}();
}
//#endregion
//#region src/layer/pan_layer.ts
var fs = 1 / 3600 / 180 * Math.PI, ps = class extends us {
	fovy0;
	J = V();
	constructor(e, t) {
		super(e, t, !0), this.fovy0 = this.globe.camera.fovy;
	}
	hit(e) {
		return {
			passThrough: !1,
			hit: e.originalEvent({
				mouse: (e) => rs.button(e) === rs.Button.LEFT,
				touch: () => !0
			}) ?? !1
		};
	}
	onInertialPointerDown(e) {
		let { x: t, y: n } = e.offset();
		is(this.globe, t, n, this.J), this.fovy0 = this.globe.camera.fovy;
	}
	onInertiaMove({ dt: e }) {
		let { velocity: { x: t, y: n } } = this.inertia.state, r = oo(Na(), [e * t, e * n], this.J), i = this.globe.camera, a = Math.min(this.globe.camera.fovy / this.fovy0, 1);
		i.phi -= a * r[0], i.theta -= a * r[1], i.theta = Jo(i.theta, -Math.PI / 2 + fs, Math.PI / 2 - fs);
	}
	get dragDetectionDelay() {
		return 0;
	}
}, ms = class extends $ {
	constructor(e) {
		super(e), this.pointingObjects.push(new ps(e, new Ho({
			omega0: .05,
			gamma: .04,
			gamma0: .001
		})));
	}
	onAddToGlobe() {
		let e = this.globe.containerElement, t = Ko(e, "dblclick", (e) => {
			e.preventDefault();
			let t = this.globe.canvas.coordFromClientCoord(e), [n, r] = this.globe.camera.coord2thetaphi(t);
			this.globe.camera.jumpTo({
				theta: n,
				phi: r
			});
		});
		this.onRemoveFromGlobe(t);
	}
}, hs = class extends us {
	hit(e) {
		return {
			passThrough: !1,
			hit: e.originalEvent({ mouse: (e) => rs.button(e) === rs.Button.MIDDLE }) ?? !1
		};
	}
	offset = {
		x: NaN,
		y: NaN
	};
	onInertialPointerDown(e) {
		let { x: t, y: n } = e.offset();
		this.offset.x = t, this.offset.y = n;
	}
	onInertiaMove({ dt: e }) {
		let { position: { x: t, y: n }, velocity: { x: r, y: i } } = this.inertia.state;
		t += this.offset.x, n += this.offset.y;
		let a = e * r, o = e * i, s = this.globe.canvas.domElement;
		n -= s.clientHeight / 2, t -= s.clientWidth / 2, t !== 0 && n !== 0 && (this.globe.camera.roll += (n * a - t * o) / (t * t + n * n));
	}
	get dragDetectionDelay() {
		return 0;
	}
}, gs = class extends $ {
	constructor(e) {
		super(e), this.pointingObjects.push(new hs(e, new Ho()));
	}
}, _s = /* @__PURE__ */ s({
	Angle: () => vs,
	SkyCoord: () => ys,
	amin2rad: () => xs,
	asec2rad: () => Ss,
	deg2rad: () => bs,
	dms2deg: () => Es,
	rad2amin: () => ws,
	rad2asec: () => Ts,
	rad2deg: () => Cs,
	wrapTo2Pi: () => Os
}), vs = class e {
	rad;
	constructor(e) {
		this.rad = e;
	}
	get deg() {
		return Cs(this.rad);
	}
	get amin() {
		return ws(this.rad);
	}
	get asec() {
		return Ts(this.rad);
	}
	static fromRad(t) {
		return new e(t);
	}
	static fromDeg(t) {
		return new e(bs(t));
	}
	static fromAmin(t) {
		return new e(xs(t));
	}
	static fromAsec(t) {
		return new e(Ss(t));
	}
	sexadecimal(e, t) {
		let n = 3600 * this.deg / e, r = t ? n < 0 ? "-" : "+" : "", i = Math.abs(n);
		return g(`${r}%02d:%02d:%07.4f`, Math.floor(i / 3600), Math.floor(i / 60 % 60), i % 60);
	}
	clone() {
		return new e(this.rad);
	}
}, ys = class e {
	a;
	d;
	constructor(e, t) {
		this.a = e, this.d = t;
	}
	static parse(t) {
		let { a: n, d: r } = As(t);
		return new e(n, r);
	}
	get xyz() {
		let e = this.a.rad, t = this.d.rad, n = Math.cos(t);
		return [
			n * Math.cos(e),
			n * Math.sin(e),
			Math.sin(t)
		];
	}
	static fromXyz([t, n, r]) {
		let i = t * t + n * n;
		if (i == 0) return e.fromRad(0, r > 0 ? Math.PI / 2 : -Math.PI / 2);
		{
			let a = 2 * Math.PI, o = (Math.atan2(n, t) + a) % a, s = Math.atan2(r, Math.sqrt(i));
			return e.fromRad(o, s);
		}
	}
	static fromRad(t, n) {
		return new e(vs.fromRad(t), vs.fromRad(n));
	}
	static fromDeg(t, n) {
		return new e(vs.fromDeg(t), vs.fromDeg(n));
	}
	toString() {
		return {
			a: this.a.sexadecimal(15, !1),
			d: this.d.sexadecimal(1, !0)
		};
	}
	squaredDistance(e) {
		let [t, n, r] = this.xyz, [i, a, o] = e.xyz, s = t - i, c = n - a, l = r - o;
		return s * s + c * c + l * l;
	}
	distance(e) {
		return Math.sqrt(this.squaredDistance(e));
	}
	cosine(e) {
		let [t, n, r] = this.xyz, [i, a, o] = e.xyz;
		return Jo(t * i + n * a + r * o, -1, 1);
	}
	angle(e) {
		return vs.fromRad(Math.acos(this.cosine(e)));
	}
};
function bs(e) {
	return .01745329252 * e;
}
function xs(e) {
	return .0002908882087 * e;
}
function Ss(e) {
	return 4848136811e-15 * e;
}
function Cs(e) {
	return 57.2957795131 * e;
}
function ws(e) {
	return 3437.7467707849 * e;
}
function Ts(e) {
	return 206264.806247096 * e;
}
function Es(e) {
	e = e.trim();
	let [t, n, r] = e.split(":").map((e) => Number(e));
	return t >= 0 ? t + n / 60 + r / 3600 : -(-t + n / 60 + r / 3600);
}
var Ds = 2 * Math.PI;
function Os(e) {
	return e < 0 ? Ds - -e % Ds : e % Ds;
}
var ks = /[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?/g;
function As(e) {
	e = e.replace(/−/g, "-"), e = e.replace(/([\+\-])\s+(\d)/, "$1$2").replace(/\[\d+\]/g, "");
	let t = e.match(ks);
	if (t == null || t.length < 2) throw Error(`invalid coord format: '${e}': numbers=${JSON.stringify(t)}`);
	return t.length == 2 ? ys.fromDeg(Number(t[0]), Number(t[1])) : new ys(js(t.slice(0, Math.floor(t.length / 2)), 15), js(t.slice(Math.floor(t.length / 2)), 1));
}
function js(e, t) {
	if (e.length == 0 || e.length > 3) throw Error(`invalid coord format: '${e.join(", ")}'`);
	let n = e[0], r = e[1] == null ? 0 : Number(e[1]), i = e[2] == null ? 0 : Number(e[2]);
	return n.substring(0, 1) == "-" ? vs.fromDeg(-t * (i / 3600 + r / 60 + Number(n.substring(1)))) : vs.fromDeg(t * (i / 3600 + r / 60 + Number(n)));
}
//#endregion
//#region src/utils/TinyHammer.ts
var Ms = class {
	el;
	callbacks;
	detectors;
	constructor(e) {
		this.el = e, this.callbacks = {
			doubletap: [],
			tap2: [],
			pinchstart: [],
			pinchmove: []
		}, this.detectors = {
			doubletap: new Ps(this),
			tap2: new Is(this),
			pinch: new Ls(this)
		};
	}
	destroy() {
		for (let e in this.detectors) this.detectors[e].destroy();
	}
	get(e) {
		return this.detectors[e];
	}
	on(e, t) {
		return this.callbacks[e].push(t), () => {
			this.callbacks[e] = this.callbacks[e].filter((e) => e !== t);
		};
	}
	runListeners(e) {
		for (let t of this.callbacks[e.type]) t(e);
	}
}, Ns = class {
	hammer;
	cleaner = Bs();
	eventListeners = [];
	constructor(e) {
		this.hammer = e;
	}
	get el() {
		return this.hammer.el;
	}
	destroy() {
		this.cleaner.flush();
	}
}, Ps = class extends Ns {
	posThreshold = 30;
	timeThreshold = 300;
	lastTap = null;
	constructor(e) {
		super(e);
		let t = zs(this.el, "touchstart", (e) => {
			if (e.touches.length === 1) {
				let t = e.touches[0], n = e.timeStamp, r = t.clientX, i = t.clientY;
				if (this.lastTap && n - this.lastTap.timeStamp < this.timeThreshold) {
					let t = r - this.lastTap.x, a = i - this.lastTap.y;
					if (Math.sqrt(t * t + a * a) < this.posThreshold) {
						this.hammer.runListeners({
							type: "doubletap",
							center: {
								x: this.lastTap.x,
								y: this.lastTap.y
							},
							pointerType: "touch",
							timeStamp: n,
							scale: 1,
							srcEvent: e
						}), this.lastTap = null, e.preventDefault();
						return;
					}
				}
				this.lastTap = {
					timeStamp: n,
					x: r,
					y: i
				};
			}
		});
		this.cleaner.add(t);
	}
	set(e) {
		e.posThreshold !== void 0 && (this.posThreshold = e.posThreshold), e.timeThreshold !== void 0 && (this.timeThreshold = e.timeThreshold);
	}
};
function Fs(e) {
	let t = 0, n = 0;
	for (let r = 0; r < e.length; r++) t += e[r].clientX, n += e[r].clientY;
	return {
		x: t / e.length,
		y: n / e.length
	};
}
var Is = class extends Ns {
	constructor(e) {
		super(e), this.setupListeners();
	}
	setupListeners() {
		let e = 0, t = [], n = (n) => {
			n.touches.length === 2 && (e = n.timeStamp, t = Array.from(n.touches).map((e) => ({
				x: e.clientX,
				y: e.clientY
			})));
		}, r = (n) => {
			if (n.touches.length === 0 && n.timeStamp - e < 500) {
				let e = Array.from(n.changedTouches).map((e) => ({
					x: e.clientX,
					y: e.clientY
				})), r = t.map((t, n) => {
					let r = e[n] ?? t;
					return Math.sqrt((r.x - t.x) ** 2 + (r.y - t.y) ** 2);
				});
				if (Math.max(...r) <= 10) {
					let e = Fs(n.changedTouches);
					this.hammer.runListeners({
						type: "tap2",
						center: e,
						pointerType: "touch",
						timeStamp: n.timeStamp,
						scale: 1,
						srcEvent: n
					}), n.preventDefault();
				}
			}
		}, i = zs(this.el, "touchstart", n), a = zs(this.el, "touchend", r);
		this.cleaner.add(i), this.cleaner.add(a);
	}
}, Ls = class extends Ns {
	initialDistance = null;
	initialCenter = null;
	constructor(e) {
		super(e), this.setupListeners();
	}
	setupListeners() {
		let e = zs(this.el, "touchstart", (e) => {
			e.touches.length === 2 && (this.initialDistance = Rs(e.touches[0], e.touches[1]), this.initialCenter = Fs(e.touches), this.hammer.runListeners({
				type: "pinchstart",
				center: this.initialCenter,
				pointerType: "touch",
				timeStamp: e.timeStamp,
				scale: 1,
				srcEvent: e
			}), e.preventDefault());
		}), t = zs(this.el, "touchmove", (e) => {
			if (e.touches.length === 2 && this.initialDistance !== null && this.initialCenter !== null) {
				let t = Rs(e.touches[0], e.touches[1]) / this.initialDistance, n = Fs(e.touches);
				this.hammer.runListeners({
					type: "pinchmove",
					center: n,
					pointerType: "touch",
					timeStamp: e.timeStamp,
					scale: t,
					srcEvent: e
				});
			}
		}), n = zs(this.el, "touchend", (e) => {
			this.initialDistance = null, this.initialCenter = null;
		});
		this.cleaner.add(e), this.cleaner.add(t), this.cleaner.add(n);
	}
};
function Rs(e, t) {
	let n = e.clientX - t.clientX, r = e.clientY - t.clientY;
	return Math.sqrt(n * n + r * r);
}
function zs(e, t, n, r) {
	return e.addEventListener(t, n, r), () => {
		e.removeEventListener(t, n);
	};
}
function Bs() {
	let e = [];
	return {
		add: (t) => {
			e.push(t);
		},
		flush: () => {
			for (; e.length > 0;) e.pop()();
		}
	};
}
//#endregion
//#region src/layer/touch_layer.ts
var Vs = class extends $ {
	mc;
	constructor(e) {
		super(e), this.mc = new Ms(this.globe.canvas.domElement), this.setupPinch(), this.setupDoubleTap(), this.setupTap2(), this.onRelease(() => {
			this.mc.destroy();
		});
	}
	setupDoubleTap() {
		this.mc.get("doubletap").set({ posThreshold: 30 }), this.mc.on("doubletap", (e) => {
			if (e.pointerType === "touch") {
				let { x: t, y: n } = e.center, { theta: r, phi: i, fovy: a } = Hs(this.globe, .5, {
					clientX: t,
					clientY: n
				});
				this.globe.camera.jumpTo({
					theta: r,
					phi: i,
					fovy: a
				}), this.globe.requestRefresh();
			}
		});
	}
	setupTap2() {
		this.mc.on("tap2", () => {
			let e = this.globe.camera;
			e.jumpTo({ fovy: e.fovy * 2 });
		});
	}
	setupPinch() {
		let e = 1;
		this.mc.on("pinchstart", () => {
			e = 1;
		}), this.mc.on("pinchmove", (t) => {
			let { x: n, y: r } = t.center, { theta: i, phi: a, fovy: o } = Hs(this.globe, e / t.scale, {
				clientX: n,
				clientY: r
			}), s = this.globe.camera;
			e = t.scale, s.theta = i, s.phi = a, s.fovy = o, s.cage(), this.globe.requestRefresh();
		});
	}
};
function Hs(e, t, n) {
	let r = e.canvas, i = e.camera, a = i.thetaphi2xyz(i.theta, i.phi), o = r.xyzFromClientCoord(n), [s, c, l] = a, [u, d, f] = o, p = (1 - t) * (u - s), m = (1 - t) * (d - c), h = (1 - t) * (f - l);
	s += p, c += m, l += h;
	let g = ys.fromXyz([
		s,
		c,
		l
	]), [_, v] = i.coord2thetaphi(g);
	return {
		theta: _,
		phi: v,
		fovy: i.fovy * t
	};
}
//#endregion
//#region src/lib/wheel-event-normalizer/realEventDetector.ts
var Us = {
	testDuration: 200,
	maxDecreasingRate: 1
};
function Ws(e = {}) {
	e = {
		...Us,
		...e
	};
	let t = e.testDuration, n = e.maxDecreasingRate, r = new Ks(Math.floor(t / 16) + 4);
	return (e) => {
		r.push([e.timeStamp, e.deltaY]);
		let i;
		for (i = 2; i <= r.length; ++i) {
			let [n, a] = r.back(i);
			if (e.timeStamp - n <= t) {
				if (e.deltaY * a < 0) return !0;
			} else break;
		}
		if (r.length < 2) return !0;
		let a = [];
		for (let e = 2; e < i; ++e) a.push(r.back(e - 1)[0] - r.back(e)[0]);
		let o = Gs(a);
		if (Math.abs(e.deltaY) <= 1 && a[0] > o * 1.05) return !1;
		let [s, c] = r.back(i - 1);
		return (e.deltaY / c) ** (1e3 / (e.timeStamp - s)) >= n;
	};
}
function Gs(e) {
	return e.length & 1 ? e[e.length >> 1] : (e[e.length >> 1] + e[(e.length >> 1) - 1]) / 2;
}
var Ks = class {
	n;
	origin = 0;
	xs = [];
	constructor(e) {
		this.n = e;
	}
	back(e) {
		let t = (this.origin - e + this.xs.length) % this.xs.length;
		return this.xs[t];
	}
	push(e) {
		this.xs.length < this.n ? this.xs.push(e) : this.xs[this.origin] = e, this.origin = (this.origin + 1) % this.n;
	}
	get length() {
		return this.xs.length;
	}
}, qs = {
	hotDuration: 150,
	on: {}
}, Js = class {
	cb;
	isRealEvent;
	inertia;
	raf;
	direction = 0;
	rawFire;
	options;
	lastRawEvent;
	constructor(e, t = qs) {
		this.cb = e, this.options = t = {
			...qs,
			...t
		}, this.isRealEvent = t.isRealEvent ?? Ws(), this.inertia = t.inertia ?? new Bo();
	}
	feedRawEvent(e) {
		this.lastRawEvent = e, this.isRealEvent(e) && (this.direction = Math.sign(e.deltaY), this.rawFire = performance.now(), this.raf === void 0 && (this.options.on.start?.(), this.startAnimation()));
	}
	startAnimation() {
		let e = (n) => {
			this.raf = void 0;
			let r = n - t, i = n - this.rawFire < this.options.hotDuration;
			t = n, i && this.inertia.addImpulse(r * this.direction), this.inertia.evolve(n);
			let { moving: a, v: o } = this.inertia.state;
			a || i ? (this.cb({
				dt: r,
				deltaY: o,
				rawEvent: this.lastRawEvent
			}), this.raf = requestAnimationFrame(e)) : this.options.on.end?.();
		}, t = performance.now();
		this.raf = requestAnimationFrame(e);
	}
	stop() {
		this.inertia.stop();
	}
}, Ys = class e {
	x;
	y;
	constructor(e, t) {
		this.x = e, this.y = t;
	}
	clone() {
		return new e(this.x, this.y);
	}
};
function Xs(e) {
	return window.TouchEvent && e instanceof TouchEvent;
}
var Zs = class e {
	e;
	constructor(e) {
		this.e = e;
	}
	originalEvent({ mouse: e, touch: t }) {
		return Xs(this.e) ? t && t(this.e) : e && e(this.e);
	}
	get clientX() {
		return Xs(this.e) ? (this.e.type === "touchend" ? this.e.changedTouches : this.e.touches).item(0).clientX : this.e.clientX;
	}
	get clientY() {
		return Xs(this.e) ? (this.e.type === "touchend" ? this.e.changedTouches : this.e.touches).item(0).clientY : this.e.clientY;
	}
	get clientCoord() {
		return new Ys(this.clientX, this.clientY);
	}
	get timeStamp() {
		return this.e.timeStamp;
	}
	static onDown(t, n, r = !1) {
		let i = (t) => {
			n(new e(t));
		}, a = (t) => {
			t.touches.length === 1 && n(new e(t));
		};
		return t.addEventListener("mousedown", i, {
			capture: r,
			passive: !0
		}), t.addEventListener("touchstart", a, {
			capture: r,
			passive: !0
		}), () => {
			t.removeEventListener("mousedown", i, { capture: r }), t.removeEventListener("touchstart", a, { capture: r });
		};
	}
	static onMove(t, n, r = !1) {
		let i = (t) => {
			n(new e(t));
		}, a = (t) => {
			t.touches.length === 1 && n(new e(t));
		};
		return t.addEventListener("mousemove", i, {
			capture: r,
			passive: !0
		}), t.addEventListener("touchmove", a, {
			capture: r,
			passive: !0
		}), () => {
			t.removeEventListener("mousemove", i, { capture: r }), t.removeEventListener("touchmove", a, { capture: r });
		};
	}
	static onUp(t, n, r = !1) {
		let i = (t) => {
			n(new e(t));
		}, a = (t) => {
			t.touches.length === 0 && n(new e(t));
		};
		return t.addEventListener("mouseup", i, r), t.addEventListener("touchend", a, r), () => {
			t.removeEventListener("mouseup", i, r), t.removeEventListener("touchend", a, r);
		};
	}
}, Qs = class extends $ {
	inertia = new Bo({
		gamma: .1,
		gamma0: .1,
		omega0: 2,
		minSpeed: 1e-4
	});
	onAddToGlobe() {
		let e, t = this.globe.containerElement, n = new Js((t) => {
			this.inertia.dragTo(t.deltaY), e === void 0 && (e = this.globe.animations.add(({ T: t, dt: r }) => {
				this.inertia.evolve(t), this.inertia.state.moving || e?.stop(), this.zoomStep(this.globe.canvas.xyzFromClientCoord(n.lastRawEvent), r);
			}, { cameraMotion: !0 }), e.then(() => {
				e = void 0, n.stop();
			}));
		}, {
			inertia: new Bo({
				gamma0: .002,
				omega0: 1,
				minSpeed: 1e-4
			}),
			hotDuration: 150
		}), r = Ko(t, "wheel", (e) => {
			e.preventDefault(), n.feedRawEvent(e);
		}, { passive: !1 });
		this.onRemoveFromGlobe(r);
		let i = Zs.onDown(t, () => {
			e?.stop();
		});
		this.onRemoveFromGlobe(i);
	}
	zoomStep(e, t) {
		let { x: n } = this.inertia.state, r = this.globe.camera, i = Math.exp(2e-5 * t * n), a = r.thetaphi2xyz(Math.PI / 2, 0), o = r.thetaphi2xyz(r.theta, r.phi), [s, c, l] = o, [u, d, f] = e, p = (1 - i) * (u - s), m = (1 - i) * (d - c), h = (1 - i) * (f - l), g = $o(a, o), _ = Jo(Math.sqrt(1 / (g * g) - 1) / r.fovy - .1, 0, 1);
		p = _ * p + (1 - _) * s, m = _ * m + (1 - _) * c, h = _ * h + (1 - _) * l, ar([
			s,
			c,
			l
		], a) >= .1 * r.fovy && (s += p, c += m, l += h);
		let v = ys.fromXyz([
			s,
			c,
			l
		]), [y, b] = r.coord2thetaphi(v);
		r.theta = y, r.phi = b, r.fovy *= i, r.cage();
	}
}, $s = /* @__PURE__ */ s({
	fastStart2: () => nc,
	fastStart4: () => ic,
	linear: () => ec,
	slowStart2: () => tc,
	slowStart4: () => rc,
	slowStartStop2: () => ac,
	slowStartStop4: () => oc
});
function ec(e) {
	return e;
}
function tc(e) {
	return e * e;
}
function nc(e) {
	return e = 1 - e, 1 - e * e;
}
function rc(e) {
	let t = e * e;
	return t * t;
}
function ic(e) {
	e = 1 - e;
	let t = e * e;
	return 1 - t * t;
}
function ac(e) {
	let t = 1 - e;
	return e < .5 ? 2 * e * e : -2 * t * t + 1;
}
function oc(e) {
	let t = e * e, n = 1 - e, r = n * n;
	return e < .5 ? 8 * t * t : -8 * r * r + 1;
}
//#endregion
//#region src/utils/matrilx-utils.ts
var sc = /* @__PURE__ */ s({
	composite: () => cc,
	izenith3: () => dc,
	izenith4: () => fc,
	mulZenith4: () => lc,
	normalizeZenith: () => mc,
	zenith3: () => uc
});
function cc(e, t) {
	let n = Q(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
	for (let r = 0; r < e.length; ++r) _n(n, n, t[r], e[r]);
	return n;
}
function lc(e, t, n, r) {
	let i = Math.cos(t), a = Math.sin(t), o = Math.cos(r), s = Math.sin(r), c = Math.cos(n), l = Math.sin(n);
	return bn(e, e, Q(i * o * l - a * s, -i * l * s - o * a, i * c, 0, i * s + o * a * l, i * o - a * l * s, c * a, 0, -c * o, c * s, l, 0, 0, 0, 0, 1)), e;
}
function uc(e, t, n) {
	let r = Math.cos(e), i = Math.sin(e), a = Math.cos(n), o = Math.sin(n), s = Math.cos(t), c = Math.sin(t);
	return Xe(r * a * c - i * o, -r * c * o - a * i, r * s, r * o + a * i * c, r * a - i * c * o, s * i, -s * a, s * o, c);
}
function dc(e, t, n) {
	let r = Math.cos(e), i = Math.sin(e), a = Math.cos(n), o = Math.sin(n), s = Math.cos(t), c = Math.sin(t);
	return Xe(r * a * c - i * o, r * o + a * i * c, -s * a, -r * c * o - a * i, r * a - i * c * o, s * o, r * s, s * i, c);
}
function fc(e, t, n) {
	let r = Math.cos(e), i = Math.sin(e), a = Math.cos(n), o = Math.sin(n), s = Math.cos(t), c = Math.sin(t);
	return Q(r * a * c - i * o, r * o + a * i * c, -s * a, 0, -r * c * o - a * i, r * a - i * c * o, s * o, 0, r * s, s * i, c, 0, 0, 0, 0, 1);
}
function pc(e) {
	let t = Math.asin(e[8]);
	return [
		Math.atan2(e[5], e[2]),
		t,
		Math.atan2(e[7], -e[6])
	];
}
function mc(e, t, n) {
	return pc(uc(e, t, n));
}
//#endregion
//#region src/view/MvpMatrix.ts
var hc = class {
	pv;
	iPv;
	eyePosition;
	direction;
	fovCenter;
	up;
	aspectRatio;
	fovy;
	arc;
	radius;
	constructor(e) {
		this.pv = e;
		let t = this.iPv = At(Z(), e) || Z(), n = [
			t[8] / t[11],
			t[9] / t[11],
			t[10] / t[11]
		], r = [
			t[12] - t[8] * t[15] / t[11],
			t[13] - t[9] * t[15] / t[11],
			t[14] - t[10] * t[15] / t[11]
		], i = [
			t[4] - t[7] * t[8] / t[11],
			t[5] - t[7] * t[9] / t[11],
			t[6] - t[7] * t[10] / t[11]
		];
		this.up = i;
		let a = [
			t[0] - t[3] * t[8] / t[11],
			t[1] - t[3] * t[9] / t[11],
			t[2] - t[3] * t[10] / t[11]
		], o = hr(i), s = hr(a) / o, c = Kn(n, r), l = 2 * o, u = -c + Math.sqrt(c * c - gr(n) + 1), d = l * u;
		this.eyePosition = n, this.direction = r, this.aspectRatio = s, this.fovy = l, this.arc = d, this.radius = this.arc * Math.sqrt(1 + s * s) / 2, this.fovCenter = [
			n[0] + u * r[0],
			n[1] + u * r[1],
			n[2] + u * r[2]
		];
	}
	ndc2xyz(e, t, n) {
		let r = this.iPv, i = 1 / (r[3] * e + r[7] * t + r[11] * n + r[15]), a = Kr([
			0,
			0,
			0,
			0
		], [
			i * e,
			i * t,
			i * n,
			i
		], r);
		return [
			a[0],
			a[1],
			a[2]
		];
	}
	ndc2sphereXYZ(e, t, n = !1, r = 1) {
		let i = this.ndc2xyz(e, t, -1), a = this.ndc2xyz(e, t, 1), o = es(i, a), s = $o(o, o), c = $o(o, a), l = $o(a, a) - r * r, u = c * c - s * l, d = (-c - Math.sqrt(n ? Math.abs(u) : u)) / s;
		return [
			d * i[0] + (1 - d) * a[0],
			d * i[1] + (1 - d) * a[1],
			d * i[2] + (1 - d) * a[2]
		];
	}
}, gc = class {
	globe;
	aspectRatio = -1;
	mode = "STEREOGRAPHIC";
	theta = 0;
	phi = 0;
	fovy = bs(45);
	roll = 0;
	lodBias = 0;
	za = 0;
	zd = Math.PI / 2;
	zp = 0;
	min_fovy = Ss(5);
	max_fovy = 4;
	retina = !0;
	constructor(e, t = {}) {
		this.globe = e;
		for (let e of [
			"aspectRatio",
			"fovy",
			"lodBias",
			"mode",
			"phi",
			"retina",
			"roll",
			"theta",
			"za",
			"zd",
			"zp"
		]) t[e] !== void 0 && (this[e] = t[e]);
		this.setLodHooks();
	}
	coord2thetaphi(e) {
		let t = er(Cn(), e.xyz, uc(this.za, this.zd, this.zp));
		return Qo(t[0], t[1], t[2]);
	}
	xyz2thetaphi(e) {
		return this.coord2thetaphi(ys.fromXyz(e));
	}
	thetaphi2xyz(e, t) {
		return er([
			0,
			0,
			0
		], Zo(e, t), dc(this.za, this.zd, this.zp));
	}
	center() {
		return yc(this);
	}
	jumpTo(e, t = {}) {
		let n = t.duration ?? 400, r = t.easingFunction || ic;
		this.globe.animations.stopCameraMotion();
		let i = {
			aspectRatio: this.aspectRatio,
			theta: this.theta,
			phi: this.phi,
			fovy: this.fovy,
			roll: this.roll,
			mode: this.mode,
			za: this.za,
			zd: this.zd,
			zp: this.zp
		}, a = { ...i };
		for (let [t, n] of Object.entries(e)) n !== void 0 && (a[t] = n);
		if (t.coord) {
			let e = er(Cn(), t.coord.xyz, uc(a.za, a.zd, a.zp));
			[a.theta, a.phi] = Qo(e[0], e[1], e[2]);
		}
		i.mode !== a.mode && this.changeMode(a.mode, n), i.phi = Os(i.phi), Math.abs(i.phi - a.phi) > Math.PI && (i.phi > a.phi ? a.phi += 2 * Math.PI : i.phi += 2 * Math.PI), i.za = Os(i.za), a.za = Os(a.za), Math.abs(i.za - a.za) > Math.PI && (i.za > a.za ? a.za += 2 * Math.PI : i.za += 2 * Math.PI);
		let o = Bn(Zo(i.theta, i.phi), Zo(a.theta, a.phi));
		return this.globe.animations.add(({ r: e }) => {
			let n = r(e);
			this.phi = n * a.phi + (1 - n) * i.phi, this.theta = n * a.theta + (1 - n) * i.theta;
			let s = 1 - (2 * (n - .5)) ** 2;
			this.fovy = t.keepFovy ? (1 - n) * i.fovy + n * a.fovy : s * Math.max(o - 2 * i.fovy, 0) + (1 - n) * i.fovy + n * a.fovy, this.roll = (1 - n) * i.roll + n * a.roll, this.za = (1 - n) * i.za + n * a.za, this.zd = (1 - n) * i.zd + n * a.zd, this.zp = (1 - n) * i.zp + n * a.zp;
		}, {
			duration: n,
			cameraMotion: !0
		});
	}
	modeTransitionPv;
	view() {
		return {
			mvp: new hc(this.modeTransitionPv ?? this.pv()),
			lodBias: this.lodBias,
			pixelRatio: this.pixelRatio,
			drawingBufferHeight: this.globe.gl.drawingBufferHeight
		};
	}
	customPvMatrix;
	pv(e = this.mode) {
		return (this.customPvMatrix || _c)({
			aspectRatio: this.aspectRatio,
			theta: this.theta,
			phi: this.phi,
			fovy: this.fovy,
			roll: this.roll,
			mode: e,
			za: this.za,
			zd: this.zd,
			zp: this.zp
		});
	}
	modeAnimation;
	changeMode(e, t = 200) {
		this.globe.emit("camera-mode-change", { mode: e });
		let n = this.mode;
		this.modeAnimation && this.modeAnimation.stop(), this.mode = e, this.modeAnimation = this.globe.animations.add(({ r: e }) => {
			e = ic(e), this.modeTransitionPv = cc([1 - e, e], [this.pv(n), this.pv()]);
		}, {
			duration: t,
			immediate: !0,
			cameraMotion: !0
		}), this.modeAnimation.then(() => {
			this.modeAnimation = void 0, this.modeTransitionPv = void 0;
		});
	}
	cageAnimation;
	cage() {
		let { min_fovy: e, max_fovy: t } = this;
		this.cageAnimation === void 0 && (this.fovy < e || t < this.fovy) && (this.cageAnimation = this.globe.animations.add(({ dt: n }) => {
			if (e <= this.fovy && this.fovy <= t) {
				this.cageAnimation.stop();
				return;
			}
			let r = this.fovy > t ? t : e, i = Math.log(this.fovy / r);
			i += (i < 0 ? -1 : 1) * .001, this.fovy *= Math.exp(-.005 * n * i);
		}, { cameraMotion: !0 }), this.cageAnimation.then(() => this.cageAnimation = void 0));
	}
	izenith() {
		return fc(this.za, this.zd, this.zp);
	}
	lodAnimation;
	setLodHooks() {
		this.globe.on("camera-move-start", () => {
			this.lodAnimation && this.lodAnimation.stop(), this.lodBias = 1;
		}), this.globe.on("camera-move-end", () => {
			this.lodAnimation = this.globe.animations.add(({ r: e }) => this.lodBias = 1 - e, { duration: 200 }), this.lodAnimation.then(() => {
				this.lodAnimation = void 0;
			});
		});
	}
	setRetina(e) {
		this.retina = e, this.globe.resize(), this.globe.requestRefresh();
	}
	get pixelRatio() {
		return this.retina ? window.devicePixelRatio : 1;
	}
};
function _c(e) {
	let t = Z();
	return vc(t, e), lc(t, e.za, e.zd, e.zp), t;
}
function vc(e, t) {
	let n = t.fovy / 2, r = t.aspectRatio, i = Math.cos(t.phi), a = Math.sin(t.phi), o = Math.cos(t.theta), s = Math.sin(t.theta), c = Math.sin(t.roll), l = Math.cos(t.roll);
	switch (t.mode) {
		case "GNOMONIC":
			Dt(e, (i * s * c + l * a) / (r * n), (-i * l * s + a * c) / n, 41 * i * o / 39, i * o, (-i * l + a * s * c) / (r * n), -(i * c + l * a * s) / n, 41 * o * a / 39, o * a, -o * c / (r * n), o * l / n, 41 * s / 39, s, 0, 0, -4 / 39, 0);
			break;
		case "STEREOGRAPHIC":
			Dt(e, 2 * (i * s * c + l * a) / (r * n), 2 * (-i * l * s + a * c) / n, 13 * i * o / 11, i * o, 2 * (-i * l + a * s * c) / (r * n), -(2 * i * c + 2 * l * a * s) / n, 13 * o * a / 11, o * a, -2 * o * c / (r * n), 2 * o * l / n, 13 * s / 11, s, 0, 0, 7 / 11, 1);
			break;
		case "FLOATING_EYE":
			Dt(e, (n + 1) * (i * s * c + l * a) / (r * n), (n + 1) * (-i * l * s + a * c) / n, 41 * i * o / 39, i * o, (n + 1) * (-i * l + a * s * c) / (r * n), -(n + 1) * (i * c + l * a * s) / n, 41 * o * a / 39, o * a, -o * c * (n + 1) / (r * n), o * l * (n + 1) / n, 41 * s / 39, s, 0, 0, 41 * n / 39 - 20 / 39, n);
			break;
	}
}
function yc(e) {
	let { theta: t, phi: n, za: r, zd: i, zp: a } = e, o = er([
		0,
		0,
		0
	], Zo(t, n), dc(r, i, a));
	return ys.fromXyz(o);
}
//#endregion
//#region src/globe/events.ts
function bc(e) {
	return { camera: e };
}
//#endregion
//#region src/globe/animation.ts
var xc = class {
	globe;
	rafId;
	animations = [];
	constructor(e) {
		this.globe = e;
	}
	add(e, t = {}) {
		let n = new Sc(e, t, () => {
			let e = this.animations.indexOf(n);
			e >= 0 && this.animations.splice(e, 1);
		});
		return n.cameraMotion && this.animations.filter((e) => e.cameraMotion).length === 0 && this.globe.emit("camera-move-start", bc(this.globe.camera)), this.animations.push(n), n.promise.finally(() => {
			n.cameraMotion && this.animations.filter((e) => e.cameraMotion).length === 0 && this.globe.emit("camera-move-end", bc(this.globe.camera));
		}), this.tick(), n.wrap();
	}
	tick() {
		this.animations.length > 0 && this.rafId === void 0 && (this.rafId = requestAnimationFrame(() => {
			let e = performance.now();
			this.rafId = void 0;
			let t = 0;
			for (let n of this.animations.slice()) n.cameraMotion && ++t, n.update(e);
			this.globe.draw(), this.tick(), t > 0 && this.globe.emit("camera-move", bc(this.globe.camera));
		}));
	}
	get refreshScheduled() {
		return !!this.rafId;
	}
	stopCameraMotion() {
		for (let e of this.animations.slice()) e.cameraMotion && e.stop();
	}
	clear() {
		for (; this.animations.length > 0;) this.animations[0].stop();
	}
}, Sc = class {
	cb;
	options;
	onStop;
	start = performance.now();
	last = this.start;
	resolve;
	reject;
	cameraMotion;
	promise;
	constructor(e, t = {}, n) {
		this.cb = e, this.options = t, this.onStop = n, this.cameraMotion = !!t.cameraMotion, this.promise = new Promise((e, t) => {
			this.resolve = e, this.reject = t;
		}), this.options.immediate && this.update(performance.now());
	}
	update(e) {
		let { duration: t } = this.options, n = e - this.start, r = e - this.last;
		if (this.last = e, t === void 0) this.cb({
			t: n,
			T: e,
			dt: r,
			r: NaN
		});
		else if (t === 0) this.cb({
			t: n,
			T: e,
			dt: r,
			r: 1
		}), this.expire();
		else {
			let i = n / t;
			this.cb({
				t: n,
				T: e,
				dt: r,
				r: Math.min(1, i)
			}), n > t && this.expire();
		}
	}
	expire() {
		this.stop();
	}
	stop(e = !1) {
		this.onStop(), e ? this.reject() : this.resolve();
	}
	wrap() {
		let e = this.stop.bind(this);
		return Object.assign(this.promise, { stop: e });
	}
}, Cc = class {
	globe;
	domElement;
	gl;
	releaseCanvas;
	preserveBuffer;
	constructor(e, t = {}) {
		this.globe = e;
		let { preserveBuffer: n = !1, jsdomTest: r = !1, webgl: i = "webgl2" } = t;
		this.preserveBuffer = n;
		let { canvas: a, gl: o, release: s } = b({
			alpha: !0,
			antialias: !1,
			stencil: !1,
			premultipliedAlpha: !1,
			preserveDrawingBuffer: n
		}, {
			jsdomTest: r,
			webgl: i
		});
		this.domElement = a, this.gl = o, this.releaseCanvas = s, a.style.backgroundColor = "#000", a.style.width = a.style.height = "100%", a.style.display = "block";
	}
	release() {
		this.releaseCanvas();
	}
	resize(e) {
		let t = this.domElement, n = e ? window.devicePixelRatio : 1, r = n * t.clientWidth, i = n * t.clientHeight;
		t.width = r, t.height = i, this.gl.viewport(0, 0, r, i);
	}
	setSize(e, t) {
		let n = this.domElement;
		n.width = e, n.height = t, this.gl.viewport(0, 0, e, t);
	}
	get aspectRatio() {
		let e = this.domElement, t = e.width / e.height;
		return isNaN(t) ? 1 : t;
	}
	coordFromClientCoord(e) {
		return ys.fromXyz(this.xyzFromClientCoord(e));
	}
	xyzFromClientCoord(e) {
		return this.xyzFromNdc(this.ndcFromClientCoord(e));
	}
	xyzFromOffset(e, t) {
		return this.xyzFromNdc(this.ndcFromOffset(e, t));
	}
	coordFromOffset(e, t) {
		return ys.fromXyz(this.xyzFromOffset(e, t));
	}
	xyzFromNdc([e, t]) {
		return this.globe.camera.view().mvp.ndc2sphereXYZ(e, t, !0);
	}
	ndcFromClientCoord(e) {
		let t = this.domElement.getBoundingClientRect(), [n, r] = [e.clientX - t.left, e.clientY - t.top];
		return this.ndcFromOffset(n, r);
	}
	ndcFromOffset(e, t) {
		return [2 * e / this.domElement.clientWidth - 1, 1 - 2 * t / this.domElement.clientHeight];
	}
	get pixelData() {
		if (!this.preserveBuffer) throw Error("this.offscreen must be true");
		let e = this.gl, t = e.drawingBufferWidth, n = e.drawingBufferHeight, r = new Uint8Array(t * n * 4);
		return e.finish(), e.readPixels(0, 0, e.drawingBufferWidth, e.drawingBufferHeight, e.RGBA, e.UNSIGNED_BYTE, r), {
			width: t,
			height: n,
			buffer: r.buffer
		};
	}
}, wc = class extends Zs {
	globe;
	view;
	coord;
	constructor(e, t, n) {
		super(e.e), this.globe = t, this.view = n, this.coord = t.canvas.coordFromClientCoord(e);
	}
	offset() {
		let e = this.globe.canvas.domElement.getBoundingClientRect();
		return {
			x: this.clientX - e.left,
			y: this.clientY - e.top
		};
	}
	coord2offset(e) {
		let t = Kr(yr(), [...e.xyz, 1], this.view.mvp.pv), n = t[0] / t[3], r = t[1] / t[3], i = this.globe.canvas.domElement.getBoundingClientRect();
		return [i.width * (n + 1) / 2, i.height * (1 - (r + 1) / 2)];
	}
	stopCount = 0;
	stopPropagation() {
		++this.stopCount;
	}
	get stopped() {
		return this.stopCount > 0;
	}
}, Tc = class {
	current;
	downEvent;
	constructor(e, t) {
		this.current = e, this.downEvent = t;
	}
	get coord() {
		return this.current.coord;
	}
	get offset() {
		return this.current.offset;
	}
	coord2offset(e) {
		return this.coord2offset(e);
	}
	stopPropagation() {
		return this.current.stopPropagation();
	}
	get stopped() {
		return this.current.stopped;
	}
	delta() {
		return {
			x: this.current.clientX - this.downEvent.clientX,
			y: this.current.clientY - this.downEvent.clientY
		};
	}
	get moved() {
		return !(this.current.clientX === this.downEvent.clientX && this.current.clientY === this.downEvent.clientY);
	}
};
//#endregion
//#region src/globe/pointer_event.ts
function Ec(e) {
	let t = cs(), n = e.containerElement, r = !1, i = () => e.camera.view(), a = Zs.onDown(n, (t) => {
		let n = [], a = new wc(t, e, i());
		r = !0;
		layerLoop: for (let t = e.layers.length - 1; t >= 0; --t) {
			let r = e.layers[t];
			for (let t of r.pointingObjects) {
				let { hit: r, passThrough: i } = t.hit(a);
				if (r && (e.setCursor(t.dragIcon(a)), n.push(t), t.runOnPointerDown(a), !i || a.stopped)) break layerLoop;
			}
		}
		let s = Zs.onMove(document, (t) => {
			let r = i(), o = t.timeStamp - a.timeStamp, s = new Tc(new wc(t, e, r), a);
			for (let e of n) o >= e.dragDetectionDelay && e.runOnDrag(s);
		}), c = Zs.onUp(document, (l) => {
			c(), s(), r = !1;
			let u = i(), d = new wc(l, e, u), f = new Tc(d, a), p = new Tc(a, a), m = new wc(t, e, u), h = l.timeStamp - t.timeStamp;
			for (let e of n) e.runOnPointerUp(h >= e.dragDetectionDelay ? f : p);
			if (Go(t, l)) {
				for (let e of n) if (e.runOnClick(h >= e.dragDetectionDelay ? d : m), d.stopped) break;
			}
			o(d), e.emit("pointer-up", d);
		});
		e.emit("pointer-down", a);
	});
	t.add(a);
	let o = (t) => {
		if (!r) {
			let n = 0;
			for (let r = e.layers.length - 1; r >= 0; --r) {
				let i = e.layers[r];
				for (let r of i.pointingObjects) {
					let { hit: i } = r.runHover(t);
					i && n++ === 0 && e.setCursor(r.hoverIcon(t));
				}
			}
		}
	}, s, c = Zs.onMove(n, (t) => {
		e.emit("pointer-move", new wc(t, e, i()));
		let n = new wc(t, e, i());
		o(n), s = n;
	});
	t.add(c), t.add(e.on("layer-change", () => {
		s && o(s);
	}));
	let l = Ko(n, "contextmenu", (t) => {
		let n = new wc(new Zs(t), e, i()), r = 0;
		layerLoop: for (let t = e.layers.length - 1; t >= 0; --t) {
			let i = e.layers[t];
			for (let e of i.pointingObjects) {
				let { hit: t, passThrough: i } = e.hit(n);
				if (t && (++r, e.runOnContextMenu(n), !i || n.stopped)) break layerLoop;
			}
		}
		r > 0 && t.preventDefault();
	});
	return t.add(l), t.flush;
}
//#endregion
//#region src/globe/index.ts
var Dc = class {
	containerElement;
	camera;
	animations;
	canvas;
	dataRepository;
	visualEffectRenderer;
	_visualEffect;
	constructor(e, t = {}) {
		this.containerElement = e, this.dataRepository = t.dataRepository ?? `${location.protocol}//hscmap.mtk.nao.ac.jp/stellar-globe/static`, this.canvas = new Cc(this, t), this.onRelease(() => this.canvas.release()), e.appendChild(this.canvas.domElement), this.onRelease(() => e.removeChild(this.canvas.domElement)), this.animations = new xc(this), this.onRelease(() => this.animations.clear()), this.onRelease(Ec(this)), this.camera = new gc(this, {
			aspectRatio: this.canvas.aspectRatio,
			...t.viewOptions ?? {}
		});
		let n = t.visualEffect ?? t.distortion;
		n && this.setVisualEffect(n), t.noDefaultLayers || kc(this), t.jsdomTest || this.initResizeObserver(), this.onRelease(() => this._alreadyReleased = !0), this.onRelease(() => {
			this.visualEffectRenderer && this.visualEffectRenderer.release();
		});
	}
	setVisualEffect(e) {
		this.visualEffectRenderer &&= (this.visualEffectRenderer.release(), void 0), e ? (this._visualEffect = e, this.visualEffectRenderer = new Ro(this.gl, e, this)) : this._visualEffect = void 0, this.requestRefresh();
	}
	get visualEffect() {
		return this._visualEffect;
	}
	captureVisualEffectSnapshot() {
		return this.visualEffectRenderer ? (this.rafId !== void 0 && (cancelAnimationFrame(this.rafId), this.rafId = void 0), this.draw(), this.visualEffectRenderer.captureSnapshot(), !0) : !1;
	}
	clearVisualEffectSnapshot() {
		return this.visualEffectRenderer ? (this.visualEffectRenderer.clearSnapshot(), !0) : !1;
	}
	_alreadyReleased = !1;
	get alreadyReleased() {
		return this._alreadyReleased;
	}
	layers = [];
	get gl() {
		return this.canvas.gl;
	}
	events = os();
	emit = this.events.emit;
	on = this.events.on;
	releaseCallbacks = cs();
	onRelease = this.releaseCallbacks.add;
	release() {
		for (let e of this.layers.slice()) e.release();
		this.releaseCallbacks.flush();
	}
	resize() {
		this.canvas.resize(this.camera.retina), this.camera.aspectRatio = this.canvas.aspectRatio, this.emit("resize", {}), this.requestRefresh();
	}
	initResizeObserver() {
		let e = new ResizeObserver((e) => {
			requestAnimationFrame(() => this.resize());
		});
		e.observe(this.canvas.domElement), this.onRelease(() => {
			e.disconnect();
		}), this.resize();
	}
	addNewLayer(e, ...t) {
		let n = new e(this, ...t);
		return this.addLayer(n);
	}
	addLayer(e) {
		if (this.hasLayer(e)) throw console.warn(e), Error("The layer is added twice");
		return this.layers.push(e), this.layerSorter.sort(), e.runOnAddToGlobeCallbacks(), this.requestRefresh(), this.emit("layer-change", { added: [e] }), e;
	}
	removeLayer(e) {
		let t = this.layers.indexOf(e);
		t >= 0 && (e.runRemoveFromGlobeCallbacks(), this.layers.splice(t, 1), this.requestRefresh(), this.emit("layer-change", { removed: [e] }));
	}
	hasLayer(e) {
		return this.layers.includes(e);
	}
	rafId;
	requestRefresh() {
		if (this._alreadyReleased) {
			console.trace("called Globe.requestRefresh after release");
			return;
		}
		this.rafId === void 0 && !this.animations.refreshScheduled && (this.rafId = requestAnimationFrame(() => {
			this.rafId = void 0, this.draw();
		}));
	}
	draw() {
		if (this._alreadyReleased) return;
		let e = this.gl, t = this.canvas.domElement;
		p(this.gl, "draw", () => {
			if (e.colorMask(!0, !0, !0, !0), e.clearColor(0, 0, 0, 1), e.clear(e.COLOR_BUFFER_BIT), this.visualEffectRenderer && this._visualEffect) this.visualEffectRenderer.pipeAndDraw(() => {
				let n = this._visualEffect.scale, { width: r, height: i } = t;
				t.width = Math.floor(t.width * n), t.height = Math.floor(t.height * n), e.clear(e.COLOR_BUFFER_BIT);
				for (let e of this.layers) e.render(this.camera.view());
				t.width = r, t.height = i;
			});
			else {
				let t = this.camera.view();
				for (let e of this.layers) e.render(t);
				e.clearColor(0, 0, 0, 1), e.colorMask(!1, !1, !1, !0), e.clear(e.COLOR_BUFFER_BIT), e.colorMask(!0, !0, !0, !0), e.flush();
			}
		});
	}
	layerSorter = new Oc(this);
	cursorMemo = "default";
	setCursor(e) {
		this.cursorMemo !== e && (this.cursorMemo = e, this.containerElement.style.cursor = e);
	}
}, Oc = class {
	globe;
	constructor(e) {
		this.globe = e;
	}
	sortFunc;
	setSortFunc(e) {
		this.sortFunc = e, e && (this.sort(), this.globe.requestRefresh());
	}
	sort() {
		this.sortFunc && this.globe.layers.sort(this.sortFunc);
	}
};
function kc(e) {
	e.addNewLayer(ms), e.addNewLayer(gs), e.addNewLayer(Qs), e.addNewLayer(Vs);
}
//#endregion
//#region src/layer/pointer_lock_layer.ts
var Ac = 1 / 3600 / 180 * Math.PI, jc = class extends $ {
	options;
	constructor(e, t = {}) {
		super(e), this.options = t;
	}
	onAddToGlobe() {
		let e = this.globe.canvas.domElement, t = !1, n = () => {
			t && (t = !1, this.globe.emit("camera-move-end", bc(this.globe.camera)));
		}, r = (t) => {
			if (!Nc(t.key) || !t.shiftKey || !t.ctrlKey || t.repeat || Mc(t.target) || document.pointerLockElement === e) return;
			e.focus();
			let n = e.requestPointerLock?.();
			n && typeof n.catch == "function" && n.catch((e) => console.warn("Pointer lock request was rejected", e));
		}, i = (t) => {
			Nc(t.key) && document.pointerLockElement === e && document.exitPointerLock?.();
		}, a = () => {
			document.pointerLockElement === e && document.exitPointerLock?.();
		}, o = () => {
			document.pointerLockElement === e ? t || (t = !0, this.globe.emit("camera-move-start", bc(this.globe.camera))) : n();
		}, s = (t) => {
			if (document.pointerLockElement !== e) return;
			let n = (this.options.invertX ? -1 : 1) * t.movementX, r = (this.options.invertY ? -1 : 1) * t.movementY;
			if ((!Number.isFinite(n) || n === 0) && (!Number.isFinite(r) || r === 0)) return;
			let i = e.clientWidth / 2, a = e.clientHeight / 2, o = is(this.globe, i, a), [s, c] = oo(Na(), [n, r], o), l = this.globe.camera;
			l.phi += s, l.theta = Jo(l.theta + c, -Math.PI / 2 + Ac, Math.PI / 2 - Ac), this.globe.requestRefresh(), this.globe.emit("camera-move", bc(l));
		}, c = Ko(window, "keydown", r), l = Ko(window, "keyup", i), u = Ko(window, "blur", a), d = Ko(document, "mousemove", s), f = Ko(document, "pointerlockchange", o);
		this.onRemoveFromGlobe(() => {
			c(), l(), u(), d(), f(), document.pointerLockElement === e && document.exitPointerLock?.(), n();
		});
	}
};
function Mc(e) {
	return e instanceof HTMLElement ? e.isContentEditable ? !0 : e.closest("input, textarea, select, button, [contenteditable=\"true\"]") !== null : !1;
}
function Nc(e) {
	return e === "Shift" || e === "Control";
}
//#endregion
//#region src/layer/overlayAlpha.ts
var Pc = .1, Fc = 4;
function Ic(e) {
	return 1 - Lc(e);
}
function Lc(e) {
	let t = Pc, n = Fc;
	return Jo((e.mvp.arc - t) * n, 0, 1);
}
//#endregion
//#region src/utils/canvas.ts
function Rc(e, t, n) {
	let { canvas: r, ctx: i } = zc();
	r.width = e, r.height = t, i.save(), i.clearRect(0, 0, e, t);
	let a = n(i);
	return i.restore(), a;
}
var zc = (() => {
	let e, t;
	return () => (e ??= document.createElement("canvas"), t ??= e.getContext("2d", { willReadFrequently: !0 }), {
		canvas: e,
		ctx: t
	});
})(), Bc = "precision mediump float;\nuniform   sampler2D  u_texture;\nuniform   float      u_alpha;\nuniform   vec4       u_color;\nvarying   vec2       v_tCoord;\nvarying   vec4       v_color;\n\nvoid main() {\n    gl_FragColor = u_color * v_color * texture2D(u_texture, v_tCoord);\n    gl_FragColor.a *= u_alpha;\n}", Vc = "uniform    mat4   u_pvMatrix, u_mMatrix;\nuniform    float  u_width, u_height;\nattribute  vec3   a_vCoord;\nattribute  vec2   a_size, a_tCoord;\nattribute  vec4   a_color;\nvarying    vec2   v_tCoord;\nvarying    vec4   v_color;\n\nvoid main(void) {\n    gl_Position = u_pvMatrix * vec4(a_vCoord, 1.);\n    gl_Position.x += a_size.x / u_width * gl_Position.w;\n    gl_Position.y += a_size.y / u_height * gl_Position.w;\n    v_tCoord = a_tCoord;\n    v_color = a_color;\n}", Hc = class extends Error {};
function Uc(e, t, n) {
	let r = e.map((e, t) => ({
		box: e,
		index: t
	})).sort((e, t) => t.box.height - e.box.height), i = [], a = 0, o = 0, s = 0, c = 0, l = 0;
	for (let { box: e, index: u } of r) if (e.width > t || e.height > n || (s + e.width <= t ? (i.push({
		x: s,
		y: c,
		index: u
	}), s += e.width, l = Math.max(l, e.height)) : (s = 0, c += l, l = e.height, i.push({
		x: s,
		y: c,
		index: u
	}), s += e.width), a = Math.max(a, s), o = c + l, o > n)) throw new Hc();
	return {
		boxPositions: i.sort((e, t) => e.index - t.index).map((e) => ({
			x: e.x,
			y: e.y
		})),
		containerWidth: a,
		containerHeight: o
	};
}
function Wc(e, t) {
	let n = 256;
	for (; n < t;) try {
		return Uc(e, n, n);
	} catch (e) {
		if (e instanceof Hc) n *= 2;
		else throw e;
	}
	throw new Hc();
}
//#endregion
//#region src/renderer/billboard_renderer/index.ts
var Gc = class {
	gl;
	scale = 1;
	program;
	attribList;
	texture;
	color = [
		1,
		1,
		1,
		1
	];
	constructor(e, t = [], n = []) {
		this.gl = e, this.program = S.new(e, Vc, Bc), this.attribList = new E(e, { members: [
			{
				name: "a_vCoord",
				nComponents: 3
			},
			{
				name: "a_color",
				nComponents: 4
			},
			{
				name: "a_size",
				nComponents: 2
			},
			{
				name: "a_tCoord",
				nComponents: 2
			}
		] }), this.texture = new A(e), this.buildArray(t, n);
	}
	release() {
		this.program.release(), this.attribList.release(), this.texture.release();
	}
	buildArray(e, t) {
		let n = this.gl, r = Kc(e, n.getParameter(n.MAX_TEXTURE_SIZE));
		this.texture.bind(() => {
			n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, n.RGBA, n.UNSIGNED_BYTE, r.imageData), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.LINEAR_MIPMAP_LINEAR), n.generateMipmap(n.TEXTURE_2D);
		});
		let i = [], { width: a, height: o } = r.imageData;
		for (let e of t) {
			let { rect: { left: t, right: n, top: s, bottom: c, width: l, height: u }, origin: d } = r.bbox[e.imageID];
			i.push(...e.position, ...e.color, (-1 + d[0]) * l, (-1 + d[1]) * u, t / a, c / o, ...e.position, ...e.color, (1 + d[0]) * l, (-1 + d[1]) * u, n / a, c / o, ...e.position, ...e.color, (1 + d[0]) * l, (1 + d[1]) * u, n / a, s / o, ...e.position, ...e.color, (-1 + d[0]) * l, (-1 + d[1]) * u, t / a, c / o, ...e.position, ...e.color, (1 + d[0]) * l, (1 + d[1]) * u, n / a, s / o, ...e.position, ...e.color, (-1 + d[0]) * l, (1 + d[1]) * u, t / a, s / o);
		}
		this.attribList.setData({ array: new Float32Array(i) });
	}
	render(e, t = 1) {
		if (this.attribList.vertexCount === 0 || t <= 0) return;
		let n = this.gl, r = this.program;
		r.use();
		let i = this.scale * e.pixelRatio;
		r.uniformMatrix4fv({ u_pvMatrix: e.mvp.pv }), r.uniform4fv({ u_color: this.color }), r.uniform1i({ u_texture: 0 }), r.uniform1f({
			u_alpha: t,
			u_width: 1 / i * n.drawingBufferWidth,
			u_height: 1 / i * n.drawingBufferHeight
		}), _(n, [n.BLEND], () => {
			n.blendFunc(n.SRC_ALPHA, n.ONE_MINUS_SRC_ALPHA), this.texture.bind(() => {
				this.attribList.enable(r, () => {
					n.drawArrays(n.TRIANGLES, 0, this.attribList.vertexCount);
				});
			});
		});
	}
};
function Kc(e, t) {
	let n = e.map((e) => ({
		width: e.imageData.width + 2,
		height: e.imageData.height + 2
	}));
	try {
		let { boxPositions: r, containerHeight: i, containerWidth: a } = Wc(n, t), o = qc(a), s = qc(i);
		return Rc(o, s, (t) => {
			let n = [];
			for (let i = 0; i < e.length; ++i) {
				let a = e[i], { x: o, y: s } = r[i], { width: c, height: l } = a.imageData;
				t.putImageData(a.imageData, o + 1, s + 1), n.push({
					rect: new Jc(c, l, o, s),
					origin: a.origin
				});
			}
			return {
				imageData: t.getImageData(0, 0, o, s),
				bbox: n
			};
		});
	} catch (e) {
		if (e instanceof Hc) return {
			imageData: new ImageData(1, 1),
			bbox: []
		};
		throw e;
	}
}
function qc(e) {
	let t = 1;
	for (; t < e;) t *= 2;
	return t;
}
var Jc = class {
	width;
	height;
	left;
	top;
	constructor(e, t, n, r) {
		this.width = e, this.height = t, this.left = n, this.top = r;
	}
	get right() {
		return this.left + this.width;
	}
	get bottom() {
		return this.top + this.height;
	}
}, Yc = "precision mediump float;\n\nuniform float u_fovy;\nvarying vec4 v_color;\nvarying float v_y;\nvarying float v_w;\n\n/**/\nvoid main() {\n    float alpha = 1. - smoothstep(0., 0.9, abs(v_y));\n    alpha *= clamp(4. * (v_w - 0.2), 0., 1.);\n    gl_FragColor = vec4(v_color.rgb, alpha * v_color.a);\n}\n\n/*/\n\nvoid main() {\n    // 線の中心からの距離を計算\n    float edgeDistance = abs(v_y); // 中心からの距離\n\n    // ぼかしを適用する閾値を設定\n    float blurStart = 0.9; // ぼかしを開始する閾値\n    float blurEnd = 1.0; // ぼかしを終了する閾値\n\n    // smoothstepを使用して、端の1ピクセルのみをぼかす\n    float alpha = 1. - smoothstep(blurStart, blurEnd, edgeDistance);\n\n    // その他の透明度の調整\n    alpha *= clamp(4. * (v_w - 0.2), 0., 1.);\n\n    // 最終的な色の設定\n    gl_FragColor = vec4(v_color.rgb, alpha * v_color.a);\n}\n\n/**/", Xc = "precision mediump float;\n\nuniform    mat4   u_pvmMatrix;\nuniform    float  u_aspectRatio;\nuniform    float  u_alpha;\nuniform    float  u_fovy;\nuniform    float  u_minWidth;\nuniform    int    u_darkenNarrowLine;\nattribute  vec3   a_p;\nattribute  vec3   a_a;\nattribute  vec3   a_b;\nattribute  float  a_y;\nattribute  float  a_width;\nattribute  vec4   a_color;\nvarying    vec4   v_color;\nvarying    float  v_y;\nvarying    float  v_w;\n\n\nvoid main(void) {\n    vec4 p4 = u_pvmMatrix * vec4(a_p, 1.);\n\n    vec4 a4 = u_pvmMatrix * vec4(a_a, 1.),\n         b4 = u_pvmMatrix * vec4(a_b, 1.);\n\n    vec2 a2 = (p4.w * a4.xy - a4.w * p4.xy) / (p4.w * p4.w),\n         b2 = (p4.w * b4.xy - b4.w * p4.xy) / (p4.w * p4.w);\n\n    a2.x *= u_aspectRatio;\n    b2.x *= u_aspectRatio;\n    a2 = normalize(a2);\n    b2 = normalize(b2);\n\n    vec2 t2 = normalize(b2 - a2),\n         v2 = vec2(-t2.y, t2.x);\n\n	v_color = a_color;\n    v_color.a *= u_alpha;\n\n    float cosecPhi = clamp(1. / (a2.y*v2.x - a2.x*v2.y), -2., 2.),\n          width = a_width / u_fovy,\n          minWidth = u_minWidth * p4.w;\n\n    if (width < minWidth) {\n        if (u_darkenNarrowLine == 1) {\n            v_color.a *= width / minWidth;\n        }\n        width = minWidth;\n    }\n\n    vec2 d2 = width * a_y * v2 * cosecPhi;\n    d2.x /= u_aspectRatio;\n    p4.xy += d2;\n    gl_Position = p4;\n\n    v_y = a_y;\n    v_w = gl_Position.w;\n}", Zc = class {
	gl;
	program;
	attribList;
	darkenNarrowLine;
	minWidth;
	blendMode;
	modelMatrix = Z();
	_paths = [];
	setPaths(e) {
		this._paths = e.slice(), this.needsUpdatePaths = !0;
	}
	constructor(e, t = {}) {
		this.gl = e, this.darkenNarrowLine = t.darkenNarrowLine ?? !0, this.minWidth = t.minWidth ?? 5, this.blendMode = t.blendMode ?? "ADD", this.program = S.new(e, Xc, Yc), this.attribList = new E(e, { members: [
			{
				name: "a_p",
				nComponents: 3
			},
			{
				name: "a_a",
				nComponents: 3
			},
			{
				name: "a_b",
				nComponents: 3
			},
			{
				name: "a_y",
				nComponents: 1
			},
			{
				name: "a_width",
				nComponents: 1
			},
			{
				name: "a_color",
				nComponents: 4
			}
		] });
	}
	alreadyReleased = !1;
	release() {
		this.alreadyReleased = !0, this.attribList.release(), this.program.release();
	}
	needsUpdatePaths = !1;
	render(e, t = 1) {
		if (this.needsUpdatePaths &&= (this.updateVBO(), !1), this.attribList.vertexCount === 0 || t <= 0) return;
		let n = e.mvp, r = this.gl, i = this.program;
		i.enableAttribList(this.attribList, () => {
			i.uniformMatrix4fv({ u_pvmMatrix: bn(Z(), n.pv, this.modelMatrix) }), i.uniform1f({
				u_alpha: t,
				u_fovy: n.fovy,
				u_aspectRatio: n.aspectRatio,
				u_minWidth: e.pixelRatio * this.minWidth / r.drawingBufferHeight
			}), i.uniform1i({ u_darkenNarrowLine: +!!this.darkenNarrowLine });
			let a = [r.BLEND];
			_(r, a, () => {
				switch (this.blendMode) {
					case "ADD":
						r.blendFunc(r.SRC_ALPHA, r.ONE);
						break;
					case "NORMAL":
						r.blendFunc(r.SRC_ALPHA, r.ONE_MINUS_SRC_ALPHA);
						break;
				}
				r.drawArrays(r.TRIANGLE_STRIP, 0, this.attribList.vertexCount);
			});
		});
	}
	updateVBO() {
		let e = [], t = this._paths;
		for (let n of t) switch (n.joint) {
			case "MITER":
				Qc(e, n);
				break;
			case "NONE":
				$c(e, n);
				break;
		}
		this.attribList.setData({ array: new Float32Array(e) });
	}
};
function Qc(e, t) {
	let n = t.points.slice();
	if (t.points.length < 2) throw Error("Path must include more than 2 points");
	if (t.close) n.unshift(n[n.length - 1]), n.push(n[1], n[2]);
	else {
		n.unshift({
			...n[0],
			position: n[0].position.map((e, t) => 2 * e - n[1].position[t])
		});
		let e = n.length - 1;
		n.push({
			...n[e],
			position: n[e].position.map((t, r) => 2 * t - n[e - 1].position[r])
		});
	}
	for (let t = 1; t < n.length - 1; ++t) {
		let r = n[t], i = n[t - 1], a = n[t + 1];
		e.push(...r.position, ...i.position, ...a.position, -1, .5 * r.size, ...r.color), t === 1 && e.push(...e.slice(e.length - 15)), e.push(...r.position, ...i.position, ...a.position, 1, .5 * r.size, ...r.color);
	}
	e.push(...e.slice(e.length - 15));
}
function $c(e, t) {
	let n = t.points.slice();
	if (n.length < 2) throw Error("Path must include more than 2 points");
	t.close && n.push(n[0]);
	for (let t = 0; t < n.length - 1; ++t) {
		let r = n[t], i = n[t + 1], a = [
			0,
			1,
			2
		].map((e) => 2 * r.position[e] - i.position[e]), o = [
			0,
			1,
			2
		].map((e) => 2 * i.position[e] - r.position[e]);
		e.push(...r.position, ...a, ...i.position, 1, .5 * r.size, ...r.color), e.push(...r.position, ...a, ...i.position, 1, .5 * r.size, ...r.color), e.push(...r.position, ...a, ...i.position, -1, .5 * r.size, ...r.color), e.push(...i.position, ...r.position, ...o, 1, .5 * i.size, ...i.color), e.push(...i.position, ...r.position, ...o, -1, .5 * i.size, ...i.color), e.push(...i.position, ...r.position, ...o, -1, .5 * i.size, ...i.color);
	}
}
//#endregion
//#region src/renderer/path_renderer/index.ts
var el = /* @__PURE__ */ s({ Renderer: () => Zc }), tl;
function nl(e) {
	let t = tl ??= rl();
	e(t), document.body.appendChild(t);
	let { clientWidth: n, clientHeight: r } = t;
	return document.body.removeChild(t), {
		width: n,
		height: r
	};
}
function rl() {
	let e = document.createElement("div");
	return e.style.position = "fixed", e.style.visibility = "hidden", e;
}
//#endregion
//#region src/utils/text2imagedata.ts
function il(e, t = "48pt sans-serif", n = "rgba(255, 255, 255, 1)", r = 10) {
	let { width: i, height: a } = nl((n) => {
		n.style.font = t, n.innerText = e;
	});
	return i += 2 * r, a += 2 * r, Rc(i, a, (o) => {
		o.font = t, o.textBaseline = "top", o.lineCap = "round", o.lineJoin = "round";
		for (let [t, n] of [
			[.25, 15],
			[.5, 10],
			[.75, 5]
		]) o.strokeStyle = `rgba(0, 0, 0, ${t})`, o.lineWidth = n, o.strokeText(e, r, r);
		return o.fillStyle = n, o.fillText(e, r, r), o.getImageData(0, 0, i, a);
	});
}
//#endregion
//#region src/layer/constellation_layer/japanese.ts
var al = {
	Andromeda: "アンドロメダ",
	Antlia: "ポンプ",
	Apus: "風鳥",
	Aquarius: "水瓶",
	Aquila: "鷲",
	Ara: "祭壇",
	Aries: "牡羊",
	Auriga: "御者",
	Boötes: "牛飼い",
	Caelum: "彫刻具",
	Camelopardalis: "キリン",
	Cancer: "蟹",
	CanesVenatici: "猟犬",
	CanisMajor: "大犬",
	CanisMinor: "小犬",
	Capricornus: "山羊",
	Carina: "竜骨",
	Cassiopeia: "カシオペヤ",
	Centaurus: "ケンタウルス",
	Cepheus: "ケフェウス",
	Cetus: "鯨",
	Chamaeleon: "カメレオン",
	Circinus: "コンパス",
	Columba: "鳩",
	ComaBerenices: "髪",
	CoronaAustralis: "南の冠",
	CoronaBorealis: "冠",
	Corvus: "烏",
	Crater: "コップ",
	Crux: "南十字",
	Cygnus: "白鳥",
	Delphinus: "海豚",
	Dorado: "旗魚",
	Draco: "竜",
	Equuleus: "小馬",
	Eridanus: "エリダヌス",
	Fornax: "炉",
	Gemini: "双子",
	Grus: "鶴",
	Hercules: "ヘルクレス",
	Horologium: "時計",
	Hydra: "海蛇",
	Hydrus: "水蛇",
	Indus: "インディアン",
	Lacerta: "蜥蜴",
	Leo: "獅子",
	LeoMinor: "小獅子",
	Lepus: "兎",
	Libra: "天秤",
	Lupus: "狼",
	Lynx: "山猫",
	Lyra: "琴",
	Mensa: "テーブル山",
	Microscopium: "顕微鏡",
	Monoceros: "一角獣",
	Musca: "蝿",
	Norma: "定規",
	Octans: "八分儀",
	Ophiuchus: "蛇遣",
	Orion: "オリオン",
	Pavo: "孔雀",
	Pegasus: "ペガスス",
	Perseus: "ペルセウス",
	Phoenix: "鳳凰",
	Pictor: "画架",
	Pisces: "魚",
	PiscisAustrinus: "南の魚",
	Puppis: "艫",
	Pyxis: "羅針盤",
	Reticulum: "レチクル",
	Sagitta: "矢",
	Sagittarius: "射手",
	Scorpius: "蠍",
	Sculptor: "彫刻室",
	Scutum: "楯",
	Serpens: "蛇",
	Sextans: "六分儀",
	Taurus: "牡牛",
	Telescopium: "望遠鏡",
	Triangulum: "三角",
	TriangulumAustrale: "南の三角",
	Tucana: "巨嘴鳥",
	UrsaMajor: "大熊",
	UrsaMinor: "小熊",
	Vela: "帆",
	Virgo: "乙女",
	Volans: "飛魚",
	Vulpecula: "小狐"
}, ol = {
	Andromeda: "アンドロメダ",
	Antlia: "ポンプ",
	Apus: "ふうちょう",
	Aquarius: "みずがめ",
	Aquila: "わし",
	Ara: "さいだん",
	Aries: "おひつじ",
	Auriga: "ぎょしゃ",
	Boötes: "うしかい",
	Caelum: "ちょうこくぐ",
	Camelopardalis: "キリン",
	Cancer: "かに",
	CanesVenatici: "りょうけん",
	CanisMajor: "おおいぬ",
	CanisMinor: "こいぬ",
	Capricornus: "やぎ",
	Carina: "りゅうこつ",
	Cassiopeia: "カシオペヤ",
	Centaurus: "ケンタウルス",
	Cepheus: "ケフェウス",
	Cetus: "くじら",
	Chamaeleon: "カメレオン",
	Circinus: "コンパス",
	Columba: "はと",
	ComaBerenices: "かみのけ",
	CoronaAustralis: "みなみのかんむり",
	CoronaBorealis: "かんむり",
	Corvus: "からす",
	Crater: "コップ",
	Crux: "みなみじゅうじ",
	Cygnus: "はくちょう",
	Delphinus: "いるか",
	Dorado: "かじき",
	Draco: "りゅう",
	Equuleus: "こうま",
	Eridanus: "エリダヌス",
	Fornax: "ろ",
	Gemini: "ふたご",
	Grus: "つる",
	Hercules: "ヘルクレス",
	Horologium: "とけい",
	Hydra: "うみへび",
	Hydrus: "みずへび",
	Indus: "インディアン",
	Lacerta: "とかげ",
	Leo: "しし",
	LeoMinor: "こじし",
	Lepus: "うさぎ",
	Libra: "てんびん",
	Lupus: "おおかみ",
	Lynx: "やまねこ",
	Lyra: "こと",
	Mensa: "テーブルさん",
	Microscopium: "けんびきょう",
	Monoceros: "いっかくじゅう",
	Musca: "はえ",
	Norma: "じょうぎ",
	Octans: "はちぶんぎ",
	Ophiuchus: "へびつかい",
	Orion: "オリオン",
	Pavo: "くじゃく",
	Pegasus: "ペガスス",
	Perseus: "ペルセウス",
	Phoenix: "ほうおう",
	Pictor: "がか",
	Pisces: "うお",
	PiscisAustrinus: "みなみのうお",
	Puppis: "とも",
	Pyxis: "らしんばん",
	Reticulum: "レチクル",
	Sagitta: "や",
	Sagittarius: "いて",
	Scorpius: "さそり",
	Sculptor: "ちょうこくしつ",
	Scutum: "たて",
	Serpens: "へび",
	Sextans: "ろくぶんぎ",
	Taurus: "おうし",
	Telescopium: "ぼうえんきょう",
	Triangulum: "さんかく",
	TriangulumAustrale: "みなみのさんかく",
	Tucana: "きょしちょう",
	UrsaMajor: "おおぐま",
	UrsaMinor: "こぐま",
	Vela: "ほ",
	Virgo: "おとめ",
	Volans: "とびうお",
	Vulpecula: "こぎつね"
}, sl = class e extends $ {
	static defaultOptions() {
		return {
			showLines: !0,
			showNames: !1,
			lang: "English",
			fadeInDuration: 400,
			nameFont: "12pt fantasy",
			nameColor: "rgba(239, 225, 196, 1)"
		};
	}
	pathRenderer;
	billboardRenderer;
	fadeInAlpha = 1;
	nameFont;
	nameColor;
	showLines;
	showNames;
	lang;
	constructor(t, n = {}) {
		super(t);
		let r = {
			...e.defaultOptions(),
			...n
		};
		this.showLines = r.showLines, this.showNames = r.showNames, this.lang = r.lang, this.nameFont = r.nameFont, this.nameColor = r.nameColor, this.addAnimation(({ r: e }) => {
			this.fadeInAlpha = e;
		}, { duration: r.fadeInDuration }), this.onRelease(() => {
			this.pathRenderer?.release(), this.billboardRenderer?.release();
		});
	}
	render(e) {
		let t = this.fadeInAlpha * Lc(e), n = this.globe.gl;
		this.showLines && (this.pathRenderer || (this.pathRenderer = new Zc(this.globe.gl), this.buildLines()), p(n, "Constellation.lines", () => {
			this.pathRenderer.render(e, t);
		})), this.showNames && (this.billboardRenderer || (this.billboardRenderer = new Gc(this.globe.gl), this.buildNameBillboards()), p(n, "Constellation.names", () => {
			this.billboardRenderer.render(e, t);
		}));
	}
	async buildLines() {
		let e = await ul(), t = [];
		for (let n of Object.keys(e)) {
			let r = e[n], i = (() => {
				let e = {};
				for (let t of r.stars) e[t.name] = t;
				return e;
			})(), a = r.ecliptical ? [
				1,
				.75,
				0,
				.25
			] : [
				1,
				1,
				1,
				.25
			];
			for (let e of r.lines) {
				let n = e.split("-").map((e) => i[e]);
				for (let e = 0; e < n.length - 1; ++e) {
					let r = {
						points: [{
							position: cl(n[e]),
							color: a,
							size: .015
						}, {
							position: cl(n[e + 1]),
							color: a,
							size: .015
						}],
						close: !1,
						joint: "NONE"
					};
					t.push(r);
				}
			}
		}
		this.pathRenderer.setPaths(t), this.globe.requestRefresh();
	}
	async buildNameBillboards() {
		let e = await ul(), t = [], n = [];
		for (let r of Object.keys(e)) {
			let i = e[r];
			n.push({
				imageID: t.length,
				position: ll(i.stars),
				color: [
					1,
					1,
					1,
					1
				]
			});
			let a = {
				English: r,
				Hiragana: ol[r],
				Kanji: al[r]
			}[this.lang];
			t.push({
				imageData: il(a, this.nameFont, this.nameColor),
				origin: [0, 0]
			});
		}
		this.billboardRenderer.buildArray(t, n), this.globe.requestRefresh();
	}
};
function cl(e) {
	return ys.fromDeg(e.ra, e.dec).xyz;
}
function ll(e) {
	let t = [
		0,
		0,
		0
	];
	for (let n of e) cl(n).forEach((e, n) => t[n] += e);
	t = t.map((t) => t / e.length);
	let n = Math.sqrt(t.reduce((e, t) => e + t * t, 0));
	return t.map((e) => e / n);
}
async function ul() {
	return (await import("./constellations-d2WbcRtv.js")).default;
}
//#endregion
//#region src/renderer/cube_map_renderer2/frag.glsl?raw
var dl = "precision mediump float;\n\nuniform samplerCube u_cubeTexture;\nuniform mat4 u_mMatrix;\nuniform float u_alpha;\nvarying vec3 v_position;\nvarying float v_z;\n\nvoid main() {\n    gl_FragColor = textureCube(u_cubeTexture, (u_mMatrix * vec4(v_position, 1.)).yzx);\n    gl_FragColor.a *= u_alpha * smoothstep(0., 0.4, v_z);\n}", fl = "precision mediump float;\n\nuniform    mat4          u_pvMatrix;\nuniform    float         u_radius;\nattribute  vec3          a_position;\nvarying    vec3          v_position;\nvarying    float         v_z;\n\nvoid main(void) {\n    gl_Position = u_pvMatrix * vec4(u_radius * a_position, 1.);\n    v_position = u_radius * a_position;\n    v_z = gl_Position.z;\n}\n", pl = class {
	gl;
	program;
	attribList;
	indexBuffer;
	texture;
	constructor(e) {
		this.gl = e, this.program = S.new(e, fl, dl), this.buildArray();
	}
	release() {
		this.program.release(), this.attribList.release(), this.indexBuffer.release(), this.texture && this.gl.deleteTexture(this.texture);
	}
	render(e, t = 1) {
		if (this.texture === void 0 || t <= 0) return;
		let n = this.program, r = this.gl;
		n.use(), n.enableAttribList(this.attribList, () => {
			n.uniform1i({ u_cubeTexture: 0 }), n.uniformMatrix4fv({
				u_pvMatrix: e.mvp.pv,
				u_mMatrix: this.mMatrix()
			}), n.uniform1f({
				u_alpha: t,
				u_radius: 1
			}), _(r, [r.BLEND], () => {
				r.blendFunc(r.SRC_ALPHA, r.ONE), this.indexBuffer.bind(() => {
					r.bindTexture(r.TEXTURE_CUBE_MAP, this.texture), r.drawElements(r.TRIANGLE_STRIP, this.indexBuffer.length, r.UNSIGNED_SHORT, 0), r.bindTexture(r.TEXTURE_CUBE_MAP, null);
				});
			});
		});
	}
	mMatrix() {
		return ml;
	}
	buildArray() {
		let { position: e, index: t } = hl(10);
		this.attribList = new E(this.gl, {
			members: [{
				name: "a_position",
				nComponents: 3
			}],
			array: new Float32Array(e)
		}), this.indexBuffer = new k(this.gl, { array: new Int16Array(t) });
	}
	setupTexture() {
		let e = this.gl;
		this.texture = e.createTexture(), e.bindTexture(e.TEXTURE_CUBE_MAP, this.texture), e.texParameteri(e.TEXTURE_CUBE_MAP, e.TEXTURE_MIN_FILTER, e.LINEAR_MIPMAP_LINEAR), e.texParameteri(e.TEXTURE_CUBE_MAP, e.TEXTURE_MAG_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_CUBE_MAP, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_CUBE_MAP, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.bindTexture(e.TEXTURE_CUBE_MAP, null);
	}
	static faces = [
		"px",
		"py",
		"pz",
		"nx",
		"ny",
		"nz"
	];
	setCubeImage(e) {
		let t = this.gl;
		this.texture || this.setupTexture();
		let n = [
			t.TEXTURE_CUBE_MAP_POSITIVE_X,
			t.TEXTURE_CUBE_MAP_POSITIVE_Y,
			t.TEXTURE_CUBE_MAP_POSITIVE_Z,
			t.TEXTURE_CUBE_MAP_NEGATIVE_X,
			t.TEXTURE_CUBE_MAP_NEGATIVE_Y,
			t.TEXTURE_CUBE_MAP_NEGATIVE_Z
		];
		t.bindTexture(t.TEXTURE_CUBE_MAP, this.texture);
		for (let r = 0; r < n.length; ++r) t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, 1), t.texImage2D(n[r], 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, e[r]), t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, 0);
		t.generateMipmap(t.TEXTURE_CUBE_MAP), t.bindTexture(t.TEXTURE_CUBE_MAP, null);
	}
}, ml = Z();
function hl(e = 5) {
	let t = [
		[2, 1],
		[2, -1],
		[0, 1],
		[0, -1],
		[1, 1],
		[1, -1]
	], n = [], r = [], i = 0;
	for (let a of t) {
		for (let t = 0; t < e; ++t) {
			let r = -1 + 2 * (t / (e - 1));
			for (let t = 0; t < e; ++t) {
				let i = -1 + 2 * (t / (e - 1)), o = Math.sqrt(1 + r * r + i * i), s = (a[0] + 1) % 3, c = (a[0] + 2) % 3, l = a[0], u = {
					[s]: r / o,
					[c]: i / o,
					[l]: a[1] / o
				};
				n.push(u[0], u[1], u[2]);
			}
		}
		for (let t = 0; t < e - 1; ++t) {
			r.push(i + t * e);
			for (let n = 0; n < e; ++n) r.push(i + t * e + n, i + (t + 1) * e + n);
			r.push(i + (t + 1) * e + (e - 1));
		}
		i += e * e;
	}
	return {
		position: n,
		index: r
	};
}
//#endregion
//#region src/utils/setWorkerErrorHandler.ts
function gl(e) {
	return e.addEventListener("error", (t) => {
		console.error(t), e.terminate();
	}), e;
}
//#endregion
//#region src/utils/image/background_image_decoder.ts?worker&inline
var _l = "(function(){function e(){self.addEventListener(`message`,async e=>{let{id:n,url:r,flipY:i}=e.data;try{let e=await(await fetch(r,{mode:`cors`})).blob(),a=await createImageBitmap(e,{imageOrientation:i?`flipY`:void 0});t({id:n,type:`ok`,imageBitmap:a},[a])}catch(e){t({id:n,type:`error`,message:String(e)})}})}function t(e,t=[]){self.postMessage(e,t)}e()})();", vl = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", _l], { type: "text/javascript;charset=utf-8" });
function yl(e) {
	let t;
	try {
		if (t = vl && (self.URL || self.webkitURL).createObjectURL(vl), !t) throw "";
		let n = new Worker(t, { name: e?.name });
		return n.addEventListener("error", () => {
			(self.URL || self.webkitURL).revokeObjectURL(t);
		}), n;
	} catch {
		return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(_l), { name: e?.name });
	}
}
//#endregion
//#region src/utils/image/index.ts
async function bl(e, { failover: t, flipY: n = !0 } = {}) {
	try {
		return await xl.load(e, { flipY: n });
	} catch (e) {
		if (t) return t;
		throw e;
	}
}
var xl = new class {
	deferreds = /* @__PURE__ */ new Map();
	seq = 0;
	_worker;
	get worker() {
		if (!this._worker) {
			let e = gl(new yl());
			e.addEventListener("message", this.workerOnMessage), this._worker = e;
		}
		return this._worker;
	}
	load(e, { flipY: t = !0 } = {}) {
		let n = ++this.seq, r = Sl();
		this.deferreds.set(n, r);
		let i = {
			id: n,
			url: new URL(e, location.href).href,
			flipY: t
		};
		return this.worker.postMessage(i), r.promise;
	}
	workerOnMessage = async (e) => {
		let t = e.data, { id: n } = t, { resolve: r, reject: i } = this.deferreds.get(n);
		this.deferreds.delete(n), t.type === "error" && i(t.message), t.type === "ok" && r(t.imageBitmap);
	};
}();
function Sl() {
	let e, t;
	return {
		promise: new Promise((n, r) => {
			e = n, t = r;
		}),
		resolve: e,
		reject: t
	};
}
//#endregion
//#region src/layer/eso_milky_way_layer/index.ts
var Cl = class extends $ {
	renderer;
	constructor(e, t = {}) {
		super(e), this.loadImages(t);
	}
	fadeAlpha = 0;
	async loadImages({ fadeInDuration: e = 400, imageSize: t = 1024 }) {
		let n = !0;
		this.onRelease(() => n = !1);
		let r = this.globe.gl, i = Math.min(r.getParameter(r.MAX_CUBE_MAP_TEXTURE_SIZE), t), a = await wl.loadImages(this.globe.dataRepository, i);
		n && (this.renderer = new wl(this.globe.gl, a), this.onRelease(() => this.renderer?.release()), this.addAnimation(({ r: e }) => {
			this.fadeAlpha = e;
		}, { duration: e }));
	}
	render(e) {
		p(this.globe.gl, "EsoMiokyWay", () => {
			let t = Lc(e) * this.fadeAlpha;
			this.renderer?.render(e, t);
		});
	}
	static attributions = [{
		which: "The Milky Way Panorama",
		label: "ESO/S. Brunier",
		link: "https://www.eso.org/public/images/eso0932a/"
	}];
}, wl = class extends pl {
	constructor(e, t) {
		super(e), this.setCubeImage(t);
	}
	m = Q(.0017373464070261, -.4792437255382538, -.8776800036430359, 0, .8911036849021912, .3990314602851868, -.2161209583282471, 0, .4537965655326843, -.7817283272743225, .4277492463588715, 0, 0, 0, 0, 1);
	mMatrix() {
		return this.m;
	}
	static async loadImages(e, t) {
		for (let n of [1024, 512]) if (n <= t) {
			let t = [
				"px",
				"py",
				"pz",
				"nx",
				"ny",
				"nz"
			].map((t) => `${e}/eso_milky_way_layer/images-${n}/${t}.png`);
			return await Promise.all(t.map((e) => bl(e, { flipY: !1 })));
		}
		throw Error(`No available image: size: ${t}`);
	}
};
//#endregion
//#region src/layer/grid_layer.ts
function Tl() {
	return {
		modelMatrix: void 0,
		blendMode: "ADD",
		defaultGridColor: [
			.25,
			.5,
			1,
			.75
		],
		width: .008,
		thetaLine: {
			nTheta: 18,
			nPhi: 360,
			gridColors: { 9: [
				1,
				0,
				0,
				.75
			] }
		},
		phiLine: {
			nTheta: 180,
			nPhi: 24,
			gridColors: {
				0: [
					1,
					0,
					0,
					.5
				],
				6: [
					.5,
					1,
					0,
					.5
				],
				12: [
					0,
					1,
					1,
					.5
				],
				18: [
					.5,
					0,
					1,
					.5
				]
			}
		},
		fadeInDuration: 400
	};
}
var El = class extends $ {
	pathRenderer;
	options;
	fadeAlpha = 0;
	constructor(e, t) {
		super(e), this.options = Tl(), t?.(this.options), this.pathRenderer = new Zc(this.globe.gl), this.pathRenderer.blendMode = this.options.blendMode, this.pathRenderer.setPaths(this.generatePaths()), this.onRelease(() => {
			this.pathRenderer.release();
		}), this.addAnimation(({ r: e }) => {
			this.fadeAlpha = e;
		}, { duration: this.options.fadeInDuration });
	}
	render(e) {
		let t = this.fadeAlpha * Lc(e), n = this.globe.gl;
		this.options.modelMatrix && (this.pathRenderer.modelMatrix = this.options.modelMatrix()), p(n, "Grid", () => {
			this.pathRenderer.render(e, t);
		});
	}
	generatePaths() {
		let { width: e, defaultGridColor: t } = this.options, n = [];
		thetaLines: {
			let { nTheta: r, nPhi: i, gridColors: a } = this.options.thetaLine;
			for (let o = 1; o < r; ++o) {
				let s = Math.PI * (o / r - .5), c = a[o] ?? t;
				n.push({
					points: Yo(0, i).map((t) => {
						let n = 2 * Math.PI * t / i;
						return {
							position: [
								Math.cos(s) * Math.cos(n),
								Math.cos(s) * Math.sin(n),
								Math.sin(s)
							],
							color: c,
							size: e
						};
					}),
					close: !0,
					joint: "MITER"
				});
			}
		}
		phiLines: {
			let { nTheta: r, nPhi: i, gridColors: a } = this.options.phiLine;
			for (let o = 0; o < i; ++o) {
				let s = 2 * Math.PI * o / i, c = a[o] ?? t;
				n.push({
					points: Yo(0, r + 1).map((t) => {
						let n = Math.PI * (t - 90) / r;
						return {
							position: [
								Math.cos(n) * Math.cos(s),
								Math.cos(n) * Math.sin(s),
								Math.sin(n)
							],
							color: c,
							size: e
						};
					}),
					close: !1,
					joint: "MITER"
				});
			}
		}
		return n;
	}
}, Dl = "precision mediump float;\nvarying   vec4   v_color;\nvarying   float  v_w;\n\n\nvoid main() {\n    float r = 2. * length(gl_PointCoord - vec2(0.5));\n    float v = (1. - smoothstep(0.6, 1.0, r)) * clamp(4. * (v_w - 0.2), 0., 1.);\n    gl_FragColor = v_color;\n    gl_FragColor.a *= v;\n}", Ol = "uniform    mat4   u_pvMatrix;\nuniform    float  u_minSize;\nuniform    float  u_alpha;\nuniform    float  u_fovy;\nuniform    float  u_bufferHeight;\nuniform    int    u_darkenSmallPoint;\nattribute  vec3   a_position;\nattribute  float  a_size;\nattribute  vec4   a_color;\nvarying    vec4   v_color;\nvarying    float  v_w;\n\n\n\nvoid main(void) {\n    gl_Position = u_pvMatrix * vec4(a_position, 1.);\n    float pointSize = u_bufferHeight * a_size / (gl_Position.w * u_fovy);\n    float screenSize = max(pointSize, u_minSize);\n    float r = pointSize / screenSize;\n    v_color = a_color;\n    v_color.a *= u_darkenSmallPoint != 0 ? u_alpha * r * r : u_alpha;\n    gl_PointSize = screenSize;\n    v_w = gl_Position.w;\n}", kl = class {
	gl;
	program;
	attribList;
	darkenSmallPoint = !0;
	minSize = 3;
	constructor(e) {
		this.gl = e, this.program = S.new(e, Ol, Dl), this.attribList = new E(e, { members: [
			{
				name: "a_position",
				nComponents: 3
			},
			{
				name: "a_size",
				nComponents: 1
			},
			{
				name: "a_color",
				nComponents: 4
			}
		] });
	}
	release() {
		this.attribList.release(), this.program.release();
	}
	render(e, t = 1) {
		if (this.attribList.vertexCount === 0 || t <= 0) return;
		let n = e.mvp, r = this.gl, i = this.program;
		i.enableAttribList(this.attribList, () => {
			i.uniformMatrix4fv({ u_pvMatrix: n.pv }), i.uniform1f({
				u_alpha: t,
				u_fovy: n.fovy,
				u_bufferHeight: r.drawingBufferHeight,
				u_minSize: this.minSize
			}), i.uniform1i({ u_darkenSmallPoint: +!!this.darkenSmallPoint }), _(r, [r.BLEND], () => {
				r.blendFunc(r.SRC_ALPHA, r.ONE), r.drawArrays(r.POINTS, 0, this.attribList.vertexCount);
			});
		});
	}
	updateVBO(e) {
		let t = [];
		for (let n of e) t.push(...n.position, n.size, ...n.color);
		this.attribList.setData({ array: new Float32Array(t) });
	}
	setArray(e) {
		this.attribList.setData({ array: e });
	}
}, Al = "(function(){function e(e,...t){let n=0;return e.replace(/%(-)?(0)?(\\d+)?(\\.\\d+)?([dfs])/g,(e,r,i,a,o,s)=>{if(n>=t.length)return e;let c=t[n++],l=``,u=0;switch(s){case`d`:c=parseInt(c).toString();break;case`f`:c=parseFloat(c).toFixed(o?parseInt(o.substring(1)):6);break;case`s`:c=c.toString();break}return a&&(u=parseInt(a)-c.length,l=Array(u+1).join(i?`0`:` `)),r?c+l:l+c})}function t(e,t,n){return e<t?t:e>n?n:e}var n=class t{rad;constructor(e){this.rad=e}get deg(){return s(this.rad)}get amin(){return c(this.rad)}get asec(){return l(this.rad)}static fromRad(e){return new t(e)}static fromDeg(e){return new t(i(e))}static fromAmin(e){return new t(a(e))}static fromAsec(e){return new t(o(e))}sexadecimal(t,n){let r=3600*this.deg/t,i=n?r<0?`-`:`+`:``,a=Math.abs(r);return e(`${i}%02d:%02d:%07.4f`,Math.floor(a/3600),Math.floor(a/60%60),a%60)}clone(){return new t(this.rad)}},r=class e{a;d;constructor(e,t){this.a=e,this.d=t}static parse(t){let{a:n,d:r}=d(t);return new e(n,r)}get xyz(){let e=this.a.rad,t=this.d.rad,n=Math.cos(t);return[n*Math.cos(e),n*Math.sin(e),Math.sin(t)]}static fromXyz([t,n,r]){let i=t*t+n*n;if(i==0)return e.fromRad(0,r>0?Math.PI/2:-Math.PI/2);{let a=2*Math.PI,o=(Math.atan2(n,t)+a)%a,s=Math.atan2(r,Math.sqrt(i));return e.fromRad(o,s)}}static fromRad(t,r){return new e(n.fromRad(t),n.fromRad(r))}static fromDeg(t,r){return new e(n.fromDeg(t),n.fromDeg(r))}toString(){return{a:this.a.sexadecimal(15,!1),d:this.d.sexadecimal(1,!0)}}squaredDistance(e){let[t,n,r]=this.xyz,[i,a,o]=e.xyz,s=t-i,c=n-a,l=r-o;return s*s+c*c+l*l}distance(e){return Math.sqrt(this.squaredDistance(e))}cosine(e){let[n,r,i]=this.xyz,[a,o,s]=e.xyz;return t(n*a+r*o+i*s,-1,1)}angle(e){return n.fromRad(Math.acos(this.cosine(e)))}};function i(e){return .01745329252*e}function a(e){return .0002908882087*e}function o(e){return 4848136811e-15*e}function s(e){return 57.2957795131*e}function c(e){return 3437.7467707849*e}function l(e){return 206264.806247096*e}2*Math.PI;let u=/[-+]?[0-9]*\\.?[0-9]+([eE][-+]?[0-9]+)?/g;function d(e){e=e.replace(/−/g,`-`),e=e.replace(/([\\+\\-])\\s+(\\d)/,`$1$2`).replace(/\\[\\d+\\]/g,``);let t=e.match(u);if(t==null||t.length<2)throw Error(`invalid coord format: '${e}': numbers=${JSON.stringify(t)}`);return t.length==2?r.fromDeg(Number(t[0]),Number(t[1])):new r(f(t.slice(0,Math.floor(t.length/2)),15),f(t.slice(Math.floor(t.length/2)),1))}function f(e,t){if(e.length==0||e.length>3)throw Error(`invalid coord format: '${e.join(`, `)}'`);let r=e[0],i=e[1]==null?0:Number(e[1]),a=e[2]==null?0:Number(e[2]);return r.substring(0,1)==`-`?n.fromDeg(-t*(a/3600+i/60+Number(r.substring(1)))):n.fromDeg(t*(a/3600+i/60+Number(r)))}self.addEventListener(`message`,async e=>{let t=e.data;try{await p(t)}finally{self.close()}});async function p({dataRepository:e}){let t=[],n=(await(await fetch(`${e}/hipparcos-catalog/index.json`)).json()).map(t=>`${e}/hipparcos-catalog/${t}`);for(let e=0;e<n.length;++e){let r=n[e];h(await(await fetch(r)).json(),t);let i=new Float32Array(t).buffer,a={buffer:i,end:e===n.length-1};self.postMessage(a,[i])}}function m(e){return 10**(-e/2.5)}function h(e,t){let n=m(-1.47),a=i(5);for(let i of e){let e=r.fromRad(i[0],i[1]).xyz,o=[.75,.75,1,1],s=m(i[2]),c=a*Math.sqrt(s/n);t.push(...e,c,...o)}}})();", jl = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", Al], { type: "text/javascript;charset=utf-8" });
function Ml(e) {
	let t;
	try {
		if (t = jl && (self.URL || self.webkitURL).createObjectURL(jl), !t) throw "";
		let n = new Worker(t, { name: e?.name });
		return n.addEventListener("error", () => {
			(self.URL || self.webkitURL).revokeObjectURL(t);
		}), n;
	} catch {
		return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(Al), { name: e?.name });
	}
}
//#endregion
//#region src/layer/hipparcos_catalog_layer/index.ts
var Nl = class extends $ {
	pointRenderer;
	fadeInAlpha = 0;
	constructor(e, { fadeInDuration: t = 400 } = {}) {
		super(e), this.pointRenderer = new kl(this.globe.gl), this.onRelease(Pl(e.dataRepository, () => {
			this.addAnimation(({ r: e }) => {
				this.fadeInAlpha = e;
			}, { duration: t });
		}, (e) => {
			let t = new Float32Array(e);
			this.pointRenderer.setArray(t), this.globe.requestRefresh();
		})), this.onRelease(() => {
			this.pointRenderer.release();
		});
	}
	render(e) {
		p(this.globe.gl, "HipparcosCatalog", () => {
			let t = this.fadeInAlpha * Lc(e);
			this.pointRenderer?.render(e, t);
		});
	}
};
function Pl(e, t, n) {
	let r = gl(new Ml()), i = 0, a = () => {
		a = void 0, o(), r.terminate();
	}, o = Ko(r, "message", (e) => {
		let r = e.data;
		a && (i++ === 0 && t(), n(r.buffer)), r.end && a?.();
	}), s = { dataRepository: e };
	return r.postMessage(s), () => {
		a?.();
	};
}
//#endregion
//#region src/lib/cache/index.ts
var Fl = class {
	store = /* @__PURE__ */ new Map();
	onDrop;
	maxSize;
	constructor(e) {
		this.maxSize = e.maxSize, this.onDrop = e.onDrop;
	}
	set(e, t) {
		if (this.store.has(e)) {
			let t = this.store.get(e);
			this.onDrop?.(t, e);
		}
		return this.store.set(e, t), this.deleteOldItems(), this;
	}
	peek(e) {
		return this.store.get(e);
	}
	get(e) {
		if (this.store.has(e)) {
			let t = this.store.get(e);
			return this.store.delete(e), this.store.set(e, t), t;
		}
	}
	*keys() {
		for (let e of this.store.keys()) yield e;
	}
	has(e) {
		return this.store.has(e);
	}
	clear() {
		if (this.onDrop) for (let [e, t] of this.store) this.onDrop(t, e);
		this.store.clear();
	}
	delete(e) {
		if (this.store.has(e)) {
			let t = this.store.get(e);
			this.onDrop?.(t, e), this.store.delete(e);
		}
	}
	setLimit(e) {
		this.maxSize = e, this.deleteOldItems();
	}
	get size() {
		return this.store.size;
	}
	deleteOldItems() {
		for (; this.store.size > this.maxSize;) for (let [e, t] of this.store) {
			this.onDrop?.(t, e), this.store.delete(e);
			break;
		}
	}
}, Il = 0;
function Ll() {
	return ++Il;
}
//#endregion
//#region src/renderer/tile_renderer/tract.ts
var Rl = class e {
	naxis1;
	naxis2;
	crval1;
	crval2;
	mMatrix;
	invMMatrix;
	pixelScale;
	refPoint;
	id = Ll();
	fov = bs(1.8);
	tileSize;
	minTileLevel;
	maxTileLevel;
	flipV;
	constructor(t, n, r, i, a, o, s, c = {}) {
		this.naxis1 = t, this.naxis2 = n, this.crval1 = r, this.crval2 = i, this.tileSize = c.tileSize || 256, this.minTileLevel = c.minTileLevel || 0, this.maxTileLevel = c.maxTileLevel || 8;
		let l = Z();
		zt(l, l, r), Rt(l, l, -i), bn(l, l, Q(0, 1, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1)), bn(l, l, [
			s[0],
			s[2],
			0,
			0,
			s[1],
			s[3],
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			1
		]), Pt(l, l, [
			-a,
			-o,
			0
		]), Pt(l, l, [
			.5,
			.5,
			0
		]), this.flipV = c.flipV ?? !1, c.flipV && (Pt(l, l, [
			0,
			n,
			0
		]), Ft(l, l, [
			1,
			-1,
			1
		])), this.mMatrix = l, this.invMMatrix = At(Z(), this.mMatrix), this.refPoint = ys.fromRad(r, i).xyz, this.pixelScale = Math.sqrt(Math.abs(s[0] * s[3] - s[1] * s[2])), e.id2tract.set(this.id, this);
	}
	pixel2xyz(e, t) {
		let n = Kr(yr(), [
			e,
			t,
			0,
			1
		], this.mMatrix), r = Math.sqrt(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);
		return [
			n[0] / r,
			n[1] / r,
			n[2] / r
		];
	}
	xyz2pixel(e) {
		let t = ar(e, this.refPoint), n = 1 / Math.cos(t), [r, i, a] = e, o = Kr(yr(), [
			n * r,
			n * i,
			n * a,
			1
		], this.invMMatrix);
		return [o[0], o[1]];
	}
	pix2jacobian(e, t) {
		let n = ar(this.pixel2xyz(e, t), this.refPoint);
		return 1 / Math.cos(n) ** 3;
	}
	ndc2pixel(e, t) {
		let n = bn(Z(), this.invMMatrix, e.mvp.iPv);
		t((e, t) => {
			let r = -(n[2] * e + n[6] * t + n[14]) / n[10], i = 1 / (n[3] * e + n[7] * t + n[11] * r + n[15]), a = xr(e, t, r, 1);
			return Kr(a, a, n), [
				i * a[0],
				i * a[1],
				i
			];
		});
	}
	static noIndex = {
		minP: 0,
		maxP: -1,
		minQ: 0,
		maxQ: -1,
		baseLevel: -1,
		lodAlpha: -1
	};
	tileIndices(t, n) {
		let r = Infinity, i = -Infinity, a = Infinity, o = -Infinity;
		if (this.ndc2pixel(t, (e) => {
			for (let [t, n] of [
				[-1, -1],
				[-1, 1],
				[1, -1],
				[1, 1]
			]) {
				let [s, c, l] = e(t, n);
				if (l < 0) return;
				s < r && (r = s), s > i && (i = s), c < a && (a = c), c > o && (o = c);
			}
		}), i < 0 || this.naxis1 < r || o < 0 || this.naxis2 < a) return e.noIndex;
		r = Math.max(r, 0), i = Math.min(i, this.naxis1), a = Math.max(a, 0), o = Math.min(o, this.naxis2);
		let s = t.mvp.arc / this.pixelScale / t.drawingBufferHeight, c = Jo(Math.log(s) / Math.LN2 + n, this.minTileLevel, this.maxTileLevel), l = Math.floor(c), u = 1 - (c - l), d = this.tileSize << l;
		return {
			minP: Math.floor(a / d),
			maxP: Math.floor(o / d),
			minQ: Math.floor(r / d),
			maxQ: Math.floor(i / d),
			baseLevel: l,
			lodAlpha: u
		};
	}
	static fromFitsHeader(t, n = {}) {
		console.assert(t.CTYPE1 === void 0 || t.CTYPE1 === "RA---TAN"), console.assert(t.CTYPE2 === void 0 || t.CTYPE2 === "DEC--TAN"), console.assert(t.LONPOLE === void 0), console.assert(t.LATPOLE === void 0);
		let { tileSize: r, minTileLevel: i, maxTileLevel: a, flipV: o } = n;
		return new e(zl(t, "NAXIS1", "number"), zl(t, "NAXIS2", "number"), bs(zl(t, "CRVAL1", "number")), bs(zl(t, "CRVAL2", "number")), zl(t, "CRPIX1", "number"), zl(t, "CRPIX2", "number"), [
			bs(zl(t, "CD1_1", "number")),
			bs(zl(t, "CD1_2", "number", 0)),
			bs(zl(t, "CD2_1", "number", 0)),
			bs(zl(t, "CD2_2", "number"))
		], {
			tileSize: r,
			minTileLevel: i,
			maxTileLevel: a,
			flipV: o
		});
	}
	static id2tract = /* @__PURE__ */ new Map();
	static fromId(t) {
		return e.id2tract.get(t);
	}
	static encodeTileId(e, t, n, r) {
		return `${e.id}:${t}:${n}:${r}`;
	}
	static decodeTileId(t) {
		let [n, r, i, a] = t.split(":").map(Number);
		return {
			tract: e.fromId(n),
			level: r,
			p: i,
			q: a
		};
	}
	encodeTileId(t, n, r) {
		return e.encodeTileId(this, t, n, r);
	}
};
function zl(e, t, n, r) {
	let i = t in e ? e[t] : r;
	if (typeof i !== n) throw Error(`type mismatch: ${n} for [${t}] = ${i}`);
	return i;
}
//#endregion
//#region src/renderer/tile_renderer/tract_spatial_index.ts
var Bl = /* @__PURE__ */ l((/* @__PURE__ */ o(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.uniq2orderpix = e.orderpix2uniq = e.fxy2tu = e.bit_decombine = e.bit_combine = e.fxy2nest = e.vec2ang = e.ang2vec = e.tu2za = e.za2tu = e.tu2fxy = e.pixcoord2vec_ring = e.pixcoord2vec_nest = e.nside2resol = e.nside2pixarea = e.corners_ring = e.corners_nest = e.max_pixrad = e.query_disc_inclusive_ring = e.query_disc_inclusive_nest = e.pix2ang_ring = e.pix2vec_ring = e.pix2ang_nest = e.pix2vec_nest = e.ring2fxy = e.ring2nest = e.nest2ring = e.ang2pix_ring = e.ang2pix_nest = e.vec2pix_ring = e.vec2pix_nest = e.nside2npix = e.nside2order = e.order2nside = void 0;
	function t(e) {
		return 1 << e;
	}
	e.order2nside = t;
	function n(e) {
		return ue(e);
	}
	e.nside2order = n;
	function r(e) {
		return 12 * e * e;
	}
	e.nside2npix = r;
	function i(e, t) {
		var n = ne(t[0], t[1], t[2]), r = n.z, i = n.a;
		return M(e, r, i);
	}
	e.vec2pix_nest = i;
	function a(e, t) {
		var n = ne(t[0], t[1], t[2]), r = n.z, i = n.a;
		return c(e, M(e, r, i));
	}
	e.vec2pix_ring = a;
	function o(e, t, n) {
		return M(e, Math.cos(t), n);
	}
	e.ang2pix_nest = o;
	function s(e, t, n) {
		return c(e, M(e, Math.cos(t), n));
	}
	e.ang2pix_ring = s;
	function c(e, t) {
		var n = ce(e, t), r = n.f, i = n.x, a = n.y;
		return U(e, r, i, a);
	}
	e.nest2ring = c;
	function l(e, t) {
		if (e == 1) return t;
		var n = u(e, t), r = n.f, i = n.x, a = n.y;
		return H(e, r, i, a);
	}
	e.ring2nest = l;
	function u(e, t) {
		var n = 2 * e * (e - 1);
		if (t < n) {
			var r = Math.floor((Math.sqrt(1 + 2 * t) + 1) / 2), i = t - 2 * r * (r - 1), a = Math.floor(i / r), o = i % r, s = e - r + o, c = e - 1 - o;
			return {
				f: a,
				x: s,
				y: c
			};
		}
		if (t < n + 8 * e * e) {
			var o = t - n, l = 4 * e, r = e - Math.floor(o / l), u = +(r % 2 == 0), i = o % l * 2 + u, d = i - 4 * e, f = r + 5 * e - 1, p = (f + d) / 2, m = (f - d) / 2, h = Math.floor(p / e), g = Math.floor(m / e), _ = 5 - (h + g), v = h - g + 4, a = 4 * _ + (v >> 1) % 4, s = p % e, c = m % e;
			return {
				f: a,
				x: s,
				y: c
			};
		} else {
			var y = 12 * e * e - t - 1, r = Math.floor((Math.sqrt(1 + 2 * y) + 1) / 2), i = y - 2 * r * (r - 1), a = 11 - Math.floor(i / r), o = i % r, s = r - o - 1, c = o;
			return {
				f: a,
				x: s,
				y: c
			};
		}
	}
	e.ring2fxy = u;
	function d(e, t) {
		var n = ce(e, t), r = n.f, i = n.x, a = n.y, o = W(e, r, i, a), s = o.t, c = o.u, l = te(s, c), u = l.z, d = l.a;
		return V(u, d);
	}
	e.pix2vec_nest = d;
	function f(e, t) {
		var n = ce(e, t), r = n.f, i = n.x, a = n.y, o = W(e, r, i, a), s = o.t, c = o.u, l = te(s, c), u = l.z, d = l.a;
		return {
			theta: Math.acos(u),
			phi: d
		};
	}
	e.pix2ang_nest = f;
	function p(e, t) {
		return d(e, l(e, t));
	}
	e.pix2vec_ring = p;
	function m(e, t) {
		return f(e, l(e, t));
	}
	e.pix2ang_ring = m;
	function h(e, t, n, r) {
		if (n > L) throw Error("query_disc: radius must < PI/2");
		var i = _(e), a = R / e, o = ne(t[0], t[1], t[2]), s = o.z, c = o.a, l = Math.sqrt(1 - s * s), u = Math.cos(n), f = Math.sin(n), p = s * u + l * f, m = s * u - l * f, h = B(p, 0).u, g = B(m, 0).u, y = l * u - s * f < 0, b = l * u + s * f < 0, S = Math.floor((L - h) / a), w = Math.floor((L - g) / a + 1);
		if (y) {
			++S;
			for (var T = 1; T <= S; ++T) C(e, T, r);
			++S;
		}
		if (S == 0 && (C(e, 1, r), S = 2), b) {
			--w;
			for (var T = w; T <= 4 * e - 1; ++T) C(e, T, r);
			--w;
		}
		w == 4 * e && (C(e, 4 * e - 1, r), w = 4 * e - 2);
		for (var E = Math.acos(s), T = S; T <= w; ++T) x(e, T, c, E, n + i, function(a) {
			v(d(e, a), t) <= n + i && r(a);
		});
	}
	e.query_disc_inclusive_nest = h;
	function g(e, t, n, r) {
		return h(e, t, n, function(t) {
			r(c(e, t));
		});
	}
	e.query_disc_inclusive_ring = g;
	function _(e) {
		var t = R / e;
		return v(y(t, e * t), y(t, (e + 1) * t));
	}
	e.max_pixrad = _;
	function v(e, t) {
		return 2 * Math.asin(Math.sqrt(b(e, t)) / 2);
	}
	function y(e, t) {
		var n = te(e, t), r = n.z, i = n.a;
		return V(r, i);
	}
	function b(e, t) {
		var n = e[0] - t[0], r = e[1] - t[1], i = e[2] - t[2];
		return n * n + r * r + i * i;
	}
	function x(e, t, n, r, i, a) {
		if (r < i || r + i > I) return C(e, t, a);
		var o = R * (2 - t / e), s = te(R, o).z, c = Math.sin(r), l = Math.cos(r), u = Math.sin(i), d = Math.cos(i), f = Math.atan2(Math.sqrt(-de(s - l * d) / (de(c) * u * u) + 1) * u, (-s * l + d) / c);
		if (f >= I) return C(e, t, a);
		for (var p = S(e, t, B(s, P(n - f, F)).t), m = S(e, t, B(s, P(n + f, F)).t), h = N(e, p, o), g = T(e, N(e, m, o)), _ = h; !w(_, g); _ = T(e, _)) a(H(e, _.f, _.x, _.y));
	}
	function S(e, t, n) {
		var r = R / e;
		return n /= r, n = (n + t % 2 >> 1 << 1) + 1 - t % 2, n *= r, n;
	}
	function C(e, t, n) {
		var r = R * (2 - t / e), i = N(e, R * (1 + (1 - t % 2) / e), r), a = i;
		do
			n(H(e, a.f, a.x, a.y)), a = T(e, a);
		while (!w(a, i));
	}
	function w(e, t) {
		return e.x == t.x && e.y == t.y && e.f == t.f;
	}
	function T(e, t) {
		var n = t.f, r = t.x, i = t.y;
		if (++r, r == e) switch (Math.floor(n / 4)) {
			case 0:
				n = (n + 1) % 4, r = i, i = e;
				break;
			case 1:
				n -= 4, r = 0;
				break;
			case 2:
				n = 4 + (n + 1) % 4, r = 0;
				break;
		}
		if (--i, i == -1) switch (Math.floor(n / 4)) {
			case 0:
				n = 4 + (n + 1) % 4, i = e - 1;
				break;
			case 1:
				n += 4, i = e - 1;
				break;
			case 2:
				n = 8 + (n + 1) % 4, i = r - 1, r = 0;
				break;
		}
		return {
			f: n,
			x: r,
			y: i
		};
	}
	function E(e, t) {
		for (var n = ce(e, t), r = n.f, i = n.x, a = n.y, o = W(e, r, i, a), s = o.t, c = o.u, l = R / e, u = [], d = 0, f = [
			[0, l],
			[-l, 0],
			[0, -l],
			[l, 0]
		]; d < f.length; d++) {
			var p = f[d], m = p[0], h = p[1], g = te(s + m, c + h), _ = g.z, v = g.a;
			u.push(V(_, v));
		}
		return u;
	}
	e.corners_nest = E;
	function D(e, t) {
		return E(e, l(e, t));
	}
	e.corners_ring = D;
	function O(e) {
		return I / (3 * e * e);
	}
	e.nside2pixarea = O;
	function k(e) {
		return Math.sqrt(I / 3) / e;
	}
	e.nside2resol = k;
	function A(e, t, n, r) {
		var i = ce(e, t), a = i.f, o = i.x, s = i.y, c = W(e, a, o, s), l = c.t, u = c.u, d = R / e, f = te(l + d * (n - r), u + d * (n + r - 1)), p = f.z, m = f.a;
		return V(p, m);
	}
	e.pixcoord2vec_nest = A;
	function j(e, t, n, r) {
		return A(e, l(e, t), n, r);
	}
	e.pixcoord2vec_ring = j;
	function M(e, t, n) {
		var r = B(t, n), i = r.t, a = r.u, o = N(e, i, a), s = o.f, c = o.x, l = o.y;
		return H(e, s, c, l);
	}
	function N(e, t, n) {
		var r = ae(t, n), i = r.f, a = r.p, o = r.q;
		return {
			f: i,
			x: fe(Math.floor(e * a), 0, e - 1),
			y: fe(Math.floor(e * o), 0, e - 1)
		};
	}
	e.tu2fxy = N;
	function P(e, t) {
		return e < 0 ? t - -e % t : e % t;
	}
	var F = 2 * Math.PI, I = Math.PI, L = Math.PI / 2, R = Math.PI / 4, z = Math.PI / 8;
	function ee(e) {
		return e < 0 ? -ee(-e) : 2 - Math.sqrt(3 * (1 - e));
	}
	function B(e, t) {
		if (Math.abs(e) <= 2 / 3) {
			var n = t, r = 3 * z * e;
			return {
				t: n,
				u: r
			};
		} else {
			var i = t % L, a = ee(e), n = t - (Math.abs(a) - 1) * (i - R), r = R * a;
			return {
				t: n,
				u: r
			};
		}
	}
	e.za2tu = B;
	function te(e, t) {
		var n = Math.abs(t);
		if (n >= L) return {
			z: K(t),
			a: 0
		};
		if (n <= Math.PI / 4) {
			var r = 8 / (3 * I) * t, i = e;
			return {
				z: r,
				a: i
			};
		} else {
			var a = e % (Math.PI / 2), i = e - (n - R) / (n - L) * (a - R), r = K(t) * (1 - 1 / 3 * de(2 - 4 * n / I));
			return {
				z: r,
				a: i
			};
		}
	}
	e.tu2za = te;
	function ne(e, t, n) {
		var r = e * e + t * t;
		if (r == 0) return {
			z: n < 0 ? -1 : 1,
			a: 0
		};
		var i = (Math.atan2(t, e) + F) % F;
		return n /= Math.sqrt(n * n + r), {
			z: n,
			a: i
		};
	}
	function V(e, t) {
		var n = Math.sqrt(1 - e * e);
		return [
			n * Math.cos(t),
			n * Math.sin(t),
			e
		];
	}
	function re(e, t) {
		return V(Math.cos(e), t);
	}
	e.ang2vec = re;
	function ie(e) {
		var t = ne(e[0], e[1], e[2]), n = t.z, r = t.a;
		return {
			theta: Math.acos(n),
			phi: r
		};
	}
	e.vec2ang = ie;
	function ae(e, t) {
		e /= R, t /= R, e = P(e, 8), e += -4, t += 5;
		var n = fe((t + e) / 2, 0, 5), r = Math.floor(n), i = fe((t - e) / 2, 3 - r, 6 - r), a = Math.floor(i), o = 5 - (r + a);
		if (o < 0) return {
			f: 0,
			p: 1,
			q: 1
		};
		var s = r - a + 4;
		return {
			f: 4 * o + (s >> 1) % 4,
			p: n % 1,
			q: i % 1
		};
	}
	function H(e, t, n, r) {
		return t * e * e + oe(n, r);
	}
	e.fxy2nest = H;
	function oe(e, t) {
		return q(e < 65536), q(t < 32768), e & 1 | (e & 2 | t & 1) << 1 | (e & 4 | t & 2) << 2 | (e & 8 | t & 4) << 3 | (e & 16 | t & 8) << 4 | (e & 32 | t & 16) << 5 | (e & 64 | t & 32) << 6 | (e & 128 | t & 64) << 7 | (e & 256 | t & 128) << 8 | (e & 512 | t & 256) << 9 | (e & 1024 | t & 512) << 10 | (e & 2048 | t & 1024) << 11 | (e & 4096 | t & 2048) << 12 | (e & 8192 | t & 4096) << 13 | (e & 16384 | t & 8192) << 14 | (e & 32768 | t & 16384) << 15 | t & 32768 << 16;
	}
	e.bit_combine = oe;
	function se(e) {
		return q(e <= 2147483647), {
			x: (e & 1) >> 0 | (e & 4) >> 1 | (e & 16) >> 2 | (e & 64) >> 3 | (e & 256) >> 4 | (e & 1024) >> 5 | (e & 4096) >> 6 | (e & 16384) >> 7 | (e & 65536) >> 8 | (e & 262144) >> 9 | (e & 1048576) >> 10 | (e & 4194304) >> 11 | (e & 16777216) >> 12 | (e & 67108864) >> 13 | (e & 268435456) >> 14 | (e & 1073741824) >> 15,
			y: (e & 2) >> 1 | (e & 8) >> 2 | (e & 32) >> 3 | (e & 128) >> 4 | (e & 512) >> 5 | (e & 2048) >> 6 | (e & 8192) >> 7 | (e & 32768) >> 8 | (e & 131072) >> 9 | (e & 524288) >> 10 | (e & 2097152) >> 11 | (e & 8388608) >> 12 | (e & 33554432) >> 13 | (e & 134217728) >> 14 | (e & 536870912) >> 15
		};
	}
	e.bit_decombine = se;
	function ce(e, t) {
		var n = e * e, r = Math.floor(t / n), i = se(t % n);
		return {
			f: r,
			x: i.x,
			y: i.y
		};
	}
	function U(e, t, n, r) {
		var i = Math.floor(t / 4), a = i + 2, o = n + r, s = a * e - o - 1;
		if (s < e) {
			var c = t % 4, l = 2 * s * (s - 1) + s * c + e - r - 1;
			return l;
		}
		if (s < 3 * e) {
			var u = n - r, d = ((t % 4 * 2 - i % 2 + 1) * e + u + 8 * e) % (8 * e), l = 2 * e * (e - 1) + (s - e) * 4 * e + (d >> 1);
			return l;
		} else {
			var f = 4 * e - s, p = 3 - t % 4, m = 4 * f - f * p - r, h = 4 * f - m + 1, l = 12 * e * e - 2 * f * (f - 1) - h;
			return l;
		}
	}
	function W(e, t, n, r) {
		var i = Math.floor(t / 4), a = i + 2, o = t % 4 * 2 - i % 2 + 1, s = n + r, c = n - r, l = a * e - s - 1;
		return {
			t: (o * e + c + 8 * e) / e * R,
			u: L - l / e * R
		};
	}
	e.fxy2tu = W;
	function G(e, t) {
		return 4 * ((1 << 2 * e) - 1) + t;
	}
	e.orderpix2uniq = G;
	function le(e) {
		q(e <= 2147483647);
		for (var t = 0, n = (e >> 2) + 1; n >= 4;) n >>= 2, ++t;
		var r = e - ((1 << 2 * t) - 1 << 2);
		return {
			order: t,
			ipix: r
		};
	}
	e.uniq2orderpix = le;
	function ue(e) {
		for (var t = -1; e > 0;) e >>= 1, ++t;
		return t;
	}
	var K = Math.sign || function(e) {
		return e > 0 ? 1 : e < 0 ? -1 : 0;
	};
	function de(e) {
		return e * e;
	}
	function fe(e, t, n) {
		return e < t ? t : e > n ? n : e;
	}
	function q(e) {
		if (console.assert(e), !e) debugger;
	}
})))()), Vl = 32, Hl = 8, Ul = 1, Wl = 8, Gl = Math.PI / 2, Kl = class {
	tracts;
	buckets = /* @__PURE__ */ new Map();
	maxTractFov;
	nside;
	constructor(e) {
		this.tracts = e, this.maxTractFov = e.reduce((e, t) => Math.max(e, t.fov), 0);
		let t = Jl(e.length);
		if (this.nside = 1 << t, !(e.length <= Vl)) for (let t of e) {
			let e = Bl.vec2pix_nest(this.nside, t.refPoint), n = this.buckets.get(e);
			n ? n.push(t) : this.buckets.set(e, [t]);
		}
	}
	visible(e, t, n) {
		if (this.tracts.length <= Vl || t + this.maxTractFov > Gl) {
			this.scanAll(e, t, n);
			return;
		}
		let r = /* @__PURE__ */ new Set();
		Bl.query_disc_inclusive_nest(this.nside, e, t + this.maxTractFov, (i) => {
			let a = this.buckets.get(i);
			if (a) for (let i of a) r.has(i.id) || (r.add(i.id), ql(e, t, i) && n(i));
		});
	}
	scanAll(e, t, n) {
		for (let r of this.tracts) ql(e, t, r) && n(r);
	}
};
function ql(e, t, n) {
	return mr(e, n.refPoint) <= Xo(t + n.fov);
}
function Jl(e) {
	return e <= Vl ? Ul : Jo(Math.ceil(Math.log(e / (12 * Hl)) / Math.log(4)), Ul, Wl);
}
//#endregion
//#region src/renderer/tile_renderer/frag.glsl?raw
var Yl = "precision mediump float;\n\nuniform sampler2D u_texture0;\nuniform float u_layer_alpha;\nuniform float u_alpha;\nuniform vec4  u_color;\nvarying vec2 v_tCoord;\n\nvoid main() {\n    u_layer_alpha;\n    gl_FragColor = texture2D(u_texture0, v_tCoord);\n    gl_FragColor.rgb *= u_layer_alpha;\n    gl_FragColor.a *= u_alpha;\n    gl_FragColor *= u_color;\n        // gl_FragColor.g += 0.5 * u_alpha;\n}\n", Xl = "uniform    mat4   u_pvMatrix;\nuniform    mat4   u_mMatrix;\nuniform    mat3   u_texMatrix;\nuniform    mat3   u_tileMatrix;\nattribute  vec2   a_coord;\nvarying    vec2   v_tCoord;\n\n\nvoid main(void) {\n    v_tCoord = (u_texMatrix * vec3(a_coord, 1.)).xy;\n    vec4 position = u_mMatrix * vec4((u_tileMatrix * vec3(v_tCoord, 1.)).xy, 0., 1.);\n    // position.xyz /= vec3(length(position.xyz)); // for fd2u\n    gl_Position = u_pvMatrix * position;\n}\n", Zl = class {
	globe;
	textureProvider;
	gl;
	program;
	attribList;
	animationLod = 1;
	lodBias = 0;
	integerLevel = !1;
	alreadyReleased = !1;
	color = [
		1,
		1,
		1,
		1
	];
	tractIndex;
	tractIndexRevision = -1;
	constructor(e, t) {
		this.globe = e, this.textureProvider = t;
		let { gl: n } = e;
		this.gl = n, this.program = S.new(this.gl, Xl, Yl), this.attribList = new E(this.gl, {
			members: [{
				name: "a_coord",
				nComponents: 2
			}],
			array: this.buildArray()
		});
	}
	release() {
		this.alreadyReleased = !0, this.attribList.release(), this.program.release();
	}
	render(e, t = 1) {
		t <= 0 || this.activateProgram(() => {
			this.visibleTracts(e, (n) => {
				let { program: r } = this, i = new Ql(this, n);
				r.uniform1f({ u_layer_alpha: t }), r.uniform4fv({ u_color: this.color }), r.uniformMatrix4fv({ u_pvMatrix: e.mvp.pv }), i.render(e);
			}), this.textureProvider.flushQueue(e.mvp.direction);
		});
	}
	visibleTracts(e, t) {
		this.getTractIndex().visible(e.mvp.direction, e.mvp.arc, t);
	}
	getTractIndex() {
		if (this.tractIndex && this.tractIndexRevision === this.textureProvider.tractRevision) return this.tractIndex;
		let e = [];
		return this.textureProvider.walkTracts((t) => {
			e.push(t);
		}), this.tractIndex = new Kl(e), this.tractIndexRevision = this.textureProvider.tractRevision, this.tractIndex;
	}
	draw() {
		let { gl: e } = this;
		e.drawArrays(e.TRIANGLE_STRIP, 0, this.attribList.vertexCount);
	}
	activateProgram(e) {
		let { gl: t, program: n } = this;
		n.use(), this.attribList.enable(this.program, () => {
			_(t, [t.BLEND], () => {
				t.blendFunc(t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA), t.activeTexture(t.TEXTURE0), n.uniform1i({ u_texture0: 0 }), e(), t.bindTexture(t.TEXTURE_2D, null);
			});
		});
	}
	buildArray() {
		return new Float32Array([
			0,
			0,
			1,
			0,
			0,
			1,
			1,
			1
		]);
	}
	visibleTiles(e, t, n) {
		this.visibleTracts(e, (r) => {
			let { tiles: i } = new Ql(this, r).visibleTiles(e, t, !1);
			for (let e of i) n(e.tile.id);
		});
	}
}, Ql = class {
	renderer;
	tract;
	constructor(e, t) {
		this.renderer = e, this.tract = t;
	}
	render(e) {
		let t = this.tract, { lodBias: n, animationLod: r } = this.renderer, { tiles: i, baseLevel: a, lodAlpha: o } = this.visibleTiles(e, n + r * e.lodBias, !0);
		i.sort((e, t) => t.tile.level - e.tile.level), this.renderer.program.uniformMatrix4fv({ u_mMatrix: t.mMatrix });
		for (let e of i) {
			let t = !this.renderer.integerLevel && a === e.tile.level ? o : 1;
			e.tile.render(t, this.renderer, e.tt);
		}
	}
	visibleTiles(e, t, n) {
		let r = this.tract, i = [], a = /* @__PURE__ */ new Set(), { minP: o, maxP: s, minQ: c, maxQ: l, baseLevel: u, lodAlpha: d } = r.tileIndices(e, t);
		for (let e = o; e <= s; ++e) for (let t = c; t <= l; ++t) this.readyTilesFor(u, e, t, n, (e, t) => {
			a.has(e.id) || i.push({
				tile: e,
				tt: t
			}), a.add(e.id);
		});
		return {
			tiles: i,
			baseLevel: u,
			lodAlpha: d
		};
	}
	readyTilesFor(e, t, n, r, i) {
		let { renderer: a, tract: o } = this, { textureProvider: s } = a;
		for (let c = e; c <= o.maxTileLevel; ++c) {
			let l = o.encodeTileId(c, t, n), u = s.get(l), d = $l.get(l);
			if (u) {
				if (i(d, u), r && u.needUpdate() && s.requestTile(l, {
					fadeIn: !1,
					immediate: c < o.maxTileLevel
				}), (a.integerLevel || c > e) && u.fadeAlpha >= 1) break;
			} else r && s.requestTile(l, {
				immediate: !1,
				fadeIn: !0
			});
			t >>= 1, n >>= 1;
		}
	}
}, $l = class e {
	id;
	level;
	texMatrix;
	tileMatrix;
	constructor(e) {
		this.id = e;
		let { tract: t, level: n, p: r, q: i } = Rl.decodeTileId(e);
		this.level = n;
		let a = t.tileSize << n, o = (Math.min((t.naxis2 >> n) - 1 << n, a * (r + 1)) - a * r) / a, s = (Math.min((t.naxis1 >> n) - 1 << n, a * (i + 1)) - a * i) / a;
		this.texMatrix = Xe(s, 0, 0, 0, o, 0, 0, 0, 1), this.tileMatrix = Xe(a, 0, 0, 0, a, 0, a * i, a * r, 1);
	}
	render(e, t, n) {
		n.beforeRender();
		let { gl: r, program: i } = t;
		r.bindTexture(r.TEXTURE_2D, n.tex.name), i.uniform1f({ u_alpha: e * n.fadeAlpha }), i.uniformMatrix3fv({
			u_texMatrix: this.texMatrix,
			u_tileMatrix: this.tileMatrix
		}), t.draw();
	}
	static cache = new Fl({ maxSize: 1e4 });
	static get(t) {
		let n = this.cache.get(t);
		if (n) return n;
		let r = new e(t);
		return this.cache.set(t, r), r;
	}
}, eu = (() => {
	let e = [], t, n = () => {
		t = requestAnimationFrame(() => {
			t = void 0, e.length > 0 && (e.shift()(), n());
		});
	};
	return () => new Promise((r) => {
		e.push(r), t === void 0 && n();
	});
})(), tu = class {
	globe;
	constructor(e) {
		this.globe = e;
	}
	alreadyReleased = !1;
	release() {
		this.releaseCallbacks.flush(), this.alreadyReleased = !0;
	}
	releaseCallbacks = cs();
	onRelease = this.releaseCallbacks.add;
	_tractRevision = 0;
	get tractRevision() {
		return this._tractRevision;
	}
	tractsUpdated() {
		this._tractRevision++;
	}
	_revision = 0;
	get revision() {
		return this._revision;
	}
	update() {
		this._revision++;
	}
}, nu = class {
	id;
	tract;
	level;
	p;
	q;
	center;
	constructor(e) {
		this.id = e;
		let { tract: t, level: n, p: r, q: i } = Rl.decodeTileId(e);
		this.tract = t, this.level = n, this.p = r, this.q = i;
		let a = (t.tileSize << n) * (r + .5), o = (t.tileSize << n) * (i + .5);
		this.center = t.pixel2xyz(o, a);
	}
}, ru = class extends tu {
	nParallel = 2;
	loading = /* @__PURE__ */ new Set();
	requestQueue = /* @__PURE__ */ new Map();
	cache;
	deadTileId = /* @__PURE__ */ new Set();
	constructor(e) {
		super(e), this.cache = new Fl({
			maxSize: 2e3,
			onDrop: (e) => e.release()
		}), this.onRelease(() => {
			this.cache.clear();
		});
	}
	get(e) {
		return this.cache.get(e);
	}
	requestTile(e, { immediate: t, fadeIn: n }) {
		if (this.deadTileId.has(e) || this.loading.has(e) || this.requestQueue.has(e)) return;
		let r = new nu(e);
		t ? this.load({
			ref: r,
			fadeIn: n
		}, { sync: t }) : this.requestQueue.set(e, {
			ref: r,
			fadeIn: n
		});
	}
	flushQueue(e) {
		let t = [];
		for (this.requestQueue.forEach((e) => t.push(e)), t.sort((t, n) => t.ref.level === n.ref.level ? mr(t.ref.center, e) - mr(n.ref.center, e) : n.ref.level - t.ref.level); t.length > 0 && this.loading.size < this.nParallel;) {
			let e = t.shift();
			this.load(e, { sync: !1 });
		}
		this.requestQueue.clear();
	}
	async load(e, { sync: t }) {
		let { ref: n, fadeIn: r } = e;
		this.loading.add(n.id), t || await eu(), this.makeTileTexture(n, {
			fadeIn: r,
			sync: t
		}).then((e) => {
			if (this.alreadyReleased) {
				e.release();
				return;
			}
			this.cache.set(n.id, e), this.globe.requestRefresh();
		}).catch((e) => {
			this.deadTileId.add(n.id), console.warn(e);
		}).then(() => {
			this.loading.delete(n.id), this.loading.size == 0 && this.globe.emit("imageloadend", {});
		});
	}
	clearCache(e) {
		if (e) for (let t of this.cache.keys()) e(t) || (this.cache.delete(t), this.deadTileId.delete(t));
		else this.cache.clear(), this.deadTileId.clear();
	}
	setCacheSize(e) {
		this.cache.setLimit(e);
	}
}, iu = class extends ru {
	constructor(e) {
		super(e);
	}
	async makeTileTexture(e, { fadeIn: t }) {
		let n = await bl(this.ref2url(e)), r = new au(this, { fadeIn: t }), i = this.globe.gl;
		return r.bind(() => {
			i.texImage2D(i.TEXTURE_2D, 0, i.RGBA, i.RGBA, i.UNSIGNED_BYTE, n), e.level === e.tract.maxTileLevel && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, i.LINEAR_MIPMAP_LINEAR), i.generateMipmap(i.TEXTURE_2D));
		}), r;
	}
}, au = class {
	tp;
	revision;
	tex;
	fadeAlpha = 1;
	constructor(e, { fadeIn: t = !1, revision: n }) {
		this.tp = e;
		let r = e.globe.gl;
		this.tex = new A(r), this.revision = n ?? e.revision, t && this.fadeIn();
	}
	fadeIn(e = 200) {
		this.tp.globe.animations.add((({ r: e }) => {
			this.fadeAlpha = e;
		}), {
			duration: e,
			immediate: !0
		});
	}
	release() {
		this.tex.release();
	}
	bind(e) {
		this.tex.bind(e);
	}
	needUpdate() {
		return this.revision < this.tp.revision;
	}
	beforeRender() {}
}, ou = /* @__PURE__ */ s({
	AsyncTextureProvider: () => ru,
	Renderer: () => Zl,
	SimpleImageTextureProvider: () => iu,
	TextureProvider: () => tu,
	TileRef: () => nu,
	TileTexture: () => au,
	Tract: () => Rl
}), su = class {
	globe;
	baseUrl;
	r;
	region = {};
	filters = [];
	alreadyReleased = !1;
	fadeInAlpha = 0;
	constructor(e, t, n) {
		this.globe = e, this.baseUrl = t, this.r = new Zc(e.gl), this.r.minWidth = 3, this.load().then(() => {
			e.animations.add(({ r: e }) => {
				this.fadeInAlpha = e;
			}, { duration: 1e3 }), this.setFilter(n);
		});
	}
	release() {
		this.alreadyReleased = !0, this.r.release();
	}
	async load() {
		let e = { data: { $any: [] } };
		this.region = cu(await (await fetch(`${this.baseUrl}/area.json`)).json().catch((t) => e));
	}
	rebuild() {
		if (this.alreadyReleased) return;
		let e = .01, t = [];
		for (let n of this.filters) {
			let r = this.region[n.filterName] || [], i = [...n.color, .75];
			for (let n of r) {
				let r = {
					points: n.map((t) => ({
						position: t,
						color: i,
						size: e
					})),
					close: !0,
					joint: "MITER"
				};
				t.push(r);
			}
		}
		{
			let n = this.region.$any || [], r = Object.keys(this.region).length == 1 ? [
				0,
				1,
				0,
				.5
			] : [
				1,
				1,
				1,
				.25
			];
			for (let i of n) {
				let n = {
					points: i.map((t) => ({
						position: t,
						color: r,
						size: e
					})),
					close: !0,
					joint: "MITER"
				};
				t.push(n);
			}
		}
		this.r.setPaths(t), this.globe.requestRefresh();
	}
	setFilter(e) {
		this.filters = e, this.rebuild();
	}
	render(e, t = 1) {
		this.r.render(e, t * this.fadeInAlpha * Lc(e));
	}
};
function cu(e) {
	return Array.isArray(e) ? { $any: e } : e;
}
//#endregion
//#region src/utils/date.ts
var lu = /* @__PURE__ */ s({
	JulianDay: () => uu,
	modifiedJulianDay: () => du,
	siderealTimeHour: () => fu,
	siderealTimeRadian: () => pu,
	zenithSkyCoord: () => mu
});
function uu(e) {
	return Number(e) / 864e5 + 2440587.5;
}
function du(e) {
	return uu(e) - 2400000.5;
}
function fu(e) {
	let t = .671262 + 1.0027379094 * (uu(e) - 2440000.5);
	return t = t >= 0 ? t % 1 : 1 - -t % 1, 24 * t;
}
function pu(e) {
	return bs(fu(e) * 15);
}
function mu({ when: e, where: t, zp: n }) {
	return {
		za: pu(e) + bs(t.lon),
		zd: bs(t.lat),
		zp: n ?? 0
	};
}
//#endregion
//#region src/utils/image_filter/imageFilter.vert.glsl?raw
var hu = "#version 300 es\n\nin     vec2   a_coord;\nout    vec2   v_coord;\n\nvoid main(void) {\n    gl_Position = vec4(2. * a_coord - vec2(1.), 0., 1.);\n    v_coord = a_coord;\n}", gu = class {
	gl;
	program;
	attribList;
	frameBuffer;
	textures = [];
	constructor(e, t) {
		this.gl = e, this.attribList = new E(e, {
			members: [{
				name: "a_coord",
				nComponents: 2
			}],
			array: new Float32Array([
				0,
				0,
				1,
				0,
				1,
				1,
				0,
				0,
				1,
				1,
				0,
				1
			])
		}), this.frameBuffer = e.createFramebuffer(), this.program = S.new(e, hu, t);
	}
	release() {
		this.attribList.release(), this.gl.deleteFramebuffer(this.frameBuffer), this.program.release();
		for (let e of this.textures) e.release();
	}
	setUniformParams() {}
	applyToImages(e, t, n, r) {
		return this.apply(e, t, n, r.length, (e, t) => e.setImage(r[t]));
	}
	apply(e, t, n, r, i) {
		let { gl: a, program: o } = this;
		a.bindTexture(a.TEXTURE_2D, e.name), a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, t, n, 0, a.RGBA, a.UNSIGNED_BYTE, null), a.bindTexture(a.TEXTURE_2D, null), a.bindFramebuffer(a.FRAMEBUFFER, this.frameBuffer), a.framebufferTexture2D(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0, a.TEXTURE_2D, e.name, 0);
		let { drawingBufferWidth: s, drawingBufferHeight: c } = a;
		a.viewport(0, 0, t, n);
		for (let e = 0; e < r; ++e) this.textures[e] || (this.textures[e] = new A(this.gl)), i(this.textures[e], e);
		o.use(), this.setUniformParams(), this.attribList.enable(o, () => {
			for (let e = 0; e < r; ++e) a.uniform1i(o.uniformLocation(`u_texture${e}`), e), a.activeTexture(a[`TEXTURE${e}`]), a.bindTexture(a.TEXTURE_2D, this.textures[e].name);
			a.drawArrays(a.TRIANGLES, 0, 6);
			for (let e = 0; e < r; ++e) a.activeTexture(a[`TEXTURE${e}`]), a.bindTexture(a.TEXTURE_2D, null);
		}), a.bindFramebuffer(a.FRAMEBUFFER, null), a.activeTexture(a.TEXTURE0), a.viewport(0, 0, s, c);
	}
}, _u = "vec3 decode_png(in vec3 y) {\n    //   a = 10000.,\n    //   b = -1/8;\n    // \n    //   = pack =\n    //   y = asinh(a * x) / asinh(a) - b / (1 - b);\n\n    //   = unpack =\n    //   x = 1/a * sinh((y + b/(1-b))*asinh(a))\n\n    vec3 x = 0.0001 * sinh(9.903487555 * (y - 0.1111111111));\n    return x;\n}", vu = "float scale(in float x, in float beta) {\n    return asinh(beta * x) / asinh(beta);\n}\n\nvec3 sdss_true_color(in vec3 raw, in float beta, in float a, in float bias, in float b0) {\n    raw += b0;\n    float i = (raw.r + raw.g + raw.b) / 3.;\n    vec3 color = scale(i, beta) / i * raw;\n    color = a * color + bias;\n    return color;\n}\n", yu = "#version 300 es\n\nprecision highp float;\n\nuniform sampler2D  u_texture0, u_texture1, u_texture2;\nuniform float u_beta;\nuniform float u_a;\nuniform float u_bias;\nuniform float u_b0;\nin vec2 v_coord;\nout vec4 outputColor;\n\n//@import ./decode_png;\n//@import ./sdss_true_color;\n\nvoid main(void){\n    vec3 raw = decode_png(vec3(\n        texture(u_texture0, v_coord).r,\n        texture(u_texture1, v_coord).r,\n        texture(u_texture2, v_coord).r\n    ));\n    vec3 color = sdss_true_color(raw, u_beta, u_a, u_bias, u_b0);\n    outputColor = vec4(color, 1.);\n}\n", bu = "vec3 simple_rgb(in vec3 raw, in float beta, in float a, in float bias, in float b0) {\n    raw += b0;\n    vec3 color = asinh(beta * raw) / asinh(vec3(beta));\n    color = a * color + vec3(bias);\n    return color;\n}", xu = "#version 300 es\n\nprecision highp float;\n\nuniform sampler2D  u_texture0, u_texture1, u_texture2;\nuniform float u_beta;\nuniform float u_a;\nuniform float u_bias;\nuniform float u_b0;\nin      vec2  v_coord;\nout     vec4  outputColor;\n\n//@import ./decode_png;\n//@import ./simple_rgb;\n\nvoid main(void){\n    vec3 raw = decode_png(vec3(\n        texture(u_texture0, v_coord).r,\n        texture(u_texture1, v_coord).r,\n        texture(u_texture2, v_coord).r\n    ));\n    vec3 color = simple_rgb(raw, u_beta, u_a, u_bias, u_b0);\n    outputColor = vec4(color, 1.);\n}", Su = class extends gu {
	params;
	constructor(e, t) {
		super(e, Du(xu)), this.params = t;
	}
	setUniformParams() {
		this.program.uniform1f({
			u_a: this.params.a,
			u_bias: this.params.bias,
			u_beta: this.params.beta,
			u_b0: this.params.b0
		});
	}
}, Cu = class extends gu {
	params;
	constructor(e, t) {
		super(e, Du(yu)), this.params = t;
	}
	setUniformParams() {
		this.program.uniform1f({
			u_a: this.params.a,
			u_bias: this.params.bias,
			u_beta: this.params.beta,
			u_b0: this.params.b0
		});
	}
}, wu = class e extends gu {
	params;
	constructor(t, n) {
		super(t, e.fragmentShader(n)), this.params = n;
	}
	static fragmentShader(e) {
		let t = e.colors.length, n = Yo(t).map((e) => `t${e} = texture(u_texture${e}, v_coord).r`).join(", "), r = Yo(t).map((e) => `u_color[${e}][0] * t${e}`).join(" + "), i = Yo(t).map((e) => `u_color[${e}][1] * t${e}`).join(" + "), a = Yo(t).map((e) => `u_color[${e}][2] * t${e}`).join(" + ");
		return Du(`\
      #version 300 es

      precision highp float;
      uniform sampler2D ${Yo(t).map((e) => `u_texture${e}`)};
      uniform vec3  u_color[${t}];
      uniform float u_beta;
      uniform float u_a;
      uniform float u_bias;
      uniform float u_b0;
      in      vec2  v_coord;
      out     vec4  outputColor;

      //@import ./decode_png;
      //@import ./simple_rgb;
      
      void main(void){
        float ${n};
        vec3 raw = decode_png(vec3(${r}, ${i}, ${a}));
        vec3 color = simple_rgb(raw, u_beta, u_a, u_bias, u_b0);
        outputColor = vec4(color, 1.);
      }
    `);
	}
	setUniformParams() {
		this.program.uniform3fv(Object.fromEntries(this.params.colors.map((e, t) => [`u_color[${t}]`, e]))), this.program.uniform1f({
			u_a: this.params.a,
			u_bias: this.params.bias,
			u_beta: this.params.beta,
			u_b0: this.params.b0
		});
	}
}, Tu = class e extends gu {
	params;
	constructor(t, n) {
		super(t, e.fragmentShader(n)), this.params = n;
	}
	static fragmentShader(e) {
		let t = e.colors.length, n = Yo(t).map((e) => `t${e} = texture(u_texture${e}, v_coord).r`).join(", "), r = Yo(t).map((e) => `u_color[${e}][0] * t${e}`).join(" + "), i = Yo(t).map((e) => `u_color[${e}][1] * t${e}`).join(" + "), a = Yo(t).map((e) => `u_color[${e}][2] * t${e}`).join(" + ");
		return Du(`\
      #version 300 es
      precision highp float;
      uniform sampler2D ${Yo(t).map((e) => `u_texture${e}`)};
      uniform vec3  u_color[${t}];
      uniform float u_beta;
      uniform float u_a;
      uniform float u_bias;
      uniform float u_b0;
      in      vec2  v_coord;
      out     vec4  outputColor;

      //@import ./decode_png;
      //@import ./sdss_true_color;
      
      void main(void){
        float ${n};
        vec3 raw = decode_png(vec3(${r}, ${i}, ${a}));
        vec3 color = sdss_true_color(raw, u_beta, u_a, u_bias, u_b0);
        outputColor = vec4(color, 1.);
      }
    `);
	}
	setUniformParams() {
		this.program.uniform3fv(Object.fromEntries(this.params.colors.map((e, t) => [`u_color[${t}]`, e]))), this.program.uniform1f({
			u_a: this.params.a,
			u_bias: this.params.bias,
			u_beta: this.params.beta,
			u_b0: this.params.b0
		});
	}
}, Eu = class extends ru {
	tracts = [];
	tractName = /* @__PURE__ */ new Map();
	imageFilter;
	params;
	imageCache;
	magFilter;
	baseUrl;
	constructor(e, { baseUrl: t, params: n, magFilter: r }) {
		super(e), this.baseUrl = t, this.magFilter = r, this.imageCache = Ou(), this.onRelease(() => this.imageCache.release()), this.setParams(n), this.loadMetadata();
		let i = this.globe.on("resize", () => this.updateImageCacheSize());
		this.onRelease(i);
	}
	updateImageCacheSize() {
		let { width: e, height: t } = this.globe.canvas.domElement, n = Math.floor(8 * this.params.filters.length * e * t / 256 ** 2);
		this.imageCache.setCacheSize(n);
	}
	setParams(e) {
		if (e.type !== this.params?.type || e.filters.length !== this.params?.filters.length) {
			switch (this.imageFilter && this.imageFilter.release(), e.type) {
				case "sdssTrueColor":
					this.imageFilter = new Cu(this.globe.gl, e.sdssTrueColor);
					break;
				case "simpleRgb":
					this.imageFilter = new Su(this.globe.gl, e.simpleRgb);
					break;
				case "simpleColorMatrix":
					this.imageFilter = new wu(this.globe.gl, e.simpleColorMatrix);
					break;
				case "sdssTrueColorMatrix":
					this.imageFilter = new Tu(this.globe.gl, e.sdssTrueColorMatrix);
					break;
			}
			this.onRelease(() => this.imageFilter.release());
		}
		switch (e.type) {
			case "sdssTrueColor":
				this.imageFilter.params = e.sdssTrueColor;
				break;
			case "simpleRgb":
				this.imageFilter.params = e.simpleRgb;
				break;
			case "simpleColorMatrix":
				this.imageFilter.params = e.simpleColorMatrix;
				break;
			case "sdssTrueColorMatrix":
				this.imageFilter.params = e.sdssTrueColorMatrix;
				break;
		}
		this.params = { ...e }, this.updateImageCacheSize(), this.update();
	}
	async loadMetadata() {
		let e = await (await fetch(`${this.baseUrl}/meta.json`)).json();
		if (!this.alreadyReleased) {
			this.tracts = [], this.tractName.clear();
			for (let t of Object.keys(e)) {
				let n = Rl.fromFitsHeader(e[t].wcs);
				this.tractName.set(n, t), this.tracts.push(n);
			}
			this.tractsUpdated(), this.updateImageCacheSize(), this.globe.requestRefresh();
		}
	}
	walkTracts(e) {
		for (let t of this.tracts) e(t);
	}
	imageUrls(e) {
		return this.params.filters.map((t) => `${this.baseUrl}/${t}/${this.tractName.get(e.tract)}/${e.level}/${e.p}/${e.q}.png`);
	}
	async makeTileTexture(e, { sync: t, fadeIn: n }) {
		let r = this.imageUrls(e), i = this.revision, a = await Promise.all(r.map((e) => this.imageCache(e))), o = new au(this, {
			fadeIn: n,
			revision: i
		}), s = this.globe.gl, { tileSize: c } = e.tract;
		return this.alreadyReleased ? o : (p(s, "imageFilter", () => {
			this.imageFilter.apply(o.tex, c, c, a.length, (e, t) => {
				e.bind(() => {
					let e = a[t];
					s.texImage2D(s.TEXTURE_2D, 0, s.LUMINANCE, s.LUMINANCE, s.UNSIGNED_BYTE, e);
				});
			});
		}), o.tex.bind(() => {
			e.level === e.tract.maxTileLevel && (s.generateMipmap(s.TEXTURE_2D), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, s.LINEAR_MIPMAP_LINEAR)), this.magFilter === "nearest" && e.level === 0 && s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, s.NEAREST);
		}), o);
	}
	setMagFilter(e) {
		this.magFilter = e, this.update();
	}
};
function Du(e) {
	let t = {
		decode_png: _u,
		sdss_true_color: vu,
		simple_rgb: bu
	};
	return e.replace(/^\s*\/\/@import\s+\.\/(.*?);/gm, (e, n) => t[n]);
}
function Ou(e = 0) {
	let t = new Fl({ maxSize: e }), n = ku();
	return Object.assign(async (e) => {
		let r = t.get(e);
		if (r) return r;
		let i = await bl(e, { failover: await n });
		return t.set(e, i), i;
	}, {
		release: () => t.clear(),
		setCacheSize: (e) => t.setLimit(e)
	});
}
async function ku(e = 0, t = 0, n = 0, r = 255) {
	let i = new ImageData(1, 1);
	i.data[0] = e, i.data[1] = t, i.data[2] = n, i.data[3] = r;
	let a = document.createElement("canvas");
	a.width = 1, a.height = 1, y(a.getContext("2d")).putImageData(i, 0, 0);
	let o = await new Promise((e) => a.toBlob((t) => e(t)));
	return await createImageBitmap(o);
}
//#endregion
//#region src/layer/ssp_tile_layer/TextureProvider/params.ts
var Au = [
	"HSC-I",
	"HSC-R",
	"HSC-G"
];
function ju({ filters: e }) {
	return {
		type: "sdssTrueColor",
		filters: e,
		sdssTrueColor: {
			beta: 3e4,
			a: 1,
			bias: .05,
			b0: 0
		}
	};
}
function Mu({ filters: e }) {
	return {
		type: "simpleRgb",
		filters: e,
		simpleRgb: {
			beta: 3e4,
			a: 1,
			bias: .05,
			b0: 0
		}
	};
}
function Nu({ filters: e }) {
	return {
		type: "simpleColorMatrix",
		filters: e,
		simpleColorMatrix: {
			colors: [
				[
					1,
					0,
					0
				],
				[
					0,
					1,
					0
				],
				[
					0,
					0,
					1
				]
			],
			beta: 3e4,
			a: 1,
			bias: .05,
			b0: 0
		}
	};
}
function Pu({ filters: e }) {
	return {
		type: "sdssTrueColorMatrix",
		filters: e,
		sdssTrueColorMatrix: {
			colors: [
				[
					1,
					0,
					0
				],
				[
					0,
					1,
					0
				],
				[
					0,
					0,
					1
				]
			],
			beta: 3e4,
			a: 1,
			bias: .05,
			b0: 0
		}
	};
}
var Fu = {
	simpleRgb: Mu,
	simpleColorMatrix: Nu,
	sdssTrueColor: ju,
	sdssTrueColorMatrix: Pu
};
function Iu({ type: e = "sdssTrueColor", filters: t = Au } = {}) {
	return { ...Fu[e]({ filters: t }) };
}
function Lu(e, t) {
	if (e.type !== t) throw Error(`SspTileLayerParams: type mismatch: expected=${t}, but actual: ${e.type}`);
}
//#endregion
//#region src/layer/ssp_tile_layer/index.ts
var Ru = class extends $ {
	tileRenderer;
	areaRenderer;
	alpha = 1;
	outline;
	constructor(e, t) {
		super(e);
		let n = t.baseUrl, r = t.colorParams ?? Iu({ type: "sdssTrueColor" }), i = t.magFilter ?? "linear", a = zu(r);
		this.outline = t.outline ?? !1;
		let o = new Eu(e, {
			baseUrl: n,
			params: r,
			magFilter: i
		});
		this.onRelease(() => o.release()), this.tileRenderer = new Zl(e, o), this.onRelease(() => this.tileRenderer.release()), this.areaRenderer = new su(e, n, a), this.onRelease(() => this.areaRenderer.release());
	}
	render(e) {
		let t = this.globe.gl, n = Lc(e);
		p(t, "sspTile", () => {
			this.tileRenderer.render(e, 1 - n);
		}), this.outline && p(t, "sspTileOutline", () => {
			this.areaRenderer.render(e, this.alpha * n);
		});
	}
	setParams(e) {
		let t = 2 + Math.log2(this.globe.camera.pixelRatio), { textureProvider: n } = this.tileRenderer, r = this.globe.camera.view(), i = /* @__PURE__ */ new Set();
		this.tileRenderer.visibleTiles(r, t, (e) => i.add(e)), n.setParams(e), n.clearCache((e) => i.has(e)), this.setAreaFilters(zu(e)), this.globe.requestRefresh();
	}
	setAreaFilters(e) {
		this.areaRenderer.setFilter(e), this.globe.requestRefresh();
	}
	setMagFilter(e) {
		this.tileRenderer.textureProvider.setMagFilter(e), this.globe.requestRefresh();
	}
	static defaultParams = Iu;
	static assertType = Lu;
};
function zu(e) {
	let t = [
		[
			1,
			.25,
			.25
		],
		[
			.25,
			1,
			.25
		],
		[
			.25,
			.25,
			1
		]
	];
	switch (e.type) {
		case "sdssTrueColor":
		case "simpleRgb": return e.filters.map((e, n) => ({
			filterName: e,
			color: t[n]
		}));
		case "sdssTrueColorMatrix": return e.filters.map((t, n) => ({
			filterName: t,
			color: e.sdssTrueColorMatrix.colors[n]
		}));
		case "simpleColorMatrix": return e.filters.map((t, n) => ({
			filterName: t,
			color: e.simpleColorMatrix.colors[n]
		}));
	}
}
//#endregion
//#region src/layer/text_layer.ts
var Bu = {
	color: "white",
	font: "12px sans-serif"
}, Vu = class extends $ {
	renderer;
	defaultFont;
	defaultColor;
	alphaFunc;
	constructor(e, { texts: t, defaultColor: n = Bu.color, defaultFont: r = Bu.font, alphaFunc: i }) {
		super(e), this.defaultFont = r, this.defaultColor = n, this.alphaFunc = i ?? Lc, this.renderer = new Gc(this.globe.gl), this.buildTextBillboards(t), this.globe.requestRefresh(), this.onRelease(() => {
			this.renderer.release();
		});
	}
	update({ defaultColor: e, defaultFont: t, texts: n } = {}) {
		this.defaultFont = t ?? (t === null ? Bu.font : this.defaultFont), this.defaultColor = e ?? (e === null ? Bu.color : this.defaultColor), n && this.buildTextBillboards(n), this.globe.requestRefresh();
	}
	buildTextBillboards(e) {
		let t = [], n = [];
		for (let r of e) n.push({
			imageID: t.length,
			position: r.position,
			color: [
				1,
				1,
				1,
				1
			]
		}), t.push({
			imageData: il(r.text, r.font || this.defaultFont, r.color || this.defaultColor),
			origin: [0, 0]
		});
		this.renderer.buildArray(t, n);
	}
	render(e, t = 1) {
		this.renderer.render(e, t * this.alphaFunc(e));
	}
}, Hu = Xe(-.05487553939, -.873437104725, -.483834991775, .494109453633, -.444829594298, .746982248696, -.867666135681, -.198076389622, .455983794523), Uu = class e {
	mat;
	invMat;
	constructor(e) {
		this.mat = e, this.invMat = $e(Ke(), e);
	}
	rotate(e) {
		return er([
			0,
			0,
			0
		], e, this.mat);
	}
	invert(e) {
		return er([
			0,
			0,
			0
		], e, this.invMat);
	}
	static GALACTIC = new e(Hu);
	static EQUATORIAL = new e(Qe(Ke()));
};
//#endregion
//#region src/renderer/hips_renderer/properties.ts
async function Wu(e) {
	let t = `${e}/properties`, n = await (await fetch(t)).text(), r = {};
	for (let e of n.split("\n")) if (!e.match(/^\s*#/) && e.indexOf("=") >= 0) {
		let [t, n] = e.split("=").map((e) => e.replace(/\s*(.*?)\s*$/, "$1"));
		r[t] = n;
	}
	if (!("hips_order" in r) || !("hips_tile_width" in r)) throw Error("invalid properties file");
	return r;
}
//#endregion
//#region src/renderer/hips_renderer/frag.glsl?raw
var Gu = "precision mediump float;\nuniform sampler2D u_texture1;\nuniform sampler2D u_shiftmap;\nuniform mat3 u_tMatrix;\nuniform float u_alpha;\nvarying vec2 v_coord;\nvarying float v_w;\n\nconst float DELTA_MAP_N = 64.; // This value must equal to valeu of DELTA_MAP_N in interface.ts\n\n/*\n    // TypeScript\n    function encode(v: number) {\n        const VMAX = 0.015\n        return ((v / VMAX) + 1) / 2 * 256\n    }\n*/\n\nconst float VMAX = 0.015;\nvec2 decode_shiftmap(vec2 e) {\n    e *= 255. / 256.;\n    return (2. * e - 1.) * VMAX;\n}\n\nvec2 delta_coord(vec2 c) {\n    return (1. / DELTA_MAP_N) * ((DELTA_MAP_N - 1.) * c + vec2(0.5));\n}\n\nvoid main() {\n    vec2 tCoord = (u_tMatrix * vec3(v_coord - decode_shiftmap(texture2D(u_shiftmap, delta_coord(v_coord)).xy), 1)).xy;\n    gl_FragColor = texture2D(u_texture1, tCoord);\n    gl_FragColor.a *= u_alpha * clamp(4. * (v_w - 0.2), 0., 1.);\n    // vec2 d = pow(2. * (v_coord - vec2(0.5)), vec2(10.));\n    // gl_FragColor.g += 0.75 * dot(d, d);\n}", Ku = "precision mediump float;\nuniform sampler2D u_texture1;\nuniform sampler2D u_shiftmap;\nuniform mat3 u_tMatrix;\nuniform float u_alpha;\nvarying vec2 v_coord;\nvarying float v_w;\n\nconst float DELTA_MAP_N = 64.; // This value must equal to valeu of DELTA_MAP_N in interface.ts\n\n/*\n    // TypeScript\n    function encode(v: number) {\n        const VMAX = 0.015\n        return ((v / VMAX) + 1) / 2 * 256\n    }\n*/\n\nconst float VMAX = 0.015;\nvec2 decode_shiftmap(vec2 e) {\n    e *= 255. / 256.;\n    return (2. * e - 1.) * VMAX;\n}\n\nvec2 delta_coord(vec2 c) {\n    return (1. / DELTA_MAP_N) * ((DELTA_MAP_N - 1.) * c + vec2(0.5));\n}\n\nvoid main() {\n    vec2 tCoord = (u_tMatrix * vec3(v_coord - decode_shiftmap(texture2D(u_shiftmap, delta_coord(v_coord)).xy), 1)).xy;\n    float v = texture2D(u_texture1, tCoord).r;\n    gl_FragColor.rgb = vec3(0.);\n    gl_FragColor.a = u_alpha * (1. - v);\n}\n", qu = Math.PI;
2 * Math.PI;
var Ju = Math.PI / 2, Yu = Math.PI / 4, Xu = Math.PI / 8, Zu = (() => {
	let e = (() => {
		function e(e) {
			let t = Math.floor(e / 4), n = e % 4, r = [
				0,
				1 / 3,
				2 / 3,
				1
			];
			return [r[t], r[n]];
		}
		let t = [];
		for (let n = 0; n < 16; ++n) t.push(e(n));
		return t;
	})(), t = [
		/* @__PURE__ */ new Float32Array(16),
		/* @__PURE__ */ new Float32Array(16),
		/* @__PURE__ */ new Float32Array(16)
	], n = [
		/* @__PURE__ */ new Float32Array(16),
		/* @__PURE__ */ new Float32Array(16),
		/* @__PURE__ */ new Float32Array(16)
	], r = new Float32Array([
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0
	]);
	return (i, a) => {
		let o = 1 << i, s = Yu / o, { f: c, x: l, y: u } = rd(o, a), { t: d, u: f } = Qu(o, c, l, u), p = Math.abs(f) <= Yu;
		if ((c < 4 || 8 <= c) && l + u === o - 1) {
			for (let r = 0; r < 16; ++r) {
				let [i, a] = e[r], o = d + s * (1 - a - i), l = f + s * (i - a), u = $u(o, l, c >= 8), p = $u(o, l, c < 4), m = ed(u.z, u.a), h = ed(p.z, p.a);
				t[0][r] = m[0], t[1][r] = m[1], t[2][r] = m[2], n[0][r] = h[0], n[1][r] = h[1], n[2][r] = h[2];
			}
			return {
				a: [
					td(ud, t[0]),
					td(ud, t[1]),
					td(ud, t[2])
				],
				b: [
					td(ud, n[0]),
					td(ud, n[1]),
					td(ud, n[2])
				]
			};
		} else {
			for (let n = 0; n < 16; ++n) {
				let [r, i] = e[n], { z: a, a: o } = $u(d + s * (1 - i - r), f + s * (r - i), p), c = ed(a, o);
				t[0][n] = c[0], t[1][n] = c[1], t[2][n] = c[2];
			}
			return {
				a: [
					td(ud, t[0]),
					td(ud, t[1]),
					td(ud, t[2])
				],
				b: [
					r,
					r,
					r
				]
			};
		}
	};
})();
function Qu(e, t, n, r) {
	let i = t >> 2, a = i + 2, o = t % 4 * 2 - i % 2 + 1, s = n + r, c = n - r, l = a * e - s - 1;
	return {
		t: (o * e + c + 8 * e) / e * Yu,
		u: Ju - l / e * Yu
	};
}
function $u(e, t, n) {
	let r = Math.abs(t);
	if (n) return {
		z: t / (3 * Xu),
		a: e
	};
	{
		if (r >= Ju) return {
			z: ad(t),
			a: 0
		};
		let n = e % (Math.PI / 2), i = e - (r - Yu) / (r - Ju) * (n - Yu);
		return {
			z: ad(t) * (1 - 1 / 3 * id(2 - 4 * r / qu)),
			a: i
		};
	}
}
function ed(e, t) {
	let n = e * e, r = n > 1 ? -Math.sqrt(n - 1) : Math.sqrt(1 - n);
	return [
		r * Math.cos(t),
		r * Math.sin(t),
		e
	];
}
function td(e, t) {
	let n = t.length, r = new Float32Array(n);
	for (let i = 0; i < n; ++i) {
		let a = 0;
		for (let r = 0; r < n; ++r) a += e[i + r * n] * t[r];
		r[i] = a;
	}
	return r;
}
function nd(e, t) {
	let n = 1 << e, r = n * n;
	return sd(e, (Math.floor(t / r) >> 2 << 2) * r + t % r);
}
function rd(e, t) {
	let n = e * e, r = Math.floor(t / n), { x: i, y: a } = od(t % n);
	return {
		f: r,
		x: i,
		y: a
	};
}
function id(e) {
	return e * e;
}
var ad = Math.sign || ((e) => e > 0 ? 1 : e < 0 ? -1 : 0);
function od(e) {
	return cd(e <= 2147483647), {
		x: (e & 1) >> 0 | (e & 4) >> 1 | (e & 16) >> 2 | (e & 64) >> 3 | (e & 256) >> 4 | (e & 1024) >> 5 | (e & 4096) >> 6 | (e & 16384) >> 7 | (e & 65536) >> 8 | (e & 262144) >> 9 | (e & 1048576) >> 10 | (e & 4194304) >> 11 | (e & 16777216) >> 12 | (e & 67108864) >> 13 | (e & 268435456) >> 14 | (e & 1073741824) >> 15,
		y: (e & 2) >> 1 | (e & 8) >> 2 | (e & 32) >> 3 | (e & 128) >> 4 | (e & 512) >> 5 | (e & 2048) >> 6 | (e & 8192) >> 7 | (e & 32768) >> 8 | (e & 131072) >> 9 | (e & 524288) >> 10 | (e & 2097152) >> 11 | (e & 8388608) >> 12 | (e & 33554432) >> 13 | (e & 134217728) >> 14 | (e & 536870912) >> 15
	};
}
function sd(e, t) {
	return 4 * ((1 << 2 * e) - 1) + t;
}
function cd(e) {
	if (console.assert(e), !e) debugger;
}
function ld(e) {
	let t = 0;
	for (; e > 1;) e >>= 1, ++t;
	return t;
}
var ud = new Float32Array([
	81 / 4,
	-81 / 2,
	99 / 4,
	-9 / 2,
	-81 / 2,
	81,
	-99 / 2,
	9,
	99 / 4,
	-99 / 2,
	121 / 4,
	-11 / 2,
	-9 / 2,
	9,
	-11 / 2,
	1,
	-243 / 4,
	243 / 2,
	-297 / 4,
	27 / 2,
	405 / 4,
	-405 / 2,
	495 / 4,
	-45 / 2,
	-81 / 2,
	81,
	-99 / 2,
	9,
	0,
	0,
	0,
	0,
	243 / 4,
	-243 / 2,
	297 / 4,
	-27 / 2,
	-81,
	162,
	-99,
	18,
	81 / 4,
	-81 / 2,
	99 / 4,
	-9 / 2,
	0,
	0,
	0,
	0,
	-81 / 4,
	81 / 2,
	-99 / 4,
	9 / 2,
	81 / 4,
	-81 / 2,
	99 / 4,
	-9 / 2,
	-9 / 2,
	9,
	-11 / 2,
	1,
	0,
	0,
	0,
	0,
	-243 / 4,
	405 / 4,
	-81 / 2,
	0,
	243 / 2,
	-405 / 2,
	81,
	0,
	-297 / 4,
	495 / 4,
	-99 / 2,
	0,
	27 / 2,
	-45 / 2,
	9,
	0,
	729 / 4,
	-1215 / 4,
	243 / 2,
	0,
	-1215 / 4,
	2025 / 4,
	-405 / 2,
	0,
	243 / 2,
	-405 / 2,
	81,
	0,
	0,
	0,
	0,
	0,
	-729 / 4,
	1215 / 4,
	-243 / 2,
	0,
	243,
	-405,
	162,
	0,
	-243 / 4,
	405 / 4,
	-81 / 2,
	0,
	0,
	0,
	0,
	0,
	243 / 4,
	-405 / 4,
	81 / 2,
	0,
	-243 / 4,
	405 / 4,
	-81 / 2,
	0,
	27 / 2,
	-45 / 2,
	9,
	0,
	0,
	0,
	0,
	0,
	243 / 4,
	-81,
	81 / 4,
	0,
	-243 / 2,
	162,
	-81 / 2,
	0,
	297 / 4,
	-99,
	99 / 4,
	0,
	-27 / 2,
	18,
	-9 / 2,
	0,
	-729 / 4,
	243,
	-243 / 4,
	0,
	1215 / 4,
	-405,
	405 / 4,
	0,
	-243 / 2,
	162,
	-81 / 2,
	0,
	0,
	0,
	0,
	0,
	729 / 4,
	-243,
	243 / 4,
	0,
	-243,
	324,
	-81,
	0,
	243 / 4,
	-81,
	81 / 4,
	0,
	0,
	0,
	0,
	0,
	-243 / 4,
	81,
	-81 / 4,
	0,
	243 / 4,
	-81,
	81 / 4,
	0,
	-27 / 2,
	18,
	-9 / 2,
	0,
	0,
	0,
	0,
	0,
	-81 / 4,
	81 / 4,
	-9 / 2,
	0,
	81 / 2,
	-81 / 2,
	9,
	0,
	-99 / 4,
	99 / 4,
	-11 / 2,
	0,
	9 / 2,
	-9 / 2,
	1,
	0,
	243 / 4,
	-243 / 4,
	27 / 2,
	0,
	-405 / 4,
	405 / 4,
	-45 / 2,
	0,
	81 / 2,
	-81 / 2,
	9,
	0,
	0,
	0,
	0,
	0,
	-243 / 4,
	243 / 4,
	-27 / 2,
	0,
	81,
	-81,
	18,
	0,
	-81 / 4,
	81 / 4,
	-9 / 2,
	0,
	0,
	0,
	0,
	0,
	81 / 4,
	-81 / 4,
	9 / 2,
	0,
	-81 / 4,
	81 / 4,
	-9 / 2,
	0,
	9 / 2,
	-9 / 2,
	1,
	0,
	0,
	0,
	0,
	0
]), dd = "(function(){let e=Math.PI,t=2*Math.PI,n=Math.PI/2,r=Math.PI/4,i=Math.PI/8,a=(()=>{let e=(()=>{function e(e){let t=Math.floor(e/4),n=e%4,r=[0,1/3,2/3,1];return[r[t],r[n]]}let t=[];for(let n=0;n<16;++n)t.push(e(n));return t})(),t=[new Float32Array(16),new Float32Array(16),new Float32Array(16)],n=[new Float32Array(16),new Float32Array(16),new Float32Array(16)],i=new Float32Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);return(a,u)=>{let d=1<<a,f=r/d,{f:p,x:m,y:h}=g(d,u),{t:_,u:v}=o(d,p,m,h),y=Math.abs(v)<=r;if((p<4||8<=p)&&m+h===d-1){for(let r=0;r<16;++r){let[i,a]=e[r],o=_+f*(1-a-i),l=v+f*(i-a),u=s(o,l,p>=8),d=s(o,l,p<4),m=c(u.z,u.a),h=c(d.z,d.a);t[0][r]=m[0],t[1][r]=m[1],t[2][r]=m[2],n[0][r]=h[0],n[1][r]=h[1],n[2][r]=h[2]}return{a:[l(T,t[0]),l(T,t[1]),l(T,t[2])],b:[l(T,n[0]),l(T,n[1]),l(T,n[2])]}}else{for(let n=0;n<16;++n){let[r,i]=e[n],{z:a,a:o}=s(_+f*(1-i-r),v+f*(r-i),y),l=c(a,o);t[0][n]=l[0],t[1][n]=l[1],t[2][n]=l[2]}return{a:[l(T,t[0]),l(T,t[1]),l(T,t[2])],b:[i,i,i]}}}})();function o(e,t,i,a){let o=t>>2,s=o+2,c=t%4*2-o%2+1,l=i+a,u=i-a,d=s*e-l-1;return{t:(c*e+u+8*e)/e*r,u:n-d/e*r}}function s(t,a,o){let s=Math.abs(a);if(o)return{z:a/(3*i),a:t};{if(s>=n)return{z:x(a),a:0};let i=t%(Math.PI/2),o=t-(s-r)/(s-n)*(i-r);return{z:x(a)*(1-1/3*b(2-4*s/e)),a:o}}}function c(e,t){let n=e*e,r=n>1?-Math.sqrt(n-1):Math.sqrt(1-n);return[r*Math.cos(t),r*Math.sin(t),e]}function l(e,t){let n=t.length,r=new Float32Array(n);for(let i=0;i<n;++i){let a=0;for(let r=0;r<n;++r)a+=e[i+r*n]*t[r];r[i]=a}return r}function u(e,t){let n=0;for(let r=0;r<e.length;++r)n+=e[r]*t[r];return n}function d(e,t,n,r,i){let a=n*n,o=a*n,s=r*r,c=s*r;return i?n-r>=0?e.map(e=>u([o,a,n,1],l(e,[c,s,r,1]))):t.map(e=>u([o,a,n,1],l(e,[c,s,r,1]))):e.map(e=>u([o,a,n,1],l(e,[c,s,r,1])))}function f(e,t){let n=e*e,r=Math.floor(t/n),{x:i,y:a}=S(t%n);return(r<4||8<=r)&&i+a===e-1}function p(e,t,n){function r(e){return(e/.015+1)/2*256}let i=1<<e,{a:o,b:s}=a(e,t),c=new Uint8Array(3*n*n),l=f(i,t);function u(e,n){let r=d(o,s,e,n,l),{x:a,y:c}=m(i,t,r),u=c,f=1-a;return[e-u,n-f]}let p=0;for(let e=0;e<n;++e){let t=e/(n-1);for(let e=0;e<n;++e){let[i,a]=u(e/(n-1),t);c[3*p+0]=r(i),c[3*p+1]=r(a),c[3*p+2]=0,++p}}return c}function m(i,a,s){let c=i*i,l=Math.floor(a/c),{z:u,a:d}=h(s[0],s[1],s[2]),{t:f,u:p}=v(u,y(d-(l%4+2.5)*n,t)-e+(l%4+.5)*n,l),m=g(i,a),_=o(i,m.f,m.x,m.y),b=r/i,x=l%4==1||l%4==2?y(f,t)-y(_.t,t):y(f+e,t)-y(_.t+e,t),S=p-_.u+b;return{x:(x+S)/b/2,y:(S-x)/b/2}}function h(e,n,r){let i=e*e+n*n;if(i===0)return{z:r<0?-1:1,a:0};{let a=(Math.atan2(n,e)+t)%t;return r/=Math.sqrt(r*r+i),{z:r,a}}}function g(e,t){let n=e*e,r=Math.floor(t/n),{x:i,y:a}=S(t%n);return{f:r,x:i,y:a}}function _(e){return e<0?-_(-e):2-Math.sqrt(3*(1-e))}function v(e,t,a){if(Math.abs(e)<=2/3)return{t,u:3*i*e};{a%=4;let i=t-a*n,o=_(e);return{t:t-(Math.abs(o)-1)*(i-r),u:r*o}}}function y(e,t){return e<0?t- -e%t:e%t}function b(e){return e*e}let x=Math.sign||(e=>e>0?1:e<0?-1:0);function S(e){return w(e<=2147483647),{x:(e&1)>>0|(e&4)>>1|(e&16)>>2|(e&64)>>3|(e&256)>>4|(e&1024)>>5|(e&4096)>>6|(e&16384)>>7|(e&65536)>>8|(e&262144)>>9|(e&1048576)>>10|(e&4194304)>>11|(e&16777216)>>12|(e&67108864)>>13|(e&268435456)>>14|(e&1073741824)>>15,y:(e&2)>>1|(e&8)>>2|(e&32)>>3|(e&128)>>4|(e&512)>>5|(e&2048)>>6|(e&8192)>>7|(e&32768)>>8|(e&131072)>>9|(e&524288)>>10|(e&2097152)>>11|(e&8388608)>>12|(e&33554432)>>13|(e&134217728)>>14|(e&536870912)>>15}}function C(e){w(e<=2147483647);let t=0,n=(e>>2)+1;for(;n>=4;)n>>=2,++t;let r=e-((1<<2*t)-1<<2);return{order:t,index:r}}function w(e){if(console.assert(e),!e)debugger}let T=new Float32Array([81/4,-81/2,99/4,-9/2,-81/2,81,-99/2,9,99/4,-99/2,121/4,-11/2,-9/2,9,-11/2,1,-243/4,243/2,-297/4,27/2,405/4,-405/2,495/4,-45/2,-81/2,81,-99/2,9,0,0,0,0,243/4,-243/2,297/4,-27/2,-81,162,-99,18,81/4,-81/2,99/4,-9/2,0,0,0,0,-81/4,81/2,-99/4,9/2,81/4,-81/2,99/4,-9/2,-9/2,9,-11/2,1,0,0,0,0,-243/4,405/4,-81/2,0,243/2,-405/2,81,0,-297/4,495/4,-99/2,0,27/2,-45/2,9,0,729/4,-1215/4,243/2,0,-1215/4,2025/4,-405/2,0,243/2,-405/2,81,0,0,0,0,0,-729/4,1215/4,-243/2,0,243,-405,162,0,-243/4,405/4,-81/2,0,0,0,0,0,243/4,-405/4,81/2,0,-243/4,405/4,-81/2,0,27/2,-45/2,9,0,0,0,0,0,243/4,-81,81/4,0,-243/2,162,-81/2,0,297/4,-99,99/4,0,-27/2,18,-9/2,0,-729/4,243,-243/4,0,1215/4,-405,405/4,0,-243/2,162,-81/2,0,0,0,0,0,729/4,-243,243/4,0,-243,324,-81,0,243/4,-81,81/4,0,0,0,0,0,-243/4,81,-81/4,0,243/4,-81,81/4,0,-27/2,18,-9/2,0,0,0,0,0,-81/4,81/4,-9/2,0,81/2,-81/2,9,0,-99/4,99/4,-11/2,0,9/2,-9/2,1,0,243/4,-243/4,27/2,0,-405/4,405/4,-45/2,0,81/2,-81/2,9,0,0,0,0,0,-243/4,243/4,-27/2,0,81,-81,18,0,-81/4,81/4,-9/2,0,0,0,0,0,81/4,-81/4,9/2,0,-81/4,81/4,-9/2,0,9/2,-9/2,1,0,0,0,0,0]);function E(){self.addEventListener(`message`,e=>{let{id:t}=e.data,{order:n,index:r}=C(t),i=[{id:t,arraybuffer:p(n,r,64).buffer}];self.postMessage(i,i.map(e=>e.arraybuffer))})}E()})();", fd = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", dd], { type: "text/javascript;charset=utf-8" });
function pd(e) {
	let t;
	try {
		if (t = fd && (self.URL || self.webkitURL).createObjectURL(fd), !t) throw "";
		let n = new Worker(t, { name: e?.name });
		return n.addEventListener("error", () => {
			(self.URL || self.webkitURL).revokeObjectURL(t);
		}), n;
	} catch {
		return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(dd), { name: e?.name });
	}
}
//#endregion
//#region src/renderer/hips_renderer/shiftmap/index.ts
function md(e, t, n) {
	let r = nd(e, t);
	hd.cache.has(r) ? n(hd.cache.get(r)) : hd.enqueue(r).then(n);
}
var hd = new class {
	cache = /* @__PURE__ */ new Map();
	worker;
	resolve = /* @__PURE__ */ new Map();
	processing;
	queue = [];
	enqueue(e) {
		return this.cache.has(e) ? Promise.resolve(this.cache.get(e)) : (this.processing !== e && this.queue.indexOf(e) < 0 && (this.queue.push(e), this.doNextJob()), new Promise((t) => {
			this.resolve.has(e) || this.resolve.set(e, []), this.resolve.get(e).push(t);
		}));
	}
	receiveShiftmap({ id: e, arraybuffer: t }) {
		let n = new Uint8Array(t), r = this.queue.indexOf(e);
		if (r >= 0 && this.queue.splice(r, 1), this.cache.set(e, n), this.resolve.has(e)) {
			for (let t of this.resolve.get(e)) t(n);
			this.resolve.delete(e);
		}
	}
	async doNextJob() {
		if (this.processing === void 0) {
			let e = this.queue.shift();
			if (e !== void 0) {
				let t = { id: e };
				await this.startWorker(), this.processing = e, this.worker.postMessage(t);
			} else this.requestQuitWorker();
		}
	}
	async startWorker() {
		this.worker || (this.eventManager.emit("hips-shiftmap-worker-start", {}), this.cancelQuit(), this.worker = gl(new pd()), this.worker.addEventListener("message", (e) => {
			let t = e.data;
			for (let e of t) this.receiveShiftmap(e);
			this.processing = void 0, this.doNextJob();
		}));
	}
	quitTimer;
	cancelQuit() {
		this.quitTimer !== void 0 && (clearTimeout(this.quitTimer), this.quitTimer = void 0);
	}
	requestQuitWorker() {
		this.cancelQuit(), this.quitTimer = setTimeout(() => {
			this.eventManager.emit("hips-shiftmap-worker-end", {}), this.quitTimer = void 0, this.worker.terminate(), this.worker = void 0;
		}, 5e3);
	}
	eventManager = os();
}(), gd = hd.eventManager.on;
function _d(e, t) {
	let n = 1 << e, r = n * n, i = Math.floor(t / r);
	if (4 <= i && i < 8) return !1;
	let a = i >= 8 ? t % r : r - t % r - 1;
	return [
		0,
		1,
		2,
		3
	].indexOf(a) >= 0;
}
function vd(e) {
	if (e === 0) hd.enqueue(sd(0, 0)), hd.enqueue(sd(0, 8));
	else {
		let t = 1 << 2 * e;
		for (let n = 0; n < 4; ++n) hd.enqueue(nd(e, t - n - 1)), hd.enqueue(nd(e, 8 * t + n));
	}
}
function yd(e) {
	e.texImage2D(e.TEXTURE_2D, 0, e.LUMINANCE, 1, 1, 0, e.LUMINANCE, e.UNSIGNED_BYTE, new Uint8Array([128]));
}
//#endregion
//#region src/renderer/hips_renderer/vert.glsl?raw
var bd = "precision mediump float;\nattribute  vec2   a_coord;\nuniform    mat4   u_pvMatrix;\nuniform    mat3   u_rotMatrix;\nuniform    mat3   u_tMatrix;\nuniform    float  u_belt_end;\nuniform    mat4   u_ax, u_ay, u_az;\nuniform    mat4   u_bx, u_by, u_bz;\nvarying    vec2   v_coord;\nvarying    float  v_w;\n\n\nvoid main(void) {\n    float p = a_coord.x;\n    float q = a_coord.y;\n    float p2 = p*p,  q2 = q*q;\n    float p3 = p2*p, q3 = q2*q;\n    float p4 = p3*p, q4 = q3*q;\n    vec4 P = vec4(p3, p2, p, 1.);\n    vec4 Q = vec4(q3, q2, q, 1.);\n    vec3 position;\n    vec3 a = vec3(\n        dot(P, u_ax * Q),\n        dot(P, u_ay * Q),\n        dot(P, u_az * Q)\n    );\n    vec3 b = vec3(\n        dot(P, u_bx * Q),\n        dot(P, u_by * Q),\n        dot(P, u_bz * Q)\n    );\n    position = mix(a, b, step(0., u_belt_end * (q - p) - 1./128.));\n    gl_Position = u_pvMatrix * vec4(u_rotMatrix * position, 1.);\n    v_coord = a_coord;\n    v_w = gl_Position.w;\n}", xd = 2, Sd = class {
	globe;
	textureProvider;
	gl;
	program;
	attribList;
	animationLod;
	lodBias;
	integerOrder;
	releaseCallbacks = cs();
	onRelease = this.releaseCallbacks.add;
	tileCache;
	shiftmapZero;
	constructor(e, t, { animationLod: n = 1, lodBias: r = 0, integerOrder: i = !1 } = {}) {
		this.globe = e, this.textureProvider = t, this.animationLod = n, this.lodBias = r, this.integerOrder = i;
		let a = this.gl = this.globe.gl;
		this.program = S.new(a, bd, this.shaderFrag()), this.onRelease(() => this.program.release()), this.attribList = new E(a, {
			members: [{
				name: "a_coord",
				nComponents: 2
			}],
			array: this.buildArray()
		}), this.onRelease(() => this.attribList.release()), this.shiftmapZero = new A(a), this.shiftmapZero.bind(() => {
			yd(a);
		}), this.onRelease(() => this.shiftmapZero.release()), this.tileCache = new Fl({
			maxSize: 5e3,
			onDrop: (e) => e.release()
		}), this.onRelease(() => this.tileCache.clear()), this.onRelease(gd("hips-shiftmap-worker-start", () => {
			e.emit("hips-shiftmap-worker-start", {});
		})), this.onRelease(gd("hips-shiftmap-worker-end", () => {
			e.emit("hips-shiftmap-worker-end", {});
		}));
		for (let e = xd; e < 5; ++e) vd(e);
		e.requestRefresh();
	}
	release() {
		this.releaseCallbacks.flush();
	}
	render(e, t = 1) {
		this.activateProgram(() => {
			let { gl: n, program: r } = this;
			r.uniformMatrix4fv({ u_pvMatrix: e.mvp.pv }), r.uniformMatrix3fv({ u_rotMatrix: this.textureProvider.coordFrame.mat }), r.uniform1i({ u_shiftmap: 0 }), r.uniform1i({ u_texture1: 1 });
			let i = this.visibleTiles(e, (e, n) => {
				let r = this.tileCache.get(n);
				r || (r = new wd(this, n), this.tileCache.set(n, r)), r.render(e, t);
			});
			n.activeTexture(n.TEXTURE0), n.bindTexture(n.TEXTURE_2D, null), n.activeTexture(n.TEXTURE1), n.bindTexture(n.TEXTURE_2D, null), vd(i), vd(i + 1), n.activeTexture(n.TEXTURE0);
		}), this.textureProvider.flushQueue(this.textureProvider.coordFrame.invert(e.mvp.direction));
	}
	draw() {
		let { gl: e } = this;
		e.drawArrays(e.TRIANGLE_STRIP, 0, this.attribList.vertexCount);
	}
	visibleTiles(e, t) {
		let { maxTileOrder: n } = this.textureProvider, r = this.realOrder(e);
		this.integerOrder && (r = Math.floor(r));
		let i = Math.ceil(Jo(r, xd, n)), a = 1 << i;
		return Cd(this.textureProvider.coordFrame, a, e.mvp.direction, e.mvp.radius, (e) => {
			t(r, Bl.orderpix2uniq(i, e));
		}), i;
	}
	realOrder(e) {
		let { minTileOrder: t, maxTileOrder: n, tileOrder: r } = this.textureProvider, i = e.mvp.arc;
		return Jo(Math.log(Math.sqrt(Math.PI / 3) * this.globe.gl.drawingBufferHeight / i) / Math.LN2 - r - (this.lodBias + this.animationLod * e.lodBias), t, n);
	}
	activateProgram(e) {
		let t = this.gl;
		this.program.use(), this.attribList.enable(this.program, () => {
			_(t, [t.BLEND], () => {
				t.blendFunc(t.SRC_ALPHA, t.ONE), e();
			});
		});
	}
	buildArray() {
		let e = [];
		for (let t = 0; t < 32; ++t) {
			let n = t / 32, r = (t + 1) / 32;
			for (let t = 0; t <= 32; ++t) {
				let i = t / 32;
				for (let n = t === 0 ? 2 : 1; n !== 0; --n) e.push(r, i);
				for (let r = t === 32 ? 2 : 1; r !== 0; --r) e.push(n, i);
			}
		}
		return new Float32Array(e);
	}
	shaderFrag() {
		return Gu;
	}
};
function Cd(e, t, n, r, i) {
	if (n = e.invert(n), r > Math.PI / 2) {
		let e = 12 * t * t;
		for (let t = 0; t < e; ++t) i(t);
	} else Bl.query_disc_inclusive_nest(t, n, r, i);
}
var wd = class e {
	renderer;
	hid;
	order;
	index;
	coeff;
	isBeltEnd;
	shiftmap;
	constructor(t, n) {
		this.renderer = t, this.hid = n;
		let { order: r, ipix: i } = Bl.uniq2orderpix(n);
		this.order = r, this.index = i, this.coeff = Zu(r, i), this.isBeltEnd = e.isBeltEnd(r, i);
		let a = !0;
		this.onRelease(() => a = !1), _d(r, i) && md(r, i, (e) => {
			if (a) {
				let t = this.renderer.globe.gl;
				this.shiftmap = new A(t), this.shiftmap.bind(() => {
					t.texImage2D(t.TEXTURE_2D, 0, t.RGB, 64, 64, 0, t.RGB, t.UNSIGNED_BYTE, e);
				}), this.onRelease(() => {
					this.shiftmap?.release();
				});
			}
		});
	}
	releaseCallbacks = cs();
	onRelease = this.releaseCallbacks.add;
	release() {
		this.releaseCallbacks.flush();
	}
	render(e, t) {
		let { gl: n, program: r } = this.renderer;
		r.uniform1f({ u_belt_end: +!!this.isBeltEnd }), r.uniformMatrix4fv({
			u_ax: this.coeff.a[0],
			u_ay: this.coeff.a[1],
			u_az: this.coeff.a[2]
		}), this.isBeltEnd && r.uniformMatrix4fv({
			u_bx: this.coeff.b[0],
			u_by: this.coeff.b[1],
			u_bz: this.coeff.b[2]
		}), this.textures(e, (e, i, a) => {
			let o = t * a;
			r.uniform1f({ u_alpha: o }), r.uniformMatrix3fv({ u_tMatrix: i }), n.activeTexture(n.TEXTURE1), n.bindTexture(n.TEXTURE_2D, e.tex.name), n.activeTexture(n.TEXTURE0), n.bindTexture(n.TEXTURE_2D, (this.shiftmap || this.renderer.shiftmapZero).name), this.renderer.draw();
		});
	}
	static isBeltEnd(e, t) {
		let n = 1 << e, r = n * n, i = Math.floor(t / r), { x: a, y: o } = Bl.bit_decombine(t % r);
		return (i < 4 || 8 <= i) && a + o === n - 1;
	}
	textures(e, t) {
		let n = this.renderer.textureProvider, r = Math.ceil(e), i = this.order, a = this.index, o = Ke(), s = 1;
		for (; i >= n.minTileOrder;) {
			if (i <= r) {
				let c = Bl.orderpix2uniq(i, a), l = n.get(c);
				if (l) {
					l.revision < this.renderer.textureProvider.revision && n.request(c, { immediate: !0 });
					let a = (r === i ? 1 + e - i : 1) * l.fadeAlpha;
					if (t(l, et(Ke(), o), a * s), s *= 1 - a, a >= 1) break;
				} else n.request(c);
			}
			ot(o, o, [2, 2]), it(o, o, [a & 2 ? -.5 : 0, a & 1 ? 0 : -.5]), --i, a >>= 2;
		}
	}
}, Td = class extends Sd {
	activateProgram(e) {
		let t = this.gl;
		this.program.use(), this.attribList.enable(this.program, () => {
			_(t, [t.BLEND], () => {
				t.blendFunc(t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA), e();
			});
		});
	}
	shaderFrag() {
		return Ku;
	}
}, Ed = class {
	globe;
	tileOrder;
	maxTileOrder;
	minTileOrder;
	coordFrame;
	constructor(e, t, n, r, i) {
		this.globe = e, this.tileOrder = t, this.maxTileOrder = n, this.minTileOrder = r, this.coordFrame = i;
	}
	_revision = 0;
	get revision() {
		return this._revision;
	}
	update() {
		++this._revision;
	}
	releaseCallbacks = cs();
	onRelease = this.releaseCallbacks.add;
	release() {
		this.releaseCallbacks.flush();
	}
}, Dd = class {
	tex;
	revision;
	fadeAlpha = 1;
	constructor(e, t) {
		let n = e.globe.gl;
		this.tex = new A(n), this.revision = e.revision, t && e.globe.animations.add((({ r: e }) => {
			this.fadeAlpha = e;
		}), { duration: 200 });
	}
	release() {
		this.tex.release();
	}
	bind(e) {
		this.tex.bind(e);
	}
}, Od = class {
	hid;
	center;
	order;
	index;
	constructor(e) {
		this.hid = e;
		let { order: t, ipix: n } = Bl.uniq2orderpix(e);
		this.order = t, this.index = n, this.center = Bl.pix2vec_nest(1 << t, n);
	}
}, kd = class extends Ed {
	cache = new Fl({
		maxSize: 1e3,
		onDrop: (e) => e.release()
	});
	alreadyReleased = !1;
	release() {
		this.alreadyReleased = !0, this.cache.clear(), super.release();
	}
	get(e) {
		return this.cache.get(e);
	}
	refsToLoad = /* @__PURE__ */ new Map();
	refsInLoading = /* @__PURE__ */ new Map();
	deadHid = /* @__PURE__ */ new Set();
	request(e, t) {
		let n = t?.immediate ?? !1;
		if (!this.deadHid.has(e) && !this.refsInLoading.has(e) && !this.refsToLoad.has(e)) {
			let t = new Od(e);
			n ? this.load(t) : this.refsToLoad.set(e, t);
		}
	}
	nParallel = 4;
	flushQueue(e) {
		if (this.refsInLoading.size >= this.nParallel) return;
		let t = [];
		this.refsToLoad.forEach((e) => t.push(e)), t.sort((t, n) => t.order === n.order ? mr(e, t.center) - mr(e, n.center) : t.order - n.order);
		for (let e of t) {
			if (this.refsInLoading.size >= this.nParallel) break;
			this.load(e);
		}
		this.refsToLoad.clear();
	}
	load(e) {
		this.refsInLoading.set(e.hid, e);
		let t = !this.cache.has(e.hid);
		this.makeTileTexture(e, t).then((t) => {
			this.alreadyReleased ? t.release() : (this.cache.set(e.hid, t), this.globe.requestRefresh());
		}).catch((t) => {
			this.deadHid.add(e.hid), console.error(t);
		}).then(() => {
			this.refsInLoading.delete(e.hid), this.globe.requestRefresh();
		});
	}
	clearCacheWithOrderAbove(e) {
		for (let t of this.cache.keys()) {
			let { order: n } = Bl.uniq2orderpix(t);
			n > 0 && n >= e && this.cache.delete(t);
		}
	}
}, Ad = class e extends kd {
	baseUrl;
	properties;
	format;
	constructor(e, t, n) {
		Number(n.hips_order) > 13 && console.warn(`hips_order exceeded the limit: ${n.hips_order} > 13`);
		let r = Math.min(Number(n.hips_order), 13), i = n.hips_order_min ? Number(n.hips_order_min) : 3, a = Number(n.hips_tile_width), o = ((e) => {
			switch (e) {
				case "equatorial": return Uu.EQUATORIAL;
				case "galactic": return Uu.GALACTIC;
				case "hsc/zenith":
				case "zenith":
					let [e, t, r] = JSON.parse(n["hsc/zenith"]);
					return new Uu(dc(e, t, r));
			}
			return Uu.EQUATORIAL;
		})(n.hips_frame), s = ld(a), c = ((e) => {
			let t = e.split(/\s+/)[0];
			return { jpeg: "jpg" }[t] || t;
		})(n.hips_tile_format);
		super(e, s, r, i, o), this.baseUrl = t, this.properties = n, this.format = c;
	}
	async makeTileTexture(e, t) {
		let n = await bl(this.tileId2Url(e.order, e.index)), r = new Dd(this, t), i = this.globe.gl;
		return r.bind(() => {
			i.texImage2D(i.TEXTURE_2D, 0, i.RGBA, i.RGBA, i.UNSIGNED_BYTE, n), e.order === this.minTileOrder && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, i.LINEAR_MIPMAP_LINEAR), i.generateMipmap(i.TEXTURE_2D));
		}), r;
	}
	tileId2Url(e, t) {
		let n = Math.floor(t / 1e4) * 1e4;
		return `${this.baseUrl}/Norder${e}/Dir${n}/Npix${t}.${this.format}`;
	}
	static async fromBaseUrl(t, n) {
		let r = await Wu(n);
		return new e(t, n, r);
	}
}, jd = class extends $ {
	globe;
	baseUrl;
	layerOptions;
	renderer;
	alpha = 1;
	constructor(e, t, n = {}, r = {}) {
		super(e), this.globe = e, this.baseUrl = t, this.layerOptions = r, this.asyncInit(n);
	}
	async asyncInit(e) {
		let t = !0;
		this.onRelease(() => t = !1);
		let n = await Wu(this.baseUrl);
		if (t) {
			let t = new Ad(this.globe, this.baseUrl, n);
			this.renderer = ((n) => {
				switch (n) {
					case "default": return new Sd(this.globe, t, e);
					case "multiply": return new Td(this.globe, t, e);
				}
			})(this.layerOptions.mode ?? "default"), this.onRelease(() => {
				this.renderer.release();
			});
		}
	}
	render(e) {
		let t = this.alpha * (this.layerOptions.fadeOnZoom ? Lc(e) : 1);
		t > 0 && this.renderer?.render(e, t);
	}
}, Md = /* @__PURE__ */ s({
	AsyncTextureProvider: () => kd,
	CoordFrame: () => Uu,
	SimpleImageLayer: () => jd,
	SimpleImageTextureProvider: () => Ad,
	TextureProvider: () => Ed,
	TextureRef: () => Od,
	TileTexture: () => Dd,
	fetchHiPSProperties: () => Wu
}), Nd = "(function(){var e=Object.create,t=Object.defineProperty,n=Object.getOwnPropertyDescriptor,r=Object.getOwnPropertyNames,i=Object.getPrototypeOf,a=Object.prototype.hasOwnProperty,o=(e,t)=>()=>(t||(e((t={exports:{}}).exports,t),e=null),t.exports),s=(e,i,o,s)=>{if(i&&typeof i==`object`||typeof i==`function`)for(var c=r(i),l=0,u=c.length,d;l<u;l++)d=c[l],!a.call(e,d)&&d!==o&&t(e,d,{get:(e=>i[e]).bind(null,d),enumerable:!(s=n(i,d))||s.enumerable});return e},c=(n,r,a)=>(a=n==null?{}:e(i(n)),s(r||!n||!n.__esModule?t(a,`default`,{value:n,enumerable:!0}):a,n)),l=o(((e,t)=>{(function(){\"use strict\";var e=[],n=3988292384;function r(){var t,r,i;for(r=0;r<256;r+=1){for(t=r,i=0;i<8;i+=1)t&1?t=n^t>>>1:t>>>=1;e[r]=t>>>0}}function i(e){return Array.prototype.map.call(e,function(e){return e.charCodeAt(0)})}function a(e){var t=-1,r,i,a,o;for(r=0,a=e.length;r<a;r+=1){for(o=(t^e[r])&255,i=0;i<8;i+=1)(o&1)==1?o=o>>>1^n:o>>>=1;t=t>>>8^o}return t^-1}function o(t,n){var r,i,a;if(!((o.crc===void 0||!n||!t)&&(o.crc=-1,!t))){for(r=o.crc,i=0,a=t.length;i<a;i+=1)r=r>>>8^e[(r^t[i])&255];return o.crc=r,r^-1}}r(),t.exports=function(e,t){var e=typeof e==`string`?i(e):e;return((t?a(e):o(e))>>>0).toString(16)},t.exports.direct=a,t.exports.table=o})()})),u=o(((e,t)=>{(function(){var e=32768,n,r,i=null,a,o,s,c,l,u,d,f,p,m,h,g,_,v,y,b=[0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535],ee=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],x=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,99,99],S=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577],C=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],w=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];function T(){this.next=null,this.list=null}function te(){this.e=0,this.b=0,this.n=0,this.t=null}function E(e,t,n,r,i,a){this.BMAX=16,this.N_MAX=288,this.status=0,this.root=null,this.m=0;var o,s=[],c,l,u,d,f,p,m,h=[],g,_,v,y=new te,b=[],ee=[],x,S=[],C,w,E,ne,D=this.root=null;for(f=0;f<this.BMAX+1;f++)s[f]=0;for(f=0;f<this.BMAX+1;f++)h[f]=0;for(f=0;f<this.BMAX;f++)b[f]=null;for(f=0;f<this.N_MAX;f++)ee[f]=0;for(f=0;f<this.BMAX+1;f++)S[f]=0;c=t>256?e[256]:this.BMAX,g=e,_=0,f=t;do s[g[_]]++,_++;while(--f>0);if(s[0]===t){this.root=null,this.m=0,this.status=0;return}for(p=1;p<=this.BMAX&&s[p]===0;p++);for(m=p,a<p&&(a=p),f=this.BMAX;f!==0&&s[f]===0;f--);for(u=f,a>f&&(a=f),w=1<<p;p<f;p++,w<<=1)if((w-=s[p])<0){this.status=2,this.m=a;return}if((w-=s[f])<0){this.status=2,this.m=a;return}for(s[f]+=w,S[1]=p=0,g=s,_=1,C=2;--f>0;)S[C++]=p+=g[_++];g=e,_=0,f=0;do(p=g[_++])!==0&&(ee[S[p]++]=f);while(++f<t);for(t=S[u],S[0]=f=0,g=ee,_=0,d=-1,x=h[0]=0,v=null,E=0;m<=u;m++)for(o=s[m];o-->0;){for(;m>x+h[1+d];){if(x+=h[1+d],d++,E=(E=u-x)>a?a:E,(l=1<<(p=m-x))>o+1)for(l-=o+1,C=m;++p<E&&!((l<<=1)<=s[++C]);)l-=s[C];for(x+p>c&&x<c&&(p=c-x),E=1<<p,h[1+d]=p,v=[],ne=0;ne<E;ne++)v[ne]=new te;D=D?D.next=new T:this.root=new T,D.next=null,D.list=v,b[d]=v,d>0&&(S[d]=f,y.b=h[d],y.e=16+p,y.t=v,p=(f&(1<<x)-1)>>x-h[d],b[d-1][p].e=y.e,b[d-1][p].b=y.b,b[d-1][p].n=y.n,b[d-1][p].t=y.t)}for(y.b=m-x,_>=t?y.e=99:g[_]<n?(y.e=g[_]<256?16:15,y.n=g[_++]):(y.e=i[g[_]-n],y.n=r[g[_++]-n]),l=1<<m-x,p=f>>x;p<E;p+=l)v[p].e=y.e,v[p].b=y.b,v[p].n=y.n,v[p].t=y.t;for(p=1<<m-1;(f&p)!==0;p>>=1)f^=p;for(f^=p;(f&(1<<x)-1)!==S[d];)x-=h[d],d--}this.m=h[1],this.status=+(w!==0&&u!==1)}function ne(){return v.length===y?-1:v[y++]&255}function D(e){for(;l<e;)c|=ne()<<l,l+=8}function O(e){return c&b[e]}function k(e){c>>=e,l-=e}function A(t,i,a){var o,s,c;if(a===0)return 0;for(c=0;;){for(D(g),s=m.list[O(g)],o=s.e;o>16;){if(o===99)return-1;k(s.b),o-=16,D(o),s=s.t[O(o)],o=s.e}if(k(s.b),o===16){if(r&=e-1,t[i+c++]=n[r++]=s.n,c===a)return a;continue}if(o===15)break;for(D(o),f=s.n+O(o),k(o),D(_),s=h.list[O(_)],o=s.e;o>16;){if(o===99)return-1;k(s.b),o-=16,D(o),s=s.t[O(o)],o=s.e}for(k(s.b),D(o),p=r-s.n-O(o),k(o);f>0&&c<a;)f--,p&=e-1,r&=e-1,t[i+c++]=n[r++]=n[p++];if(c===a)return a}return u=-1,c}function j(t,i,a){var o=l&7;if(k(o),D(16),o=O(16),k(16),D(16),o!==(~c&65535))return-1;for(k(16),f=o,o=0;f>0&&o<a;)f--,r&=e-1,D(8),t[i+o++]=n[r++]=O(8),k(8);return f===0&&(u=-1),o}function re(e,t,n){if(!i){var r,c=[],l;for(r=0;r<144;r++)c[r]=8;for(;r<256;r++)c[r]=9;for(;r<280;r++)c[r]=7;for(;r<288;r++)c[r]=8;if(o=7,l=new E(c,288,257,ee,x,o),l.status!==0)return console.error(`HufBuild error: `+l.status),-1;for(i=l.root,o=l.m,r=0;r<30;r++)c[r]=5;if(s=5,l=new E(c,30,0,S,C,s),l.status>1)return i=null,console.error(`HufBuild error: `+l.status),-1;a=l.root,s=l.m}return m=i,h=a,g=o,_=s,A(e,t,n)}function ie(e,t,n){var r,i,a,o,s,c,l,u,d=[],f;for(r=0;r<316;r++)d[r]=0;if(D(5),l=257+O(5),k(5),D(5),u=1+O(5),k(5),D(4),c=4+O(4),k(4),l>286||u>30)return-1;for(i=0;i<c;i++)D(3),d[w[i]]=O(3),k(3);for(;i<19;i++)d[w[i]]=0;if(g=7,f=new E(d,19,19,null,null,g),f.status!==0)return-1;for(m=f.root,g=f.m,o=l+u,r=a=0;r<o;)if(D(g),s=m.list[O(g)],i=s.b,k(i),i=s.n,i<16)d[r++]=a=i;else if(i===16){if(D(2),i=3+O(2),k(2),r+i>o)return-1;for(;i-->0;)d[r++]=a}else if(i===17){if(D(3),i=3+O(3),k(3),r+i>o)return-1;for(;i-->0;)d[r++]=0;a=0}else{if(D(7),i=11+O(7),k(7),r+i>o)return-1;for(;i-->0;)d[r++]=0;a=0}if(g=9,f=new E(d,l,257,ee,x,g),g===0&&(f.status=1),f.status!==0&&f.status!==1)return-1;for(m=f.root,g=f.m,r=0;r<u;r++)d[r]=d[r+l];return _=6,f=new E(d,u,0,S,C,_),h=f.root,_=f.m,_===0&&l>257||f.status!==0?-1:A(e,t,n)}function ae(){n||=[],r=0,c=0,l=0,u=-1,d=!1,f=p=0,m=null}function M(t,i,a){for(var o=0,s;o<a;){if(d&&u===-1)return o;if(f>0){if(u!==0)for(;f>0&&o<a;)f--,p&=e-1,r&=e-1,t[i+o++]=n[r++]=n[p++];else{for(;f>0&&o<a;)f--,r&=e-1,D(8),t[i+o++]=n[r++]=O(8),k(8);f===0&&(u=-1)}if(o===a)return o}if(u===-1){if(d)break;D(1),O(1)!==0&&(d=!0),k(1),D(2),u=O(2),k(2),m=null,f=0}switch(u){case 0:s=j(t,i+o,a-o);break;case 1:s=m?A(t,i+o,a-o):re(t,i+o,a-o);break;case 2:s=m?A(t,i+o,a-o):ie(t,i+o,a-o);break;default:s=-1;break}if(s===-1)return d?0:-1;o+=s}return o}function N(e){var t=[],n;ae(),v=e,y=0;do n=M(t,t.length,1024);while(n>0);return v=null,t}t.exports=N})()})),d=o(((e,t)=>{(function(){var e=32768,n=6,r=32768,i=1024*8,a=2*e,o=3,s=258,c=16,l=8192,u=15,d=l,f=1<<u,p=f-1,m=e-1,h=0,g=4096,_=s+o+1,v=e-_,y=1,b=15,ee=7,x=29,S=256,C=256,w=S+1+x,T=30,te=19,E=16,ne=17,D=18,O=2*w+1,k=parseInt((u+o-1)/o,10),A,j,re,ie,ae=null,M,N,oe,P,se,ce,le,ue,F,I,L,de,fe,pe,R,z,B,me,V,H,he,ge,_e,ve,ye,U,W,G,be,K,q,J,xe,Y,X,Se,Ce,Z,we,Te,Ee,De,Oe,ke,Ae,je,Me,Ne,Pe,Fe,Ie,Le;l>r&&console.error(`error: INBUFSIZ is too small`),e<<1>1<<c&&console.error(`error: WSIZE is too large`),u>c-1&&console.error(`error: HASH_BITS is too large`),(u<8||s!==258)&&console.error(`error: Code too clever`);function Re(){this.fc=0,this.dl=0}function ze(){this.dyn_tree=null,this.static_tree=null,this.extra_bits=null,this.extra_base=0,this.elems=0,this.max_length=0,this.max_code=0}function Q(e,t,n,r){this.good_length=e,this.max_lazy=t,this.nice_length=n,this.max_chain=r}function Be(){this.next=null,this.len=0,this.ptr=[],this.off=0}var Ve=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],He=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],Ue=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],We=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],Ge=[new Q(0,0,0,0),new Q(4,4,8,4),new Q(4,5,16,8),new Q(4,6,32,32),new Q(4,4,16,16),new Q(8,16,32,32),new Q(8,16,128,128),new Q(8,32,128,256),new Q(32,128,258,1024),new Q(32,258,258,4096)];function Ke(e){var t;if(e?e<1?e=1:e>9&&(e=9):e=n,_e=e,ie=!1,V=!1,ae===null){for(A=j=re=null,ae=[],P=[],se=[],ce=[],le=[],U=[],t=0;t<O;t++)U[t]=new Re;for(W=[],t=0;t<2*T+1;t++)W[t]=new Re;for(G=[],t=0;t<w+2;t++)G[t]=new Re;for(be=[],t=0;t<T;t++)be[t]=new Re;for(K=[],t=0;t<2*te+1;t++)K[t]=new Re;q=new ze,J=new ze,xe=new ze,Y=[],X=[],Z=[],we=[],Te=[],Ee=[],De=[],Oe=[]}}function qe(e){e.next=A,A=e}function Je(){var e;return A===null?e=new Be:(e=A,A=A.next),e.next=null,e.len=e.off=0,e}function Ye(t){return le[e+t]}function Xe(t,n){return le[e+t]=n}function Ze(e){ae[N+M++]=e,N+M===i&&Ot()}function Qe(e){e&=65535,N+M<i-2?(ae[N+M++]=e&255,ae[N+M++]=e>>>8):(Ze(e&255),Ze(e>>>8))}function $e(){L=(L<<k^P[B+o-1]&255)&p,de=Ye(L),le[B&m]=de,Xe(L,B)}function et(e,t){$(t[e].fc,t[e].dl)}function tt(e){return(e<256?Te[e]:Te[256+(e>>7)])&255}function nt(e,t,n){return e[t].fc<e[n].fc||e[t].fc===e[n].fc&&Z[t]<=Z[n]}function rt(e,t,n){var r;for(r=0;r<n&&Le<Ie.length;r++)e[t+r]=Ie[Le++]&255;return r}function it(){var t;for(t=0;t<f;t++)le[e+t]=0;if(ge=Ge[_e].max_lazy,ve=Ge[_e].good_length,ye=Ge[_e].nice_length,he=Ge[_e].max_chain,B=0,I=0,H=rt(P,0,2*e),H<=0){V=!0,H=0;return}for(V=!1;H<_&&!V;)ot();for(L=0,t=0;t<o-1;t++)L=(L<<k^P[t]&255)&p}function at(e){var t=he,n=B,r,i,a=z,o=B>v?B-v:h,c=B+s,l=P[n+a-1],u=P[n+a],d,f;z>=ve&&(t>>=2);do{if(r=e,P[r+a]!==u||P[r+a-1]!==l||P[r]!==P[n]||P[++r]!==P[n+1])continue;for(n+=2,r++;n<c;){for(f=!1,d=0;d<8;d+=1)if(n+=1,r+=1,P[n]!==P[r]){f=!0;break}if(f)break}if(i=s-(c-n),n=c-s,i>a){if(me=e,a=i,i>=ye)break;l=P[n+a-1],u=P[n+a]}}while((e=le[e&m])>o&&--t!==0);return a}function ot(){var t,n,r=a-H-B;if(r===-1)r--;else if(B>=e+v){for(t=0;t<e;t++)P[t]=P[t+e];for(me-=e,B-=e,I-=e,t=0;t<f;t++)n=Ye(t),Xe(t,n>=e?n-e:h);for(t=0;t<e;t++)n=le[t],le[t]=n>=e?n-e:h;r+=e}V||(t=rt(P,B+H,r),t<=0?V=!0:H+=t)}function st(){for(;H!==0&&j===null;){var e;if($e(),de!==h&&B-de<=v&&(R=at(de),R>H&&(R=H)),R>=o)if(e=Ct(B-me,R-o),H-=R,R<=ge){R--;do B++,$e();while(--R!==0);B++}else B+=R,R=0,L=P[B]&255,L=(L<<k^P[B+1]&255)&p;else e=Ct(0,P[B]&255),H--,B++;for(e&&(St(0),I=B);H<_&&!V;)ot()}}function ct(){for(;H!==0&&j===null;){if($e(),z=R,fe=me,R=o-1,de!==h&&z<ge&&B-de<=v&&(R=at(de),R>H&&(R=H),R===o&&B-me>g&&R--),z>=o&&R<=z){var e=Ct(B-1-fe,z-o);H-=z-1,z-=2;do B++,$e();while(--z!==0);pe=!1,R=o-1,B++,e&&(St(0),I=B)}else pe?(Ct(0,P[B-1]&255)&&(St(0),I=B),B++,H--):(pe=!0,B++,H--);for(;H<_&&!V;)ot()}}function lt(){V||(ue=0,F=0,ft(),it(),j=null,M=0,N=0,_e<=3?(z=o-1,R=0):(R=o-1,pe=!1),oe=!1)}function ut(e,t,n){var r;return!ie&&(lt(),ie=!0,H===0)?(oe=!0,0):(r=dt(e,t,n),r===n?n:oe?r:(_e<=3?st():ct(),H===0&&(pe&&Ct(0,P[B-1]&255),St(1),oe=!0),r+dt(e,r+t,n-r)))}function dt(e,t,n){for(var r=0,i,a;j!==null&&r<n;){for(i=n-r,i>j.len&&(i=j.len),a=0;a<i;a++)e[t+r+a]=j.ptr[j.off+a];if(j.off+=i,j.len-=i,r+=i,j.len===0){var o=j;j=j.next,qe(o)}}if(r===n)return r;if(N<M){for(i=n-r,i>M-N&&(i=M-N),a=0;a<i;a++)e[t+r+a]=ae[N+a];N+=i,r+=i,M===N&&(M=N=0)}return r}function ft(){var e,t,n,r,i;if(be[0].dl===0){for(q.dyn_tree=U,q.static_tree=G,q.extra_bits=Ve,q.extra_base=S+1,q.elems=w,q.max_length=b,q.max_code=0,J.dyn_tree=W,J.static_tree=be,J.extra_bits=He,J.extra_base=0,J.elems=T,J.max_length=b,J.max_code=0,xe.dyn_tree=K,xe.static_tree=null,xe.extra_bits=Ue,xe.extra_base=0,xe.elems=te,xe.max_length=ee,xe.max_code=0,n=0,r=0;r<x-1;r++)for(Ee[r]=n,e=0;e<1<<Ve[r];e++)we[n++]=r;for(we[n-1]=r,i=0,r=0;r<16;r++)for(De[r]=i,e=0;e<1<<He[r];e++)Te[i++]=r;for(i>>=7;r<T;r++)for(De[r]=i<<7,e=0;e<1<<He[r]-7;e++)Te[256+i++]=r;for(t=0;t<=b;t++)Y[t]=0;for(e=0;e<=143;)G[e++].dl=8,Y[8]++;for(;e<=255;)G[e++].dl=9,Y[9]++;for(;e<=279;)G[e++].dl=7,Y[7]++;for(;e<=287;)G[e++].dl=8,Y[8]++;for(gt(G,w+1),e=0;e<T;e++)be[e].dl=5,be[e].fc=Et(e,5);pt()}}function pt(){var e;for(e=0;e<w;e++)U[e].fc=0;for(e=0;e<T;e++)W[e].fc=0;for(e=0;e<te;e++)K[e].fc=0;U[C].fc=1,Pe=Fe=0,ke=Ae=je=0,Me=0,Ne=1}function mt(e,t){for(var n=X[t],r=t<<1;r<=Se&&(r<Se&&nt(e,X[r+1],X[r])&&r++,!nt(e,n,X[r]));)X[t]=X[r],t=r,r<<=1;X[t]=n}function ht(e){var t=e.dyn_tree,n=e.extra_bits,r=e.extra_base,i=e.max_code,a=e.max_length,o=e.static_tree,s,c,l,u,d,f,p=0;for(u=0;u<=b;u++)Y[u]=0;for(t[X[Ce]].dl=0,s=Ce+1;s<O;s++)c=X[s],u=t[t[c].dl].dl+1,u>a&&(u=a,p++),t[c].dl=u,!(c>i)&&(Y[u]++,d=0,c>=r&&(d=n[c-r]),f=t[c].fc,Pe+=f*(u+d),o!==null&&(Fe+=f*(o[c].dl+d)));if(p!==0){do{for(u=a-1;Y[u]===0;)u--;Y[u]--,Y[u+1]+=2,Y[a]--,p-=2}while(p>0);for(u=a;u!==0;u--)for(c=Y[u];c!==0;)l=X[--s],!(l>i)&&(t[l].dl!==u&&(Pe+=(u-t[l].dl)*t[l].fc,t[l].fc=u),c--)}}function gt(e,t){var n=[],r=0,i,a;for(i=1;i<=b;i++)r=r+Y[i-1]<<1,n[i]=r;for(a=0;a<=t;a++){var o=e[a].dl;o!==0&&(e[a].fc=Et(n[o]++,o))}}function _t(e){var t=e.dyn_tree,n=e.static_tree,r=e.elems,i,a,o=-1,s=r;for(Se=0,Ce=O,i=0;i<r;i++)t[i].fc===0?t[i].dl=0:(X[++Se]=o=i,Z[i]=0);for(;Se<2;){var c=X[++Se]=o<2?++o:0;t[c].fc=1,Z[c]=0,Pe--,n!==null&&(Fe-=n[c].dl)}for(e.max_code=o,i=Se>>1;i>=1;i--)mt(t,i);do i=X[y],X[y]=X[Se--],mt(t,y),a=X[y],X[--Ce]=i,X[--Ce]=a,t[s].fc=t[i].fc+t[a].fc,Z[i]>Z[a]+1?Z[s]=Z[i]:Z[s]=Z[a]+1,t[i].dl=t[a].dl=s,X[y]=s++,mt(t,y);while(Se>=2);X[--Ce]=X[y],ht(e),gt(t,o)}function vt(e,t){var n,r=-1,i,a=e[0].dl,o=0,s=7,c=4;for(a===0&&(s=138,c=3),e[t+1].dl=65535,n=0;n<=t;n++)i=a,a=e[n+1].dl,!(++o<s&&i===a)&&(o<c?K[i].fc+=o:i===0?o<=10?K[ne].fc++:K[D].fc++:(i!==r&&K[i].fc++,K[E].fc++),o=0,r=i,a===0?(s=138,c=3):i===a?(s=6,c=3):(s=7,c=4))}function yt(e,t){var n,r=-1,i,a=e[0].dl,o=0,s=7,c=4;for(a===0&&(s=138,c=3),n=0;n<=t;n++)if(i=a,a=e[n+1].dl,!(++o<s&&i===a)){if(o<c)do et(i,K);while(--o!==0);else i===0?o<=10?(et(ne,K),$(o-3,3)):(et(D,K),$(o-11,7)):(i!==r&&(et(i,K),o--),et(E,K),$(o-3,2));o=0,r=i,a===0?(s=138,c=3):i===a?(s=6,c=3):(s=7,c=4)}}function bt(){var e;for(vt(U,q.max_code),vt(W,J.max_code),_t(xe),e=te-1;e>=3&&K[We[e]].dl===0;e--);return Pe+=3*(e+1)+5+5+4,e}function xt(e,t,n){var r;for($(e-257,5),$(t-1,5),$(n-4,4),r=0;r<n;r++)$(K[We[r]].dl,3);yt(U,e-1),yt(W,t-1)}function St(e){var t,n,r,i=B-I,a;if(Oe[je]=Me,_t(q),_t(J),r=bt(),t=Pe+3+7>>3,n=Fe+3+7>>3,n<=t&&(t=n),i+4<=t&&I>=0)for($(0+e,3),Dt(),Qe(i),Qe(~i),a=0;a<i;a++)Ze(P[I+a]);else n===t?($(2+e,3),wt(G,be)):($(4+e,3),xt(q.max_code+1,J.max_code+1,r+1),wt(U,W));pt(),e!==0&&Dt()}function Ct(e,t){if(ce[ke++]=t,e===0?U[t].fc++:(e--,U[we[t]+S+1].fc++,W[tt(e)].fc++,se[Ae++]=e,Me|=Ne),Ne<<=1,ke&7||(Oe[je++]=Me,Me=0,Ne=1),_e>2&&!(ke&4095)){var n=ke*8,r=B-I,i;for(i=0;i<T;i++)n+=W[i].fc*(5+He[i]);if(n>>=3,Ae<parseInt(ke/2,10)&&n<parseInt(r/2,10))return!0}return ke===l-1||Ae===d}function wt(e,t){var n,r,i=0,a=0,o=0,s=0,c,l;if(ke!==0)do i&7||(s=Oe[o++]),r=ce[i++]&255,s&1?(c=we[r],et(c+S+1,e),l=Ve[c],l!==0&&(r-=Ee[c],$(r,l)),n=se[a++],c=tt(n),et(c,t),l=He[c],l!==0&&(n-=De[c],$(n,l))):et(r,e),s>>=1;while(i<ke);et(C,e)}var Tt=16;function $(e,t){F>Tt-t?(ue|=e<<F,Qe(ue),ue=e>>Tt-F,F+=t-Tt):(ue|=e<<F,F+=t)}function Et(e,t){var n=0;do n|=e&1,e>>=1,n<<=1;while(--t>0);return n>>1}function Dt(){F>8?Qe(ue):F>0&&Ze(ue),ue=0,F=0}function Ot(){var e,t;if(M!==0){for(e=Je(),j===null?j=re=e:re=re.next=e,e.len=M-N,t=0;t<e.len;t++)e.ptr[t]=ae[N+t];M=N=0}}function kt(e,t){var r,i;Ie=e,Le=0,t===void 0&&(t=n),Ke(t),i=[];do r=ut(i,i.length,1024);while(r>0);return Ie=null,i}t.exports=kt,t.exports.DEFAULT_LEVEL=n})()})),f=o(((e,t)=>{(function(){\"use strict\";t.exports={inflate:u(),deflate:d()}})()})),p=c(o(((e,t)=>{(function(){\"use strict\";var e=l(),n=f(),r=31,i=139,a={deflate:8},o={FTEXT:1,FHCRC:2,FEXTRA:4,FNAME:8,FCOMMENT:16},s={fat:0,amiga:1,vmz:2,unix:3,\"vm/cms\":4,atari:5,hpfs:6,macintosh:7,\"z-system\":8,cplm:9,\"tops-20\":10,ntfs:11,qdos:12,acorn:13,vfat:14,vms:15,beos:16,tandem:17,theos:18},c=`unix`,u=6;function d(e,t){t.push(e&255)}function p(e,t){t.push(e&255),t.push(e>>>8)}function m(e,t){p(e&65535,t),p(e>>>16,t)}function h(e,t){var n,r=e.length;for(n=0;n<r;n+=1)d(e.charCodeAt(n),t)}function g(e){return e.shift()}function _(e){return e.shift()|e.shift()<<8}function v(e){var t=_(e),n=_(e);return n>32768?(n-=32768,(n<<16|t)+32768*2**16):n<<16|t}function y(e){for(var t=[];e[0]!==0;)t.push(String.fromCharCode(e.shift()));return e.shift(),t.join(``)}function b(e,t){var n,r=[];for(n=0;n<t;n+=1)r.push(e.shift());return r}function ee(t,l){var f=0,p,g=[];return l||={},p=l.level||u,typeof t==`string`&&(t=Array.prototype.map.call(t,function(e){return e.charCodeAt(0)})),d(r,g),d(i,g),d(a.deflate,g),l.name&&(f|=o.FNAME),d(f,g),m(l.timestamp||parseInt(Date.now()/1e3,10),g),d(p===1?4:p===9?2:0,g),d(s[c],g),l.name&&(h(l.name.substring(l.name.lastIndexOf(`/`)+1),g),d(0,g)),n.deflate(t,p).forEach(function(e){d(e,g)}),m(parseInt(e(t),16),g),m(t.length,g),g}function x(t,c){var l=Array.prototype.slice.call(t,0),u,d,f,p,m,h;if(g(l)!==r||g(l)!==i)throw`Not a GZIP file`;if(u=g(l),u=Object.keys(a).some(function(e){return d=e,a[e]===u}),!u)throw`Unsupported compression method`;if(f=g(l),v(l),g(l),u=g(l),Object.keys(s).some(function(e){if(s[e]===u)return!0}),f&o.FEXTRA&&(u=_(l),b(l,u)),f&o.FNAME&&y(l),f&o.FCOMMENT&&y(l),f&o.FHCRC&&_(l),d===`deflate`&&(h=n.inflate(l.splice(0,l.length-8))),f&o.FTEXT&&(h=Array.prototype.map.call(h,function(e){return String.fromCharCode(e)}).join(``)),p=v(l),p!==parseInt(e(h),16))throw`Checksum does not match`;if(m=v(l),m!==h.length)throw`Size of decompressed file not correct`;return h}t.exports={zip:ee,unzip:x,get DEFAULT_LEVEL(){return u}}})()}))());let m=function(e){return e[e.uint8=8]=`uint8`,e[e.uint16=16]=`uint16`,e[e.uint32=32]=`uint32`,e[e.float32=-32]=`float32`,e[e.float64=-64]=`float64`,e}({});function h(e,t,n,r){let i=e[t];if(i??=r,typeof i!=n)throw Error(`Type mismatch: ${i} for ${t}`);return i}self.addEventListener(`message`,async e=>{let t=e.data,n=self;try{let e=g(t),r={requestId:t.requestId,hduSources:e};n.postMessage(r,e.map(e=>e.data))}catch(e){let r={requestId:t.requestId,error:e};throw n.postMessage(r),e}});function g(e){let{headers:t,dataBuffers:n}=b(T(e.fileContent)?te(e.fileContent):e.fileContent);return e.hduDecodeOptions||=t.map((e,t)=>({sourceIndex:t})),e.hduDecodeOptions.map(e=>{if(e.sourceIndex>=t.length)throw Error(`hdul.length(${t.length}) >= sourceIndex(${e.sourceIndex})`);let r=e.outputDataType??_(t[e.sourceIndex]),i=t[e.sourceIndex],a=n[e.sourceIndex];return{header:i,data:v(i,a,r),dataType:r}})}function _(e){let t=h(e,`BITPIX`,`number`);switch(t){case 8:return m.uint8;case 16:return m.uint16;case 32:return m.uint32;case-32:return m.float32;case-64:return m.float64;default:throw Error(`Invalid bitpix: ${t}`)}}function v(e,t,n){let{nPixels:r}=x(e),i=h(e,`BITPIX`,`number`),a;switch(i){case 8:a=e=>t.getUint8(e);break;case 16:a=e=>t.getUint16(2*e);break;case 32:a=e=>t.getUint32(4*e);break;case-32:a=e=>t.getFloat32(4*e);break;case-64:a=e=>t.getFloat64(8*e);break;default:throw Error(`Invalid bitpix: ${i}`)}let o=e=>a(e);if([m.float32,m.float64].indexOf(n)>=0){let t=h(e,`BZERO`,`number`,0),n=h(e,`BSCALE`,`number`,1);o=e=>n*a(e)+t}let s={[m.uint8]:Uint8Array,[m.uint16]:Uint16Array,[m.uint32]:Uint32Array,[m.float32]:Float32Array,[m.float64]:Float64Array}[n],c=new s(r);for(let e=0;e<r;++e)c[e]=o(e);return c.buffer}let y=2880;function b(e){let t=0,n=[],r=[];for(let i=0;t<e.byteLength;++i){let i={};for(;;){let n=new Uint8Array(e,t,y);t+=y;let{end:r,header:a}=C(n);if(i={...i,...a},r)break}let{byteLength:a}=x(i);n.push(i),r.push(new DataView(e,t,a)),t+=ee(a,y)}return{headers:n,dataBuffers:r}}function ee(e,t){return(Math.floor((e-1)/t)+1)*t}function x(e){let t=h(e,`NAXIS`,`number`),n=S(1,t+1).map(t=>h(e,`NAXIS${t}`,`number`)),r=t==0?0:n.reduce((e,t)=>e*t,1),i=Math.abs(h(e,`BITPIX`,`number`))/8;return{nPixels:r,byteDepth:i,byteLength:r*i,naxis:t,naxes:n}}function S(e,t){let n=[];for(let r=e;r<t;++r)n.push(r);return n}function C(e){let t=String.fromCharCode.apply(String,e),n={};if(t.length!=y)throw Error(`invalid byte sequence: ${t} `);let r=!1;cardLoop:for(let e=0;e<36;++e){let i=t.substring(e*80,(e+1)*80),a=w.parse(i);switch(a.type){case 0:r=!0;break cardLoop;case 3:n[a.key]=a.value;break}}return{end:r,header:n}}var w=class e{type;key;value;comment;constructor(e,{key:t,value:n,comment:r}={}){this.type=e,this.key=t,this.value=n,this.comment=r}static parse(t){switch(t.substring(0,8)){case`END     `:return new e(0);case`COMMENT `:{let n=t.substring(8).trim();return new e(1,{comment:n})}case`HISTORY `:{let n=t.substring(8).trim();return new e(2,{comment:n})}default:{let[n,r]=t.split(`=`);if(!r)return new e(4);n.match(/^HIERARCH /)&&(n=n.substring(9));let i=n.trim(),{value:a,comment:o}=this.parseValueString(r);return new e(3,{key:i,value:a,comment:o})}}}static parseValueString(e){let[t,n]=e.split(`/`),r;n&&(r=n.trim()),t=t.trim();let i;return i=t==`T`?!0:t==`F`?!1:t.substring(0,1)==`'`?t.substring(1,t.length-1):Number(t),{value:i,comment:r}}};function T(e){let t=new Uint8Array(e,0,2);return t[0]==31&&t[1]==139}function te(e){return new Uint8Array(p.default.unzip(new Uint8Array(e))).buffer}})();", Pd = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", Nd], { type: "text/javascript;charset=utf-8" });
function Fd(e) {
	let t;
	try {
		if (t = Pd && (self.URL || self.webkitURL).createObjectURL(Pd), !t) throw "";
		let n = new Worker(t, { name: e?.name });
		return n.addEventListener("error", () => {
			(self.URL || self.webkitURL).revokeObjectURL(t);
		}), n;
	} catch {
		return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(Nd), { name: e?.name });
	}
}
//#endregion
//#region src/lib/fits/types.ts
var Id = /* @__PURE__ */ function(e) {
	return e[e.uint8 = 8] = "uint8", e[e.uint16 = 16] = "uint16", e[e.uint32 = 32] = "uint32", e[e.float32 = -32] = "float32", e[e.float64 = -64] = "float64", e;
}({});
function Ld(e, t, n, r) {
	let i = e[t];
	if (i ??= r, typeof i != n) throw Error(`Type mismatch: ${i} for ${t}`);
	return i;
}
//#endregion
//#region src/lib/fits/hdu.ts
var Rd = class e {
	header;
	data;
	dataType;
	constructor(e, t, n) {
		this.header = e, this.data = t, this.dataType = n;
	}
	static fromSource(t) {
		return new e(t.header, t.data, t.dataType);
	}
	card(e, t) {
		return Ld(this.header, e, t);
	}
	uint8array() {
		return this.typedArray(Id.uint8, Uint8Array);
	}
	uint16array() {
		return this.typedArray(Id.uint16, Uint16Array);
	}
	uint32array() {
		return this.typedArray(Id.uint32, Uint32Array);
	}
	float32array() {
		return this.typedArray(Id.float32, Float32Array);
	}
	float64array() {
		return this.typedArray(Id.float64, Float64Array);
	}
	typedArray(e, t) {
		if (this.dataType != e) throw Error(`type mismatch: ${Id[this.dataType]} -> ${Id[e]}`);
		return new t(this.data);
	}
}, zd = class e {
	worker;
	requestId = 0;
	callbacks = /* @__PURE__ */ new Map();
	decode(e, t) {
		return new Promise(async (n, r) => {
			let i = this.setupWorker(), a = ++this.requestId, o = {
				requestId: a,
				fileContent: e,
				hduDecodeOptions: t
			};
			this.callbacks.set(a, {
				resolve: n,
				reject: r
			}), i.postMessage(o);
		});
	}
	setupWorker() {
		return this.worker === void 0 && (this.worker = gl(new Fd()), this.worker.addEventListener("message", (e) => {
			let t = e.data, { resolve: n, reject: r } = this.callbacks.get(t.requestId);
			this.callbacks.delete(t.requestId), t.error ? r(t.error) : n(t.hduSources.map(Rd.fromSource));
		})), this.worker;
	}
	static _singleton;
	static singleton() {
		return this._singleton ??= new e(), this._singleton;
	}
};
async function Bd(e, t) {
	return await zd.singleton().decode(e, t);
}
//#endregion
//#region src/lib/fits/fits.ts
var Vd = class extends Array {
	static DataType = Id;
	static async decode(e, t) {
		return await Bd(e, t);
	}
	static async fetch(e, t) {
		let n = await (await fetch(e, { credentials: "same-origin" })).arrayBuffer();
		return await this.decode(n, t);
	}
}, Hd = /* @__PURE__ */ s({
	Fits: () => Vd,
	Hdu: () => Rd
}), Ud = "#version 300 es\n#define M_PI 3.14159265358979323846264\nprecision highp float;\nuniform sampler2D  u_texture0;\nuniform sampler2D  u_texture1;\nuniform sampler2D  u_texture2;\nuniform sampler2D  u_texture3;\nuniform vec4       u_a;\nuniform vec4       u_b;\nuniform vec4       u_beta;\nuniform vec4       u_bias;\nuniform mat4       u_mix;\nuniform float      u_exposure;\nuniform float      u_gamma;\nuniform float      u_ground;\nin vec2            v_coord;\nout vec4           outputColor;\n\n\nvoid main(void){\n    vec4 source = vec4(\n        texture(u_texture0, v_coord).r,\n        texture(u_texture1, v_coord).r,\n        texture(u_texture2, v_coord).r,\n        texture(u_texture3, v_coord).r\n    );\n    source = u_a * (source + u_b);\n    // β = 0 で 0/0 になることを防ぎ、線形伸張の極限に近づける。\n    vec4 safeBeta = max(u_beta, vec4(1.0e-6));\n    source = asinh(safeBeta * source) / asinh(safeBeta) + u_bias;\n    source = clamp(source, 0., 1.);\n    source = -0.5 * (cos(M_PI * clamp(source, 0., 1.)) - 1.0);\n    vec3 rgb = (u_mix * source).rgb;\n    rgb = pow(u_exposure * max(vec3(0.), (rgb + u_ground)), vec3(u_gamma));\n    outputColor.rgb = rgb;\n    outputColor.a = 1.;\n}\n", Wd = class {
	maxBytes;
	entries = /* @__PURE__ */ new Map();
	usedBytes = 0;
	constructor(e = 32 * 1024 * 1024) {
		this.maxBytes = e;
	}
	get(e) {
		let t = this.entries.get(e);
		return t && (this.entries.delete(e), this.entries.set(e, t)), t;
	}
	set(e, t) {
		this.delete(e);
		let n = t.reduce((e, t) => e + t.byteLength, 0);
		if (!(n > this.maxBytes)) {
			for (; this.usedBytes + n > this.maxBytes;) {
				let e = this.entries.keys().next().value;
				if (e === void 0) break;
				this.delete(e);
			}
			this.entries.set(e, t), this.usedBytes += n;
		}
	}
	clear() {
		this.entries.clear(), this.usedBytes = 0;
	}
	delete(e) {
		let t = this.entries.get(e);
		t && (this.usedBytes -= t.reduce((e, t) => e + t.byteLength, 0), this.entries.delete(e));
	}
}, Gd = class extends ru {
	url;
	onload;
	mixer;
	meta;
	nFilters = -1;
	sourceCache = new Wd();
	constructor(e, t, n) {
		super(e), this.url = t, this.onload = n, this.mixer = new Kd(this.globe.gl);
		try {
			this.globe.gl.getExtension("OES_texture_float");
		} catch (e) {
			throw console.warn("not supported: OES_texture_float"), e;
		}
		this.loadMetadata();
	}
	release() {
		this.sourceCache.clear(), this.mixer.release(), super.release();
	}
	tract;
	async loadMetadata() {
		let e = await (await fetch(`${this.url}/meta.json`)).json();
		this.alreadyReleased || (this.meta = e, this.tract = Rl.fromFitsHeader(e.wcs, e.tractOptions), this.tractsUpdated(), this.nFilters = e.filters.length, this.nFilters, `${this.nFilters}`, this.onload && this.onload(), this.globe.requestRefresh());
	}
	walkTracts(e) {
		this.tract && e(this.tract);
	}
	async loadTileSources(e) {
		let t = this.sourceCache.get(e.id);
		if (t) return t;
		let n = this.meta.filters, r = await Promise.all(n.map(async (t) => {
			let n = `${this.url}/${t}/${e.level}/${e.p}/${e.q}.fits`;
			return (await Vd.fetch(n, [{
				outputDataType: Vd.DataType.float32,
				sourceIndex: 0
			}]).catch(() => void 0))?.[0]?.float32array();
		})), i = r.filter((e) => e !== void 0);
		return !this.alreadyReleased && i.length === r.length && this.sourceCache.set(e.id, i), r;
	}
	async makeTileTexture(e, { fadeIn: t }) {
		let n = await this.loadTileSources(e), r = new au(this, { fadeIn: t });
		if (this.alreadyReleased) return r;
		let i = this.globe.gl, { tileSize: a } = e.tract;
		try {
			this.mixer.apply(r.tex, a, a, 4, (e, t) => {
				e.bind(() => {
					i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, i.NEAREST), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, i.NEAREST), t < this.nFilters && n[t] ? i.texImage2D(i.TEXTURE_2D, 0, i.R32F, a, a, 0, i.RED, i.FLOAT, n[t]) : i.texImage2D(i.TEXTURE_2D, 0, i.R32F, 1, 1, 0, i.RED, i.FLOAT, new Float32Array([0]));
				});
			});
		} catch (e) {
			console.error(e);
		}
		return r.tex.bind(() => {
			e.level === e.tract.maxTileLevel && (i.generateMipmap(i.TEXTURE_2D), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, i.LINEAR_MIPMAP_LINEAR));
		}), r;
	}
}, Kd = class extends gu {
	a = [
		1,
		1,
		1,
		1
	];
	b = [
		0,
		0,
		0,
		0
	];
	beta = [
		1,
		1,
		1,
		1
	];
	bias = [
		0,
		0,
		0,
		0
	];
	mix = Z();
	exposure = 1;
	gamma = 1;
	ground = 0;
	constructor(e) {
		super(e, Ud);
	}
	setUniformParams() {
		this.program.uniform4fv({
			u_a: this.a,
			u_b: this.b,
			u_beta: this.beta,
			u_bias: this.bias
		}), this.program.uniformMatrix4fv({ u_mix: this.mix }), this.program.uniform1f({
			u_exposure: this.exposure,
			u_gamma: this.gamma,
			u_ground: this.ground
		});
	}
}, qd = {
	nFilters: 3,
	a: [
		2.1564270999383357,
		.8434669892882071,
		.7522785922246117,
		1
	],
	b: [
		-.0031533022160069855,
		-.0038556900890443758,
		-.010009120969340549,
		0
	],
	mix: [
		1,
		0,
		0,
		0,
		1,
		0,
		0,
		0,
		1
	],
	beta: [
		10000.000000000007,
		10000.000000000007,
		10000.000000000007,
		100
	],
	bias: [
		0,
		0,
		.04682409587279897,
		0
	],
	exposure: 1,
	gamma: 1,
	ground: 0,
	view: {
		a: 1.463284868397011,
		d: -.09383673108726251,
		fovy: .01227455369231466,
		roll: 0
	}
}, Jd = {
	nFilters: 4,
	a: [
		5.114574480775759,
		3.450128519829859,
		3.5100669157322,
		4.845075513435606
	],
	b: [
		-.002497315896211854,
		-.001969200980067999,
		-.0052241833324896255,
		-.0016067149842944476
	],
	mix: [
		1,
		0,
		0,
		0,
		.5,
		0,
		0,
		.5,
		.5,
		0,
		0,
		.5
	],
	beta: [
		10000.000000000007,
		10000.000000000007,
		10000.000000000007,
		10000.000000000007
	],
	bias: [
		-.02008353199264593,
		0,
		0,
		0
	],
	exposure: 1,
	gamma: 1,
	ground: 0,
	view: {
		a: .9905878324545823,
		d: .4207413467368718,
		fovy: .015285766772945008,
		roll: 0
	}
}, Yd = {
	nFilters: 4,
	a: [
		2.199295029536234,
		2.0103885194367055,
		1.9841269841269842,
		2.022793120413001
	],
	b: [
		-.001648548459980411,
		-.0025677667840354867,
		-.0033194448390797488,
		-.01946514951398076
	],
	mix: [
		.2,
		0,
		0,
		0,
		1,
		0,
		0,
		0,
		1,
		.8,
		0,
		0
	],
	beta: [
		12.058291997314814,
		43.60555950912844,
		83.93141691026881,
		65.15882757731914
	],
	bias: [
		0,
		0,
		0,
		0
	],
	exposure: 1,
	gamma: 1,
	ground: 0,
	view: {
		a: .18668047898454176,
		d: .720410877137467,
		fovy: .013242880368563102,
		roll: -2.1982248398339577
	}
}, Xd = {
	nFilters: 3,
	a: [
		.23,
		.23,
		.23,
		1
	],
	b: [
		-.0015895982627862676,
		-.0009480014211160102,
		-.0021133462033806082,
		0
	],
	mix: [
		1,
		0,
		0,
		0,
		1,
		0,
		0,
		0,
		1
	],
	beta: [
		50000.00000000002,
		50000.00000000002,
		50000.00000000002,
		1
	],
	bias: [
		0,
		0,
		0,
		0
	],
	exposure: 1,
	gamma: 1,
	ground: 0,
	view: {
		a: .8707219737107226,
		d: .7243653901912854,
		fovy: .0077661185967460656,
		roll: 0
	}
}, Zd = {
	nFilters: 1,
	a: [
		14.999999999999988,
		1,
		1,
		1
	],
	b: [
		-.060338206346271225,
		0,
		0,
		0
	],
	mix: [
		1,
		1,
		1,
		0,
		0,
		1,
		0,
		0,
		0,
		0,
		1,
		0,
		0,
		0,
		0,
		1
	],
	beta: [
		5132.13554142474,
		1,
		1,
		1
	],
	bias: [
		-.4992466526217914,
		0,
		0,
		0
	],
	exposure: 1,
	gamma: 1,
	ground: 0,
	view: {
		a: 3.6791262758257988,
		d: .9486076070489848,
		fovy: .004814157234411436,
		roll: 0
	}
}, Qd = [
	"m31",
	"m42",
	"m45",
	"m101",
	"perseus"
], $d = {
	m31: Yd,
	m42: qd,
	m45: Jd,
	m101: Zd,
	perseus: Xd
}, ef = {
	m31: [
		"I",
		"R",
		"G",
		"Ha"
	],
	m42: [
		"Y",
		"I",
		"G"
	],
	m45: [
		"Y",
		"I",
		"R",
		"G"
	],
	m101: ["-"],
	perseus: [
		"I",
		"R",
		"G"
	]
};
function tf(e) {
	let { a: t, b: n, beta: r, bias: i, mix: a, exposure: o, gamma: s, ground: c } = $d[e];
	return {
		a: [...t],
		b: [...n],
		beta: [...r],
		bias: [...i],
		mix: [...a],
		exposure: o,
		gamma: s,
		ground: c
	};
}
//#endregion
//#region src/layer/beautiful_object/index.ts
var nf = class extends $ {
	renderer;
	textureProvider;
	params;
	nFilters;
	constructor(e, t, n = tf(t)) {
		super(e), this.textureProvider = new Gd(e, e.dataRepository + "/pretty_picture/" + t), this.nFilters = $d[t].nFilters, this.params = rf(n), this.applyMixerParams(), this.onRelease(() => this.textureProvider.release()), this.renderer = new Zl(e, this.textureProvider), this.onRelease(() => this.renderer.release());
	}
	setMixerParams(e) {
		af(this.params, e) || (this.params = rf(e), this.applyMixerParams(), this.textureProvider.update(), this.globe.requestRefresh());
	}
	applyMixerParams() {
		let { mixer: e } = this.textureProvider, t = this.params;
		e.beta = t.beta, e.a = t.a, e.b = t.b, e.bias = t.bias, e.mix = of(t.mix, this.nFilters), e.exposure = t.exposure, e.gamma = t.gamma, e.ground = t.ground;
	}
	render(e) {
		let t = Ic(e), n = this.globe.gl;
		p(n, "BeautifulObjects", () => {
			this.renderer.render(e, t);
		});
	}
};
function rf(e) {
	return {
		...e,
		a: [...e.a],
		b: [...e.b],
		beta: [...e.beta],
		bias: [...e.bias],
		mix: [...e.mix]
	};
}
function af(e, t) {
	return e.exposure === t.exposure && e.gamma === t.gamma && e.ground === t.ground && [
		"a",
		"b",
		"beta",
		"bias",
		"mix"
	].every((n) => e[n].length === t[n].length && e[n].every((e, r) => e === t[n][r]));
}
function of(e, t) {
	let n = [
		1,
		0,
		0,
		0,
		0,
		1,
		0,
		0,
		0,
		0,
		1,
		0,
		0,
		0,
		0,
		1
	];
	for (let r = 0; r < 3; ++r) for (let i = 0; i < t; ++i) n[4 * i + r] = e[3 * i + r];
	return Q(n[0], n[1], n[2], n[3], n[4], n[5], n[6], n[7], n[8], n[9], n[10], n[11], n[12], n[13], n[14], n[15]);
}
//#endregion
//#region src/renderer/triangle_renderer/frag.glsl?raw
var sf = "precision mediump float;\nuniform float u_alpha;\nvarying vec4 v_color;\n\nvoid main() {\n    gl_FragColor = v_color;\n    gl_FragColor.a *= u_alpha;\n}", cf = "precision mediump float;\n\nuniform mat4 u_pvmMatrix;\nattribute vec3 a_position;\nattribute vec4 a_color;\nvarying vec4 v_color;\n\nvoid main(void) {\n    gl_Position = u_pvmMatrix * vec4(a_position, 1.);\n    v_color = a_color;\n}\n", lf = /* @__PURE__ */ s({ Renderer: () => uf }), uf = class {
	gl;
	blendMode = "ADD";
	modelMatrix = Z();
	program;
	attribList;
	releaseCallbacks = cs();
	onRelease = this.releaseCallbacks.add;
	constructor(e) {
		this.gl = e, this.program = S.new(e, cf, sf), this.attribList = new E(e, { members: [{
			name: "a_position",
			nComponents: 3
		}, {
			name: "a_color",
			nComponents: 4
		}] }), this.onRelease(() => {
			this.attribList.release(), this.program.release();
		});
	}
	vertices = [];
	needsUpdate = !1;
	addStrips(e) {
		this.vertices.push(e[0], ...e, e[e.length - 1]), this.needsUpdate = !0;
	}
	addTriangle(e, t, n) {
		this.addStrips([
			e,
			t,
			n,
			n
		]);
	}
	release() {
		this.releaseCallbacks.flush();
	}
	render(e, t = 1) {
		if (this.needsUpdate && this.updateVBO(), this.attribList.vertexCount === 0 || t <= 0) return;
		let n = e.mvp, r = this.gl, i = this.program;
		i.enableAttribList(this.attribList, () => {
			i.uniformMatrix4fv({ u_pvmMatrix: bn(Z(), n.pv, this.modelMatrix) }), i.uniform1f({ u_alpha: t }), _(r, [r.BLEND], () => {
				switch (this.blendMode) {
					case "ADD":
						r.blendFunc(r.SRC_ALPHA, r.ONE);
						break;
					case "NORMAL":
						r.blendFunc(r.SRC_ALPHA, r.ONE_MINUS_SRC_ALPHA);
						break;
				}
				r.drawArrays(r.TRIANGLE_STRIP, 0, this.attribList.vertexCount);
			});
		});
	}
	updateVBO() {
		let e = [];
		for (let t of this.vertices) e.push(...t.position, ...t.color);
		this.attribList.setData({ array: new Float32Array(e) }), this.needsUpdate = !1;
	}
}, df = "(function(){function e(e){return e}self.addEventListener(`message`,t=>{setTimeout(()=>{self.postMessage(e(t.data))},1e3)})})();", ff = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", df], { type: "text/javascript;charset=utf-8" });
function pf(e) {
	let t;
	try {
		if (t = ff && (self.URL || self.webkitURL).createObjectURL(ff), !t) throw "";
		let n = new Worker(t, { name: e?.name });
		return n.addEventListener("error", () => {
			(self.URL || self.webkitURL).revokeObjectURL(t);
		}), n;
	} catch {
		return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(df), { name: e?.name });
	}
}
//#endregion
//#region src/devel/echo-worker/index.ts
function mf(e) {
	return new Promise((t) => {
		let n = gl(new pf());
		n.postMessage(e), n.addEventListener("message", (e) => {
			n.terminate(), t(e.data);
		});
	});
}
//#endregion
//#region src/utils/memoize.ts
function hf(e) {
	let t = /* @__PURE__ */ new Map();
	return function(...n) {
		let r = JSON.stringify(n);
		if (t.has(r)) return t.get(r);
		let i = e(...n);
		return t.set(r, i), i;
	};
}
//#endregion
//#region src/layer/marker_layer/marker.ts
function gf({ size: e }, { canvas: t, ctx: n }) {
	t.width = e, t.height = e, n.strokeStyle = "#ffffff", n.globalAlpha = 1, n.setTransform(e / 2, 0, 0, e / 2, (e - 2) / 2, (e - 2) / 2), n.clearRect(-1, -1, 2, 2);
}
function _f({ width: e }, t) {
	t.lineWidth = e, t.beginPath(), t.arc(0, 0, 1 - e, 0, 2 * Math.PI, !1), t.stroke();
}
function vf({ width: e }, t) {
	t.lineWidth = e, t.beginPath(), t.moveTo(-1, 0), t.lineTo(1, 0), t.moveTo(0, -1), t.lineTo(0, 1), t.stroke();
}
function yf(e, t) {
	t.rotate(Math.PI / 4), vf(e, t);
}
function bf(e, t) {
	vf(e, t), t.clearRect(-.5, -.5, 1, 1);
}
function xf(e, t) {
	t.rotate(Math.PI / 4), bf(e, t);
}
function Sf({ width: e }, t) {
	t.lineWidth = e, t.beginPath(), t.arc(0, 0, e / 2, 0, 2 * Math.PI, !1), t.stroke();
}
function Cf(e, t) {
	_f(e, t), bf(e, t);
}
function wf(e, t) {
	_f(e, t), xf(e, t);
}
function Tf(e, t) {
	vf(e, t), yf(e, t);
}
function Ef(e, t) {
	bf(e, t), xf(e, t);
}
function Df(e, t) {
	bf(e, t), xf(e, t), _f(e, t);
}
function Of({ width: e }, t, n, r = 0) {
	let i = 1 - e;
	t.lineWidth = e, t.beginPath(), t.moveTo(i * Math.cos(r), i * Math.sin(r));
	for (let e = 0; e < n; ++e) t.lineTo(i * Math.cos(2 * Math.PI * e / n + r), i * Math.sin(2 * Math.PI * e / n + r));
	t.closePath(), t.stroke();
}
function kf(e, t) {
	Of(e, t, 3, -Math.PI / 2);
}
function Af(e, t) {
	Of(e, t, 5, -Math.PI / 2);
}
function jf(e, t) {
	Of(e, t, 4, Math.PI / 4);
}
function Mf(e, t) {
	Of(e, t, 4);
}
var Nf = {
	circle: _f,
	plus: vf,
	x: yf,
	hollowPlus: bf,
	hollowX: xf,
	dot: Sf,
	circledHollowPlus: Cf,
	circledHollowX: wf,
	diamond: Mf,
	square: jf,
	asterisk: Tf,
	hollowAsterisk: Ef,
	circledHollowAsterisk: Df,
	triangle: kf,
	pentagon: Af
}, Pf = Object.keys(Nf), Ff = hf((e, t) => {
	let { size: n } = t, { canvas: r, ctx: i } = If();
	return gf(t, {
		canvas: r,
		ctx: i
	}), Nf[e](t, i), i.getImageData(0, 0, n, n);
}), If = (() => {
	let e;
	return () => {
		if (!e) {
			let t = document.createElement("canvas");
			e = {
				canvas: t,
				ctx: t.getContext("2d", { willReadFrequently: !0 })
			};
		}
		return e;
	};
})(), Lf = class {
	value2coord;
	n;
	size;
	root;
	constructor(e, t) {
		this.value2coord = t, this.n = e.length === 0 ? -1 : t(e[0]).length, this.size = e.length, this.root = this.constructTree(e.slice(), 0);
	}
	constructTree(e, t) {
		if (e.length === 0) return;
		let n = this.value2coord, r = t % this.n;
		e.sort((e, t) => n(e)[r] - n(t)[r]);
		let i = Math.floor(e.length / 2), a = e[i];
		return {
			coord: n(a),
			value: a,
			left: this.constructTree(e.slice(0, i), r + 1),
			right: this.constructTree(e.slice(i + 1), r + 1)
		};
	}
	nearest(e, t = 1, n = Infinity) {
		if (!this.root) return [];
		let r = [];
		return this.dig(r, e, this.root, 0, t, n), r.map((e) => e.value);
	}
	dig(e, t, n, r, i, a) {
		let o = r % this.n, s = Rf(t, n.coord);
		if (s <= a * a) {
			let t = 0;
			for (t = 0; t < e.length && !(s <= e[t].d2); ++t);
			t < i && (e.splice(t, 0, {
				d2: s,
				value: n.value
			}), e.splice(i), e.length === i && (a = Math.sqrt(e[e.length - 1].d2)));
		}
		t[o] < n.coord[o] ? (n.left && this.dig(e, t, n.left, o + 1, i, a), n.right && n.coord[o] - t[o] < a && this.dig(e, t, n.right, o + 1, i, a)) : (n.left && t[o] - n.coord[o] <= a && this.dig(e, t, n.left, o + 1, i, a), n.right && this.dig(e, t, n.right, o + 1, i, a));
	}
};
function Rf(e, t) {
	let n = 0;
	for (let r = 0; r < e.length; ++r) {
		let i = e[r] - t[r];
		n += i * i;
	}
	return n;
}
//#endregion
//#region src/layer/marker_layer/index.ts
var zf = 32, Bf = class extends $ {
	options;
	renderer;
	constructor(e, t) {
		super(e), this.options = t, this.renderer = new Gc(this.globe.gl), this.renderer.color = t.baseColor ?? this.renderer.color, this.onRelease(() => this.renderer.release()), this.update(t);
	}
	render(e) {
		this.renderer.render(e);
	}
	update(e) {
		this.options = {
			...this.options,
			...e
		}, Uf(this.renderer, this.options), this.globe.requestRefresh();
	}
	set baseColor(e) {
		this.renderer.color = e ?? [
			1,
			1,
			1,
			1
		];
	}
}, Vf = class extends $ {
	options;
	baseMarkerRenderer;
	focusedMarkerRenderer;
	pointingObject;
	constructor(e, t) {
		super(e), this.options = t, this.baseMarkerRenderer = new Gc(this.globe.gl), this.onRelease(() => this.baseMarkerRenderer.release()), this.focusedMarkerRenderer = new Gc(this.globe.gl), this.onRelease(() => this.focusedMarkerRenderer.release()), this.pointingObjects.push(this.pointingObject = new Hf(() => ({
			layer: this,
			renderer: this.focusedMarkerRenderer,
			options: this.options
		}))), this.update(t);
	}
	update(e) {
		this.options = {
			...this.options,
			...e
		}, Uf(this.baseMarkerRenderer, this.options), this.pointingObject.refresh(), this.globe.requestRefresh();
	}
	render(e) {
		let t = this.globe.gl;
		p(t, "ClickableMarker", () => {
			this.baseMarkerRenderer.render(e, this.options.dimmAlpha), this.focusedMarkerRenderer.render(e);
		});
	}
	set onClick(e) {
		this.options.onClick = e;
	}
	set onHoverChange(e) {
		this.options.onHoverChange = e;
	}
	set baseColor(e) {
		this.baseMarkerRenderer.color = e ?? [
			1,
			1,
			1,
			1
		], this.focusedMarkerRenderer.color = e ?? [
			1,
			1,
			1,
			1
		];
	}
	set dimmAlpha(e) {
		this.options.dimmAlpha = e, this.globe.requestRefresh();
	}
}, Hf = class extends ls {
	backdoor;
	index;
	constructor(e) {
		super(), this.backdoor = e, this.index = this.rebuildIndex();
	}
	focusedIndex = -1;
	rebuildIndex() {
		let { options: { markers: e } } = this.backdoor();
		return this.index = new Lf(e.map((e, t) => t), (t) => e[t].position);
	}
	refresh() {
		this.focusedIndex = -1, this.rebuildIndex(), this.refreshActiveMarkerRenderer();
	}
	refreshActiveMarkerRenderer() {
		let { options: e, layer: t, renderer: n } = this.backdoor(), { markers: r } = e;
		Uf(n, {
			...e,
			markers: this.focusedIndex >= 0 ? [r[this.focusedIndex]] : []
		}), t.globe.requestRefresh();
	}
	onClick(e) {
		let { options: { onClick: t } } = this.backdoor();
		t && this.focusedIndex >= 0 && t({ index: this.focusedIndex });
	}
	hit(e) {
		let { layer: t, options: n } = this.backdoor(), r = (n.markerSize ?? zf) * t.globe.camera.pixelRatio, i = t.globe.camera.fovy, a = t.globe.canvas.domElement.height, o = i * r / a, s = this.index.nearest(e.coord.xyz, 1, o), c = this.focusedIndex;
		if (this.focusedIndex = s.length > 0 ? s[0] : -1, c !== this.focusedIndex) {
			this.refreshActiveMarkerRenderer();
			let { options: { onHoverChange: e } } = this.backdoor();
			e?.({ index: this.focusedIndex >= 0 ? this.focusedIndex : null });
		}
		return {
			hit: this.focusedIndex >= 0,
			passThrough: !0
		};
	}
};
function Uf(e, t) {
	let { markers: n, defaultColor: r, defaultType: i } = t, a = Object.fromEntries(Pf.map((e, t) => [e, t])), o = n.map(({ position: e, color: t, type: n }) => ({
		position: e,
		imageID: a[n ?? i],
		color: t ?? r
	})), s = Pf.map((e) => ({
		imageData: Ff(e, {
			size: t.markerSize ?? zf,
			width: t.markerWidth ?? .2
		}),
		origin: [0, 0]
	}));
	e.buildArray(s, o);
}
//#endregion
//#region src/layer/path_layer.ts
var Wf = class e extends $ {
	pathRenderer;
	_dimOnZoom;
	constructor(t, n) {
		super(t);
		let r = {
			...e.defaultOptions(),
			...n
		};
		this.pathRenderer = new Zc(this.globe.gl, r), this._dimOnZoom = r.dimOnZoom, this.onRelease(() => {
			this.pathRenderer.release();
		}), this.pathRenderer.setPaths(n.paths);
	}
	render(e) {
		let t;
		t = typeof this._dimOnZoom == "function" ? this._dimOnZoom(e.mvp.fovy) : this._dimOnZoom ? Lc(e) : 1, this.pathRenderer.render(e, t);
	}
	set paths(e) {
		this.pathRenderer.setPaths(e), this.globe.requestRefresh();
	}
	set blendeMode(e) {
		this.pathRenderer.blendMode = e, this.globe.requestRefresh();
	}
	set dimOnZoom(e) {
		this._dimOnZoom = e, this.globe.requestRefresh();
	}
	set darkenNarrowLine(e) {
		this.pathRenderer.darkenNarrowLine = e, this.globe.requestRefresh();
	}
	static defaultOptions() {
		return {
			blendMode: "NORMAL",
			dimOnZoom: !1,
			darkenNarrowLine: !0
		};
	}
}, Gf = /* @__PURE__ */ o(((e, t) => {
	(function() {
		var e = [], n = 3988292384;
		function r() {
			var t, r, i;
			for (r = 0; r < 256; r += 1) {
				for (t = r, i = 0; i < 8; i += 1) t & 1 ? t = n ^ t >>> 1 : t >>>= 1;
				e[r] = t >>> 0;
			}
		}
		function i(e) {
			return Array.prototype.map.call(e, function(e) {
				return e.charCodeAt(0);
			});
		}
		function a(e) {
			var t = -1, r, i, a, o;
			for (r = 0, a = e.length; r < a; r += 1) {
				for (o = (t ^ e[r]) & 255, i = 0; i < 8; i += 1) (o & 1) == 1 ? o = o >>> 1 ^ n : o >>>= 1;
				t = t >>> 8 ^ o;
			}
			return t ^ -1;
		}
		function o(t, n) {
			var r, i, a;
			if (!((o.crc === void 0 || !n || !t) && (o.crc = -1, !t))) {
				for (r = o.crc, i = 0, a = t.length; i < a; i += 1) r = r >>> 8 ^ e[(r ^ t[i]) & 255];
				return o.crc = r, r ^ -1;
			}
		}
		r(), t.exports = function(e, t) {
			var e = typeof e == "string" ? i(e) : e;
			return ((t ? a(e) : o(e)) >>> 0).toString(16);
		}, t.exports.direct = a, t.exports.table = o;
	})();
})), Kf = /* @__PURE__ */ o(((e, t) => {
	(function() {
		var e = 32768, n, r, i = null, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b = [
			0,
			1,
			3,
			7,
			15,
			31,
			63,
			127,
			255,
			511,
			1023,
			2047,
			4095,
			8191,
			16383,
			32767,
			65535
		], x = [
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			11,
			13,
			15,
			17,
			19,
			23,
			27,
			31,
			35,
			43,
			51,
			59,
			67,
			83,
			99,
			115,
			131,
			163,
			195,
			227,
			258,
			0,
			0
		], S = [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			1,
			1,
			1,
			2,
			2,
			2,
			2,
			3,
			3,
			3,
			3,
			4,
			4,
			4,
			4,
			5,
			5,
			5,
			5,
			0,
			99,
			99
		], C = [
			1,
			2,
			3,
			4,
			5,
			7,
			9,
			13,
			17,
			25,
			33,
			49,
			65,
			97,
			129,
			193,
			257,
			385,
			513,
			769,
			1025,
			1537,
			2049,
			3073,
			4097,
			6145,
			8193,
			12289,
			16385,
			24577
		], w = [
			0,
			0,
			0,
			0,
			1,
			1,
			2,
			2,
			3,
			3,
			4,
			4,
			5,
			5,
			6,
			6,
			7,
			7,
			8,
			8,
			9,
			9,
			10,
			10,
			11,
			11,
			12,
			12,
			13,
			13
		], T = [
			16,
			17,
			18,
			0,
			8,
			7,
			9,
			6,
			10,
			5,
			11,
			4,
			12,
			3,
			13,
			2,
			14,
			1,
			15
		];
		function E() {
			this.next = null, this.list = null;
		}
		function D() {
			this.e = 0, this.b = 0, this.n = 0, this.t = null;
		}
		function O(e, t, n, r, i, a) {
			this.BMAX = 16, this.N_MAX = 288, this.status = 0, this.root = null, this.m = 0;
			var o, s = [], c, l, u, d, f, p, m, h = [], g, _, v, y = new D(), b = [], x = [], S, C = [], w, T, O, k, A = this.root = null;
			for (f = 0; f < this.BMAX + 1; f++) s[f] = 0;
			for (f = 0; f < this.BMAX + 1; f++) h[f] = 0;
			for (f = 0; f < this.BMAX; f++) b[f] = null;
			for (f = 0; f < this.N_MAX; f++) x[f] = 0;
			for (f = 0; f < this.BMAX + 1; f++) C[f] = 0;
			c = t > 256 ? e[256] : this.BMAX, g = e, _ = 0, f = t;
			do
				s[g[_]]++, _++;
			while (--f > 0);
			if (s[0] === t) {
				this.root = null, this.m = 0, this.status = 0;
				return;
			}
			for (p = 1; p <= this.BMAX && s[p] === 0; p++);
			for (m = p, a < p && (a = p), f = this.BMAX; f !== 0 && s[f] === 0; f--);
			for (u = f, a > f && (a = f), T = 1 << p; p < f; p++, T <<= 1) if ((T -= s[p]) < 0) {
				this.status = 2, this.m = a;
				return;
			}
			if ((T -= s[f]) < 0) {
				this.status = 2, this.m = a;
				return;
			}
			for (s[f] += T, C[1] = p = 0, g = s, _ = 1, w = 2; --f > 0;) C[w++] = p += g[_++];
			g = e, _ = 0, f = 0;
			do
				(p = g[_++]) !== 0 && (x[C[p]++] = f);
			while (++f < t);
			for (t = C[u], C[0] = f = 0, g = x, _ = 0, d = -1, S = h[0] = 0, v = null, O = 0; m <= u; m++) for (o = s[m]; o-- > 0;) {
				for (; m > S + h[1 + d];) {
					if (S += h[1 + d], d++, O = (O = u - S) > a ? a : O, (l = 1 << (p = m - S)) > o + 1) for (l -= o + 1, w = m; ++p < O && !((l <<= 1) <= s[++w]);) l -= s[w];
					for (S + p > c && S < c && (p = c - S), O = 1 << p, h[1 + d] = p, v = [], k = 0; k < O; k++) v[k] = new D();
					A = A ? A.next = new E() : this.root = new E(), A.next = null, A.list = v, b[d] = v, d > 0 && (C[d] = f, y.b = h[d], y.e = 16 + p, y.t = v, p = (f & (1 << S) - 1) >> S - h[d], b[d - 1][p].e = y.e, b[d - 1][p].b = y.b, b[d - 1][p].n = y.n, b[d - 1][p].t = y.t);
				}
				for (y.b = m - S, _ >= t ? y.e = 99 : g[_] < n ? (y.e = g[_] < 256 ? 16 : 15, y.n = g[_++]) : (y.e = i[g[_] - n], y.n = r[g[_++] - n]), l = 1 << m - S, p = f >> S; p < O; p += l) v[p].e = y.e, v[p].b = y.b, v[p].n = y.n, v[p].t = y.t;
				for (p = 1 << m - 1; (f & p) !== 0; p >>= 1) f ^= p;
				for (f ^= p; (f & (1 << S) - 1) !== C[d];) S -= h[d], d--;
			}
			this.m = h[1], this.status = +(T !== 0 && u !== 1);
		}
		function k() {
			return v.length === y ? -1 : v[y++] & 255;
		}
		function A(e) {
			for (; l < e;) c |= k() << l, l += 8;
		}
		function j(e) {
			return c & b[e];
		}
		function M(e) {
			c >>= e, l -= e;
		}
		function N(t, i, a) {
			var o, s, c;
			if (a === 0) return 0;
			for (c = 0;;) {
				for (A(g), s = m.list[j(g)], o = s.e; o > 16;) {
					if (o === 99) return -1;
					M(s.b), o -= 16, A(o), s = s.t[j(o)], o = s.e;
				}
				if (M(s.b), o === 16) {
					if (r &= e - 1, t[i + c++] = n[r++] = s.n, c === a) return a;
					continue;
				}
				if (o === 15) break;
				for (A(o), f = s.n + j(o), M(o), A(_), s = h.list[j(_)], o = s.e; o > 16;) {
					if (o === 99) return -1;
					M(s.b), o -= 16, A(o), s = s.t[j(o)], o = s.e;
				}
				for (M(s.b), A(o), p = r - s.n - j(o), M(o); f > 0 && c < a;) f--, p &= e - 1, r &= e - 1, t[i + c++] = n[r++] = n[p++];
				if (c === a) return a;
			}
			return u = -1, c;
		}
		function P(t, i, a) {
			var o = l & 7;
			if (M(o), A(16), o = j(16), M(16), A(16), o !== (~c & 65535)) return -1;
			for (M(16), f = o, o = 0; f > 0 && o < a;) f--, r &= e - 1, A(8), t[i + o++] = n[r++] = j(8), M(8);
			return f === 0 && (u = -1), o;
		}
		function F(e, t, n) {
			if (!i) {
				var r, c = [], l;
				for (r = 0; r < 144; r++) c[r] = 8;
				for (; r < 256; r++) c[r] = 9;
				for (; r < 280; r++) c[r] = 7;
				for (; r < 288; r++) c[r] = 8;
				if (o = 7, l = new O(c, 288, 257, x, S, o), l.status !== 0) return console.error("HufBuild error: " + l.status), -1;
				for (i = l.root, o = l.m, r = 0; r < 30; r++) c[r] = 5;
				if (s = 5, l = new O(c, 30, 0, C, w, s), l.status > 1) return i = null, console.error("HufBuild error: " + l.status), -1;
				a = l.root, s = l.m;
			}
			return m = i, h = a, g = o, _ = s, N(e, t, n);
		}
		function I(e, t, n) {
			var r, i, a, o, s, c, l, u, d = [], f;
			for (r = 0; r < 316; r++) d[r] = 0;
			if (A(5), l = 257 + j(5), M(5), A(5), u = 1 + j(5), M(5), A(4), c = 4 + j(4), M(4), l > 286 || u > 30) return -1;
			for (i = 0; i < c; i++) A(3), d[T[i]] = j(3), M(3);
			for (; i < 19; i++) d[T[i]] = 0;
			if (g = 7, f = new O(d, 19, 19, null, null, g), f.status !== 0) return -1;
			for (m = f.root, g = f.m, o = l + u, r = a = 0; r < o;) if (A(g), s = m.list[j(g)], i = s.b, M(i), i = s.n, i < 16) d[r++] = a = i;
			else if (i === 16) {
				if (A(2), i = 3 + j(2), M(2), r + i > o) return -1;
				for (; i-- > 0;) d[r++] = a;
			} else if (i === 17) {
				if (A(3), i = 3 + j(3), M(3), r + i > o) return -1;
				for (; i-- > 0;) d[r++] = 0;
				a = 0;
			} else {
				if (A(7), i = 11 + j(7), M(7), r + i > o) return -1;
				for (; i-- > 0;) d[r++] = 0;
				a = 0;
			}
			if (g = 9, f = new O(d, l, 257, x, S, g), g === 0 && (f.status = 1), f.status !== 0 && f.status !== 1) return -1;
			for (m = f.root, g = f.m, r = 0; r < u; r++) d[r] = d[r + l];
			return _ = 6, f = new O(d, u, 0, C, w, _), h = f.root, _ = f.m, _ === 0 && l > 257 || f.status !== 0 ? -1 : N(e, t, n);
		}
		function L() {
			n ||= [], r = 0, c = 0, l = 0, u = -1, d = !1, f = p = 0, m = null;
		}
		function R(t, i, a) {
			for (var o = 0, s; o < a;) {
				if (d && u === -1) return o;
				if (f > 0) {
					if (u !== 0) for (; f > 0 && o < a;) f--, p &= e - 1, r &= e - 1, t[i + o++] = n[r++] = n[p++];
					else {
						for (; f > 0 && o < a;) f--, r &= e - 1, A(8), t[i + o++] = n[r++] = j(8), M(8);
						f === 0 && (u = -1);
					}
					if (o === a) return o;
				}
				if (u === -1) {
					if (d) break;
					A(1), j(1) !== 0 && (d = !0), M(1), A(2), u = j(2), M(2), m = null, f = 0;
				}
				switch (u) {
					case 0:
						s = P(t, i + o, a - o);
						break;
					case 1:
						s = m ? N(t, i + o, a - o) : F(t, i + o, a - o);
						break;
					case 2:
						s = m ? N(t, i + o, a - o) : I(t, i + o, a - o);
						break;
					default:
						s = -1;
						break;
				}
				if (s === -1) return d ? 0 : -1;
				o += s;
			}
			return o;
		}
		function z(e) {
			var t = [], n;
			L(), v = e, y = 0;
			do
				n = R(t, t.length, 1024);
			while (n > 0);
			return v = null, t;
		}
		t.exports = z;
	})();
})), qf = /* @__PURE__ */ o(((e, t) => {
	(function() {
		var e = 32768, n = 6, r = 32768, i = 1024 * 8, a = 2 * e, o = 3, s = 258, c = 16, l = 8192, u = 15, d = l, f = 1 << u, p = f - 1, m = e - 1, h = 0, g = 4096, _ = s + o + 1, v = e - _, y = 1, b = 15, x = 7, S = 29, C = 256, w = 256, T = C + 1 + S, E = 30, D = 19, O = 16, k = 17, A = 18, j = 2 * T + 1, M = parseInt((u + o - 1) / o, 10), N, P, F, I, L = null, R, z, ee, B, te, ne, V, re, ie, ae, H, oe, se, ce, U, W, G, le, ue, K, de, fe, q, pe, me, he, ge, _e, ve, J, ye, be, xe, Y, X, Se, Ce, we, Te, Ee, De, Oe, ke, Ae, je, Me, Ne, Pe, Fe, Ie, Le, Re;
		l > r && console.error("error: INBUFSIZ is too small"), e << 1 > 1 << c && console.error("error: WSIZE is too large"), u > c - 1 && console.error("error: HASH_BITS is too large"), (u < 8 || s !== 258) && console.error("error: Code too clever");
		function ze() {
			this.fc = 0, this.dl = 0;
		}
		function Be() {
			this.dyn_tree = null, this.static_tree = null, this.extra_bits = null, this.extra_base = 0, this.elems = 0, this.max_length = 0, this.max_code = 0;
		}
		function Ve(e, t, n, r) {
			this.good_length = e, this.max_lazy = t, this.nice_length = n, this.max_chain = r;
		}
		function He() {
			this.next = null, this.len = 0, this.ptr = [], this.off = 0;
		}
		var Ue = [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			1,
			1,
			1,
			2,
			2,
			2,
			2,
			3,
			3,
			3,
			3,
			4,
			4,
			4,
			4,
			5,
			5,
			5,
			5,
			0
		], We = [
			0,
			0,
			0,
			0,
			1,
			1,
			2,
			2,
			3,
			3,
			4,
			4,
			5,
			5,
			6,
			6,
			7,
			7,
			8,
			8,
			9,
			9,
			10,
			10,
			11,
			11,
			12,
			12,
			13,
			13
		], Ge = [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2,
			3,
			7
		], Ke = [
			16,
			17,
			18,
			0,
			8,
			7,
			9,
			6,
			10,
			5,
			11,
			4,
			12,
			3,
			13,
			2,
			14,
			1,
			15
		], qe = [
			new Ve(0, 0, 0, 0),
			new Ve(4, 4, 8, 4),
			new Ve(4, 5, 16, 8),
			new Ve(4, 6, 32, 32),
			new Ve(4, 4, 16, 16),
			new Ve(8, 16, 32, 32),
			new Ve(8, 16, 128, 128),
			new Ve(8, 32, 128, 256),
			new Ve(32, 128, 258, 1024),
			new Ve(32, 258, 258, 4096)
		];
		function Je(e) {
			var t;
			if (e ? e < 1 ? e = 1 : e > 9 && (e = 9) : e = n, q = e, I = !1, ue = !1, L === null) {
				for (N = P = F = null, L = [], B = [], te = [], ne = [], V = [], he = [], t = 0; t < j; t++) he[t] = new ze();
				for (ge = [], t = 0; t < 2 * E + 1; t++) ge[t] = new ze();
				for (_e = [], t = 0; t < T + 2; t++) _e[t] = new ze();
				for (ve = [], t = 0; t < E; t++) ve[t] = new ze();
				for (J = [], t = 0; t < 2 * D + 1; t++) J[t] = new ze();
				ye = new Be(), be = new Be(), xe = new Be(), Y = [], X = [], we = [], Te = [], Ee = [], De = [], Oe = [], ke = [];
			}
		}
		function Ye(e) {
			e.next = N, N = e;
		}
		function Xe() {
			var e;
			return N === null ? e = new He() : (e = N, N = N.next), e.next = null, e.len = e.off = 0, e;
		}
		function Ze(t) {
			return V[e + t];
		}
		function Qe(t, n) {
			return V[e + t] = n;
		}
		function $e(e) {
			L[z + R++] = e, z + R === i && kt();
		}
		function et(e) {
			e &= 65535, z + R < i - 2 ? (L[z + R++] = e & 255, L[z + R++] = e >>> 8) : ($e(e & 255), $e(e >>> 8));
		}
		function tt() {
			H = (H << M ^ B[G + o - 1] & 255) & p, oe = Ze(H), V[G & m] = oe, Qe(H, G);
		}
		function nt(e, t) {
			Q(t[e].fc, t[e].dl);
		}
		function rt(e) {
			return (e < 256 ? Ee[e] : Ee[256 + (e >> 7)]) & 255;
		}
		function it(e, t, n) {
			return e[t].fc < e[n].fc || e[t].fc === e[n].fc && we[t] <= we[n];
		}
		function at(e, t, n) {
			var r;
			for (r = 0; r < n && Re < Le.length; r++) e[t + r] = Le[Re++] & 255;
			return r;
		}
		function ot() {
			var t;
			for (t = 0; t < f; t++) V[e + t] = 0;
			if (fe = qe[q].max_lazy, pe = qe[q].good_length, me = qe[q].nice_length, de = qe[q].max_chain, G = 0, ae = 0, K = at(B, 0, 2 * e), K <= 0) {
				ue = !0, K = 0;
				return;
			}
			for (ue = !1; K < _ && !ue;) ct();
			for (H = 0, t = 0; t < o - 1; t++) H = (H << M ^ B[t] & 255) & p;
		}
		function st(e) {
			var t = de, n = G, r, i, a = W, o = G > v ? G - v : h, c = G + s, l = B[n + a - 1], u = B[n + a], d, f;
			W >= pe && (t >>= 2);
			do {
				if (r = e, B[r + a] !== u || B[r + a - 1] !== l || B[r] !== B[n] || B[++r] !== B[n + 1]) continue;
				for (n += 2, r++; n < c;) {
					for (f = !1, d = 0; d < 8; d += 1) if (n += 1, r += 1, B[n] !== B[r]) {
						f = !0;
						break;
					}
					if (f) break;
				}
				if (i = s - (c - n), n = c - s, i > a) {
					if (le = e, a = i, i >= me) break;
					l = B[n + a - 1], u = B[n + a];
				}
			} while ((e = V[e & m]) > o && --t !== 0);
			return a;
		}
		function ct() {
			var t, n, r = a - K - G;
			if (r === -1) r--;
			else if (G >= e + v) {
				for (t = 0; t < e; t++) B[t] = B[t + e];
				for (le -= e, G -= e, ae -= e, t = 0; t < f; t++) n = Ze(t), Qe(t, n >= e ? n - e : h);
				for (t = 0; t < e; t++) n = V[t], V[t] = n >= e ? n - e : h;
				r += e;
			}
			ue || (t = at(B, G + K, r), t <= 0 ? ue = !0 : K += t);
		}
		function lt() {
			for (; K !== 0 && P === null;) {
				var e;
				if (tt(), oe !== h && G - oe <= v && (U = st(oe), U > K && (U = K)), U >= o) if (e = Z(G - le, U - o), K -= U, U <= fe) {
					U--;
					do
						G++, tt();
					while (--U !== 0);
					G++;
				} else G += U, U = 0, H = B[G] & 255, H = (H << M ^ B[G + 1] & 255) & p;
				else e = Z(0, B[G] & 255), K--, G++;
				for (e && (wt(0), ae = G); K < _ && !ue;) ct();
			}
		}
		function ut() {
			for (; K !== 0 && P === null;) {
				if (tt(), W = U, se = le, U = o - 1, oe !== h && W < fe && G - oe <= v && (U = st(oe), U > K && (U = K), U === o && G - le > g && U--), W >= o && U <= W) {
					var e = Z(G - 1 - se, W - o);
					K -= W - 1, W -= 2;
					do
						G++, tt();
					while (--W !== 0);
					ce = !1, U = o - 1, G++, e && (wt(0), ae = G);
				} else ce ? (Z(0, B[G - 1] & 255) && (wt(0), ae = G), G++, K--) : (ce = !0, G++, K--);
				for (; K < _ && !ue;) ct();
			}
		}
		function dt() {
			ue || (re = 0, ie = 0, mt(), ot(), P = null, R = 0, z = 0, q <= 3 ? (W = o - 1, U = 0) : (U = o - 1, ce = !1), ee = !1);
		}
		function ft(e, t, n) {
			var r;
			return !I && (dt(), I = !0, K === 0) ? (ee = !0, 0) : (r = pt(e, t, n), r === n ? n : ee ? r : (q <= 3 ? lt() : ut(), K === 0 && (ce && Z(0, B[G - 1] & 255), wt(1), ee = !0), r + pt(e, r + t, n - r)));
		}
		function pt(e, t, n) {
			for (var r = 0, i, a; P !== null && r < n;) {
				for (i = n - r, i > P.len && (i = P.len), a = 0; a < i; a++) e[t + r + a] = P.ptr[P.off + a];
				if (P.off += i, P.len -= i, r += i, P.len === 0) {
					var o = P;
					P = P.next, Ye(o);
				}
			}
			if (r === n) return r;
			if (z < R) {
				for (i = n - r, i > R - z && (i = R - z), a = 0; a < i; a++) e[t + r + a] = L[z + a];
				z += i, r += i, R === z && (R = z = 0);
			}
			return r;
		}
		function mt() {
			var e, t, n, r, i;
			if (ve[0].dl === 0) {
				for (ye.dyn_tree = he, ye.static_tree = _e, ye.extra_bits = Ue, ye.extra_base = C + 1, ye.elems = T, ye.max_length = b, ye.max_code = 0, be.dyn_tree = ge, be.static_tree = ve, be.extra_bits = We, be.extra_base = 0, be.elems = E, be.max_length = b, be.max_code = 0, xe.dyn_tree = J, xe.static_tree = null, xe.extra_bits = Ge, xe.extra_base = 0, xe.elems = D, xe.max_length = x, xe.max_code = 0, n = 0, r = 0; r < S - 1; r++) for (De[r] = n, e = 0; e < 1 << Ue[r]; e++) Te[n++] = r;
				for (Te[n - 1] = r, i = 0, r = 0; r < 16; r++) for (Oe[r] = i, e = 0; e < 1 << We[r]; e++) Ee[i++] = r;
				for (i >>= 7; r < E; r++) for (Oe[r] = i << 7, e = 0; e < 1 << We[r] - 7; e++) Ee[256 + i++] = r;
				for (t = 0; t <= b; t++) Y[t] = 0;
				for (e = 0; e <= 143;) _e[e++].dl = 8, Y[8]++;
				for (; e <= 255;) _e[e++].dl = 9, Y[9]++;
				for (; e <= 279;) _e[e++].dl = 7, Y[7]++;
				for (; e <= 287;) _e[e++].dl = 8, Y[8]++;
				for (vt(_e, T + 1), e = 0; e < E; e++) ve[e].dl = 5, ve[e].fc = Dt(e, 5);
				ht();
			}
		}
		function ht() {
			var e;
			for (e = 0; e < T; e++) he[e].fc = 0;
			for (e = 0; e < E; e++) ge[e].fc = 0;
			for (e = 0; e < D; e++) J[e].fc = 0;
			he[w].fc = 1, Fe = Ie = 0, Ae = je = Me = 0, Ne = 0, Pe = 1;
		}
		function gt(e, t) {
			for (var n = X[t], r = t << 1; r <= Se && (r < Se && it(e, X[r + 1], X[r]) && r++, !it(e, n, X[r]));) X[t] = X[r], t = r, r <<= 1;
			X[t] = n;
		}
		function _t(e) {
			var t = e.dyn_tree, n = e.extra_bits, r = e.extra_base, i = e.max_code, a = e.max_length, o = e.static_tree, s, c, l, u, d, f, p = 0;
			for (u = 0; u <= b; u++) Y[u] = 0;
			for (t[X[Ce]].dl = 0, s = Ce + 1; s < j; s++) c = X[s], u = t[t[c].dl].dl + 1, u > a && (u = a, p++), t[c].dl = u, !(c > i) && (Y[u]++, d = 0, c >= r && (d = n[c - r]), f = t[c].fc, Fe += f * (u + d), o !== null && (Ie += f * (o[c].dl + d)));
			if (p !== 0) {
				do {
					for (u = a - 1; Y[u] === 0;) u--;
					Y[u]--, Y[u + 1] += 2, Y[a]--, p -= 2;
				} while (p > 0);
				for (u = a; u !== 0; u--) for (c = Y[u]; c !== 0;) l = X[--s], !(l > i) && (t[l].dl !== u && (Fe += (u - t[l].dl) * t[l].fc, t[l].fc = u), c--);
			}
		}
		function vt(e, t) {
			var n = [], r = 0, i, a;
			for (i = 1; i <= b; i++) r = r + Y[i - 1] << 1, n[i] = r;
			for (a = 0; a <= t; a++) {
				var o = e[a].dl;
				o !== 0 && (e[a].fc = Dt(n[o]++, o));
			}
		}
		function yt(e) {
			var t = e.dyn_tree, n = e.static_tree, r = e.elems, i, a, o = -1, s = r;
			for (Se = 0, Ce = j, i = 0; i < r; i++) t[i].fc === 0 ? t[i].dl = 0 : (X[++Se] = o = i, we[i] = 0);
			for (; Se < 2;) {
				var c = X[++Se] = o < 2 ? ++o : 0;
				t[c].fc = 1, we[c] = 0, Fe--, n !== null && (Ie -= n[c].dl);
			}
			for (e.max_code = o, i = Se >> 1; i >= 1; i--) gt(t, i);
			do
				i = X[y], X[y] = X[Se--], gt(t, y), a = X[y], X[--Ce] = i, X[--Ce] = a, t[s].fc = t[i].fc + t[a].fc, we[i] > we[a] + 1 ? we[s] = we[i] : we[s] = we[a] + 1, t[i].dl = t[a].dl = s, X[y] = s++, gt(t, y);
			while (Se >= 2);
			X[--Ce] = X[y], _t(e), vt(t, o);
		}
		function bt(e, t) {
			var n, r = -1, i, a = e[0].dl, o = 0, s = 7, c = 4;
			for (a === 0 && (s = 138, c = 3), e[t + 1].dl = 65535, n = 0; n <= t; n++) i = a, a = e[n + 1].dl, !(++o < s && i === a) && (o < c ? J[i].fc += o : i === 0 ? o <= 10 ? J[k].fc++ : J[A].fc++ : (i !== r && J[i].fc++, J[O].fc++), o = 0, r = i, a === 0 ? (s = 138, c = 3) : i === a ? (s = 6, c = 3) : (s = 7, c = 4));
		}
		function xt(e, t) {
			var n, r = -1, i, a = e[0].dl, o = 0, s = 7, c = 4;
			for (a === 0 && (s = 138, c = 3), n = 0; n <= t; n++) if (i = a, a = e[n + 1].dl, !(++o < s && i === a)) {
				if (o < c) do
					nt(i, J);
				while (--o !== 0);
				else i === 0 ? o <= 10 ? (nt(k, J), Q(o - 3, 3)) : (nt(A, J), Q(o - 11, 7)) : (i !== r && (nt(i, J), o--), nt(O, J), Q(o - 3, 2));
				o = 0, r = i, a === 0 ? (s = 138, c = 3) : i === a ? (s = 6, c = 3) : (s = 7, c = 4);
			}
		}
		function St() {
			var e;
			for (bt(he, ye.max_code), bt(ge, be.max_code), yt(xe), e = D - 1; e >= 3 && J[Ke[e]].dl === 0; e--);
			return Fe += 3 * (e + 1) + 5 + 5 + 4, e;
		}
		function Ct(e, t, n) {
			var r;
			for (Q(e - 257, 5), Q(t - 1, 5), Q(n - 4, 4), r = 0; r < n; r++) Q(J[Ke[r]].dl, 3);
			xt(he, e - 1), xt(ge, t - 1);
		}
		function wt(e) {
			var t, n, r, i = G - ae, a;
			if (ke[Me] = Ne, yt(ye), yt(be), r = St(), t = Fe + 3 + 7 >> 3, n = Ie + 3 + 7 >> 3, n <= t && (t = n), i + 4 <= t && ae >= 0) for (Q(0 + e, 3), Ot(), et(i), et(~i), a = 0; a < i; a++) $e(B[ae + a]);
			else n === t ? (Q(2 + e, 3), Tt(_e, ve)) : (Q(4 + e, 3), Ct(ye.max_code + 1, be.max_code + 1, r + 1), Tt(he, ge));
			ht(), e !== 0 && Ot();
		}
		function Z(e, t) {
			if (ne[Ae++] = t, e === 0 ? he[t].fc++ : (e--, he[Te[t] + C + 1].fc++, ge[rt(e)].fc++, te[je++] = e, Ne |= Pe), Pe <<= 1, Ae & 7 || (ke[Me++] = Ne, Ne = 0, Pe = 1), q > 2 && !(Ae & 4095)) {
				var n = Ae * 8, r = G - ae, i;
				for (i = 0; i < E; i++) n += ge[i].fc * (5 + We[i]);
				if (n >>= 3, je < parseInt(Ae / 2, 10) && n < parseInt(r / 2, 10)) return !0;
			}
			return Ae === l - 1 || je === d;
		}
		function Tt(e, t) {
			var n, r, i = 0, a = 0, o = 0, s = 0, c, l;
			if (Ae !== 0) do
				i & 7 || (s = ke[o++]), r = ne[i++] & 255, s & 1 ? (c = Te[r], nt(c + C + 1, e), l = Ue[c], l !== 0 && (r -= De[c], Q(r, l)), n = te[a++], c = rt(n), nt(c, t), l = We[c], l !== 0 && (n -= Oe[c], Q(n, l))) : nt(r, e), s >>= 1;
			while (i < Ae);
			nt(w, e);
		}
		var Et = 16;
		function Q(e, t) {
			ie > Et - t ? (re |= e << ie, et(re), re = e >> Et - ie, ie += t - Et) : (re |= e << ie, ie += t);
		}
		function Dt(e, t) {
			var n = 0;
			do
				n |= e & 1, e >>= 1, n <<= 1;
			while (--t > 0);
			return n >> 1;
		}
		function Ot() {
			ie > 8 ? et(re) : ie > 0 && $e(re), re = 0, ie = 0;
		}
		function kt() {
			var e, t;
			if (R !== 0) {
				for (e = Xe(), P === null ? P = F = e : F = F.next = e, e.len = R - z, t = 0; t < e.len; t++) e.ptr[t] = L[z + t];
				R = z = 0;
			}
		}
		function At(e, t) {
			var r, i;
			Le = e, Re = 0, t === void 0 && (t = n), Je(t), i = [];
			do
				r = ft(i, i.length, 1024);
			while (r > 0);
			return Le = null, i;
		}
		t.exports = At, t.exports.DEFAULT_LEVEL = n;
	})();
})), Jf = /* @__PURE__ */ o(((e, t) => {
	(function() {
		t.exports = {
			inflate: Kf(),
			deflate: qf()
		};
	})();
})), Yf = /* @__PURE__ */ l((/* @__PURE__ */ o(((e, t) => {
	(function() {
		var e = Gf(), n = Jf(), r = 31, i = 139, a = { deflate: 8 }, o = {
			FTEXT: 1,
			FHCRC: 2,
			FEXTRA: 4,
			FNAME: 8,
			FCOMMENT: 16
		}, s = {
			fat: 0,
			amiga: 1,
			vmz: 2,
			unix: 3,
			"vm/cms": 4,
			atari: 5,
			hpfs: 6,
			macintosh: 7,
			"z-system": 8,
			cplm: 9,
			"tops-20": 10,
			ntfs: 11,
			qdos: 12,
			acorn: 13,
			vfat: 14,
			vms: 15,
			beos: 16,
			tandem: 17,
			theos: 18
		}, c = "unix", l = 6;
		function u(e, t) {
			t.push(e & 255);
		}
		function d(e, t) {
			t.push(e & 255), t.push(e >>> 8);
		}
		function f(e, t) {
			d(e & 65535, t), d(e >>> 16, t);
		}
		function p(e, t) {
			var n, r = e.length;
			for (n = 0; n < r; n += 1) u(e.charCodeAt(n), t);
		}
		function m(e) {
			return e.shift();
		}
		function h(e) {
			return e.shift() | e.shift() << 8;
		}
		function g(e) {
			var t = h(e), n = h(e);
			return n > 32768 ? (n -= 32768, (n << 16 | t) + 32768 * 2 ** 16) : n << 16 | t;
		}
		function _(e) {
			for (var t = []; e[0] !== 0;) t.push(String.fromCharCode(e.shift()));
			return e.shift(), t.join("");
		}
		function v(e, t) {
			var n, r = [];
			for (n = 0; n < t; n += 1) r.push(e.shift());
			return r;
		}
		function y(t, d) {
			var m = 0, h, g = [];
			return d ||= {}, h = d.level || l, typeof t == "string" && (t = Array.prototype.map.call(t, function(e) {
				return e.charCodeAt(0);
			})), u(r, g), u(i, g), u(a.deflate, g), d.name && (m |= o.FNAME), u(m, g), f(d.timestamp || parseInt(Date.now() / 1e3, 10), g), u(h === 1 ? 4 : h === 9 ? 2 : 0, g), u(s[c], g), d.name && (p(d.name.substring(d.name.lastIndexOf("/") + 1), g), u(0, g)), n.deflate(t, h).forEach(function(e) {
				u(e, g);
			}), f(parseInt(e(t), 16), g), f(t.length, g), g;
		}
		function b(t, c) {
			var l = Array.prototype.slice.call(t, 0), u, d, f, p, y, b;
			if (m(l) !== r || m(l) !== i) throw "Not a GZIP file";
			if (u = m(l), u = Object.keys(a).some(function(e) {
				return d = e, a[e] === u;
			}), !u) throw "Unsupported compression method";
			if (f = m(l), g(l), m(l), u = m(l), Object.keys(s).some(function(e) {
				if (s[e] === u) return !0;
			}), f & o.FEXTRA && (u = h(l), v(l, u)), f & o.FNAME && _(l), f & o.FCOMMENT && _(l), f & o.FHCRC && h(l), d === "deflate" && (b = n.inflate(l.splice(0, l.length - 8))), f & o.FTEXT && (b = Array.prototype.map.call(b, function(e) {
				return String.fromCharCode(e);
			}).join("")), p = g(l), p !== parseInt(e(b), 16)) throw "Checksum does not match";
			if (y = g(l), y !== b.length) throw "Size of decompressed file not correct";
			return b;
		}
		t.exports = {
			zip: y,
			unzip: b,
			get DEFAULT_LEVEL() {
				return l;
			}
		};
	})();
})))());
//#endregion
export { vs as Angle, nf as BeautifulObjectLayer, Gc as BillboardRenderer, Fl as Cache, Vf as ClickableMarkerLayer, sl as ConstellationLayer, Ao as DistortionParams, Cl as EsoMilkyWayLayer, Po as FrostedGlassEffect, Dc as Globe, Tc as GlobePointerDragEvent, wc as GlobePointerEvent, No as GlowEffect, El as GridLayer, Nl as HipparcosCatalogLayer, gu as ImageFilter, $ as Layer, Bf as MarkerLayer, Mo as MotionBlurEffect, ms as PanLayer, Lo as PassThroughEffect, Wf as PathLayer, jo as PlanetariumDistorterParams, jo as PlanetariumEffect, jc as PointerLockLayer, ls as PointingObject, cs as ReleaseCallbacks, Fo as RippleEffect, gs as RollLayer, ys as SkyCoord, Ru as SspTileLayer, Ru as TractTileLayer, Vu as TextLayer, Vs as TouchLayer, Rl as Tract, ko as VisualEffectParams, Io as WarpEffect, Qs as ZoomLayer, _s as angle, Ic as baseAlpha, $d as beautifulObjectDefaults, ef as beautifulObjectFilters, Qd as beautifulObjectIds, yc as cameraCenter, lu as dateUtils, tf as defaultBeautifulObjectParams, $s as easing, f as enableWebglProfiler, Hd as fits, Eo as glMatrix, Yf as gzip, Md as hips, bl as loadImage, ds as makePointingObject, Pf as markerTypes, qo as math, sc as matrixUtils, Lc as overlayAlpha, el as path, g as sprintf, mf as testEchoWorker, il as text2imageData, ou as tile, lf as triangleStrip, m as webglProfileSupported, p as wegblProfile };
